module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var ws = __webpack_require__(1);
	var fs = __webpack_require__(2);
	var path = __webpack_require__(3);
	
	var installGlobalHook = __webpack_require__(4);
	installGlobalHook(window);
	var Panel = __webpack_require__(5);
	var launchEditor = __webpack_require__(381);
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(26);
	
	var node = null;
	var onStatusChange = function noop() {};
	var projectRoots = [];
	var wall = null;
	var panel = null;
	
	var config = {
	  reload: reload,
	  alreadyFoundReact: true,
	  showInspectButton: false,
	  showHiddenThemes: true,
	  inject: function inject(done) {
	    done(wall);
	  },
	  showElementSource: function showElementSource(source) {
	    launchEditor(source.fileName, source.lineNumber, projectRoots);
	  }
	};
	
	var log = function log() {
	  var _console;
	
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (_console = console).log.apply(_console, ['[React DevTools]'].concat(args));
	};
	log.warn = function () {
	  var _console2;
	
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return (_console2 = console).warn.apply(_console2, ['[React DevTools]'].concat(args));
	};
	log.error = function () {
	  var _console3;
	
	  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  return (_console3 = console).error.apply(_console3, ['[React DevTools]'].concat(args));
	};
	
	function reload() {
	  ReactDOM.unmountComponentAtNode(node);
	  node.innerHTML = '';
	  setTimeout(function () {
	    panel = ReactDOM.render(React.createElement(Panel, config), node);
	  }, 100);
	}
	
	function onDisconnected() {
	  panel = null;
	  ReactDOM.unmountComponentAtNode(node);
	  node.innerHTML = '<div id="waiting"><h2>Waiting for React to connect…</h2></div>';
	}
	
	function onError(e) {
	  panel = null;
	  ReactDOM.unmountComponentAtNode(node);
	  var message;
	  if (e.code === 'EADDRINUSE') {
	    message = 'Another instance of DevTools is running';
	  } else {
	    message = 'Unknown error (' + e.message + ')';
	  }
	  node.innerHTML = '<div id="waiting"><h2>' + message + '</h2></div>';
	}
	
	function initialize(socket) {
	  var listeners = [];
	  socket.onmessage = function (evt) {
	    var data = JSON.parse(evt.data);
	    listeners.forEach(function (fn) {
	      return fn(data);
	    });
	  };
	
	  wall = {
	    listen: function listen(fn) {
	      listeners.push(fn);
	    },
	    send: function send(data) {
	      if (socket.readyState === socket.OPEN) {
	        socket.send(JSON.stringify(data));
	      }
	    },
	    disconnect: function disconnect() {
	      socket.close();
	    }
	  };
	
	  log('Connected');
	  reload();
	}
	
	var restartTimeout = null;
	
	function connectToSocket(socket) {
	  socket.onerror = function (err) {
	    onDisconnected();
	    log.error('Error with websocket connection', err);
	  };
	  socket.onclose = function () {
	    onDisconnected();
	    log('Connection to RN closed');
	  };
	  initialize(socket);
	
	  return {
	    close: function close() {
	      onDisconnected();
	    }
	  };
	}
	
	function startServer() {
	  var port = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8097;
	
	  var httpServer = __webpack_require__(390).createServer();
	  var server = new ws.Server({ server: httpServer });
	  var connected = false;
	  server.on('connection', function (socket) {
	    if (connected) {
	      connected.close();
	      log.warn('Only one connection allowed at a time.', 'Closing the previous connection');
	    }
	    connected = socket;
	    socket.onerror = function (err) {
	      connected = false;
	      onDisconnected();
	      log.error('Error with websocket connection', err);
	    };
	    socket.onclose = function () {
	      connected = false;
	      onDisconnected();
	      log('Connection to RN closed');
	    };
	    initialize(socket);
	  });
	
	  server.on('error', function (e) {
	    onError(e);
	    log.error('Failed to start the DevTools server', e);
	    restartTimeout = setTimeout(function () {
	      return startServer(port);
	    }, 1000);
	  });
	
	  httpServer.on('request', function (req, res) {
	    // Serve a file that immediately sets up the connection.
	    var backendFile = fs.readFileSync(path.join(__dirname, '../build/backend.js'));
	    res.end(backendFile + '\n;ReactDevToolsBackend.connectToDevTools();');
	  });
	
	  httpServer.on('error', function (e) {
	    onError(e);
	    onStatusChange('Failed to start the server.');
	    restartTimeout = setTimeout(function () {
	      return startServer(port);
	    }, 1000);
	  });
	
	  httpServer.listen(port, function () {
	    onStatusChange('The server is listening on the port ' + port + '.');
	  });
	
	  return {
	    close: function close() {
	      connected = false;
	      onDisconnected();
	      clearTimeout(restartTimeout);
	      server.close();
	      httpServer.close();
	    }
	  };
	}
	
	var DevtoolsUI = {
	  setContentDOMNode: function setContentDOMNode(_node) {
	    node = _node;
	    return DevtoolsUI;
	  },
	  setProjectRoots: function setProjectRoots(_projectRoots) {
	    projectRoots = _projectRoots;
	  },
	  setStatusListener: function setStatusListener(_listener) {
	    onStatusChange = _listener;
	    return DevtoolsUI;
	  },
	  setDefaultThemeName: function setDefaultThemeName(themeName) {
	    config.themeName = themeName;
	    if (panel) {
	      var _panel$getChildContex = panel.getChildContext(),
	          store = _panel$getChildContex.store;
	      // Change default themeName if panel mounted
	
	
	      store.changeDefaultTheme(themeName);
	    }
	    return DevtoolsUI;
	  },
	  setBrowserName: function setBrowserName(name) {
	    config.browserName = name;
	    return DevtoolsUI;
	  },
	
	
	  startServer: startServer,
	  connectToSocket: connectToSocket
	};
	
	module.exports = DevtoolsUI;

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = require("ws");

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = require("fs");

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = require("path");

/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * NOTE: This file cannot `require` any other modules. We `.toString()` the
	 *       function in some places and inject the source into the page.
	 */
	function installGlobalHook(window) {
	  if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
	    return;
	  }
	  function detectReactBuildType(renderer) {
	    try {
	      if (typeof renderer.version === 'string') {
	        // React DOM Fiber (16+)
	        if (renderer.bundleType > 0) {
	          // This is not a production build.
	          // We are currently only using 0 (PROD) and 1 (DEV)
	          // but might add 2 (PROFILE) in the future.
	          return 'development';
	        }
	
	        // React 16 uses flat bundles. If we report the bundle as production
	        // version, it means we also minified and envified it ourselves.
	        return 'production';
	        // Note: There is still a risk that the CommonJS entry point has not
	        // been envified or uglified. In this case the user would have *both*
	        // development and production bundle, but only the prod one would run.
	        // This would be really bad. We have a separate check for this because
	        // it happens *outside* of the renderer injection. See `checkDCE` below.
	      }
	      var toString = Function.prototype.toString;
	      if (renderer.Mount && renderer.Mount._renderNewRootComponent) {
	        // React DOM Stack
	        var renderRootCode = toString.call(renderer.Mount._renderNewRootComponent);
	        // Filter out bad results (if that is even possible):
	        if (renderRootCode.indexOf('function') !== 0) {
	          // Hope for the best if we're not sure.
	          return 'production';
	        }
	        // Check for React DOM Stack < 15.1.0 in development.
	        // If it contains "storedMeasure" call, it's wrapped in ReactPerf (DEV only).
	        // This would be true even if it's minified, as method name still matches.
	        if (renderRootCode.indexOf('storedMeasure') !== -1) {
	          return 'development';
	        }
	        // For other versions (and configurations) it's not so easy.
	        // Let's quickly exclude proper production builds.
	        // If it contains a warning message, it's either a DEV build,
	        // or an PROD build without proper dead code elimination.
	        if (renderRootCode.indexOf('should be a pure function') !== -1) {
	          // Now how do we tell a DEV build from a bad PROD build?
	          // If we see NODE_ENV, we're going to assume this is a dev build
	          // because most likely it is referring to an empty shim.
	          if (renderRootCode.indexOf('NODE_ENV') !== -1) {
	            return 'development';
	          }
	          // If we see "development", we're dealing with an envified DEV build
	          // (such as the official React DEV UMD).
	          if (renderRootCode.indexOf('development') !== -1) {
	            return 'development';
	          }
	          // I've seen process.env.NODE_ENV !== 'production' being smartly
	          // replaced by `true` in DEV by Webpack. I don't know how that
	          // works but we can safely guard against it because `true` was
	          // never used in the function source since it was written.
	          if (renderRootCode.indexOf('true') !== -1) {
	            return 'development';
	          }
	          // By now either it is a production build that has not been minified,
	          // or (worse) this is a minified development build using non-standard
	          // environment (e.g. "staging"). We're going to look at whether
	          // the function argument name is mangled:
	          if (
	          // 0.13 to 15
	          renderRootCode.indexOf('nextElement') !== -1 ||
	          // 0.12
	          renderRootCode.indexOf('nextComponent') !== -1) {
	            // We can't be certain whether this is a development build or not,
	            // but it is definitely unminified.
	            return 'unminified';
	          } else {
	            // This is likely a minified development build.
	            return 'development';
	          }
	        }
	        // By now we know that it's envified and dead code elimination worked,
	        // but what if it's still not minified? (Is this even possible?)
	        // Let's check matches for the first argument name.
	        if (
	        // 0.13 to 15
	        renderRootCode.indexOf('nextElement') !== -1 ||
	        // 0.12
	        renderRootCode.indexOf('nextComponent') !== -1) {
	          return 'unminified';
	        }
	        // Seems like we're using the production version.
	        // However, the branch above is Stack-only so this is 15 or earlier.
	        return 'outdated';
	      }
	    } catch (err) {
	      // Weird environments may exist.
	      // This code needs a higher fault tolerance
	      // because it runs even with closed DevTools.
	      // TODO: should we catch errors in all injected code, and not just this part?
	    }
	    return 'production';
	  }
	
	  var hasDetectedBadDCE = false;
	
	  var hook = {
	    // Shared between Stack and Fiber:
	    _renderers: {},
	    helpers: {},
	    checkDCE: function checkDCE(fn) {
	      // This runs for production versions of React.
	      // Needs to be super safe.
	      try {
	        var toString = Function.prototype.toString;
	        var code = toString.call(fn);
	        // This is a string embedded in the passed function under DEV-only
	        // condition. However the function executes only in PROD. Therefore,
	        // if we see it, dead code elimination did not work.
	        if (code.indexOf('^_^') > -1) {
	          // Remember to report during next injection.
	          hasDetectedBadDCE = true;
	          // Bonus: throw an exception hoping that it gets picked up by
	          // a reporting system. Not synchronously so that it doesn't break the
	          // calling code.
	          setTimeout(function () {
	            throw new Error('React is running in production mode, but dead code ' + 'elimination has not been applied. Read how to correctly ' + 'configure React for production: ' + 'https://fb.me/react-perf-use-the-production-build');
	          });
	        }
	      } catch (err) {}
	    },
	    inject: function inject(renderer) {
	      var id = Math.random().toString(16).slice(2);
	      hook._renderers[id] = renderer;
	      var reactBuildType = hasDetectedBadDCE ? 'deadcode' : detectReactBuildType(renderer);
	      hook.emit('renderer', { id: id, renderer: renderer, reactBuildType: reactBuildType });
	      return id;
	    },
	    _listeners: {},
	    sub: function sub(evt, fn) {
	      hook.on(evt, fn);
	      return function () {
	        return hook.off(evt, fn);
	      };
	    },
	    on: function on(evt, fn) {
	      if (!hook._listeners[evt]) {
	        hook._listeners[evt] = [];
	      }
	      hook._listeners[evt].push(fn);
	    },
	    off: function off(evt, fn) {
	      if (!hook._listeners[evt]) {
	        return;
	      }
	      var ix = hook._listeners[evt].indexOf(fn);
	      if (ix !== -1) {
	        hook._listeners[evt].splice(ix, 1);
	      }
	      if (!hook._listeners[evt].length) {
	        hook._listeners[evt] = null;
	      }
	    },
	    emit: function emit(evt, data) {
	      if (hook._listeners[evt]) {
	        hook._listeners[evt].map(function (fn) {
	          return fn(data);
	        });
	      }
	    },
	    // Fiber-only:
	    supportsFiber: true,
	    _fiberRoots: {},
	    getFiberRoots: function getFiberRoots(rendererID) {
	      var roots = hook._fiberRoots;
	      if (!roots[rendererID]) {
	        roots[rendererID] = new Set();
	      }
	      return roots[rendererID];
	    },
	
	    onCommitFiberUnmount: function onCommitFiberUnmount(rendererID, fiber) {
	      // TODO: can we use hook for roots too?
	      if (hook.helpers[rendererID]) {
	        hook.helpers[rendererID].handleCommitFiberUnmount(fiber);
	      }
	    },
	    onCommitFiberRoot: function onCommitFiberRoot(rendererID, root) {
	      var mountedRoots = hook.getFiberRoots(rendererID);
	      var current = root.current;
	      var isKnownRoot = mountedRoots.has(root);
	      var isUnmounting = current.memoizedState == null || current.memoizedState.element == null;
	      // Keep track of mounted roots so we can hydrate when DevTools connect.
	      if (!isKnownRoot && !isUnmounting) {
	        mountedRoots.add(root);
	      } else if (isKnownRoot && isUnmounting) {
	        mountedRoots.delete(root);
	      }
	      if (hook.helpers[rendererID]) {
	        hook.helpers[rendererID].handleCommitFiberRoot(root);
	      }
	    }
	  };
	  Object.defineProperty(window, '__REACT_DEVTOOLS_GLOBAL_HOOK__', {
	    value: hook
	  });
	}
	
	module.exports = installGlobalHook;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/* globals chrome */
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	var Container = __webpack_require__(14);
	var Store = __webpack_require__(325);
	var keyboardNav = __webpack_require__(331);
	var invariant = __webpack_require__(56);
	var assign = __webpack_require__(19);
	
	var Bridge = __webpack_require__(333);
	
	var _require = __webpack_require__(17),
	    sansSerif = _require.sansSerif;
	
	var NativeStyler = __webpack_require__(340);
	var ProfilerPlugin = __webpack_require__(344);
	var RelayPlugin = __webpack_require__(373);
	var Themes = __webpack_require__(316);
	var ThemeStore = __webpack_require__(329);
	
	var consts = __webpack_require__(32);
	
	var Panel = function (_React$Component) {
	  _inherits(Panel, _React$Component);
	
	  // TODO: typecheck plugin interface
	  function Panel(props) {
	    _classCallCheck(this, Panel);
	
	    var _this = _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).call(this, props));
	
	    _this.state = {
	      loading: true,
	      showTroubleshooting: false,
	      preferencesPanelShown: false,
	      isReact: props.alreadyFoundReact,
	      themeKey: 0,
	      themeName: props.themeName
	    };
	    _this._unMounted = false;
	    window.panel = _this;
	    _this.plugins = [];
	    return _this;
	  } // eslint-disable-line no-undef
	
	  // eslint shouldn't error on type positions. TODO: update eslint
	  // eslint-disable-next-line no-undef
	
	
	  _createClass(Panel, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        browserName: this.props.browserName || '',
	        defaultThemeName: this._themeStore && this._themeStore.defaultThemeName || '',
	        showHiddenThemes: !!this.props.showHiddenThemes,
	        showInspectButton: this.props.showInspectButton !== false,
	        store: this._store,
	        theme: this._themeStore && this._themeStore.theme || Themes.ChromeDefault,
	        themeName: this._themeStore && this._themeStore.themeName || '',
	        themes: this._themeStore && this._themeStore.themes || {}
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.alreadyFoundReact) {
	        this.inject();
	      } else {
	        this.lookForReact();
	      }
	
	      if (this.props.reloadSubscribe) {
	        this._unsub = this.props.reloadSubscribe(function () {
	          return _this2.reload();
	        });
	      }
	
	      if (this.state.loading) {
	        this._troubleshootingTimeout = setTimeout(function () {
	          return _this2.setState({ showTroubleshooting: true });
	        }, 3000);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unMounted = true;
	      if (this._unsub) {
	        this._unsub();
	      }
	      this.teardown();
	
	      if (this._troubleshootingTimeout !== null) {
	        clearTimeout(this._troubleshootingTimeout);
	      }
	    }
	  }, {
	    key: 'pauseTransfer',
	    value: function pauseTransfer() {
	      if (this._bridge) {
	        this._bridge.pause();
	      }
	    }
	  }, {
	    key: 'resumeTransfer',
	    value: function resumeTransfer() {
	      if (this._bridge) {
	        this._bridge.resume();
	      }
	    }
	  }, {
	    key: 'reload',
	    value: function reload() {
	      if (this._unsub) {
	        this._unsub();
	      }
	      this.teardown();
	      if (!this._unMounted) {
	        this.setState({ loading: true }, this.props.reload);
	      }
	    }
	  }, {
	    key: 'getNewSelection',
	    value: function getNewSelection() {
	      if (!this._bridge || !this.props.getNewSelection) {
	        return;
	      }
	      this.props.getNewSelection(this._bridge);
	    }
	  }, {
	    key: 'hideHighlight',
	    value: function hideHighlight() {
	      this._store.hideHighlight();
	    }
	  }, {
	    key: 'sendSelection',
	    value: function sendSelection(id) {
	      if (!this._bridge || !id && !this._store.selected) {
	        return;
	      }
	      invariant(this.props.selectElement, 'cannot send selection if props.selectElement is not defined');
	      // $FlowFixMe either id or this._store.selected is a string
	      this.props.selectElement(id || this._store.selected, this._bridge);
	    }
	  }, {
	    key: 'viewComponentSource',
	    value: function viewComponentSource(id) {
	      var _this3 = this;
	
	      if (!this._bridge) {
	        return;
	      }
	      this._bridge.send('putSelectedInstance', id);
	      setTimeout(function () {
	        invariant(_this3.props.showComponentSource, 'cannot view source if props.showComponentSource is not supplied');
	        _this3.props.showComponentSource('__REACT_DEVTOOLS_GLOBAL_HOOK__.$inst', '__REACT_DEVTOOLS_GLOBAL_HOOK__.$type');
	      }, 100);
	    }
	  }, {
	    key: 'viewElementSource',
	    value: function viewElementSource(id, source) {
	      var _this4 = this;
	
	      if (!this._bridge) {
	        return;
	      }
	      this._bridge.send('putSelectedInstance', id);
	      setTimeout(function () {
	        invariant(_this4.props.showElementSource, 'cannot view source if props.showElementSource is not supplied');
	        _this4.props.showElementSource(source);
	      }, 100);
	    }
	  }, {
	    key: 'teardown',
	    value: function teardown() {
	      this.plugins.forEach(function (p) {
	        return p.teardown();
	      });
	      this.plugins = [];
	      if (this._keyListener) {
	        window.removeEventListener('keydown', this._keyListener);
	        this._keyListener = null;
	      }
	      if (this._bridge) {
	        this._bridge.send('shutdown');
	      }
	      if (this._teardownWall) {
	        this._teardownWall();
	        this._teardownWall = null;
	      }
	    }
	  }, {
	    key: 'inject',
	    value: function inject() {
	      var _this5 = this;
	
	      this.props.inject(function (wall, teardown) {
	        _this5._teardownWall = teardown;
	
	        _this5._bridge = new Bridge(wall);
	
	        _this5._themeStore = new ThemeStore(_this5.state.themeName);
	        _this5._store = new Store(_this5._bridge, _this5._themeStore);
	
	        var refresh = function refresh() {
	          return _this5.forceUpdate();
	        };
	        _this5.plugins = [new RelayPlugin(_this5._store, _this5._bridge, refresh), new ProfilerPlugin(_this5._store, _this5._bridge, refresh)];
	
	        _this5._keyListener = keyboardNav(_this5._store, window);
	
	        window.addEventListener('keydown', _this5._keyListener);
	
	        _this5._store.on('connected', function () {
	          _this5.setState({
	            loading: false,
	            themeName: _this5._themeStore.themeName
	          });
	          _this5.getNewSelection();
	        });
	        _this5._store.on('preferencesPanelShown', function () {
	          _this5.setState({
	            preferencesPanelShown: _this5._store.preferencesPanelShown
	          });
	        });
	        _this5._store.on('theme', function () {
	          // Force a deep re-render when theme changes.
	          // Use an incrementor so changes to Custom theme also update.
	          _this5.setState(function (state) {
	            return {
	              themeKey: state.themeKey + 1,
	              themeName: _this5._themeStore.theme.displayName
	            };
	          });
	        });
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this6 = this;
	
	      if (!this.state.isReact) {
	        if (!this._checkTimeout) {
	          this._checkTimeout = setTimeout(function () {
	            _this6._checkTimeout = null;
	            _this6.lookForReact();
	          }, 200);
	        }
	      }
	
	      if (prevState.loading && !this.state.loading) {
	        if (this._troubleshootingTimeout !== null) {
	          clearTimeout(this._troubleshootingTimeout);
	        }
	      } else if (!prevState.loading && this.state.loading) {
	        this._troubleshootingTimeout = setTimeout(function () {
	          return _this6.setState({ showTroubleshooting: true });
	        }, 3000);
	      }
	    }
	  }, {
	    key: 'lookForReact',
	    value: function lookForReact() {
	      var _this7 = this;
	
	      if (typeof this.props.checkForReact !== 'function') {
	        return;
	      }
	      this.props.checkForReact(function (isReact) {
	        if (isReact) {
	          _this7.setState({ isReact: true, loading: true });
	          _this7.inject();
	        } else {
	          console.log('still looking...');
	          _this7.setState({ isReact: false, loading: false });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _ref,
	          _this8 = this;
	
	      var theme = this._store ? this._themeStore.theme : Themes.ChromeDefault;
	      if (this.state.loading) {
	        // TODO: This currently shows in the Firefox shell when navigating from a
	        // React page to a non-React page. We should show a better message but
	        // properly doing so probably requires refactoring how we load the panel
	        // and communicate with the bridge.
	        return React.createElement(
	          'div',
	          { style: loadingStyle(theme) },
	          React.createElement(
	            'h2',
	            null,
	            'Connecting to React\u2026'
	          ),
	          React.createElement('br', null),
	          this.state.showTroubleshooting && React.createElement(
	            'a',
	            { style: {
	                color: 'gray',
	                textDecoration: 'underline',
	                cursor: 'pointer'
	              }, onClick: function onClick() {
	                chrome.tabs.create({
	                  active: true,
	                  url: 'https://github.com/facebook/react-devtools/blob/master/' + 'README.md#the-react-tab-doesnt-show-up'
	                });
	              } },
	            'Click here for troubleshooting instructions'
	          )
	        );
	      }
	      if (!this.state.isReact) {
	        return React.createElement(
	          'div',
	          { style: loadingStyle(theme) },
	          React.createElement(
	            'h2',
	            null,
	            'Looking for React\u2026'
	          )
	        );
	      }
	      var extraTabs = assign.apply(null, [{}].concat(this.plugins.map(function (p) {
	        return p.tabs();
	      })));
	      var extraPanes = (_ref = []).concat.apply(_ref, _toConsumableArray(this.plugins.map(function (p) {
	        return p.panes();
	      })));
	      if (this._store.capabilities.rnStyle) {
	        extraPanes.push(panelRNStyle(this._bridge, this._store.capabilities.rnStyleMeasure, theme));
	      }
	      return React.createElement(Container, {
	        key: this.state.themeKey /* Force deep re-render when theme changes */,
	        reload: this.props.reload && this.reload.bind(this),
	        menuItems: {
	          attr: function attr(id, node, val, path) {
	            if (!val || node.get('nodeType') !== 'Composite' || val[consts.type] !== 'function') {
	              return undefined;
	            }
	            return [_this8.props.showAttrSource && {
	              key: 'showSource',
	              title: 'Show function source',
	              // $FlowFixMe showAttrSource is provided
	              action: function action() {
	                return _this8.props.showAttrSource(path);
	              }
	            }, _this8.props.executeFn && {
	              key: 'executeFunction',
	              title: 'Execute function',
	              // $FlowFixMe executeFn is provided
	              action: function action() {
	                return _this8.props.executeFn(path);
	              }
	            }];
	          },
	          tree: function tree(id, node) {
	            return [_this8.props.selectElement && _this8._store.capabilities.dom && {
	              key: 'findDOMNode',
	              title: 'Find the DOM node',
	              action: function action() {
	                return _this8.sendSelection(id);
	              }
	            }, _this8.props.showComponentSource && node.get('nodeType') === 'Composite' && {
	              key: 'showComponentSource',
	              title: 'Show ' + node.get('name') + ' source',
	              action: function action() {
	                return _this8.viewComponentSource(id);
	              }
	            }, _this8.props.showElementSource && node.get('source') && {
	              key: 'showElementSource',
	              title: 'Show <' + node.get('name') + ' /> in source',
	              action: function action() {
	                return _this8.viewElementSource(id, node.get('source'));
	              }
	            }];
	          }
	        },
	        extraPanes: extraPanes,
	        extraTabs: extraTabs,
	        preferencesPanelShown: this.state.preferencesPanelShown,
	        theme: theme,
	        onViewElementSource: this.props.showElementSource ? this.viewElementSource.bind(this) : null
	      });
	    }
	  }]);
	
	  return Panel;
	}(React.Component);
	
	Panel.childContextTypes = {
	  browserName: PropTypes.string.isRequired,
	  defaultThemeName: PropTypes.string.isRequired,
	  showHiddenThemes: PropTypes.bool.isRequired,
	  showInspectButton: PropTypes.bool.isRequired,
	  store: PropTypes.object,
	  theme: PropTypes.object.isRequired,
	  themeName: PropTypes.string.isRequired,
	  themes: PropTypes.object.isRequired
	};
	
	var panelRNStyle = function panelRNStyle(bridge, supportsMeasure, theme) {
	  return function (node, id) {
	    var props = node.get('props');
	    if (!props || !props.style) {
	      return React.createElement(
	        'div',
	        { key: 'rnstyle', style: containerStyle(theme) },
	        React.createElement(
	          'strong',
	          null,
	          'No style'
	        )
	      );
	    }
	    return React.createElement(
	      'div',
	      { key: 'rnstyle', style: containerStyle(theme) },
	      React.createElement(
	        'strong',
	        null,
	        'React Native Style Editor'
	      ),
	      React.createElement(NativeStyler, { id: id, bridge: bridge, supportsMeasure: supportsMeasure })
	    );
	  };
	};
	
	var containerStyle = function containerStyle(theme) {
	  return {
	    borderTop: '1px solid ' + theme.base01,
	    padding: '0.25rem',
	    marginBottom: '0.25rem',
	    flexShrink: 0
	  };
	};
	var loadingStyle = function loadingStyle(theme) {
	  return {
	    fontFamily: sansSerif.family,
	    fontSize: sansSerif.sizes.large,
	    textAlign: 'center',
	    padding: 30,
	    flex: 1,
	
	    // This color is hard-coded to match app.html and standalone.js
	    // Without it, the loading headers change colors and look weird
	    color: '#aaa'
	  };
	};
	
	module.exports = Panel;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(7)();
	}


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(8);
	var invariant = __webpack_require__(9);
	var ReactPropTypesSecret = __webpack_require__(10);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 10 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(12);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.5.2
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var m=__webpack_require__(13),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.async_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112;n&&Symbol.for("react.placeholder");
	var z="function"===typeof Symbol&&Symbol.iterator;function A(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var k=[d,c,e,g,h,f],l=0;a=Error(b.replace(/%s/g,function(){return k[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);A(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
	function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
	H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null,currentDispatcher:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
	function L(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];e.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:I.current}}
	function M(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=z&&a[z]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function V(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=M(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function W(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,aa,b);R(b)}function ba(a,b){var d=I.currentDispatcher;null===d?B("277"):void 0;return d.readContext(a,b)}
	var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];W(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,V,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];W(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,Provider:null,Consumer:null,unstable_read:null};a.Provider={$$typeof:v,_context:a};a.Consumer=a;a.unstable_read=ba.bind(null,a);return a},forwardRef:function(a){return{$$typeof:y,render:a}},Fragment:r,StrictMode:t,unstable_AsyncMode:x,unstable_Profiler:u,createElement:L,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);
	var k=void 0;a.type&&a.type.defaultProps&&(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];e.children=k}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.5.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,
	assign:m}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 13 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContextMenu = __webpack_require__(15);
	var PropState = __webpack_require__(21);
	var React = __webpack_require__(11);
	var LeftPane = __webpack_require__(57);
	var PreferencesPanel = __webpack_require__(67);
	var SplitPane = __webpack_require__(322);
	var TabbedPane = __webpack_require__(324);
	
	var IS_VERTICAL_BREAKPOINT = 500;
	
	function shouldUseVerticalLayout(window) {
	  return window.innerWidth < IS_VERTICAL_BREAKPOINT;
	}
	
	var Container = function (_React$Component) {
	  _inherits(Container, _React$Component);
	
	  function Container(props) {
	    _classCallCheck(this, Container);
	
	    var _this = _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).call(this, props));
	
	    _this.handleResize = function (e) {
	      if (!_this.resizeTimeout) {
	        _this.resizeTimeout = setTimeout(_this.handleResizeTimeout, 50);
	      }
	    };
	
	    _this.handleResizeTimeout = function () {
	      _this.resizeTimeout = null;
	
	      _this.setState({
	        isVertical: shouldUseVerticalLayout(window)
	      });
	    };
	
	    _this.state = {
	      isVertical: shouldUseVerticalLayout(window)
	    };
	    return _this;
	  }
	  // eslint shouldn't error on type positions. TODO: update eslint
	  // eslint-disable-next-line no-undef
	
	
	  _createClass(Container, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleResize, false);
	      this.setState({
	        isVertical: shouldUseVerticalLayout(window)
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	      if (this.resizeTimeout != null) {
	        clearTimeout(this.resizeTimeout);
	      }
	    }
	
	    // $FlowFixMe future versions of Flow can infer this
	
	
	    // $FlowFixMe future versions of Flow can infer this
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          preferencesPanelShown = _props.preferencesPanelShown,
	          theme = _props.theme;
	
	
	      var tabs = _extends({
	        Elements: function Elements() {
	          return React.createElement(SplitPane, {
	            initialWidth: 10,
	            initialHeight: 10,
	            left: function left() {
	              return React.createElement(LeftPane, { reload: _this2.props.reload });
	            },
	            right: function right() {
	              return React.createElement(PropState, {
	                onViewElementSource: _this2.props.onViewElementSource,
	                extraPanes: _this2.props.extraPanes
	              });
	            },
	            isVertical: _this2.state.isVertical
	          });
	        }
	      }, this.props.extraTabs);
	
	      return React.createElement(
	        'div',
	        { style: containerStyle(preferencesPanelShown, theme) },
	        React.createElement(TabbedPane, { tabs: tabs }),
	        React.createElement(PreferencesPanel, null),
	        React.createElement(ContextMenu, { itemSources: [DEFAULT_MENU_ITEMS, this.props.menuItems] })
	      );
	    }
	  }]);
	
	  return Container;
	}(React.Component);
	
	var DEFAULT_MENU_ITEMS = {
	  tree: function tree(id, node, store) {
	    var items = [];
	    if (node.get('name')) {
	      items.push({
	        key: 'showNodesOfType',
	        title: 'Show all ' + node.get('name'),
	        action: function action() {
	          return store.changeSearch(node.get('name'));
	        }
	      });
	    }
	    if (store.capabilities.scroll) {
	      items.push({
	        key: 'scrollToNode',
	        title: 'Scroll to node',
	        action: function action() {
	          return store.scrollToNode(id);
	        }
	      });
	    }
	    if (node.get('nodeType') === 'Composite' && node.get('name')) {
	      items.push({
	        key: 'copyNodeName',
	        title: 'Copy element name',
	        action: function action() {
	          return store.copyNodeName(node.get('name'));
	        }
	      });
	    }
	    var props = node.get('props');
	    if (props) {
	      var numKeys = Object.keys(props).filter(function (key) {
	        return key !== 'children';
	      }).length;
	
	      if (numKeys > 0) {
	        items.push({
	          key: 'copyNodeProps',
	          title: 'Copy element props',
	          action: function action() {
	            return store.copyNodeProps(props);
	          }
	        });
	      }
	    }
	    return items;
	  },
	  attr: function attr(id, node, val, path, name, store) {
	    return [{
	      key: 'storeAsGlobal',
	      title: 'Store as global variable',
	      action: function action() {
	        return store.makeGlobal(id, path);
	      }
	    }];
	  }
	};
	
	var containerStyle = function containerStyle(preferencesPanelShown, theme) {
	  return {
	    backgroundColor: theme.base00,
	    color: theme.base05,
	    flex: 1,
	    display: 'flex',
	    minWidth: 0,
	    position: preferencesPanelShown ? 'relative' : null
	  };
	};
	
	module.exports = Container;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	var nullthrows = __webpack_require__(16).default;
	
	var _require = __webpack_require__(17),
	    sansSerif = _require.sansSerif;
	
	var HighlightHover = __webpack_require__(18);
	
	var decorate = __webpack_require__(20);
	
	var ContextMenu = function (_React$Component) {
	  _inherits(ContextMenu, _React$Component);
	
	  function ContextMenu(props) {
	    _classCallCheck(this, ContextMenu);
	
	    var _this = _possibleConstructorReturn(this, (ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).call(this, props));
	
	    _this.state = {
	      elementHeight: 0,
	      windowHeight: 0
	    };
	
	    _this._setRef = function (element) {
	      if (!element) {
	        return;
	      }
	
	      var elementHeight = nullthrows(element.querySelector('ul')).clientHeight;
	      var windowHeight = window.innerHeight;
	
	      if (_this.state.elementHeight === elementHeight && _this.state.windowHeight === windowHeight) {
	        return;
	      }
	
	      _this.setState({
	        elementHeight: elementHeight,
	        windowHeight: windowHeight
	      });
	    };
	
	    _this.handleBackdropClick = _this.handleBackdropClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(ContextMenu, [{
	    key: 'onClick',
	    value: function onClick(i, evt) {
	      this.props.items[i].action();
	    }
	  }, {
	    key: 'handleBackdropClick',
	    value: function handleBackdropClick(evt) {
	      evt.preventDefault();
	      this.props.hideContextMenu();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var theme = this.context.theme;
	      var _props = this.props,
	          items = _props.items,
	          open = _props.open,
	          pos = _props.pos;
	      var _state = this.state,
	          elementHeight = _state.elementHeight,
	          windowHeight = _state.windowHeight;
	
	
	      if (pos && pos.y + elementHeight > windowHeight) {
	        pos.y -= elementHeight;
	      }
	
	      if (!open) {
	        return React.createElement('div', { style: styles.hidden });
	      }
	
	      return React.createElement(
	        'div',
	        { style: styles.backdrop, onClick: this.handleBackdropClick, ref: this._setRef },
	        React.createElement(
	          'ul',
	          { style: containerStyle(pos.x, pos.y, theme) },
	          !items.length && React.createElement(
	            'li',
	            { style: emptyStyle(theme) },
	            'No actions'
	          ),
	          items.map(function (item, i) {
	            return item && React.createElement(
	              'li',
	              { style: listItemStyle(theme), key: item.key, onClick: function onClick(evt) {
	                  return _this2.onClick(i, evt);
	                } },
	              React.createElement(
	                HighlightHover,
	                { style: styles.highlightHoverItem },
	                item.title
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return ContextMenu;
	}(React.Component);
	
	ContextMenu.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	var Wrapped = decorate({
	  listeners: function listeners() {
	    return ['contextMenu'];
	  },
	  props: function props(store, _props2) {
	    if (!store.contextMenu) {
	      return { open: false };
	    }
	    var _store$contextMenu = store.contextMenu,
	        x = _store$contextMenu.x,
	        y = _store$contextMenu.y,
	        type = _store$contextMenu.type,
	        args = _store$contextMenu.args;
	
	
	    var items = [];
	    args.push(store);
	
	    _props2.itemSources.forEach(function (source) {
	      if (!source || !source[type]) {
	        return;
	      }
	      var newItems = source[type].apply(source, _toConsumableArray(args));
	      if (newItems) {
	        items = items.concat(newItems.filter(function (v) {
	          return !!v;
	        }));
	      }
	    });
	
	    return {
	      open: true,
	      pos: { x: x, y: y },
	      hideContextMenu: function hideContextMenu() {
	        return store.hideContextMenu();
	      },
	      items: items
	    };
	  }
	}, ContextMenu);
	
	var containerStyle = function containerStyle(xPos, yPos, theme) {
	  return {
	    top: yPos + 'px',
	    left: xPos + 'px',
	    position: 'fixed',
	    listStyle: 'none',
	    margin: 0,
	    padding: '0.25rem 0',
	    fontSize: sansSerif.sizes.large,
	    fontFamily: sansSerif.family,
	    borderRadius: '0.25rem',
	    overflow: 'hidden',
	    zIndex: 1,
	    backgroundColor: theme.base01
	  };
	};
	
	var emptyStyle = function emptyStyle(theme) {
	  return {
	    padding: '0.25rem 0.5rem',
	    color: theme.base03
	  };
	};
	
	var listItemStyle = function listItemStyle(theme) {
	  return {
	    color: theme.base05
	  };
	};
	
	var styles = {
	  hidden: {
	    display: 'none'
	  },
	
	  backdrop: {
	    position: 'fixed',
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0,
	    zIndex: 1
	  },
	
	  highlightHoverItem: {
	    padding: '0.25rem 0.5rem',
	    cursor: 'default',
	    WebkitUserSelect: 'none',
	    MozUserSelect: 'none',
	    userSelect: 'none'
	  }
	};
	
	module.exports = Wrapped;

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {value: true});
	
	exports.default = function nullthrows(x) {
	  if (x != null) {
	    return x;
	  }
	  throw new Error('Got unexpected null or undefined');
	};


/***/ },
/* 17 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	module.exports = {
	  monospace: {
	    family: 'Menlo, Consolas, monospace',
	    sizes: {
	      normal: 11,
	      large: 14
	    }
	  },
	  sansSerif: {
	    family: '"Helvetica Neue", "Lucida Grande", -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, sans-serif',
	    sizes: {
	      small: 10,
	      normal: 12,
	      large: 14
	    }
	  }
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	var assign = __webpack_require__(19);
	
	var HighlightHover = function (_React$Component) {
	  _inherits(HighlightHover, _React$Component);
	
	  function HighlightHover(props) {
	    _classCallCheck(this, HighlightHover);
	
	    var _this = _possibleConstructorReturn(this, (HighlightHover.__proto__ || Object.getPrototypeOf(HighlightHover)).call(this, props));
	
	    _this.state = { hover: false };
	    return _this;
	  }
	
	  _createClass(HighlightHover, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var theme = this.context.theme;
	
	
	      return React.createElement(
	        'div',
	        {
	          onMouseOver: function onMouseOver() {
	            return !_this2.state.hover && _this2.setState({ hover: true });
	          },
	          onMouseOut: function onMouseOut() {
	            return _this2.state.hover && _this2.setState({ hover: false });
	          },
	          style: assign({}, this.props.style, {
	            backgroundColor: this.state.hover ? theme.base02 : 'transparent'
	          }) },
	        this.props.children
	      );
	    }
	  }]);
	
	  return HighlightHover;
	}(React.Component);
	
	HighlightHover.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	module.exports = HighlightHover;

/***/ },
/* 19 */
/***/ function(module, exports) {

	/* eslint-disable no-unused-vars */
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	
	/**
	 * This Higher Order Component decorator function is the way the components
	 * communicate with the central Store.
	 *
	 * Example:
	 *
	 * class MyComp {
	 *   render() {
	 *     return (
	 *       <div>
	 *         Hello {this.props.name}.
	 *         <button onClick={this.props.sayHi}>Hi back</button>
	 *       </div>
	 *     );
	 *   }
	 * }
	 *
	 * module.exports = decorate({
	 *   listeners: () => ['nameChanged'],
	 *   props(store) {
	 *     return {
	 *       name: store.name,
	 *       sayHi: () => store.sayHi(),
	 *     };
	 *   },
	 * }, MyComp);
	 */
	module.exports = function (options, Component) {
	  var storeKey = options.store || 'store';
	
	  var Wrapper = function (_React$Component) {
	    _inherits(Wrapper, _React$Component);
	
	    function Wrapper(props) {
	      _classCallCheck(this, Wrapper);
	
	      var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props));
	
	      _this.state = {};
	      return _this;
	    }
	
	    _createClass(Wrapper, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        if (!this.context[storeKey]) {
	          console.warn('no store on context...');
	          return;
	        }
	        this._update = function () {
	          return _this2.forceUpdate();
	        };
	        if (!options.listeners) {
	          return;
	        }
	        this._listeners = options.listeners(this.props, this.context[storeKey]);
	        this._listeners.forEach(function (evt) {
	          _this2.context[storeKey].on(evt, _this2._update);
	        });
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var _this3 = this;
	
	        if (!this.context[storeKey]) {
	          console.warn('no store on context...');
	          return;
	        }
	        this._listeners.forEach(function (evt) {
	          _this3.context[storeKey].off(evt, _this3._update);
	        });
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        if (nextState !== this.state) {
	          return true;
	        }
	        if (options.shouldUpdate) {
	          return options.shouldUpdate(nextProps, this.props);
	        }
	        return false;
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        var _this4 = this;
	
	        if (!this.context[storeKey]) {
	          console.warn('no store on context...');
	          return;
	        }
	        if (!options.listeners) {
	          return;
	        }
	        var listeners = options.listeners(this.props, this.context[storeKey]);
	        var diff = arrayDiff(listeners, this._listeners);
	        diff.missing.forEach(function (name) {
	          _this4.context[storeKey].off(name, _this4._update);
	        });
	        diff.newItems.forEach(function (name) {
	          _this4.context[storeKey].on(name, _this4._update);
	        });
	        this._listeners = listeners;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var store = this.context[storeKey];
	        var props = store && options.props(store, this.props);
	        return React.createElement(Component, _extends({}, props, this.props));
	      }
	    }]);
	
	    return Wrapper;
	  }(React.Component);
	
	  Wrapper.contextTypes = _defineProperty({}, storeKey, PropTypes.object);
	
	  Wrapper.displayName = 'Wrapper(' + Component.name + ')';
	
	  return Wrapper;
	};
	
	function arrayDiff(array, oldArray) {
	  var names = new Set();
	  var missing = [];
	  for (var i = 0; i < array.length; i++) {
	    names.add(array[i]);
	  }
	  for (var j = 0; j < oldArray.length; j++) {
	    if (!names.has(oldArray[j])) {
	      missing.push(oldArray[j]);
	    } else {
	      names.delete(oldArray[j]);
	    }
	  }
	  return {
	    missing: missing,
	    newItems: setToArray(names)
	  };
	}
	
	function setToArray(set) {
	  var res = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = set[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var val = _step.value;
	
	      res.push(val);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return res;
	}

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlurInput = __webpack_require__(22);
	var DataView = __webpack_require__(24);
	var DetailPane = __webpack_require__(52);
	var DetailPaneSection = __webpack_require__(53);
	
	var _require = __webpack_require__(17),
	    sansSerif = _require.sansSerif;
	
	var PropVal = __webpack_require__(54);
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	
	var decorate = __webpack_require__(20);
	var invariant = __webpack_require__(56);
	
	var PropState = function (_React$Component) {
	  _inherits(PropState, _React$Component);
	
	  function PropState() {
	    _classCallCheck(this, PropState);
	
	    return _possibleConstructorReturn(this, (PropState.__proto__ || Object.getPrototypeOf(PropState)).apply(this, arguments));
	  }
	
	  _createClass(PropState, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _this2 = this;
	
	      return {
	        onChange: function onChange(path, val) {
	          _this2.props.onChange(path, val);
	        }
	      };
	    }
	  }, {
	    key: 'renderSource',
	    value: function renderSource() {
	      var theme = this.context.theme;
	      var _props = this.props,
	          id = _props.id,
	          node = _props.node,
	          onViewElementSource = _props.onViewElementSource;
	
	      var source = node.get('source');
	      if (!source) {
	        return null;
	      }
	
	      var onClick = void 0;
	      if (onViewElementSource) {
	        onClick = function onClick() {
	          return onViewElementSource(id, source);
	        };
	      }
	
	      return React.createElement(
	        'div',
	        {
	          style: sourceStyle(!!onViewElementSource, theme),
	          onClick: onClick
	        },
	        source.fileName,
	        React.createElement(
	          'span',
	          { style: sourcePosStyle(theme) },
	          ':',
	          source.lineNumber
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var theme = this.context.theme;
	
	      if (!this.props.node) {
	        return React.createElement(
	          'span',
	          { style: emptyStyle(theme) },
	          'No selection'
	        );
	      }
	
	      var nodeType = this.props.node.get('nodeType');
	
	      if (nodeType === 'Text') {
	        if (this.props.canEditTextContent) {
	          return React.createElement(
	            DetailPane,
	            null,
	            React.createElement(BlurInput, {
	              value: this.props.node.get('text'),
	              onChange: this.props.onChangeText
	            })
	          );
	        }
	        return React.createElement(
	          DetailPane,
	          { header: 'Text Node' },
	          React.createElement(
	            'span',
	            { style: noPropsStateStyle(theme) },
	            'No props/state.'
	          )
	        );
	      } else if (nodeType === 'Empty') {
	        return React.createElement(
	          DetailPane,
	          { header: 'Empty Node' },
	          React.createElement(
	            'span',
	            { style: noPropsStateStyle(theme) },
	            'No props/state.'
	          )
	        );
	      }
	
	      var editTextContent = null;
	      if (this.props.canEditTextContent) {
	        if (typeof this.props.node.get('children') === 'string') {
	          editTextContent = React.createElement(BlurInput, {
	            value: this.props.node.get('children'),
	            onChange: this.props.onChangeText
	          });
	        }
	      }
	
	      var key = this.props.node.get('key');
	      var ref = this.props.node.get('ref');
	      var state = this.props.node.get('state');
	      var context = this.props.node.get('context');
	      var propsReadOnly = !this.props.node.get('canUpdate');
	
	      return React.createElement(
	        DetailPane,
	        {
	          theme: theme },
	        key && React.createElement(
	          DetailPaneSection,
	          {
	            title: 'Key',
	            key: this.props.id + '-key' },
	          React.createElement(PropVal, {
	            val: key
	          })
	        ),
	        ref && React.createElement(
	          DetailPaneSection,
	          {
	            title: 'Ref',
	            key: this.props.id + '-ref' },
	          React.createElement(PropVal, {
	            val: ref
	          })
	        ),
	        editTextContent,
	        React.createElement(
	          DetailPaneSection,
	          {
	            hint: propsReadOnly ? 'read-only' : null,
	            title: 'Props' },
	          React.createElement(DataView, {
	            path: ['props'],
	            readOnly: propsReadOnly,
	            inspect: this.props.inspect,
	            showMenu: this.props.showMenu,
	            key: this.props.id + '-props',
	            data: this.props.node.get('props')
	          })
	        ),
	        state && React.createElement(
	          DetailPaneSection,
	          { title: 'State' },
	          React.createElement(DataView, {
	            data: state,
	            path: ['state'],
	            inspect: this.props.inspect,
	            showMenu: this.props.showMenu,
	            key: this.props.id + '-state'
	          })
	        ),
	        context && React.createElement(
	          DetailPaneSection,
	          { title: 'Context' },
	          React.createElement(DataView, {
	            data: context,
	            path: ['context'],
	            inspect: this.props.inspect,
	            showMenu: this.props.showMenu,
	            key: this.props.id + '-context'
	          })
	        ),
	        this.props.extraPanes && this.props.extraPanes.map(function (fn) {
	          return fn && fn(_this3.props.node, _this3.props.id);
	        }),
	        React.createElement('div', { style: { flex: 1 } }),
	        this.renderSource()
	      );
	    }
	  }]);
	
	  return PropState;
	}(React.Component);
	
	PropState.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	PropState.childContextTypes = {
	  onChange: PropTypes.func
	};
	
	var WrappedPropState = decorate({
	  listeners: function listeners(props, store) {
	    return ['selected', store.selected];
	  },
	  props: function props(store) {
	    var node = store.selected ? store.get(store.selected) : null;
	    return {
	      id: store.selected,
	      node: node,
	      canEditTextContent: store.capabilities.editTextContent,
	      onChangeText: function onChangeText(text) {
	        store.changeTextContent(store.selected, text);
	      },
	      onChange: function onChange(path, val) {
	        if (path[0] === 'props') {
	          store.setProps(store.selected, path.slice(1), val);
	        } else if (path[0] === 'state') {
	          store.setState(store.selected, path.slice(1), val);
	        } else if (path[0] === 'context') {
	          store.setContext(store.selected, path.slice(1), val);
	        } else {
	          invariant(false, 'the path to change() must start wth props, state, or context');
	        }
	      },
	      showMenu: function showMenu(e, val, path, name) {
	        store.showContextMenu('attr', e, store.selected, node, val, path, name);
	      },
	
	      inspect: store.inspect.bind(store, store.selected)
	    };
	  }
	}, PropState);
	
	var emptyStyle = function emptyStyle(theme) {
	  return {
	    fontFamily: sansSerif.family,
	    fontSize: sansSerif.sizes.large,
	    fontStyle: 'italic',
	    margin: 'auto',
	    color: theme.base04
	  };
	};
	
	var sourceStyle = function sourceStyle(hasViewElementSource, theme) {
	  return {
	    padding: '0.25rem 0.5rem',
	    color: theme.base05,
	    overflowWrap: 'break-word',
	    cursor: hasViewElementSource ? 'pointer' : 'default'
	  };
	};
	
	var sourcePosStyle = function sourcePosStyle(theme) {
	  return {
	    color: theme.base03
	  };
	};
	
	var noPropsStateStyle = function noPropsStateStyle(theme) {
	  return {
	    fontFamily: sansSerif.family,
	    fontSize: sansSerif.sizes.normal,
	    color: theme.base03,
	    textAlign: 'center',
	    fontStyle: 'italic',
	    padding: '0.5rem'
	  };
	};
	
	module.exports = WrappedPropState;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(11);
	var Input = __webpack_require__(23);
	
	var BlurInput = function (_React$Component) {
	  _inherits(BlurInput, _React$Component);
	
	  function BlurInput(props) {
	    _classCallCheck(this, BlurInput);
	
	    var _this = _possibleConstructorReturn(this, (BlurInput.__proto__ || Object.getPrototypeOf(BlurInput)).call(this, props));
	
	    _this.state = { text: _this.props.value || '' };
	    return _this;
	  }
	
	  _createClass(BlurInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.setState({ text: '' + nextProps.value });
	      }
	    }
	  }, {
	    key: 'done',
	    value: function done() {
	      if (this.state.text !== (this.props.value || '')) {
	        this.props.onChange(this.state.text);
	      }
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e) {
	      if (e.key === 'Enter') {
	        this.done();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return React.createElement(Input, {
	        value: this.state.text,
	        innerRef: function innerRef(i) {
	          return _this2.node = i;
	        },
	        onChange: function onChange(e) {
	          return _this2.setState({ text: e.target.value });
	        },
	        onBlur: this.done.bind(this),
	        onKeyDown: function onKeyDown(e) {
	          return _this2.onKeyDown(e);
	        }
	      });
	    }
	  }]);
	
	  return BlurInput;
	}(React.Component);
	
	module.exports = BlurInput;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	
	/**
	 * Same as base <input> component but with pre-applied theme styles.
	 * Props theme overrides context theme if provided.
	 */
	var Input = function Input(props, context) {
	  var _props$style = props.style,
	      style = _props$style === undefined ? {} : _props$style,
	      theme = props.theme,
	      innerRef = props.innerRef,
	      rest = _objectWithoutProperties(props, ['style', 'theme', 'innerRef']);
	
	  var chosenTheme = theme ? theme : context.theme;
	
	  return React.createElement('input', _extends({
	    style: _extends({}, inputStyle(chosenTheme), style),
	    ref: innerRef
	  }, rest));
	};
	
	Input.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	var inputStyle = function inputStyle(theme) {
	  return {
	    backgroundColor: theme.base00,
	    color: theme.base05
	  };
	};
	
	module.exports = Input;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	var Simple = __webpack_require__(25);
	var nullthrows = __webpack_require__(16).default;
	
	var consts = __webpack_require__(32);
	var previewComplex = __webpack_require__(51);
	
	var DataView = function (_React$Component) {
	  _inherits(DataView, _React$Component);
	
	  function DataView() {
	    _classCallCheck(this, DataView);
	
	    return _possibleConstructorReturn(this, (DataView.__proto__ || Object.getPrototypeOf(DataView)).apply(this, arguments));
	  }
	
	  _createClass(DataView, [{
	    key: 'renderSparseArrayHole',
	    value: function renderSparseArrayHole(count, key) {
	      var theme = this.context.theme;
	
	
	      return React.createElement(
	        'li',
	        { key: key },
	        React.createElement(
	          'div',
	          { style: styles.head },
	          React.createElement(
	            'div',
	            { style: sparseArrayHoleStyle(theme) },
	            'undefined \xD7 ',
	            count
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(name, key) {
	      var data = nullthrows(this.props.data);
	      return React.createElement(DataItem, {
	        key: key,
	        name: name,
	        path: this.props.path.concat([name]),
	        startOpen: this.props.startOpen,
	        inspect: this.props.inspect,
	        showMenu: this.props.showMenu,
	        readOnly: this.props.readOnly,
	        value: data[name] });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var theme = this.context.theme;
	
	      var data = this.props.data;
	      if (!data) {
	        return React.createElement(
	          'div',
	          { style: missingStyle(theme) },
	          'null'
	        );
	      }
	
	      var isArray = Array.isArray(data);
	      var elements = [];
	      if (isArray) {
	        // Iterate over array, filling holes with special items
	        var lastIndex = -1;
	        data.forEach(function (item, i) {
	          if (lastIndex < i - 1) {
	            // Have we skipped over a hole?
	            var holeCount = i - 1 - lastIndex;
	            elements.push(_this2.renderSparseArrayHole(holeCount, i + '-hole'));
	          }
	          elements.push(_this2.renderItem(i, i));
	          lastIndex = i;
	        });
	        if (lastIndex < data.length - 1) {
	          // Is there a hole at the end?
	          var holeCount = data.length - 1 - lastIndex;
	          elements.push(this.renderSparseArrayHole(holeCount, lastIndex + '-hole'));
	        }
	      } else {
	        // Iterate over a regular object
	        var names = Object.keys(data);
	        if (!this.props.noSort) {
	          names.sort(alphanumericSort);
	        }
	        names.forEach(function (name, i) {
	          elements.push(_this2.renderItem(name, name));
	        });
	      }
	
	      if (!elements.length) {
	        return React.createElement(
	          'div',
	          { style: emptyStyle(theme) },
	          isArray ? 'Empty array' : 'Empty object'
	        );
	      }
	
	      return React.createElement(
	        'ul',
	        { style: styles.container },
	        data[consts.proto] && React.createElement(DataItem, {
	          key: '__proto__',
	          name: '__proto__',
	          path: this.props.path.concat(['__proto__']),
	          startOpen: this.props.startOpen,
	          inspect: this.props.inspect,
	          showMenu: this.props.showMenu,
	          readOnly: this.props.readOnly,
	          value: data[consts.proto]
	        }),
	        elements
	      );
	    }
	  }]);
	
	  return DataView;
	}(React.Component);
	
	DataView.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	var DataItem = function (_React$Component2) {
	  _inherits(DataItem, _React$Component2);
	
	  function DataItem(props) {
	    _classCallCheck(this, DataItem);
	
	    var _this3 = _possibleConstructorReturn(this, (DataItem.__proto__ || Object.getPrototypeOf(DataItem)).call(this, props));
	
	    _this3.state = { open: !!_this3.props.startOpen, loading: false };
	    return _this3;
	  }
	
	  _createClass(DataItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.open && this.props.value && this.props.value[consts.inspected] === false) {
	        this.inspect();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open && nextProps.value && nextProps.value[consts.inspected] === false) {
	        this.inspect();
	      }
	    }
	  }, {
	    key: 'inspect',
	    value: function inspect() {
	      var _this4 = this;
	
	      this.setState({ loading: true, open: true });
	      this.props.inspect(this.props.path, function () {
	        _this4.setState({ loading: false });
	      });
	    }
	  }, {
	    key: 'toggleOpen',
	    value: function toggleOpen() {
	      if (this.state.loading) {
	        return;
	      }
	      if (this.props.value && this.props.value[consts.inspected] === false) {
	        this.inspect();
	        return;
	      }
	
	      this.setState({
	        open: !this.state.open
	      });
	    }
	  }, {
	    key: 'toggleBooleanValue',
	    value: function toggleBooleanValue(e) {
	      this.context.onChange(this.props.path, e.target.checked);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var theme = this.context.theme;
	
	      var data = this.props.value;
	      var otype = typeof data === 'undefined' ? 'undefined' : _typeof(data);
	      var complex = true;
	      var preview;
	      if (otype === 'number' || otype === 'string' || data == null /* null or undefined */ || otype === 'boolean') {
	        preview = React.createElement(Simple, {
	          readOnly: this.props.readOnly,
	          path: this.props.path,
	          data: data
	        });
	        complex = false;
	      } else {
	        preview = previewComplex(data, theme);
	      }
	
	      var inspectable = !data || !data[consts.meta] || !data[consts.meta].uninspectable;
	      var open = inspectable && this.state.open && (!data || data[consts.inspected] !== false);
	      var opener = null;
	
	      if (complex && inspectable) {
	        opener = React.createElement(
	          'div',
	          {
	            onClick: this.toggleOpen.bind(this),
	            style: styles.opener },
	          open ? React.createElement('span', { style: expandedArrowStyle(theme) }) : React.createElement('span', { style: collapsedArrowStyle(theme) })
	        );
	      } else if (otype === 'boolean' && !this.props.readOnly) {
	        opener = React.createElement('input', {
	          checked: data,
	          onChange: this.toggleBooleanValue.bind(this),
	          style: styles.toggler,
	          type: 'checkbox'
	        });
	      }
	
	      var children = null;
	      if (complex && open) {
	        var readOnly = this.props.readOnly || data[consts.meta] && data[consts.meta].readOnly;
	        // TODO path
	        children = React.createElement(
	          'div',
	          { style: styles.children },
	          React.createElement(DataView, {
	            data: data,
	            path: this.props.path,
	            inspect: this.props.inspect,
	            showMenu: this.props.showMenu,
	            readOnly: readOnly
	          })
	        );
	      }
	
	      var name = this.props.name;
	      if (name.length > 50) {
	        name = name.slice(0, 50) + '…';
	      }
	
	      return React.createElement(
	        'li',
	        null,
	        React.createElement(
	          'div',
	          { style: styles.head },
	          opener,
	          React.createElement(
	            'div',
	            {
	              style: nameStyle(complex, theme),
	              onClick: inspectable && this.toggleOpen.bind(this)
	            },
	            name,
	            ':'
	          ),
	          React.createElement(
	            'div',
	            {
	              onContextMenu: function onContextMenu(e) {
	                if (typeof _this5.props.showMenu === 'function') {
	                  _this5.props.showMenu(e, _this5.props.value, _this5.props.path, name);
	                }
	              },
	              style: previewStyle(theme)
	            },
	            preview
	          )
	        ),
	        children
	      );
	    }
	  }]);
	
	  return DataItem;
	}(React.Component);
	
	DataItem.contextTypes = {
	  onChange: PropTypes.func,
	  theme: PropTypes.object.isRequired
	};
	
	function alphanumericSort(a, b) {
	  if ('' + +a === a) {
	    if ('' + +b !== b) {
	      return -1;
	    }
	    return +a < +b ? -1 : 1;
	  }
	  return a < b ? -1 : 1;
	}
	
	var nameStyle = function nameStyle(isComplex, theme) {
	  return {
	    cursor: isComplex ? 'pointer' : 'default',
	    color: theme.special03,
	    margin: '0 0.25rem'
	  };
	};
	
	var previewStyle = function previewStyle(theme) {
	  return {
	    display: 'flex',
	    whiteSpace: 'pre',
	    wordBreak: 'break-word',
	    flex: 1,
	    color: theme.special01
	  };
	};
	
	var emptyStyle = function emptyStyle(theme) {
	  return {
	    lineHeight: '1.25rem',
	    color: theme.base04,
	    paddingLeft: '1rem'
	  };
	};
	
	var missingStyle = function missingStyle(theme) {
	  return {
	    fontWeight: 'bold',
	    lineHeight: '1.25rem',
	    color: theme.base03,
	    paddingLeft: '1rem'
	  };
	};
	
	var collapsedArrowStyle = function collapsedArrowStyle(theme) {
	  return {
	    borderColor: 'transparent transparent transparent ' + theme.base03,
	    borderStyle: 'solid',
	    borderWidth: '4px 0 4px 6px',
	    display: 'inline-block',
	    verticalAlign: 'middle'
	  };
	};
	
	var expandedArrowStyle = function expandedArrowStyle(theme) {
	  return {
	    borderColor: theme.base03 + ' transparent transparent transparent',
	    borderStyle: 'solid',
	    borderWidth: '6px 4px 0 4px',
	    display: 'inline-block',
	    verticalAlign: 'middle'
	  };
	};
	
	var sparseArrayHoleStyle = function sparseArrayHoleStyle(theme) {
	  return {
	    fontStyle: 'italic',
	    color: theme.base03,
	    margin: '2px 3px'
	  };
	};
	
	var styles = {
	  container: {
	    listStyle: 'none',
	    margin: 0,
	    padding: 0,
	    marginLeft: '0.75rem'
	  },
	
	  children: {},
	
	  opener: {
	    cursor: 'pointer',
	    marginLeft: -10,
	    position: 'absolute'
	  },
	
	  toggler: {
	    left: -15,
	    position: 'absolute',
	    top: -1
	  },
	
	  head: {
	    display: 'flex',
	    position: 'relative',
	    lineHeight: '1.25rem'
	  },
	
	  value: {}
	};
	
	module.exports = DataView;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(26);
	
	var Input = __webpack_require__(23);
	var flash = __webpack_require__(31);
	
	var _require = __webpack_require__(17),
	    monospace = _require.monospace;
	
	var Simple = function (_React$Component) {
	  _inherits(Simple, _React$Component);
	
	  function Simple(props) {
	    _classCallCheck(this, Simple);
	
	    var _this = _possibleConstructorReturn(this, (Simple.__proto__ || Object.getPrototypeOf(Simple)).call(this, props));
	
	    _this.state = {
	      text: '',
	      editing: false
	    };
	    return _this;
	  }
	
	  _createClass(Simple, [{
	    key: 'onChange',
	    value: function onChange(e) {
	      this.setState({
	        text: e.target.value
	      });
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e) {
	      if (e.key === 'Enter') {
	        this.onSubmit(true);
	        this.setState({
	          editing: false
	        });
	      }
	      if (e.key === 'Escape') {
	        this.setState({
	          editing: false
	        });
	      }
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(editing) {
	      if (this.state.text === valueToText(this.props.data)) {
	        this.setState({
	          editing: editing
	        });
	        return;
	      }
	      var value = textToValue(this.state.text);
	      if (value === BAD_INPUT) {
	        this.setState({
	          text: valueToText(this.props.data),
	          editing: editing
	        });
	        return;
	      }
	      this.context.onChange(this.props.path, value);
	      this.setState({
	        editing: editing
	      });
	    }
	  }, {
	    key: 'startEditing',
	    value: function startEditing() {
	      if (this.props.readOnly) {
	        return;
	      }
	      this.setState({
	        editing: true,
	        text: valueToText(this.props.data)
	      });
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll() {
	      var input = this.input;
	      input.selectionStart = 0;
	      input.selectionEnd = input.value.length;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.state.editing && !prevState.editing) {
	        this.selectAll();
	      }
	      if (!this.state.editing && this.props.data !== prevProps.data) {
	        // $FlowFixMe replace with root ref
	        flash(ReactDOM.findDOMNode(this), this.context.theme.state04, 'transparent', 1);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var theme = this.context.theme;
	      var readOnly = this.props.readOnly;
	      var _state = this.state,
	          editing = _state.editing,
	          text = _state.text;
	
	
	      if (editing) {
	        return React.createElement(Input, {
	          autoFocus: true,
	          innerRef: function innerRef(i) {
	            return _this2.input = i;
	          },
	          style: inputStyle(theme),
	          onChange: function onChange(e) {
	            return _this2.onChange(e);
	          },
	          onBlur: function onBlur() {
	            return _this2.onSubmit(false);
	          },
	          onKeyDown: this.onKeyDown.bind(this),
	          value: text
	        });
	      }
	
	      var data = this.props.data;
	
	      if (typeof data === 'string' && data.length > 200) {
	        data = data.slice(0, 200) + '…';
	      }
	
	      return React.createElement(
	        'div',
	        {
	          onClick: this.startEditing.bind(this),
	          style: simpleStyle(readOnly, theme)
	        },
	        valueToText(data)
	      );
	    }
	  }]);
	
	  return Simple;
	}(React.Component);
	
	Simple.propTypes = {
	  data: PropTypes.any,
	  path: PropTypes.array,
	  readOnly: PropTypes.bool
	};
	
	Simple.contextTypes = {
	  onChange: PropTypes.func,
	  theme: PropTypes.object.isRequired
	};
	
	var inputStyle = function inputStyle(theme) {
	  return {
	    flex: 1,
	    minWidth: 50,
	    boxSizing: 'border-box',
	    border: 'none',
	    padding: 0,
	    outline: 'none',
	    boxShadow: '0 0 3px ' + theme.base02,
	    fontFamily: monospace.family,
	    fontSize: 'inherit'
	  };
	};
	
	var simpleStyle = function simpleStyle(readOnly, theme) {
	  return {
	    display: 'flex',
	    flex: 1,
	    whiteSpace: 'pre-wrap',
	    cursor: readOnly ? 'default' : 'pointer'
	  };
	};
	
	var BAD_INPUT = Symbol('bad input');
	
	function textToValue(txt) {
	  if (!txt.length) {
	    return BAD_INPUT;
	  }
	  if (txt === 'undefined') {
	    return undefined;
	  }
	  try {
	    return JSON.parse(txt);
	  } catch (e) {
	    return BAD_INPUT;
	  }
	}
	
	function valueToText(value) {
	  if (value === undefined) {
	    return 'undefined';
	  } else if (typeof value === 'number') {
	    return value.toString();
	  }
	  return JSON.stringify(value);
	}
	
	module.exports = Simple;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(27);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.5.2
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(11),n=__webpack_require__(28),ba=__webpack_require__(29);function ca(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var k=[c,d,e,f,g,h],l=0;a=Error(b.replace(/%s/g,function(){return k[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function t(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:t("227");function da(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}
	var ea=!1,fa=null,ha=!1,ia=null,ja={onError:function(a){ea=!0;fa=a}};function ka(a,b,c,d,e,f,g,h,k){ea=!1;fa=null;da.apply(ja,arguments)}function la(a,b,c,d,e,f,g,h,k){ka.apply(this,arguments);if(ea){if(ea){var l=fa;ea=!1;fa=null}else t("198"),l=void 0;ha||(ha=!0,ia=l)}}var ma=null,na={};
	function oa(){if(ma)for(var a in na){var b=na[a],c=ma.indexOf(a);-1<c?void 0:t("96",a);if(!pa[c]){b.extractEvents?void 0:t("97",a);pa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.hasOwnProperty(h)?t("99",h):void 0;qa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:t("98",d,a)}}}}
	function ra(a,b,c){sa[a]?t("100",a):void 0;sa[a]=b;ta[a]=b.eventTypes[c].dependencies}var pa=[],qa={},sa={},ta={},ua=null,va=null,wa=null;function xa(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=wa(d);la(b,c,void 0,a);a.currentTarget=null}function ya(a,b){null==b?t("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function za(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Aa=null;function Ba(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)xa(a,b,c[e],d[e]);else c&&xa(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ca(a){return Ba(a,!0)}function Da(a){return Ba(a,!1)}
	var Ea={injectEventPluginOrder:function(a){ma?t("101"):void 0;ma=Array.prototype.slice.call(a);oa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];na.hasOwnProperty(c)&&na[c]===d||(na[c]?t("102",c):void 0,na[c]=d,b=!0)}b&&oa()}};
	function Fa(a,b){var c=a.stateNode;if(!c)return null;var d=ua(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?t("231",b,typeof c):void 0;
	return c}function Ga(a,b){null!==a&&(Aa=ya(Aa,a));a=Aa;Aa=null;if(a&&(b?za(a,Ca):za(a,Da),Aa?t("95"):void 0,ha))throw b=ia,ha=!1,ia=null,b;}var Ha=Math.random().toString(36).slice(2),Ia="__reactInternalInstance$"+Ha,Ja="__reactEventHandlers$"+Ha;function Ka(a){if(a[Ia])return a[Ia];for(;!a[Ia];)if(a.parentNode)a=a.parentNode;else return null;a=a[Ia];return 7===a.tag||8===a.tag?a:null}function La(a){a=a[Ia];return!a||7!==a.tag&&8!==a.tag?null:a}
	function Ma(a){if(7===a.tag||8===a.tag)return a.stateNode;t("33")}function Na(a){return a[Ja]||null}function Oa(a){do a=a.return;while(a&&7!==a.tag);return a?a:null}function Pa(a,b,c){if(b=Fa(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a)}
	function Qa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Oa(b);for(b=c.length;0<b--;)Pa(c[b],"captured",a);for(b=0;b<c.length;b++)Pa(c[b],"bubbled",a)}}function Ra(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Fa(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a))}function Ta(a){a&&a.dispatchConfig.registrationName&&Ra(a._targetInst,null,a)}
	function Ua(a){za(a,Qa)}var Va=!("undefined"===typeof window||!window.document||!window.document.createElement);function Wa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ya={animationend:Wa("Animation","AnimationEnd"),animationiteration:Wa("Animation","AnimationIteration"),animationstart:Wa("Animation","AnimationStart"),transitionend:Wa("Transition","TransitionEnd")},Za={},$a={};
	Va&&($a=document.createElement("div").style,"AnimationEvent"in window||(delete Ya.animationend.animation,delete Ya.animationiteration.animation,delete Ya.animationstart.animation),"TransitionEvent"in window||delete Ya.transitionend.transition);function ab(a){if(Za[a])return Za[a];if(!Ya[a])return a;var b=Ya[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in $a)return Za[a]=b[c];return a}
	var bb=ab("animationend"),cb=ab("animationiteration"),db=ab("animationstart"),eb=ab("transitionend"),fb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),gb=null,hb=null,ib=null;
	function jb(){if(ib)return ib;var a,b=hb,c=b.length,d,e="value"in gb?gb.value:gb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return ib=e.slice(a,1<d?1-d:void 0)}function kb(){return!0}function lb(){return!1}
	function z(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?kb:lb;this.isPropagationStopped=lb;return this}
	n(z.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=kb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=kb)},persist:function(){this.isPersistent=kb},isPersistent:lb,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=lb;this._dispatchInstances=this._dispatchListeners=null}});z.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	z.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;mb(c);return c};mb(z);function nb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function ob(a){a instanceof this?void 0:t("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
	function mb(a){a.eventPool=[];a.getPooled=nb;a.release=ob}var pb=z.extend({data:null}),qb=z.extend({data:null}),rb=[9,13,27,32],sb=Va&&"CompositionEvent"in window,tb=null;Va&&"documentMode"in document&&(tb=document.documentMode);
	var ub=Va&&"TextEvent"in window&&!tb,vb=Va&&(!sb||tb&&8<tb&&11>=tb),wb=String.fromCharCode(32),xb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},yb=!1;
	function zb(a,b){switch(a){case "keyup":return-1!==rb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Ab(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Bb=!1;function Cb(a,b){switch(a){case "compositionend":return Ab(b);case "keypress":if(32!==b.which)return null;yb=!0;return wb;case "textInput":return a=b.data,a===wb&&yb?null:a;default:return null}}
	function Db(a,b){if(Bb)return"compositionend"===a||!sb&&zb(a,b)?(a=jb(),ib=hb=gb=null,Bb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return vb&&"ko"!==b.locale?null:b.data;default:return null}}
	var Eb={eventTypes:xb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(sb)b:{switch(a){case "compositionstart":e=xb.compositionStart;break b;case "compositionend":e=xb.compositionEnd;break b;case "compositionupdate":e=xb.compositionUpdate;break b}e=void 0}else Bb?zb(a,c)&&(e=xb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=xb.compositionStart);e?(vb&&"ko"!==c.locale&&(Bb||e!==xb.compositionStart?e===xb.compositionEnd&&Bb&&(f=jb()):(gb=d,hb="value"in gb?gb.value:gb.textContent,Bb=
	!0)),e=pb.getPooled(e,b,c,d),f?e.data=f:(f=Ab(c),null!==f&&(e.data=f)),Ua(e),f=e):f=null;(a=ub?Cb(a,c):Db(a,c))?(b=qb.getPooled(xb.beforeInput,b,c,d),b.data=a,Ua(b)):b=null;return null===f?b:null===b?f:[f,b]}},Fb=null,Gb=null,Hb=null;function Ib(a){if(a=va(a)){"function"!==typeof Fb?t("280"):void 0;var b=ua(a.stateNode);Fb(a.stateNode,a.type,b)}}function Jb(a){Gb?Hb?Hb.push(a):Hb=[a]:Gb=a}function Kb(){if(Gb){var a=Gb,b=Hb;Hb=Gb=null;Ib(a);if(b)for(a=0;a<b.length;a++)Ib(b[a])}}
	function Lb(a,b){return a(b)}function Mb(a,b,c){return a(b,c)}function Nb(){}var Ob=!1;function Pb(a,b){if(Ob)return a(b);Ob=!0;try{return Lb(a,b)}finally{if(Ob=!1,null!==Gb||null!==Hb)Nb(),Kb()}}var Qb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Rb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Qb[a.type]:"textarea"===b?!0:!1}
	function Sb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Tb(a){if(!Va)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Ub(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Vb(a){var b=Ub(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Wb(a){a._valueTracker||(a._valueTracker=Vb(a))}function Xb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ub(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
	var Yb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Zb=/^(.*)[\\\/]/,C="function"===typeof Symbol&&Symbol.for,$b=C?Symbol.for("react.element"):60103,ac=C?Symbol.for("react.portal"):60106,bc=C?Symbol.for("react.fragment"):60107,cc=C?Symbol.for("react.strict_mode"):60108,dc=C?Symbol.for("react.profiler"):60114,ec=C?Symbol.for("react.provider"):60109,fc=C?Symbol.for("react.context"):60110,gc=C?Symbol.for("react.async_mode"):60111,hc=C?Symbol.for("react.forward_ref"):60112,ic=C?Symbol.for("react.placeholder"):
	60113,jc="function"===typeof Symbol&&Symbol.iterator;function kc(a){if(null===a||"object"!==typeof a)return null;a=jc&&a[jc]||a["@@iterator"];return"function"===typeof a?a:null}
	function lc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case gc:return"AsyncMode";case bc:return"Fragment";case ac:return"Portal";case dc:return"Profiler";case cc:return"StrictMode";case ic:return"Placeholder"}if("object"===typeof a){switch(a.$$typeof){case fc:return"Context.Consumer";case ec:return"Context.Provider";case hc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef")}if("function"===typeof a.then&&(a=1===a._reactStatus?a._reactResult:null))return lc(a)}return null}function mc(a){var b="";do{a:switch(a.tag){case 4:case 0:case 1:case 2:case 3:case 7:case 10:var c=a._debugOwner,d=a._debugSource,e=lc(a.type);var f=null;c&&(f=lc(c.type));c=e;e="";d?e=" (at "+d.fileName.replace(Zb,"")+":"+d.lineNumber+")":f&&(e=" (created by "+f+")");f="\n    in "+(c||"Unknown")+e;break a;default:f=""}b+=f;a=a.return}while(a);return b}
	var nc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pc=Object.prototype.hasOwnProperty,qc={},rc={};
	function sc(a){if(pc.call(rc,a))return!0;if(pc.call(qc,a))return!1;if(nc.test(a))return rc[a]=!0;qc[a]=!0;return!1}function tc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function uc(a,b,c,d){if(null===b||"undefined"===typeof b||tc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function D(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var E={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){E[a]=new D(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];E[b]=new D(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){E[a]=new D(a,2,!1,a.toLowerCase(),null)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){E[a]=new D(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){E[a]=new D(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){E[a]=new D(a,3,!0,a,null)});
	["capture","download"].forEach(function(a){E[a]=new D(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){E[a]=new D(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){E[a]=new D(a,5,!1,a.toLowerCase(),null)});var vc=/[\-:]([a-z])/g;function wc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(vc,
	wc);E[b]=new D(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(vc,wc);E[b]=new D(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(vc,wc);E[b]=new D(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});E.tabIndex=new D("tabIndex",1,!1,"tabindex",null);
	function xc(a,b,c,d){var e=E.hasOwnProperty(b)?E[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(uc(b,c,e,d)&&(c=null),d||null===e?sc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function yc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function zc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Bc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=yc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cc(a,b){b=b.checked;null!=b&&xc(a,"checked",b,!1)}
	function Dc(a,b){Cc(a,b);var c=yc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Ec(a,b.type,c):b.hasOwnProperty("defaultValue")&&Ec(a,b.type,yc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Fc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Ec(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Gc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Hc(a,b,c){a=z.getPooled(Gc.change,a,b,c);a.type="change";Jb(c);Ua(a);return a}var Ic=null,Jc=null;function Kc(a){Ga(a,!1)}
	function Lc(a){var b=Ma(a);if(Xb(b))return a}function Mc(a,b){if("change"===a)return b}var Nc=!1;Va&&(Nc=Tb("input")&&(!document.documentMode||9<document.documentMode));function Oc(){Ic&&(Ic.detachEvent("onpropertychange",Pc),Jc=Ic=null)}function Pc(a){"value"===a.propertyName&&Lc(Jc)&&(a=Hc(Jc,a,Sb(a)),Pb(Kc,a))}function Qc(a,b,c){"focus"===a?(Oc(),Ic=b,Jc=c,Ic.attachEvent("onpropertychange",Pc)):"blur"===a&&Oc()}function Rc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Lc(Jc)}
	function Sc(a,b){if("click"===a)return Lc(b)}function Tc(a,b){if("input"===a||"change"===a)return Lc(b)}
	var Uc={eventTypes:Gc,_isInputEventSupported:Nc,extractEvents:function(a,b,c,d){var e=b?Ma(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Mc:Rb(e)?Nc?f=Tc:(f=Rc,g=Qc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Sc);if(f&&(f=f(a,b)))return Hc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Ec(e,"number",e.value)}},Vc=z.extend({view:null,detail:null}),Wc={Alt:"altKey",
	Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Xc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Wc[a])?!!b[a]:!1}function Yc(){return Xc}
	var Zc=0,$c=0,ad=!1,bd=!1,cd=Vc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Yc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Zc;Zc=a.screenX;return ad?"mousemove"===a.type?a.screenX-b:0:(ad=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=$c;$c=a.screenY;return bd?"mousemove"===a.type?a.screenY-b:0:(bd=!0,0)}}),dd=cd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),ed={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},fd={eventTypes:ed,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ka(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)g=cd,h=ed.mouseLeave,k=ed.mouseEnter,l="mouse";
	else if("pointerout"===a||"pointerover"===a)g=dd,h=ed.pointerLeave,k=ed.pointerEnter,l="pointer";var m=null==f?e:Ma(f);e=null==b?e:Ma(b);a=g.getPooled(h,f,c,d);a.type=l+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;l=0;for(g=b;g;g=Oa(g))l++;g=0;for(k=e;k;k=Oa(k))g++;for(;0<l-g;)b=Oa(b),l--;for(;0<g-l;)e=Oa(e),g--;for(;l--;){if(b===e||b===e.alternate)break a;b=Oa(b);e=Oa(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
	f.alternate;if(null!==l&&l===e)break;b.push(f);f=Oa(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=Oa(d)}for(d=0;d<b.length;d++)Ra(b[d],"bubbled",a);for(d=f.length;0<d--;)Ra(f[d],"captured",c);return[a,c]}},gd=Object.prototype.hasOwnProperty;function hd(a,b){return a===b?0!==a||0!==b||1/a===1/b:a!==a&&b!==b}
	function id(a,b){if(hd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!gd.call(b,c[d])||!hd(a[c[d]],b[c[d]]))return!1;return!0}function jd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 5===b.tag?2:3}function kd(a){2!==jd(a)?t("188"):void 0}
	function ld(a){var b=a.alternate;if(!b)return b=jd(a),3===b?t("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return kd(e),a;if(g===d)return kd(e),b;g=g.sibling}t("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:t("189")}}c.alternate!==d?t("190"):void 0}5!==c.tag?t("188"):void 0;return c.stateNode.current===c?a:b}function md(a){a=ld(a);if(!a)return null;for(var b=a;;){if(7===b.tag||8===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var nd=z.extend({animationName:null,elapsedTime:null,pseudoElement:null}),od=z.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),pd=Vc.extend({relatedTarget:null});function qd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var rd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},sd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},td=Vc.extend({key:function(a){if(a.key){var b=rd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=qd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?sd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Yc,charCode:function(a){return"keypress"===
	a.type?qd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?qd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),ud=cd.extend({dataTransfer:null}),vd=Vc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Yc}),wd=z.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),xd=cd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),yd=[["abort","abort"],[bb,"animationEnd"],[cb,"animationIteration"],[db,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
	["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
	["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[eb,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],zd={},Ad={};function Bd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};zd[a]=b;Ad[c]=b}
	[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
	["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Bd(a,!0)});yd.forEach(function(a){Bd(a,!1)});
	var Cd={eventTypes:zd,isInteractiveTopLevelEventType:function(a){a=Ad[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Ad[a];if(!e)return null;switch(a){case "keypress":if(0===qd(c))return null;case "keydown":case "keyup":a=td;break;case "blur":case "focus":a=pd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=cd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	ud;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=vd;break;case bb:case cb:case db:a=nd;break;case eb:a=wd;break;case "scroll":a=Vc;break;case "wheel":a=xd;break;case "copy":case "cut":case "paste":a=od;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=dd;break;default:a=z}b=a.getPooled(e,b,c,d);Ua(b);return b}},Dd=Cd.isInteractiveTopLevelEventType,
	Ed=[];function Fd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=5!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ka(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Sb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<pa.length;h++){var k=pa[h];k&&(k=k.extractEvents(d,b,f,e))&&(g=ya(g,k))}Ga(g,!1)}}var Gd=!0;
	function F(a,b){if(!b)return null;var c=(Dd(a)?Hd:Id).bind(null,a);b.addEventListener(a,c,!1)}function Jd(a,b){if(!b)return null;var c=(Dd(a)?Hd:Id).bind(null,a);b.addEventListener(a,c,!0)}function Hd(a,b){Mb(Id,a,b)}
	function Id(a,b){if(Gd){var c=Sb(b);c=Ka(c);null===c||"number"!==typeof c.tag||2===jd(c)||(c=null);if(Ed.length){var d=Ed.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Pb(Fd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Ed.length&&Ed.push(a)}}}var Kd={},Ld=0,Md="_reactListenersID"+(""+Math.random()).slice(2);
	function Nd(a){Object.prototype.hasOwnProperty.call(a,Md)||(a[Md]=Ld++,Kd[a[Md]]={});return Kd[a[Md]]}function Od(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Qd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Rd(a,b){var c=Qd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Qd(c)}}function Sd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Sd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function Td(){for(var a=window,b=Od();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=Od(a.document)}return b}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	var Vd=Va&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
	function ae(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if($d||null==Xd||Xd!==Od(c))return null;c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Zd&&id(Zd,c)?null:(Zd=c,a=z.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ua(a),a)}
	var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Nd(e);f=ta.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ma(b):window;switch(a){case "focus":if(Rb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":case "dragend":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
	case "keydown":case "keyup":return ae(c,d)}return null}};Ea.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ua=Na;va=La;wa=Ma;Ea.injectEventPluginsByName({SimpleEventPlugin:Cd,EnterLeaveEventPlugin:fd,ChangeEventPlugin:Uc,SelectEventPlugin:be,BeforeInputEventPlugin:Eb});function ce(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
	function de(a,b){a=n({children:void 0},b);if(b=ce(b.children))a.children=b;return a}function ee(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+yc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function fe(a,b){null!=b.dangerouslySetInnerHTML?t("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ge(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?t("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:t("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:yc(c)}}
	function he(a,b){var c=yc(b.value),d=yc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ie(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var je={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function ke(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function le(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ke(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var me=void 0,ne=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==je.svg||"innerHTML"in a)a.innerHTML=b;else{me=me||document.createElement("div");me.innerHTML="<svg>"+b+"</svg>";for(b=me.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function oe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var pe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},qe=["Webkit","ms","Moz","O"];Object.keys(pe).forEach(function(a){qe.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);pe[b]=pe[a]})});
	function re(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||pe.hasOwnProperty(e)&&pe[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var se=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function te(a,b){b&&(se[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?t("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?t("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:t("61")),null!=b.style&&"object"!==typeof b.style?t("62",""):void 0)}
	function ue(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
	function ve(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Nd(a);b=ta[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Jd("scroll",a);break;case "focus":case "blur":Jd("focus",a);Jd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Tb(e)&&Jd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===fb.indexOf(e)&&F(e,a)}c[e]=!0}}}function we(){}var xe=null,ye=null;
	function ze(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ae(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}function Be(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}
	function Ce(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var De=[],Ee=-1;function G(a){0>Ee||(a.current=De[Ee],De[Ee]=null,Ee--)}function H(a,b){Ee++;De[Ee]=a.current;a.current=b}var Fe={},I={current:Fe},J={current:!1},Ge=Fe;
	function He(a,b){var c=a.type.contextTypes;if(!c)return Fe;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function K(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ie(a){G(J,a);G(I,a)}function Je(a){G(J,a);G(I,a)}
	function Ke(a,b,c){I.current!==Fe?t("168"):void 0;H(I,b,a);H(J,c,a)}function Le(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:t("108",lc(b)||"Unknown",e);return n({},c,d)}function Me(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Fe;Ge=I.current;H(I,b,a);H(J,J.current,a);return!0}
	function Ne(a,b,c){var d=a.stateNode;d?void 0:t("169");c?(b=Le(a,b,Ge),d.__reactInternalMemoizedMergedChildContext=b,G(J,a),G(I,a),H(I,b,a)):G(J,a);H(J,c,a)}var Oe=null,Pe=null;function Qe(a){return function(b){try{return a(b)}catch(c){}}}
	function Re(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Oe=Qe(function(a){return b.onCommitFiberRoot(c,a)});Pe=Qe(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
	function Se(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.firstContextDependency=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Te(a){a=a.prototype;return!(!a||!a.isReactComponent)}
	function Ue(a,b,c){var d=a.alternate;null===d?(d=new Se(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.childExpirationTime=a.childExpirationTime;d.expirationTime=b!==a.pendingProps?c:a.expirationTime;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.firstContextDependency=a.firstContextDependency;d.sibling=a.sibling;
	d.index=a.index;d.ref=a.ref;return d}
	function Ve(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=Te(d)?2:4;else if("string"===typeof d)f=7;else a:switch(d){case bc:return We(a.children,b,c,e);case gc:f=10;b|=3;break;case cc:f=10;b|=2;break;case dc:return d=new Se(15,a,e,b|4),d.type=dc,d.expirationTime=c,d;case ic:f=16;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case ec:f=12;break a;case fc:f=11;break a;case hc:f=13;break a;default:if("function"===typeof d.then){f=4;break a}}t("130",
	null==d?d:typeof d,"")}b=new Se(f,a,e,b);b.type=d;b.expirationTime=c;return b}function We(a,b,c,d){a=new Se(9,a,d,b);a.expirationTime=c;return a}function Xe(a,b,c){a=new Se(8,a,null,b);a.expirationTime=c;return a}function Ye(a,b,c){b=new Se(6,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function Ze(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c>b?a.earliestPendingTime=b:a.latestPendingTime<b&&(a.latestPendingTime=b);$e(b,a)}function $e(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d>a)&&(e=d);a=e;0!==a&&0!==c&&c<a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}var af=!1;
	function bf(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function cf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function df(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function ef(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function ff(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bf(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bf(a.memoizedState),e=c.updateQueue=bf(c.memoizedState)):d=a.updateQueue=cf(e):null===e&&(e=c.updateQueue=cf(d));null===e||d===e?ef(d,b):null===d.lastUpdate||null===e.lastUpdate?(ef(d,b),ef(e,b)):(ef(d,b),e.lastUpdate=b)}
	function gf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bf(a.memoizedState):hf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function hf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=cf(b));return b}
	function jf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:af=!0}return d}
	function kf(a,b,c,d,e){af=!1;b=hf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;if(m>e){if(null===g&&(g=k,f=l),0===h||h>m)h=m}else l=jf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var r=k.expirationTime;if(r>e){if(null===m&&(m=k,null===g&&(f=l)),0===h||h>r)h=r}else l=jf(a,b,k,l,c,d),
	null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=l}
	function lf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);mf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;mf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function mf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?t("191",c):void 0;c.call(d)}a=a.nextEffect}}
	function nf(a,b){return{value:a,source:b,stack:mc(b)}}var of={current:null},pf=null,qf=null,rf=null;function sf(a,b){var c=a.type._context;H(of,c._currentValue,a);c._currentValue=b}function tf(a){var b=of.current;G(of,a);a.type._context._currentValue=b}function uf(a){pf=a;rf=qf=null;a.firstContextDependency=null}
	function vf(a,b){if(rf!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)rf=a,b=1073741823;b={context:a,observedBits:b,next:null};null===qf?(null===pf?t("277"):void 0,pf.firstContextDependency=qf=b):qf=qf.next=b}return a._currentValue}var wf={},L={current:wf},xf={current:wf},yf={current:wf};function zf(a){a===wf?t("174"):void 0;return a}
	function Af(a,b){H(yf,b,a);H(xf,a,a);H(L,wf,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:le(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=le(b,c)}G(L,a);H(L,b,a)}function Bf(a){G(L,a);G(xf,a);G(yf,a)}function Cf(a){zf(yf.current);var b=zf(L.current);var c=le(b,a.type);b!==c&&(H(xf,a,a),H(L,c,a))}function Df(a){xf.current===a&&(G(L,a),G(xf,a))}var Ef=(new aa.Component).refs;
	function Ff(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var Jf={isMounted:function(a){return(a=a._reactInternalFiber)?2===jd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gf();d=Hf(d,a);var e=df(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);ff(a,e);If(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gf();d=Hf(d,a);var e=df(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);ff(a,e);If(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gf();c=Hf(c,a);var d=df(c);d.tag=2;void 0!==
	b&&null!==b&&(d.callback=b);ff(a,d);If(a,c)}};function Kf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!id(c,d)||!id(e,f):!0}function Lf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jf.enqueueReplaceState(b,b.state,null)}
	function Mf(a,b,c,d){var e=a.stateNode,f=K(b)?Ge:I.current;e.props=c;e.state=a.memoizedState;e.refs=Ef;e.context=He(a,f);f=a.updateQueue;null!==f&&(kf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Ff(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&
	e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(kf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Nf=Array.isArray;
	function Of(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag&&3!==c.tag?t("110"):void 0,d=c.stateNode);d?void 0:t("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ef&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?t("284"):void 0;c._owner?void 0:t("254",a)}return a}
	function Pf(a,b){"textarea"!==a.type&&t("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function Qf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Ue(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||8!==b.tag)return b=Xe(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Of(a,b,c),d.return=a,d;d=Ve(c,a.mode,d);d.ref=Of(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||6!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
	Ye(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||9!==b.tag)return b=We(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function r(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Xe(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case $b:return c=Ve(b,a.mode,c),c.ref=Of(a,null,b),c.return=a,c;case ac:return b=Ye(b,a.mode,c),b.return=a,b}if(Nf(b)||kc(b))return b=We(b,a.mode,c,null),b.return=
	a,b;Pf(a,b)}return null}function A(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case $b:return c.key===e?c.type===bc?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case ac:return c.key===e?l(a,b,c,d):null}if(Nf(c)||kc(c))return null!==e?null:m(a,b,c,d,null);Pf(a,c)}return null}function S(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
	if("object"===typeof d&&null!==d){switch(d.$$typeof){case $b:return a=a.get(null===d.key?c:d.key)||null,d.type===bc?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case ac:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Nf(d)||kc(d))return a=a.get(c)||null,m(b,a,d,e,null);Pf(b,d)}return null}function B(e,g,h,k){for(var l=null,m=null,p=g,u=g=0,q=null;null!==p&&u<h.length;u++){p.index>u?(q=p,p=null):q=p.sibling;var v=A(e,p,h[u],k);if(null===v){null===p&&(p=q);break}a&&p&&null===v.alternate&&b(e,
	p);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;p=q}if(u===h.length)return c(e,p),l;if(null===p){for(;u<h.length;u++)if(p=r(e,h[u],k))g=f(p,g,u),null===m?l=p:m.sibling=p,m=p;return l}for(p=d(e,p);u<h.length;u++)if(q=S(p,e,u,h[u],k))a&&null!==q.alternate&&p.delete(null===q.key?u:q.key),g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;a&&p.forEach(function(a){return b(e,a)});return l}function P(e,g,h,k){var l=kc(h);"function"!==typeof l?t("150"):void 0;h=l.call(h);null==h?t("151"):void 0;for(var m=l=null,p=g,u=g=
	0,q=null,v=h.next();null!==p&&!v.done;u++,v=h.next()){p.index>u?(q=p,p=null):q=p.sibling;var x=A(e,p,v.value,k);if(null===x){p||(p=q);break}a&&p&&null===x.alternate&&b(e,p);g=f(x,g,u);null===m?l=x:m.sibling=x;m=x;p=q}if(v.done)return c(e,p),l;if(null===p){for(;!v.done;u++,v=h.next())v=r(e,v.value,k),null!==v&&(g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);return l}for(p=d(e,p);!v.done;u++,v=h.next())v=S(p,e,u,v.value,k),null!==v&&(a&&null!==v.alternate&&p.delete(null===v.key?u:v.key),g=f(v,g,u),null===
	m?l=v:m.sibling=v,m=v);a&&p.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===bc&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case $b:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(9===k.tag?f.type===bc:k.type===f.type){c(a,k.sibling);d=e(k,f.type===bc?f.props.children:f.props,h);d.ref=Of(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===bc?(d=We(f.props.children,
	a.mode,h,f.key),d.return=a,a=d):(h=Ve(f,a.mode,h),h.ref=Of(a,d,f),h.return=a,a=h)}return g(a);case ac:a:{for(k=f.key;null!==d;){if(d.key===k)if(6===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ye(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&8===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
	a,a=d):(c(a,d),d=Xe(f,a.mode,h),d.return=a,a=d),g(a);if(Nf(f))return B(a,d,f,h);if(kc(f))return P(a,d,f,h);l&&Pf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 3:case 0:h=a.type,t("152",h.displayName||h.name||"Component")}return c(a,d)}}var Rf=Qf(!0),Sf=Qf(!1),Tf=null,Uf=null,Vf=!1;function Wf(a,b){var c=new Se(7,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Xf(a,b){switch(a.tag){case 7:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 8:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Yf(a){if(Vf){var b=Uf;if(b){var c=b;if(!Xf(a,b)){b=Be(c);if(!b||!Xf(a,b)){a.effectTag|=2;Vf=!1;Tf=a;return}Wf(Tf,c)}Tf=a;Uf=Ce(b)}else a.effectTag|=2,Vf=!1,Tf=a}}
	function Zf(a){for(a=a.return;null!==a&&7!==a.tag&&5!==a.tag;)a=a.return;Tf=a}function $f(a){if(a!==Tf)return!1;if(!Vf)return Zf(a),Vf=!0,!1;var b=a.type;if(7!==a.tag||"head"!==b&&"body"!==b&&!Ae(b,a.memoizedProps))for(b=Uf;b;)Wf(a,b),b=Be(b);Zf(a);Uf=Tf?Be(a.stateNode):null;return!0}function ag(){Uf=Tf=null;Vf=!1}
	function bg(a){switch(a._reactStatus){case 1:return a._reactResult;case 2:throw a._reactResult;case 0:throw a;default:throw a._reactStatus=0,a.then(function(b){if(0===a._reactStatus){a._reactStatus=1;if("object"===typeof b&&null!==b){var c=b.default;b=void 0!==c&&null!==c?c:b}a._reactResult=b}},function(b){0===a._reactStatus&&(a._reactStatus=2,a._reactResult=b)}),a;}}var cg=Yb.ReactCurrentOwner;function M(a,b,c,d){b.child=null===a?Sf(b,null,c,d):Rf(b,a.child,c,d)}
	function dg(a,b,c,d,e){c=c.render;var f=b.ref;if(!J.current&&b.memoizedProps===d&&f===(null!==a?a.ref:null))return eg(a,b,e);c=c(d,f);M(a,b,c,e);b.memoizedProps=d;return b.child}function fg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function gg(a,b,c,d,e){var f=K(c)?Ge:I.current;f=He(b,f);uf(b,e);c=c(d,f);b.effectTag|=1;M(a,b,c,e);b.memoizedProps=d;return b.child}
	function hg(a,b,c,d,e){if(K(c)){var f=!0;Me(b)}else f=!1;uf(b,e);if(null===a)if(null===b.stateNode){var g=K(c)?Ge:I.current,h=c.contextTypes,k=null!==h&&void 0!==h;h=k?He(b,g):Fe;var l=new c(d,h);b.memoizedState=null!==l.state&&void 0!==l.state?l.state:null;l.updater=Jf;b.stateNode=l;l._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=g,k.__reactInternalMemoizedMaskedChildContext=h);Mf(b,c,d,e);d=!0}else{g=b.stateNode;h=b.memoizedProps;g.props=h;var m=g.context;
	k=K(c)?Ge:I.current;k=He(b,k);var r=c.getDerivedStateFromProps;(l="function"===typeof r||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||m!==k)&&Lf(b,g,d,k);af=!1;var A=b.memoizedState;m=g.state=A;var S=b.updateQueue;null!==S&&(kf(b,S,d,g,e),m=b.memoizedState);h!==d||A!==m||J.current||af?("function"===typeof r&&(Ff(b,c,r,d),m=b.memoizedState),(h=af||Kf(b,c,h,d,A,m,k))?(l||"function"!==
	typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=m),g.props=d,g.state=m,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=
	b.memoizedProps,g.props=h,m=g.context,k=K(c)?Ge:I.current,k=He(b,k),r=c.getDerivedStateFromProps,(l="function"===typeof r||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||m!==k)&&Lf(b,g,d,k),af=!1,m=b.memoizedState,A=g.state=m,S=b.updateQueue,null!==S&&(kf(b,S,d,g,e),A=b.memoizedState),h!==d||m!==A||J.current||af?("function"===typeof r&&(Ff(b,c,r,d),A=b.memoizedState),(r=af||Kf(b,c,h,d,
	m,A,k))?(l||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,A,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,A,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&m===a.memoizedState||(b.effectTag|=4),"function"!==
	typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&m===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=A),g.props=d,g.state=A,g.context=k,d=r):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&m===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&m===a.memoizedState||(b.effectTag|=256),d=!1);return ig(a,b,c,d,f,e)}
	function ig(a,b,c,d,e,f){fg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Ne(b,c,!1),eg(a,b,f);d=b.stateNode;cg.current=b;var h=g?null:d.render();b.effectTag|=1;null!==a&&g&&(M(a,b,null,f),b.child=null);M(a,b,h,f);b.memoizedState=d.state;b.memoizedProps=d.props;e&&Ne(b,c,!0);return b.child}function jg(a){var b=a.stateNode;b.pendingContext?Ke(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ke(a,b.context,!1);Af(a,b.containerInfo)}
	function ng(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
	function og(a,b,c,d){null!==a?t("155"):void 0;var e=b.pendingProps;if("object"===typeof c&&null!==c&&"function"===typeof c.then){c=bg(c);var f=c;f="function"===typeof f?Te(f)?3:1:void 0!==f&&null!==f&&f.$$typeof?14:4;f=b.tag=f;var g=ng(c,e);switch(f){case 1:return gg(a,b,c,g,d);case 3:return hg(a,b,c,g,d);case 14:return dg(a,b,c,g,d);default:t("283",c)}}f=He(b,I.current);uf(b,d);f=c(e,f);b.effectTag|=1;if("object"===typeof f&&null!==f&&"function"===typeof f.render&&void 0===f.$$typeof){b.tag=2;K(c)?
	(g=!0,Me(b)):g=!1;b.memoizedState=null!==f.state&&void 0!==f.state?f.state:null;var h=c.getDerivedStateFromProps;"function"===typeof h&&Ff(b,c,h,e);f.updater=Jf;b.stateNode=f;f._reactInternalFiber=b;Mf(b,c,e,d);return ig(a,b,c,!0,g,d)}b.tag=0;M(a,b,f,d);b.memoizedProps=e;return b.child}
	function eg(a,b,c){null!==a&&(b.firstContextDependency=a.firstContextDependency);var d=b.childExpirationTime;if(0===d||d>c)return null;null!==a&&b.child!==a.child?t("153"):void 0;if(null!==b.child){a=b.child;c=Ue(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Ue(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
	function pg(a,b,c){var d=b.expirationTime;if(!J.current&&(0===d||d>c)){switch(b.tag){case 5:jg(b);ag();break;case 7:Cf(b);break;case 2:K(b.type)&&Me(b);break;case 3:K(b.type._reactResult)&&Me(b);break;case 6:Af(b,b.stateNode.containerInfo);break;case 12:sf(b,b.memoizedProps.value)}return eg(a,b,c)}b.expirationTime=0;switch(b.tag){case 4:return og(a,b,b.type,c);case 0:return gg(a,b,b.type,b.pendingProps,c);case 1:var e=b.type._reactResult;d=b.pendingProps;a=gg(a,b,e,ng(e,d),c);b.memoizedProps=d;return a;
	case 2:return hg(a,b,b.type,b.pendingProps,c);case 3:return e=b.type._reactResult,d=b.pendingProps,a=hg(a,b,e,ng(e,d),c),b.memoizedProps=d,a;case 5:jg(b);d=b.updateQueue;null===d?t("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;kf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)ag(),b=eg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)Uf=Ce(b.stateNode.containerInfo),Tf=b,e=Vf=!0;e?(b.effectTag|=2,b.child=Sf(b,null,d,c)):(M(a,b,d,c),ag());b=b.child}return b;
	case 7:Cf(b);null===a&&Yf(b);d=b.type;e=b.pendingProps;var f=null!==a?a.memoizedProps:null,g=e.children;Ae(d,e)?g=null:null!==f&&Ae(d,f)&&(b.effectTag|=16);fg(a,b);1073741823!==c&&b.mode&1&&e.hidden?(b.expirationTime=1073741823,b.memoizedProps=e,b=null):(M(a,b,g,c),b.memoizedProps=e,b=b.child);return b;case 8:return null===a&&Yf(b),b.memoizedProps=b.pendingProps,null;case 16:return null;case 6:return Af(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Rf(b,null,d,c):M(a,b,d,c),b.memoizedProps=
	d,b.child;case 13:return dg(a,b,b.type,b.pendingProps,c);case 14:return e=b.type._reactResult,d=b.pendingProps,a=dg(a,b,e,ng(e,d),c),b.memoizedProps=d,a;case 9:return d=b.pendingProps,M(a,b,d,c),b.memoizedProps=d,b.child;case 10:return d=b.pendingProps.children,M(a,b,d,c),b.memoizedProps=d,b.child;case 15:return d=b.pendingProps,M(a,b,d.children,c),b.memoizedProps=d,b.child;case 12:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;b.memoizedProps=e;sf(b,f);if(null!==g){var h=g.value;
	f=h===f&&(0!==h||1/h===1/f)||h!==h&&f!==f?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!J.current){b=eg(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){h=g.firstContextDependency;if(null!==h){do{if(h.context===d&&0!==(h.observedBits&f)){if(2===g.tag||3===g.tag){var k=df(c);k.tag=2;ff(g,k)}if(0===g.expirationTime||g.expirationTime>c)g.expirationTime=c;k=g.alternate;null!==k&&(0===k.expirationTime||
	k.expirationTime>c)&&(k.expirationTime=c);for(var l=g.return;null!==l;){k=l.alternate;if(0===l.childExpirationTime||l.childExpirationTime>c)l.childExpirationTime=c,null!==k&&(0===k.childExpirationTime||k.childExpirationTime>c)&&(k.childExpirationTime=c);else if(null!==k&&(0===k.childExpirationTime||k.childExpirationTime>c))k.childExpirationTime=c;else break;l=l.return}}k=g.child;h=h.next}while(null!==h)}else k=12===g.tag?g.type===b.type?null:g.child:g.child;if(null!==k)k.return=g;else for(k=g;null!==
	k;){if(k===b){k=null;break}g=k.sibling;if(null!==g){g.return=k.return;k=g;break}k=k.return}g=k}}M(a,b,e.children,c);b=b.child}return b;case 11:return f=b.type,d=b.pendingProps,e=d.children,uf(b,c),f=vf(f,d.unstable_observedBits),e=e(f),b.effectTag|=1,M(a,b,e,c),b.memoizedProps=d,b.child;default:t("156")}}function qg(a){a.effectTag|=4}var rg=void 0,sg=void 0,tg=void 0;rg=function(){};
	sg=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;zf(L.current);a=null;switch(c){case "input":f=zc(g,f);d=zc(g,d);a=[];break;case "option":f=de(g,f);d=de(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=fe(g,f);d=fe(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=we)}te(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
	c){var k=f[c];for(g in k)k.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(sa.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(g in k)!k.hasOwnProperty(g)||l&&l.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in l)l.hasOwnProperty(g)&&k[g]!==l[g]&&(h||
	(h={}),h[g]=l[g])}else h||(a||(a=[]),a.push(c,h)),h=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(sa.hasOwnProperty(c)?(null!=l&&ve(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&qg(b)}};tg=function(a,b,c,d){c!==d&&qg(b)};
	function ug(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=mc(c));null!==c&&lc(c.type);b=b.value;null!==a&&2===a.tag&&lc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function vg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){wg(a,c)}else b.current=null}
	function xg(a){"function"===typeof Pe&&Pe(a);switch(a.tag){case 2:case 3:vg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){wg(a,c)}break;case 7:vg(a);break;case 6:yg(a)}}function zg(a){return 7===a.tag||5===a.tag||6===a.tag}
	function Ag(a){a:{for(var b=a.return;null!==b;){if(zg(b)){var c=b;break a}b=b.return}t("160");c=void 0}var d=b=void 0;switch(c.tag){case 7:b=c.stateNode;d=!1;break;case 5:b=c.stateNode.containerInfo;d=!0;break;case 6:b=c.stateNode.containerInfo;d=!0;break;default:t("161")}c.effectTag&16&&(oe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||zg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;7!==c.tag&&8!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||6===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(7===e.tag||8===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?(h=f.parentNode,h.insertBefore(g,f)):(h=f,h.appendChild(g)),null===h.onclick&&(h.onclick=we)):b.appendChild(e.stateNode);else if(6!==e.tag&&null!==e.child){e.child.return=
	e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function yg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?t("160"):void 0;switch(c.tag){case 7:d=c.stateNode;e=!1;break a;case 5:d=c.stateNode.containerInfo;e=!0;break a;case 6:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(7===b.tag||8===b.tag){a:for(var f=b,g=f;;)if(xg(g),null!==g.child&&6!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
	(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(6===b.tag?(d=b.stateNode.containerInfo,e=!0):xg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;6===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
	function Bg(a,b){switch(b.tag){case 2:case 3:break;case 7:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ja]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cc(c,d);ue(a,e);b=ue(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?re(c,h):"dangerouslySetInnerHTML"===g?ne(c,h):"children"===g?oe(c,h):xc(c,g,h,b)}switch(a){case "input":Dc(c,d);break;case "textarea":he(c,d);break;case "select":a=c._wrapperState.wasMultiple,
	c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?ee(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?ee(c,!!d.multiple,d.defaultValue,!0):ee(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 8:null===b.stateNode?t("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 5:break;case 15:break;case 16:break;default:t("163")}}function Cg(a,b,c){c=df(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Dg(d);ug(a,b)};return c}
	function Eg(a,b,c){c=df(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===Fg?Fg=new Set([this]):Fg.add(this);var c=b.value,d=b.stack;ug(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
	function Gg(a){switch(a.tag){case 2:K(a.type)&&Ie(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return K(a.type._reactResult)&&Ie(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return Bf(a),Je(a),b=a.effectTag,0!==(b&64)?t("285"):void 0,a.effectTag=b&-1025|64,a;case 7:return Df(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 6:return Bf(a),null;case 12:return tf(a),null;default:return null}}
	var Hg={readContext:vf},Ig=Yb.ReactCurrentOwner,Jg=0,Kg=0,Lg=!1,N=null,Mg=null,O=0,Ng=!1,Q=null,Og=!1,Fg=null;function Pg(){if(null!==N)for(var a=N.return;null!==a;){var b=a;switch(b.tag){case 2:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ie(b);break;case 3:c=b.type._reactResult.childContextTypes;null!==c&&void 0!==c&&Ie(b);break;case 5:Bf(b);Je(b);break;case 7:Df(b);break;case 6:Bf(b);break;case 12:tf(b)}a=a.return}Mg=null;O=0;Ng=!1;N=null}
	function Qg(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){var e=b;b=a;var f=b.pendingProps;switch(b.tag){case 0:case 1:break;case 2:K(b.type)&&Ie(b);break;case 3:K(b.type._reactResult)&&Ie(b);break;case 5:Bf(b);Je(b);f=b.stateNode;f.pendingContext&&(f.context=f.pendingContext,f.pendingContext=null);if(null===e||null===e.child)$f(b),b.effectTag&=-3;rg(b);break;case 7:Df(b);var g=zf(yf.current),h=b.type;if(null!==e&&null!=b.stateNode)sg(e,b,h,f,g),e.ref!==b.ref&&(b.effectTag|=
	128);else if(f){var k=zf(L.current);if($f(b)){f=b;e=f.stateNode;var l=f.type,m=f.memoizedProps,r=g;e[Ia]=f;e[Ja]=m;h=void 0;g=l;switch(g){case "iframe":case "object":F("load",e);break;case "video":case "audio":for(l=0;l<fb.length;l++)F(fb[l],e);break;case "source":F("error",e);break;case "img":case "image":case "link":F("error",e);F("load",e);break;case "form":F("reset",e);F("submit",e);break;case "details":F("toggle",e);break;case "input":Bc(e,m);F("invalid",e);ve(r,"onChange");break;case "select":e._wrapperState=
	{wasMultiple:!!m.multiple};F("invalid",e);ve(r,"onChange");break;case "textarea":ge(e,m),F("invalid",e),ve(r,"onChange")}te(g,m);l=null;for(h in m)m.hasOwnProperty(h)&&(k=m[h],"children"===h?"string"===typeof k?e.textContent!==k&&(l=["children",k]):"number"===typeof k&&e.textContent!==""+k&&(l=["children",""+k]):sa.hasOwnProperty(h)&&null!=k&&ve(r,h));switch(g){case "input":Wb(e);Fc(e,m,!0);break;case "textarea":Wb(e);ie(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
	(e.onclick=we)}h=l;f.updateQueue=h;f=null!==h?!0:!1;f&&qg(b)}else{m=b;e=h;r=f;l=9===g.nodeType?g:g.ownerDocument;k===je.html&&(k=ke(e));k===je.html?"script"===e?(e=l.createElement("div"),e.innerHTML="<script>\x3c/script>",l=e.removeChild(e.firstChild)):"string"===typeof r.is?l=l.createElement(e,{is:r.is}):(l=l.createElement(e),"select"===e&&r.multiple&&(l.multiple=!0)):l=l.createElementNS(k,e);e=l;e[Ia]=m;e[Ja]=f;a:for(m=e,r=b,l=r.child;null!==l;){if(7===l.tag||8===l.tag)m.appendChild(l.stateNode);
	else if(6!==l.tag&&null!==l.child){l.child.return=l;l=l.child;continue}if(l===r)break;for(;null===l.sibling;){if(null===l.return||l.return===r)break a;l=l.return}l.sibling.return=l.return;l=l.sibling}r=e;l=h;m=f;var A=g,S=ue(l,m);switch(l){case "iframe":case "object":F("load",r);g=m;break;case "video":case "audio":for(g=0;g<fb.length;g++)F(fb[g],r);g=m;break;case "source":F("error",r);g=m;break;case "img":case "image":case "link":F("error",r);F("load",r);g=m;break;case "form":F("reset",r);F("submit",
	r);g=m;break;case "details":F("toggle",r);g=m;break;case "input":Bc(r,m);g=zc(r,m);F("invalid",r);ve(A,"onChange");break;case "option":g=de(r,m);break;case "select":r._wrapperState={wasMultiple:!!m.multiple};g=n({},m,{value:void 0});F("invalid",r);ve(A,"onChange");break;case "textarea":ge(r,m);g=fe(r,m);F("invalid",r);ve(A,"onChange");break;default:g=m}te(l,g);k=void 0;var B=l,P=r,v=g;for(k in v)if(v.hasOwnProperty(k)){var p=v[k];"style"===k?re(P,p):"dangerouslySetInnerHTML"===k?(p=p?p.__html:void 0,
	null!=p&&ne(P,p)):"children"===k?"string"===typeof p?("textarea"!==B||""!==p)&&oe(P,p):"number"===typeof p&&oe(P,""+p):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(sa.hasOwnProperty(k)?null!=p&&ve(A,k):null!=p&&xc(P,k,p,S))}switch(l){case "input":Wb(r);Fc(r,m,!1);break;case "textarea":Wb(r);ie(r,m);break;case "option":null!=m.value&&r.setAttribute("value",""+yc(m.value));break;case "select":g=r;g.multiple=!!m.multiple;r=m.value;null!=r?ee(g,!!m.multiple,
	r,!1):null!=m.defaultValue&&ee(g,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof g.onClick&&(r.onclick=we)}(f=ze(h,f))&&qg(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?t("166"):void 0;break;case 8:e&&null!=b.stateNode?tg(e,b,e.memoizedProps,f):("string"!==typeof f&&(null===b.stateNode?t("166"):void 0),e=zf(yf.current),zf(L.current),$f(b)?(f=b,h=f.stateNode,e=f.memoizedProps,h[Ia]=f,(f=h.nodeValue!==e)&&qg(b)):(h=b,f=(9===e.nodeType?e:e.ownerDocument).createTextNode(f),
	f[Ia]=h,b.stateNode=f));break;case 13:case 14:break;case 16:break;case 9:break;case 10:break;case 15:break;case 6:Bf(b);rg(b);break;case 12:tf(b);break;case 11:break;case 4:t("167");default:t("156")}b=N=null;f=a;if(1073741823===O||1073741823!==f.childExpirationTime){h=0;for(e=f.child;null!==e;){g=e.expirationTime;m=e.childExpirationTime;if(0===h||0!==g&&g<h)h=g;if(0===h||0!==m&&m<h)h=m;e=e.sibling}f.childExpirationTime=h}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&
	(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gg(a,O);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512)}if(null!==d)return d;if(null!==c)a=c;else break}return null}function Rg(a){var b=pg(a.alternate,a,O);null===b&&(b=Qg(a));Ig.current=null;return b}
	function Sg(a,b,c){Lg?t("243"):void 0;Lg=!0;Ig.currentDispatcher=Hg;var d=a.nextExpirationTimeToWorkOn;if(d!==O||a!==Mg||null===N)Pg(),Mg=a,O=d,N=Ue(Mg.current,null,O),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==N&&!Tg();)N=Rg(N);else for(;null!==N;)N=Rg(N)}catch(r){if(null===N)e=!0,Dg(r);else{null===N?t("271"):void 0;var f=N,g=f.return;if(null===g)e=!0,Dg(r);else{a:{var h=g,k=f,l=r;g=O;k.effectTag|=512;k.firstEffect=k.lastEffect=null;Ng=!0;l=nf(l,k);do{switch(h.tag){case 5:h.effectTag|=
	1024;h.expirationTime=g;g=Cg(h,l,g);gf(h,g);break a;case 2:case 3:k=l;var m=h.stateNode;if(0===(h.effectTag&64)&&null!==m&&"function"===typeof m.componentDidCatch&&(null===Fg||!Fg.has(m))){h.effectTag|=1024;h.expirationTime=g;g=Eg(h,k,g);gf(h,g);break a}}h=h.return}while(null!==h)}N=Qg(f);continue}}}break}while(1);Lg=!1;rf=qf=pf=Ig.currentDispatcher=null;if(e)Mg=null,a.finishedWork=null;else if(null!==N)a.finishedWork=null;else{b=a.current.alternate;null===b?t("281"):void 0;Mg=null;if(Ng){e=a.latestPendingTime;
	f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e>d||0!==f&&f>d||0!==g&&g>d){a.didError=!1;c=a.latestPingedTime;0!==c&&c<=d&&(a.latestPingedTime=0);c=a.earliestPendingTime;b=a.latestPendingTime;c===d?a.earliestPendingTime=b===d?a.latestPendingTime=0:b:b===d&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;b=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=d:c>d?a.earliestSuspendedTime=d:b<d&&(a.latestSuspendedTime=d);$e(d,a);a.expirationTime=a.expirationTime;return}if(!a.didError&&
	!c){a.didError=!0;a.nextExpirationTimeToWorkOn=d;d=a.expirationTime=1;a.expirationTime=d;return}}a.pendingCommitExpirationTime=d;a.finishedWork=b}}
	function wg(a,b){var c;a:{Lg&&!Og?t("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:case 3:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===Fg||!Fg.has(d))){a=nf(b,a);a=Eg(c,a,1);ff(c,a);If(c,1);c=void 0;break a}break;case 5:a=nf(b,a);a=Cg(c,a,1);ff(c,a);If(c,1);c=void 0;break a}c=c.return}5===a.tag&&(c=nf(b,a),c=Cg(a,c,1),ff(a,c),If(a,1));c=void 0}return c}
	function Hf(a,b){0!==Kg?a=Kg:Lg?a=Og?1:O:b.mode&1?(a=Ug?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1),null!==Mg&&a===O&&(a+=1)):a=1;Ug&&(0===Vg||a>Vg)&&(Vg=a);return a}
	function If(a,b){a:{if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;var c=a.alternate;null!==c&&(0===c.expirationTime||c.expirationTime>b)&&(c.expirationTime=b);var d=a.return;if(null===d&&5===a.tag)a=a.stateNode;else{for(;null!==d;){c=d.alternate;if(0===d.childExpirationTime||d.childExpirationTime>b)d.childExpirationTime=b;null!==c&&(0===c.childExpirationTime||c.childExpirationTime>b)&&(c.childExpirationTime=b);if(null===d.return&&5===d.tag){a=d.stateNode;break a}d=d.return}a=null}}if(null!==
	a){!Lg&&0!==O&&b<O&&Pg();Ze(a,b);if(!Lg||Og||Mg!==a){b=a;a=a.expirationTime;if(null===b.nextScheduledRoot)b.expirationTime=a,null===T?(U=T=b,b.nextScheduledRoot=b):(T=T.nextScheduledRoot=b,T.nextScheduledRoot=U);else if(c=b.expirationTime,0===c||a<c)b.expirationTime=a;V||(W?Wg&&(Y=b,Z=1,Xg(b,1,!0)):1===a?Yg(1,null):Zg(b,a))}$g>ah&&($g=0,t("185"))}}function bh(a,b,c,d,e){var f=Kg;Kg=1;try{return a(b,c,d,e)}finally{Kg=f}}
	var U=null,T=null,ch=0,dh=void 0,V=!1,Y=null,Z=0,Vg=0,eh=!1,fh=!1,gh=null,hh=null,W=!1,Wg=!1,Ug=!1,ih=null,jh=ba.unstable_now(),kh=(jh/10|0)+2,lh=kh,ah=50,$g=0,mh=null,nh=1;function oh(){kh=((ba.unstable_now()-jh)/10|0)+2}function Zg(a,b){if(0!==ch){if(b>ch)return;null!==dh&&ba.unstable_cancelScheduledWork(dh)}ch=b;a=ba.unstable_now()-jh;dh=ba.unstable_scheduleWork(ph,{timeout:10*(b-2)-a})}function Gf(){if(V)return lh;qh();if(0===Z||1073741823===Z)oh(),lh=kh;return lh}
	function qh(){var a=0,b=null;if(null!==T)for(var c=T,d=U;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===T?t("244"):void 0;if(d===d.nextScheduledRoot){U=T=d.nextScheduledRoot=null;break}else if(d===U)U=e=d.nextScheduledRoot,T.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===T){T=c;T.nextScheduledRoot=U;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===T)break;if(1===a)break;
	c=d;d=d.nextScheduledRoot}}Y=b;Z=a}function ph(a){if(a.didTimeout&&null!==U){oh();var b=U;do{var c=b.expirationTime;0!==c&&kh>=c&&(b.nextExpirationTimeToWorkOn=kh);b=b.nextScheduledRoot}while(b!==U)}Yg(0,a)}
	function Yg(a,b){hh=b;qh();if(null!==hh)for(oh(),lh=kh;null!==Y&&0!==Z&&(0===a||a>=Z)&&(!eh||kh>=Z);)Xg(Y,Z,kh>=Z),qh(),oh(),lh=kh;else for(;null!==Y&&0!==Z&&(0===a||a>=Z);)Xg(Y,Z,!0),qh();null!==hh&&(ch=0,dh=null);0!==Z&&Zg(Y,Z);hh=null;eh=!1;$g=0;mh=null;if(null!==ih)for(a=ih,ih=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){fh||(fh=!0,gh=d)}}if(fh)throw a=gh,gh=null,fh=!1,a;}
	function Xg(a,b,c){V?t("245"):void 0;V=!0;if(null===hh||c){var d=a.finishedWork;null!==d?rh(a,d,b):(a.finishedWork=null,Sg(a,!1,c),d=a.finishedWork,null!==d&&rh(a,d,b))}else d=a.finishedWork,null!==d?rh(a,d,b):(a.finishedWork=null,Sg(a,!0,c),d=a.finishedWork,null!==d&&(Tg()?a.finishedWork=d:rh(a,d,b)));V=!1}
	function rh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===ih?ih=[d]:ih.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===mh?$g++:(mh=a,$g=0);Og=Lg=!0;a.current===b?t("177"):void 0;c=a.pendingCommitExpirationTime;0===c?t("261"):void 0;a.pendingCommitExpirationTime=0;d=b.expirationTime;var e=b.childExpirationTime;d=0===d||0!==e&&e<d?e:d;a.didError=!1;0===d?(a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=
	0,a.latestPingedTime=0):(e=a.latestPendingTime,0!==e&&(e<d?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime<d&&(a.earliestPendingTime=a.latestPendingTime)),e=a.earliestSuspendedTime,0===e?Ze(a,d):d>a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,Ze(a,d)):d<e&&Ze(a,d));$e(0,a);Ig.current=null;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;xe=Gd;e=Td();if(Ud(e)){if("selectionStart"in e)var f=
	{start:e.selectionStart,end:e.selectionEnd};else a:{f=(f=e.ownerDocument)&&f.defaultView||window;var g=f.getSelection&&f.getSelection();if(g&&0!==g.rangeCount){f=g.anchorNode;var h=g.anchorOffset,k=g.focusNode;g=g.focusOffset;try{f.nodeType,k.nodeType}catch(Xa){f=null;break a}var l=0,m=-1,r=-1,A=0,S=0,B=e,P=null;b:for(;;){for(var v;;){B!==f||0!==h&&3!==B.nodeType||(m=l+h);B!==k||0!==g&&3!==B.nodeType||(r=l+g);3===B.nodeType&&(l+=B.nodeValue.length);if(null===(v=B.firstChild))break;P=B;B=v}for(;;){if(B===
	e)break b;P===f&&++A===h&&(m=l);P===k&&++S===g&&(r=l);if(null!==(v=B.nextSibling))break;B=P;P=B.parentNode}B=v}f=-1===m||-1===r?null:{start:m,end:r}}else f=null}f=f||{start:0,end:0}}else f=null;ye={focusedElem:e,selectionRange:f};Gd=!1;for(Q=d;null!==Q;){e=!1;f=void 0;try{for(;null!==Q;){if(Q.effectTag&256){var p=Q.alternate;a:switch(h=Q,h.tag){case 2:case 3:if(h.effectTag&256&&null!==p){var u=p.memoizedProps,x=p.memoizedState,R=h.stateNode;R.props=h.memoizedProps;R.state=h.memoizedState;var yh=R.getSnapshotBeforeUpdate(u,
	x);R.__reactInternalSnapshotBeforeUpdate=yh}break a;case 5:case 7:case 8:case 6:break a;default:t("163")}}Q=Q.nextEffect}}catch(Xa){e=!0,f=Xa}e&&(null===Q?t("178"):void 0,wg(Q,f),null!==Q&&(Q=Q.nextEffect))}for(Q=d;null!==Q;){p=!1;u=void 0;try{for(;null!==Q;){var w=Q.effectTag;w&16&&oe(Q.stateNode,"");if(w&128){var y=Q.alternate;if(null!==y){var q=y.ref;null!==q&&("function"===typeof q?q(null):q.current=null)}}switch(w&14){case 2:Ag(Q);Q.effectTag&=-3;break;case 6:Ag(Q);Q.effectTag&=-3;Bg(Q.alternate,
	Q);break;case 4:Bg(Q.alternate,Q);break;case 8:x=Q,yg(x),x.return=null,x.child=null,x.alternate&&(x.alternate.child=null,x.alternate.return=null)}Q=Q.nextEffect}}catch(Xa){p=!0,u=Xa}p&&(null===Q?t("178"):void 0,wg(Q,u),null!==Q&&(Q=Q.nextEffect))}q=ye;y=Td();w=q.focusedElem;u=q.selectionRange;if(y!==w&&w&&w.ownerDocument&&Sd(w.ownerDocument.documentElement,w)){null!==u&&Ud(w)&&(y=u.start,q=u.end,void 0===q&&(q=y),"selectionStart"in w?(w.selectionStart=y,w.selectionEnd=Math.min(q,w.value.length)):
	(p=w.ownerDocument||document,y=(p&&p.defaultView||window).getSelection(),x=w.textContent.length,q=Math.min(u.start,x),u=void 0===u.end?q:Math.min(u.end,x),!y.extend&&q>u&&(x=u,u=q,q=x),x=Rd(w,q),R=Rd(w,u),x&&R&&(1!==y.rangeCount||y.anchorNode!==x.node||y.anchorOffset!==x.offset||y.focusNode!==R.node||y.focusOffset!==R.offset)&&(p=p.createRange(),p.setStart(x.node,x.offset),y.removeAllRanges(),q>u?(y.addRange(p),y.extend(R.node,R.offset)):(p.setEnd(R.node,R.offset),y.addRange(p)))));y=[];for(q=w;q=
	q.parentNode;)1===q.nodeType&&y.push({element:q,left:q.scrollLeft,top:q.scrollTop});"function"===typeof w.focus&&w.focus();for(w=0;w<y.length;w++)q=y[w],q.element.scrollLeft=q.left,q.element.scrollTop=q.top}ye=null;Gd=!!xe;xe=null;a.current=b;for(Q=d;null!==Q;){d=!1;w=void 0;try{for(y=c;null!==Q;){var Sa=Q.effectTag;if(Sa&36){var oc=Q.alternate;q=Q;p=y;switch(q.tag){case 2:case 3:var X=q.stateNode;if(q.effectTag&4)if(null===oc)X.props=q.memoizedProps,X.state=q.memoizedState,X.componentDidMount();
	else{var Ih=oc.memoizedProps,Jh=oc.memoizedState;X.props=q.memoizedProps;X.state=q.memoizedState;X.componentDidUpdate(Ih,Jh,X.__reactInternalSnapshotBeforeUpdate)}var kg=q.updateQueue;null!==kg&&(X.props=q.memoizedProps,X.state=q.memoizedState,lf(q,kg,X,p));break;case 5:var lg=q.updateQueue;if(null!==lg){u=null;if(null!==q.child)switch(q.child.tag){case 7:u=q.child.stateNode;break;case 2:case 3:u=q.child.stateNode}lf(q,lg,u,p)}break;case 7:var Kh=q.stateNode;null===oc&&q.effectTag&4&&ze(q.type,q.memoizedProps)&&
	Kh.focus();break;case 8:break;case 6:break;case 15:break;case 16:break;default:t("163")}}if(Sa&128){var Ac=Q.ref;if(null!==Ac){var mg=Q.stateNode;switch(Q.tag){case 7:var Pd=mg;break;default:Pd=mg}"function"===typeof Ac?Ac(Pd):Ac.current=Pd}}var Lh=Q.nextEffect;Q.nextEffect=null;Q=Lh}}catch(Xa){d=!0,w=Xa}d&&(null===Q?t("178"):void 0,wg(Q,w),null!==Q&&(Q=Q.nextEffect))}Lg=Og=!1;"function"===typeof Oe&&Oe(b.stateNode);Sa=b.expirationTime;b=b.childExpirationTime;b=0===Sa||0!==b&&b<Sa?b:Sa;0===b&&(Fg=
	null);a.expirationTime=b;a.finishedWork=null}function Tg(){return eh?!0:null===hh||hh.timeRemaining()>nh?!1:eh=!0}function Dg(a){null===Y?t("246"):void 0;Y.expirationTime=0;fh||(fh=!0,gh=a)}function sh(a,b){var c=W;W=!0;try{return a(b)}finally{(W=c)||V||Yg(1,null)}}function th(a,b){if(W&&!Wg){Wg=!0;try{return a(b)}finally{Wg=!1}}return a(b)}function uh(a,b,c){if(Ug)return a(b,c);W||V||0===Vg||(Yg(Vg,null),Vg=0);var d=Ug,e=W;W=Ug=!0;try{return a(b,c)}finally{Ug=d,(W=e)||V||Yg(1,null)}}
	function vh(a){if(!a)return Fe;a=a._reactInternalFiber;a:{2!==jd(a)||2!==a.tag&&3!==a.tag?t("170"):void 0;var b=a;do{switch(b.tag){case 5:b=b.stateNode.context;break a;case 2:if(K(b.type)){b=b.stateNode.__reactInternalMemoizedMergedChildContext;break a}break;case 3:if(K(b.type._reactResult)){b=b.stateNode.__reactInternalMemoizedMergedChildContext;break a}}b=b.return}while(null!==b);t("171");b=void 0}if(2===a.tag){var c=a.type;if(K(c))return Le(a,c,b)}else if(3===a.tag&&(c=a.type._reactResult,K(c)))return Le(a,
	c,b);return b}function wh(a,b,c,d,e){var f=b.current;c=vh(c);null===b.context?b.context=c:b.pendingContext=c;b=e;e=df(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);ff(f,e);If(f,d);return d}function xh(a,b,c,d){var e=b.current,f=Gf();e=Hf(f,e);return wh(a,b,c,e,d)}function zh(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 7:return a.child.stateNode;default:return a.child.stateNode}}
	function Ah(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:ac,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	Fb=function(a,b,c){switch(b){case "input":Dc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Na(d);e?void 0:t("90");Xb(d);Dc(d,e)}}}break;case "textarea":he(a,c);break;case "select":b=c.value,null!=b&&ee(a,!!c.multiple,b,!1)}};
	function Bh(a){var b=2+25*(((Gf()-2+500)/25|0)+1);b<=Jg&&(b=Jg+1);this._expirationTime=Jg=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Bh.prototype.render=function(a){this._defer?void 0:t("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Ch;wh(a,b,null,c,d._onCommit);return d};
	Bh.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Bh.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:t("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?t("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;b=c;V?t("253"):void 0;Y=a;Z=b;Xg(a,b,!0);Yg(1,null);b=this._next;this._next=null;b=a.firstBatch=b;null!==
	b&&b._hasChildren&&b.render(b._children)}else this._next=null,this._defer=!1};Bh.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Ch(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Ch.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Ch.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?t("191",c):void 0;c()}}};
	function Dh(a,b,c){b=new Se(5,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
	Dh.prototype.render=function(a,b){var c=this._internalRoot,d=new Ch;b=void 0===b?null:b;null!==b&&d.then(b);xh(a,c,null,d._onCommit);return d};Dh.prototype.unmount=function(a){var b=this._internalRoot,c=new Ch;a=void 0===a?null:a;null!==a&&c.then(a);xh(null,b,null,c._onCommit);return c};Dh.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Ch;c=void 0===c?null:c;null!==c&&e.then(c);xh(b,d,a,e._onCommit);return e};
	Dh.prototype.createBatch=function(){var a=new Bh(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Eh(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Lb=sh;Mb=uh;Nb=function(){V||0===Vg||(Yg(Vg,null),Vg=0)};
	function Fh(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Dh(a,!1,b)}
	function Gh(a,b,c,d,e){Eh(c)?void 0:t("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=zh(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Fh(c,d);if("function"===typeof e){var h=e;e=function(){var a=zh(f._internalRoot);h.call(a)}}th(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return zh(f._internalRoot)}
	function Hh(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Eh(b)?void 0:t("200");return Ah(a,b,null,c)}
	var Mh={createPortal:Hh,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?t("188"):t("268",Object.keys(a)));a=md(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){return Gh(null,a,b,!0,c)},render:function(a,b,c){return Gh(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?t("38"):void 0;return Gh(a,b,c,!1,d)},unmountComponentAtNode:function(a){Eh(a)?
	void 0:t("40");return a._reactRootContainer?(th(function(){Gh(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Hh.apply(void 0,arguments)},unstable_batchedUpdates:sh,unstable_interactiveUpdates:uh,flushSync:function(a,b){V?t("187"):void 0;var c=W;W=!0;try{return bh(a,b)}finally{W=c,Yg(1,null)}},unstable_flushControlled:function(a){var b=W;W=!0;try{bh(a)}finally{(W=b)||V||Yg(1,null)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[La,
	Ma,Na,Ea.injectEventPluginsByName,qa,Ua,function(a){za(a,Ta)},Jb,Kb,Id,Ga]},unstable_createRoot:function(a,b){Eh(a)?void 0:t("278");return new Dh(a,!0,null!=b&&!0===b.hydrate)}};(function(a){var b=a.findFiberByHostInstance;return Re(n({},a,{findHostInstanceByFiber:function(a){a=md(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ka,bundleType:0,version:"16.5.2",rendererPackageName:"react-dom"});
	var Nh={default:Mh},Oh=Nh&&Mh||Nh;module.exports=Oh.default||Oh;


/***/ },
/* 28 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(30);
	} else {
	  module.exports = require('./cjs/schedule.development.js');
	}


/***/ },
/* 30 */
/***/ function(module, exports) {

	/** @license React v16.5.2
	 * schedule.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var c=null,e=!1,f=!1,g="object"===typeof performance&&"function"===typeof performance.now,l={timeRemaining:g?function(){var a=h()-performance.now();return 0<a?a:0}:function(){var a=h()-Date.now();return 0<a?a:0},didTimeout:!1};function m(){if(!e){var a=c.timesOutAt;f?n():f=!0;p(q,a)}}function r(){var a=c,b=c.next;if(c===b)c=null;else{var d=c.previous;c=d.next=b;b.previous=d}a.next=a.previous=null;a=a.callback;a(l)}
	function q(a){e=!0;l.didTimeout=a;try{if(a)for(;null!==c;){var b=exports.unstable_now();if(c.timesOutAt<=b){do r();while(null!==c&&c.timesOutAt<=b)}else break}else if(null!==c){do r();while(null!==c&&0<h()-exports.unstable_now())}}finally{e=!1,null!==c?m(c):f=!1}}
	var t=Date,u="function"===typeof setTimeout?setTimeout:void 0,v="function"===typeof clearTimeout?clearTimeout:void 0,w="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,x="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,y,z;function A(a){y=w(function(b){v(z);a(b)});z=u(function(){x(y);a(exports.unstable_now())},100)}if(g){var B=performance;exports.unstable_now=function(){return B.now()}}else exports.unstable_now=function(){return t.now()};var p,n,h;
	if("undefined"===typeof window){var C=-1;p=function(a){C=setTimeout(a,0,!0)};n=function(){clearTimeout(C)};h=function(){return 0}}else if(window._schedMock){var D=window._schedMock;p=D[0];n=D[1];h=D[2]}else{"undefined"!==typeof console&&("function"!==typeof w&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof x&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
	var E=null,F=!1,G=-1,H=!1,I=!1,J=0,K=33,L=33;h=function(){return J};var M="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===M){F=!1;var b=exports.unstable_now();a=!1;if(0>=J-b)if(-1!==G&&G<=b)a=!0;else{H||(H=!0,A(N));return}G=-1;b=E;E=null;if(null!==b){I=!0;try{b(a)}finally{I=!1}}}},!1);var N=function(a){H=!1;var b=a-J+L;b<L&&K<L?(8>b&&(b=8),L=b<K?K:b):K=b;J=a+L;F||(F=!0,window.postMessage(M,"*"))};p=function(a,
	b){E=a;G=b;I?window.postMessage(M,"*"):H||(H=!0,A(N))};n=function(){E=null;F=!1;G=-1}}exports.unstable_scheduleWork=function(a,b){var d=exports.unstable_now();b=void 0!==b&&null!==b&&null!==b.timeout&&void 0!==b.timeout?d+b.timeout:d+5E3;a={callback:a,timesOutAt:b,next:null,previous:null};if(null===c)c=a.next=a.previous=a,m(c);else{d=null;var k=c;do{if(k.timesOutAt>b){d=k;break}k=k.next}while(k!==c);null===d?d=c:d===c&&(c=a,m(c));b=d.previous;b.next=d.previous=a;a.next=d;a.previous=b}return a};
	exports.unstable_cancelScheduledWork=function(a){var b=a.next;if(null!==b){if(b===a)c=null;else{a===c&&(c=b);var d=a.previous;d.next=b;b.previous=d}a.next=a.previous=null}};


/***/ },
/* 31 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Flash the background of a dom node to a different color and then fade back
	 * to a base color.
	 *
	 * 
	 */
	'use strict';
	
	function flash(node, flashColor, baseColor, duration) {
	  node.style.transition = 'none';
	  node.style.backgroundColor = flashColor;
	  // force recalc
	  void node.offsetTop;
	  node.style.transition = 'background-color ' + duration + 's ease';
	  node.style.backgroundColor = baseColor;
	}
	
	module.exports = flash;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _Symbol = __webpack_require__(33);
	
	module.exports = {
	  name: _Symbol('name'),
	  type: _Symbol('type'),
	  inspected: _Symbol('inspected'),
	  meta: _Symbol('meta'),
	  proto: _Symbol('proto')
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(34)() ? Symbol : __webpack_require__(35);


/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
		var symbol;
		if (typeof Symbol !== 'function') return false;
		symbol = Symbol('test symbol');
		try { String(symbol); } catch (e) { return false; }
		if (typeof Symbol.iterator === 'symbol') return true;
	
		// Return 'true' for polyfills
		if (typeof Symbol.isConcatSpreadable !== 'object') return false;
		if (typeof Symbol.iterator !== 'object') return false;
		if (typeof Symbol.toPrimitive !== 'object') return false;
		if (typeof Symbol.toStringTag !== 'object') return false;
		if (typeof Symbol.unscopables !== 'object') return false;
	
		return true;
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// ES2015 Symbol polyfill for environments that do not support it (or partially support it_
	
	'use strict';
	
	var d              = __webpack_require__(36)
	  , validateSymbol = __webpack_require__(49)
	
	  , create = Object.create, defineProperties = Object.defineProperties
	  , defineProperty = Object.defineProperty, objPrototype = Object.prototype
	  , NativeSymbol, SymbolPolyfill, HiddenSymbol, globalSymbols = create(null);
	
	if (typeof Symbol === 'function') NativeSymbol = Symbol;
	
	var generateName = (function () {
		var created = create(null);
		return function (desc) {
			var postfix = 0, name, ie11BugWorkaround;
			while (created[desc + (postfix || '')]) ++postfix;
			desc += (postfix || '');
			created[desc] = true;
			name = '@@' + desc;
			defineProperty(objPrototype, name, d.gs(null, function (value) {
				// For IE11 issue see:
				// https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
				//    ie11-broken-getters-on-dom-objects
				// https://github.com/medikoo/es6-symbol/issues/12
				if (ie11BugWorkaround) return;
				ie11BugWorkaround = true;
				defineProperty(this, name, d(value));
				ie11BugWorkaround = false;
			}));
			return name;
		};
	}());
	
	// Internal constructor (not one exposed) for creating Symbol instances.
	// This one is used to ensure that `someSymbol instanceof Symbol` always return false
	HiddenSymbol = function Symbol(description) {
		if (this instanceof HiddenSymbol) throw new TypeError('TypeError: Symbol is not a constructor');
		return SymbolPolyfill(description);
	};
	
	// Exposed `Symbol` constructor
	// (returns instances of HiddenSymbol)
	module.exports = SymbolPolyfill = function Symbol(description) {
		var symbol;
		if (this instanceof Symbol) throw new TypeError('TypeError: Symbol is not a constructor');
		symbol = create(HiddenSymbol.prototype);
		description = (description === undefined ? '' : String(description));
		return defineProperties(symbol, {
			__description__: d('', description),
			__name__: d('', generateName(description))
		});
	};
	defineProperties(SymbolPolyfill, {
		for: d(function (key) {
			if (globalSymbols[key]) return globalSymbols[key];
			return (globalSymbols[key] = SymbolPolyfill(String(key)));
		}),
		keyFor: d(function (s) {
			var key;
			validateSymbol(s);
			for (key in globalSymbols) if (globalSymbols[key] === s) return key;
		}),
	
		// If there's native implementation of given symbol, let's fallback to it
		// to ensure proper interoperability with other native functions e.g. Array.from
		hasInstance: d('', (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill('hasInstance')),
		isConcatSpreadable: d('', (NativeSymbol && NativeSymbol.isConcatSpreadable) ||
			SymbolPolyfill('isConcatSpreadable')),
		iterator: d('', (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill('iterator')),
		match: d('', (NativeSymbol && NativeSymbol.match) || SymbolPolyfill('match')),
		replace: d('', (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill('replace')),
		search: d('', (NativeSymbol && NativeSymbol.search) || SymbolPolyfill('search')),
		species: d('', (NativeSymbol && NativeSymbol.species) || SymbolPolyfill('species')),
		split: d('', (NativeSymbol && NativeSymbol.split) || SymbolPolyfill('split')),
		toPrimitive: d('', (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill('toPrimitive')),
		toStringTag: d('', (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill('toStringTag')),
		unscopables: d('', (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill('unscopables'))
	});
	
	// Internal tweaks for real symbol producer
	defineProperties(HiddenSymbol.prototype, {
		constructor: d(SymbolPolyfill),
		toString: d('', function () { return this.__name__; })
	});
	
	// Proper implementation of methods exposed on Symbol.prototype
	// They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
	defineProperties(SymbolPolyfill.prototype, {
		toString: d(function () { return 'Symbol (' + validateSymbol(this).__description__ + ')'; }),
		valueOf: d(function () { return validateSymbol(this); })
	});
	defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toPrimitive, d('',
		function () { return validateSymbol(this); }));
	defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d('c', 'Symbol'));
	
	// Proper implementaton of toPrimitive and toStringTag for returned symbol instances
	defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
		d('c', SymbolPolyfill.prototype[SymbolPolyfill.toStringTag]));
	
	// Note: It's important to define `toPrimitive` as last one, as some implementations
	// implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
	// And that may invoke error in definition flow:
	// See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
	defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
		d('c', SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive]));


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign        = __webpack_require__(37)
	  , normalizeOpts = __webpack_require__(44)
	  , isCallable    = __webpack_require__(45)
	  , contains      = __webpack_require__(46)
	
	  , d;
	
	d = module.exports = function (dscr, value/*, options*/) {
		var c, e, w, options, desc;
		if ((arguments.length < 2) || (typeof dscr !== 'string')) {
			options = value;
			value = dscr;
			dscr = null;
		} else {
			options = arguments[2];
		}
		if (dscr == null) {
			c = w = true;
			e = false;
		} else {
			c = contains.call(dscr, 'c');
			e = contains.call(dscr, 'e');
			w = contains.call(dscr, 'w');
		}
	
		desc = { value: value, configurable: c, enumerable: e, writable: w };
		return !options ? desc : assign(normalizeOpts(options), desc);
	};
	
	d.gs = function (dscr, get, set/*, options*/) {
		var c, e, options, desc;
		if (typeof dscr !== 'string') {
			options = set;
			set = get;
			get = dscr;
			dscr = null;
		} else {
			options = arguments[3];
		}
		if (get == null) {
			get = undefined;
		} else if (!isCallable(get)) {
			options = get;
			get = set = undefined;
		} else if (set == null) {
			set = undefined;
		} else if (!isCallable(set)) {
			options = set;
			set = undefined;
		}
		if (dscr == null) {
			c = true;
			e = false;
		} else {
			c = contains.call(dscr, 'c');
			e = contains.call(dscr, 'e');
		}
	
		desc = { get: get, set: set, configurable: c, enumerable: e };
		return !options ? desc : assign(normalizeOpts(options), desc);
	};


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(38)()
		? Object.assign
		: __webpack_require__(39);


/***/ },
/* 38 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
		var assign = Object.assign, obj;
		if (typeof assign !== 'function') return false;
		obj = { foo: 'raz' };
		assign(obj, { bar: 'dwa' }, { trzy: 'trzy' });
		return (obj.foo + obj.bar + obj.trzy) === 'razdwatrzy';
	};


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys  = __webpack_require__(40)
	  , value = __webpack_require__(43)
	
	  , max = Math.max;
	
	module.exports = function (dest, src/*, …srcn*/) {
		var error, i, l = max(arguments.length, 2), assign;
		dest = Object(value(dest));
		assign = function (key) {
			try { dest[key] = src[key]; } catch (e) {
				if (!error) error = e;
			}
		};
		for (i = 1; i < l; ++i) {
			src = arguments[i];
			keys(src).forEach(assign);
		}
		if (error !== undefined) throw error;
		return dest;
	};


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(41)()
		? Object.keys
		: __webpack_require__(42);


/***/ },
/* 41 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
		try {
			Object.keys('primitive');
			return true;
		} catch (e) { return false; }
	};


/***/ },
/* 42 */
/***/ function(module, exports) {

	'use strict';
	
	var keys = Object.keys;
	
	module.exports = function (object) {
		return keys(object == null ? object : Object(object));
	};


/***/ },
/* 43 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (value) {
		if (value == null) throw new TypeError("Cannot use null or undefined");
		return value;
	};


/***/ },
/* 44 */
/***/ function(module, exports) {

	'use strict';
	
	var forEach = Array.prototype.forEach, create = Object.create;
	
	var process = function (src, obj) {
		var key;
		for (key in src) obj[key] = src[key];
	};
	
	module.exports = function (options/*, …options*/) {
		var result = create(null);
		forEach.call(arguments, function (options) {
			if (options == null) return;
			process(Object(options), result);
		});
		return result;
	};


/***/ },
/* 45 */
/***/ function(module, exports) {

	// Deprecated
	
	'use strict';
	
	module.exports = function (obj) { return typeof obj === 'function'; };


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(47)()
		? String.prototype.contains
		: __webpack_require__(48);


/***/ },
/* 47 */
/***/ function(module, exports) {

	'use strict';
	
	var str = 'razdwatrzy';
	
	module.exports = function () {
		if (typeof str.contains !== 'function') return false;
		return ((str.contains('dwa') === true) && (str.contains('foo') === false));
	};


/***/ },
/* 48 */
/***/ function(module, exports) {

	'use strict';
	
	var indexOf = String.prototype.indexOf;
	
	module.exports = function (searchString/*, position*/) {
		return indexOf.call(this, searchString, arguments[1]) > -1;
	};


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isSymbol = __webpack_require__(50);
	
	module.exports = function (value) {
		if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
		return value;
	};


/***/ },
/* 50 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (x) {
		return (x && ((typeof x === 'symbol') || (x['@@toStringTag'] === 'Symbol'))) || false;
	};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var React = __webpack_require__(11);
	
	var consts = __webpack_require__(32);
	
	function previewComplex(data, theme) {
	  var style = { color: theme.special04 };
	
	  if (Array.isArray(data)) {
	    return React.createElement(
	      'span',
	      { style: style },
	      'Array[',
	      data.length,
	      ']'
	    );
	  }
	
	  switch (data[consts.type]) {
	    case 'function':
	      return React.createElement(
	        'span',
	        { style: style },
	        data[consts.name] || 'fn',
	        '()'
	      );
	    case 'object':
	      return React.createElement(
	        'span',
	        { style: style },
	        data[consts.name] + '{…}'
	      );
	    case 'date':
	      return React.createElement(
	        'span',
	        { style: style },
	        data[consts.name]
	      );
	    case 'symbol':
	      return React.createElement(
	        'span',
	        { style: style },
	        data[consts.name]
	      );
	    case 'iterator':
	      return React.createElement(
	        'span',
	        { style: style },
	        data[consts.name] + '(…)'
	      );
	
	    case 'array_buffer':
	    case 'data_view':
	    case 'array':
	    case 'typed_array':
	      return React.createElement(
	        'span',
	        { style: style },
	        data[consts.name] + '[' + data[consts.meta].length + ']'
	      );
	
	    case undefined:
	    case null:
	      return '{…}';
	  }
	  return null;
	}
	
	module.exports = previewComplex;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(17),
	    monospace = _require.monospace;
	
	var React = __webpack_require__(11);
	
	var DetailPane = function (_React$Component) {
	  _inherits(DetailPane, _React$Component);
	
	  function DetailPane() {
	    _classCallCheck(this, DetailPane);
	
	    return _possibleConstructorReturn(this, (DetailPane.__proto__ || Object.getPrototypeOf(DetailPane)).apply(this, arguments));
	  }
	
	  _createClass(DetailPane, [{
	    key: 'render',
	    value: function render() {
	      return React.createElement(
	        'div',
	        { style: styles.container },
	        this.props.children
	      );
	    }
	  }]);
	
	  return DetailPane;
	}(React.Component);
	
	var styles = {
	  container: {
	    fontSize: monospace.sizes.normal,
	    fontFamily: monospace.family,
	    overflow: 'auto',
	    flex: 1,
	    display: 'flex',
	    flexDirection: 'column'
	  }
	};
	
	module.exports = DetailPane;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	
	var DetailPaneSection = function (_React$Component) {
	  _inherits(DetailPaneSection, _React$Component);
	
	  function DetailPaneSection() {
	    _classCallCheck(this, DetailPaneSection);
	
	    return _possibleConstructorReturn(this, (DetailPaneSection.__proto__ || Object.getPrototypeOf(DetailPaneSection)).apply(this, arguments));
	  }
	
	  _createClass(DetailPaneSection, [{
	    key: 'render',
	    value: function render() {
	      var theme = this.context.theme;
	      var _props = this.props,
	          children = _props.children,
	          hint = _props.hint;
	
	      return React.createElement(
	        'div',
	        { style: sectionStyle(theme) },
	        React.createElement(
	          'strong',
	          { style: styles.title },
	          this.props.title
	        ),
	        hint,
	        children
	      );
	    }
	  }]);
	
	  return DetailPaneSection;
	}(React.Component);
	
	DetailPaneSection.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	var sectionStyle = function sectionStyle(theme) {
	  return {
	    borderTop: '1px solid ' + theme.base01,
	    padding: '0.5rem',
	    flexShrink: 0
	  };
	};
	
	var styles = {
	  title: {
	    display: 'inline-block',
	    marginRight: '0.5rem',
	    lineHeight: '1.5rem'
	  }
	};
	
	module.exports = DetailPaneSection;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(26);
	var PropTypes = __webpack_require__(6);
	
	var consts = __webpack_require__(32);
	
	var _require = __webpack_require__(55),
	    getInvertedWeak = _require.getInvertedWeak;
	
	var flash = __webpack_require__(31);
	
	var PropVal = function (_React$Component) {
	  _inherits(PropVal, _React$Component);
	
	  function PropVal() {
	    _classCallCheck(this, PropVal);
	
	    return _possibleConstructorReturn(this, (PropVal.__proto__ || Object.getPrototypeOf(PropVal)).apply(this, arguments));
	  }
	
	  _createClass(PropVal, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.val === prevProps.val) {
	        return;
	      }
	      if (this.props.val && prevProps.val && _typeof(this.props.val) === 'object' && _typeof(prevProps.val) === 'object') {
	        return;
	      }
	      var node = ReactDOM.findDOMNode(this);
	      // $FlowFixMe
	      flash(node, this.context.theme.state04, 'transparent', 1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return previewProp(this.props.val, !!this.props.nested, !!this.props.inverted, this.context.theme);
	    }
	  }]);
	
	  return PropVal;
	}(React.Component);
	
	PropVal.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	function previewProp(val, nested, inverted, theme) {
	  var style = {
	    color: inverted ? getInvertedWeak(theme.state02) : theme.special01
	  };
	
	  if (typeof val === 'number') {
	    return React.createElement(
	      'span',
	      { style: style },
	      val
	    );
	  }
	  if (typeof val === 'string') {
	    style = {
	      color: inverted ? getInvertedWeak(theme.state02) : theme.special02
	    };
	    if (val.length > 50) {
	      val = val.slice(0, 50) + '…';
	    }
	
	    return React.createElement(
	      'span',
	      { style: style },
	      '"',
	      val,
	      '"'
	    );
	  }
	  if (typeof val === 'boolean') {
	    return React.createElement(
	      'span',
	      { style: style },
	      '' + val
	    );
	  }
	  if (Array.isArray(val)) {
	    style = {
	      color: inverted ? getInvertedWeak(theme.state02) : theme.special02
	    };
	    if (nested) {
	      return React.createElement(
	        'span',
	        { style: style },
	        '[(',
	        val.length,
	        ')]'
	      );
	    }
	    return previewArray(val, inverted, theme);
	  }
	  if (!val) {
	    style = {
	      color: inverted ? getInvertedWeak(theme.state02) : theme.base03
	    };
	    return React.createElement(
	      'span',
	      { style: style },
	      '' + val
	    );
	  }
	  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) !== 'object') {
	    style = {
	      color: inverted ? getInvertedWeak(theme.state02) : theme.special04
	    };
	    return React.createElement(
	      'span',
	      { style: style },
	      '\u2026'
	    );
	  }
	
	  switch (val[consts.type]) {
	    case 'date':
	      {
	        return React.createElement(
	          'span',
	          { style: style },
	          val[consts.name]
	        );
	      }
	    case 'function':
	      {
	        style = {
	          color: inverted ? getInvertedWeak(theme.state02) : theme.special04
	        };
	        return React.createElement(
	          'span',
	          { style: style },
	          val[consts.name] || 'fn',
	          '()'
	        );
	      }
	    case 'object':
	      {
	        return React.createElement(
	          'span',
	          { style: style },
	          val[consts.name] + '{…}'
	        );
	      }
	    case 'array':
	      {
	        style = {
	          color: inverted ? getInvertedWeak(theme.state02) : theme.special02
	        };
	        return React.createElement(
	          'span',
	          { style: style },
	          'Array[',
	          val[consts.meta].length,
	          ']'
	        );
	      }
	    case 'typed_array':
	    case 'array_buffer':
	    case 'data_view':
	      {
	        style = {
	          color: inverted ? getInvertedWeak(theme.state02) : theme.special02
	        };
	        return React.createElement(
	          'span',
	          { style: style },
	          val[consts.name] + '[' + val[consts.meta].length + ']'
	        );
	      }
	    case 'iterator':
	      {
	        style = {
	          color: inverted ? getInvertedWeak(theme.state02) : theme.base05
	        };
	        return React.createElement(
	          'span',
	          { style: style },
	          val[consts.name] + '(…)'
	        );
	      }
	    case 'symbol':
	      {
	        style = {
	          color: inverted ? getInvertedWeak(theme.state02) : theme.base05
	        };
	        // the name is "Symbol(something)"
	        return React.createElement(
	          'span',
	          { style: style },
	          val[consts.name]
	        );
	      }
	  }
	
	  if (nested) {
	    style = {
	      color: inverted ? getInvertedWeak(theme.state02) : theme.base05
	    };
	    return React.createElement(
	      'span',
	      { style: style },
	      '{…}'
	    );
	  }
	
	  return previewObject(val, inverted, theme);
	}
	
	function previewArray(val, inverted, theme) {
	  var items = [];
	  val.slice(0, 3).forEach(function (item, i) {
	    if (i > 0) {
	      items.push(', ');
	    }
	    items.push(React.createElement(PropVal, { key: i, val: item, nested: true, inverted: inverted, theme: theme }));
	  });
	  var style = {
	    color: inverted ? theme.base03 : theme.special01
	  };
	  return React.createElement(
	    'span',
	    { style: style },
	    '[',
	    items,
	    val.length > 3 ? ', …' : '',
	    ']'
	  );
	}
	
	function previewObject(val, inverted, theme) {
	  var names = Object.keys(val);
	  var items = [];
	  var attrStyle = {
	    color: inverted ? getInvertedWeak(theme.state02) : theme.special06
	  };
	  names.slice(0, 3).forEach(function (name, i) {
	    items.push( // Fragment
	    React.createElement(
	      'span',
	      { key: i },
	      i > 0 ? ', ' : '',
	      React.createElement(
	        'span',
	        { style: attrStyle },
	        name
	      ),
	      ': ',
	      React.createElement(PropVal, { val: val[name], nested: true, inverted: inverted, theme: theme })
	    ));
	  });
	  var style = {
	    color: inverted ? getInvertedWeak(theme.state02) : theme.special01
	  };
	  return React.createElement(
	    'span',
	    { style: style },
	    '{',
	    items,
	    names.length > 3 ? ', …' : '',
	    '}'
	  );
	}
	
	module.exports = PropVal;

/***/ },
/* 55 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	function getBrightness(hex) {
	  var _getRgb = getRgb(hex),
	      r = _getRgb.r,
	      g = _getRgb.g,
	      b = _getRgb.b;
	
	  // http://www.w3.org/TR/AERT#color-contrast
	
	
	  return Math.round((r * 299 + g * 587 + b * 114) / 1000);
	}
	
	function getInvertedMid(hex) {
	  return hexToRgba(hex, 0.8);
	}
	
	function getInvertedWeak(hex) {
	  return hexToRgba(hex, 0.65);
	}
	
	function getRgb() {
	  var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  hex = hex.replace('#', '');
	
	  if (hex.length === 3) {
	    hex = hex.charAt(0) + hex.charAt(0) + hex.charAt(1) + hex.charAt(1) + hex.charAt(2) + hex.charAt(2);
	  }
	
	  var r = parseInt(hex.substring(0, 2), 16);
	  var g = parseInt(hex.substring(2, 4), 16);
	  var b = parseInt(hex.substring(4, 6), 16);
	
	  return { r: r, g: g, b: b };
	}
	
	function hexToRgba(hex, alpha) {
	  var _getRgb2 = getRgb(hex),
	      r = _getRgb2.r,
	      g = _getRgb2.g,
	      b = _getRgb2.b;
	
	  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
	}
	
	function isBright(hex) {
	  // http://www.w3.org/TR/AERT#color-contrast
	  return getBrightness(hex) > 125;
	}
	
	module.exports = {
	  getBrightness: getBrightness,
	  getInvertedMid: getInvertedMid,
	  getInvertedWeak: getInvertedWeak,
	  getRgb: getRgb,
	  hexToRgba: hexToRgba,
	  isBright: isBright
	};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * TODO: this is copied from fbjs because fbjs doesn't play well with
	 * non-haste module systems :/. Look into how to fix this.
	 */
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var __DEV__ = ("production") === 'development';
	
	var invariant = function invariant(condition, format, a, b, c, d, e, f) {
	  if (__DEV__) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * $FLowFixMe
	 * - thinks all react component classes must inherit from React.Component
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	var SettingsPane = __webpack_require__(58);
	var TreeView = __webpack_require__(63);
	
	var LeftPane = function (_React$Component) {
	  _inherits(LeftPane, _React$Component);
	
	  function LeftPane() {
	    _classCallCheck(this, LeftPane);
	
	    return _possibleConstructorReturn(this, (LeftPane.__proto__ || Object.getPrototypeOf(LeftPane)).apply(this, arguments));
	  }
	
	  _createClass(LeftPane, [{
	    key: 'render',
	    value: function render() {
	      return React.createElement(
	        'div',
	        { style: styles.container },
	        React.createElement(SettingsPane, null),
	        React.createElement(TreeView, { reload: this.props.reload })
	      );
	    }
	  }]);
	
	  return LeftPane;
	}(React.Component);
	
	LeftPane.propTypes = {
	  reload: PropTypes.func
	};
	
	var styles = {
	  container: {
	    flex: 1,
	    display: 'flex',
	    flexDirection: 'column',
	    minWidth: 0
	  }
	};
	
	module.exports = LeftPane;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(26);
	
	var _require = __webpack_require__(17),
	    sansSerif = _require.sansSerif;
	
	var SearchUtils = __webpack_require__(59);
	var SvgIcon = __webpack_require__(60);
	var Icons = __webpack_require__(61);
	var Input = __webpack_require__(23);
	var Hoverable = __webpack_require__(62);
	
	var decorate = __webpack_require__(20);
	
	var SettingsPane = function (_React$Component) {
	  _inherits(SettingsPane, _React$Component);
	
	  function SettingsPane(props) {
	    _classCallCheck(this, SettingsPane);
	
	    var _this = _possibleConstructorReturn(this, (SettingsPane.__proto__ || Object.getPrototypeOf(SettingsPane)).call(this, props));
	
	    _this.state = { focused: false };
	    return _this;
	  }
	
	  _createClass(SettingsPane, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._key = this.onDocumentKeyDown.bind(this);
	      var doc = ReactDOM.findDOMNode(this).ownerDocument;
	      // capture=true is needed to prevent chrome devtools console popping up
	      doc.addEventListener('keydown', this._key, true);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var doc = ReactDOM.findDOMNode(this).ownerDocument;
	      doc.removeEventListener('keydown', this._key, true);
	    }
	  }, {
	    key: 'onDocumentKeyDown',
	    value: function onDocumentKeyDown(e) {
	      if (e.keyCode === 191 && // forward slash
	      e.target.nodeName !== 'INPUT' && !e.target.isContentEditable && this.input) {
	        this.input.focus();
	        e.preventDefault();
	      }
	      if (e.keyCode === 27) {
	        // escape
	        if (!this.props.searchText && !this.state.focused) {
	          return;
	        }
	        e.stopPropagation();
	        e.preventDefault();
	        this.cancel();
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.props.onChangeSearch('');
	      if (this.input) {
	        this.input.blur();
	      }
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(key) {
	      if (key === 'Enter' && this.input) {
	        // switch focus to tree view
	        this.input.blur();
	        this.props.selectFirstSearchResult();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var theme = this.context.theme;
	      var searchText = this.props.searchText;
	
	      var inputStyle;
	      if (searchText && SearchUtils.shouldSearchUseRegex(searchText) && !SearchUtils.isValidRegex(searchText)) {
	        inputStyle = errorInputStyle(theme);
	      } else if (searchText || this.state.focused) {
	        inputStyle = highlightedInputStyle(theme);
	      } else {
	        inputStyle = baseInputStyle(theme);
	      }
	
	      return React.createElement(
	        'div',
	        { style: settingsPaneStyle(theme) },
	        this.context.showInspectButton && React.createElement(InspectMenuButton, {
	          isInspectEnabled: this.props.isInspectEnabled,
	          onClick: this.props.toggleInspectEnabled,
	          theme: theme
	        }),
	        React.createElement(
	          'div',
	          { style: styles.searchInputWrapper },
	          React.createElement(Input, {
	            style: inputStyle,
	            innerRef: function innerRef(i) {
	              return _this2.input = i;
	            },
	            value: searchText,
	            onFocus: function onFocus() {
	              return _this2.setState({ focused: true });
	            },
	            onBlur: function onBlur() {
	              return _this2.setState({ focused: false });
	            },
	            onKeyDown: function onKeyDown(e) {
	              return _this2.onKeyDown(e.key);
	            },
	            placeholder: 'Search (text or /regex/)',
	            onChange: function onChange(e) {
	              return _this2.props.onChangeSearch(e.target.value);
	            },
	            title: 'Search by React component name or text'
	          }),
	          React.createElement(SearchIcon, { theme: theme }),
	          !!searchText && React.createElement(ClearSearchButton, {
	            onClick: this.cancel.bind(this),
	            theme: theme
	          })
	        ),
	        React.createElement(SettingsMenuButton, {
	          onClick: this.props.showPreferencesPanel,
	          theme: theme
	        })
	      );
	    }
	  }]);
	
	  return SettingsPane;
	}(React.Component);
	
	SettingsPane.contextTypes = {
	  showInspectButton: PropTypes.bool.isRequired,
	  theme: PropTypes.object.isRequired
	};
	SettingsPane.propTypes = {
	  isInspectEnabled: PropTypes.bool,
	  isRecording: PropTypes.bool,
	  searchText: PropTypes.string,
	  selectFirstSearchResult: PropTypes.func,
	  toggleRecord: PropTypes.func,
	  onChangeSearch: PropTypes.func,
	  toggleInspectEnabled: PropTypes.func
	};
	
	var Wrapped = decorate({
	  listeners: function listeners(props) {
	    return ['isInspectEnabled', 'isRecording', 'searchText'];
	  },
	  props: function props(store) {
	    return {
	      isInspectEnabled: store.isInspectEnabled,
	      isRecording: store.isRecording,
	      onChangeSearch: function onChangeSearch(text) {
	        return store.changeSearch(text);
	      },
	      searchText: store.searchText,
	      selectFirstSearchResult: store.selectFirstSearchResult.bind(store),
	      showPreferencesPanel: function showPreferencesPanel() {
	        store.showPreferencesPanel();
	      },
	
	      toggleInspectEnabled: function toggleInspectEnabled() {
	        return store.setInspectEnabled(!store.isInspectEnabled);
	      },
	      toggleRecord: function toggleRecord() {
	        return store.setIsRecording(!store.isRecording);
	      }
	    };
	  }
	}, SettingsPane);
	
	var ClearSearchButton = Hoverable(function (_ref) {
	  var isHovered = _ref.isHovered,
	      onClick = _ref.onClick,
	      onMouseEnter = _ref.onMouseEnter,
	      onMouseLeave = _ref.onMouseLeave,
	      theme = _ref.theme;
	  return React.createElement(
	    'div',
	    {
	      onClick: onClick,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      style: clearSearchButtonStyle(isHovered, theme)
	    },
	    '\xD7'
	  );
	});
	
	var InspectMenuButton = Hoverable(function (_ref2) {
	  var isHovered = _ref2.isHovered,
	      isInspectEnabled = _ref2.isInspectEnabled,
	      onClick = _ref2.onClick,
	      onMouseEnter = _ref2.onMouseEnter,
	      onMouseLeave = _ref2.onMouseLeave,
	      theme = _ref2.theme;
	  return React.createElement(
	    'button',
	    {
	      onClick: onClick,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      style: inspectMenuButtonStyle(isInspectEnabled, isHovered, theme),
	      title: 'Select a React element in the page to inspect it'
	    },
	    React.createElement(SvgIcon, { path: Icons.INSPECT })
	  );
	});
	
	var SettingsMenuButton = Hoverable(function (_ref3) {
	  var isHovered = _ref3.isHovered,
	      onClick = _ref3.onClick,
	      onMouseEnter = _ref3.onMouseEnter,
	      onMouseLeave = _ref3.onMouseLeave,
	      theme = _ref3.theme;
	  return React.createElement(
	    'button',
	    {
	      onClick: onClick,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      style: settingsMenuButtonStyle(isHovered, theme),
	      title: 'Customize React DevTools'
	    },
	    React.createElement(SvgIcon, { path: Icons.SETTINGS })
	  );
	});
	
	function SearchIcon(_ref4) {
	  var theme = _ref4.theme;
	
	  return React.createElement(SvgIcon, {
	    style: searchIconStyle(theme),
	    path: Icons.SEARCH
	  });
	}
	
	var settingsPaneStyle = function settingsPaneStyle(theme) {
	  return {
	    display: 'flex',
	    flexWrap: 'wrap',
	    flexShrink: 0,
	    alignItems: 'center',
	    position: 'relative',
	    backgroundColor: theme.base01,
	    borderBottom: '1px solid ' + theme.base03
	  };
	};
	
	var clearSearchButtonStyle = function clearSearchButtonStyle(isHovered, theme) {
	  return {
	    fontSize: sansSerif.sizes.large,
	    padding: '0 0.5rem',
	    position: 'absolute',
	    cursor: 'default',
	    right: 0,
	    lineHeight: '28px',
	    color: isHovered ? theme.base04 : theme.base02
	  };
	};
	
	var inspectMenuButtonStyle = function inspectMenuButtonStyle(isInspectEnabled, isHovered, theme) {
	  var color = void 0;
	  if (isInspectEnabled) {
	    color = theme.state00;
	  } else if (isHovered) {
	    color = theme.state06;
	  } else {
	    color = 'inherit';
	  }
	
	  return {
	    display: 'flex',
	    background: 'none',
	    border: 'none',
	    outline: 'none', // Use custom active highlight instead
	    marginLeft: '0.25rem',
	    color: color
	  };
	};
	
	var searchIconStyle = function searchIconStyle(theme) {
	  return {
	    position: 'absolute',
	    display: 'inline-block',
	    pointerEvents: 'none',
	    left: '0.5rem',
	    top: 0,
	    width: '1em',
	    height: '100%',
	    strokeWidth: 0,
	    stroke: theme.base03,
	    fill: theme.base03,
	    lineHeight: '28px',
	    fontSize: sansSerif.sizes.normal
	  };
	};
	
	var settingsMenuButtonStyle = function settingsMenuButtonStyle(isHovered, theme) {
	  return {
	    display: 'flex',
	    background: 'none',
	    border: 'none',
	    outline: 'none',
	    marginRight: '0.5rem',
	    color: isHovered ? theme.state06 : 'inherit'
	  };
	};
	
	var baseInputStyle = function baseInputStyle(theme) {
	  return {
	    fontSize: sansSerif.sizes.normal,
	    padding: '0.25rem',
	    margin: '0.25rem',
	    marginLeft: '1.75rem',
	    backgroundColor: 'transparent',
	    border: 'none',
	    outline: 'none',
	    width: '100%'
	  };
	};
	
	var highlightedInputStyle = function highlightedInputStyle(theme) {
	  return _extends({}, baseInputStyle(theme), {
	    backgroundColor: theme.base00
	  });
	};
	
	var errorInputStyle = function errorInputStyle(theme) {
	  return _extends({}, baseInputStyle(theme));
	};
	
	var styles = {
	  growToFill: {
	    flexGrow: 1
	  },
	  searchInputWrapper: {
	    display: 'flex',
	    alignItems: 'center',
	    flexGrow: 1,
	    flexShrink: 0,
	    position: 'relative'
	  }
	};
	
	module.exports = Wrapped;

/***/ },
/* 59 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	function isValidRegex(needle) {
	  var isValid = true;
	
	  if (needle) {
	    try {
	      searchTextToRegExp(needle);
	    } catch (error) {
	      isValid = false;
	    }
	  }
	
	  return isValid;
	}
	
	/**
	 * Convert the specified search text to a RegExp.
	 */
	function searchTextToRegExp(needle) {
	  return new RegExp(trimSearchText(needle), 'gi');
	}
	
	/**
	 * Should the current search text be converted to a RegExp?
	 */
	function shouldSearchUseRegex(needle) {
	  return !!needle && needle.charAt(0) === '/' && trimSearchText(needle).length > 0;
	}
	
	/**
	 * '/foo/' => 'foo'
	 * '/bar' => 'bar'
	 * 'baz' => 'baz'
	 */
	function trimSearchText(needle) {
	  if (needle.charAt(0) === '/') {
	    needle = needle.substr(1);
	  }
	  if (needle.charAt(needle.length - 1) === '/') {
	    needle = needle.substr(0, needle.length - 1);
	  }
	  return needle;
	}
	
	module.exports = {
	  isValidRegex: isValidRegex,
	  searchTextToRegExp: searchTextToRegExp,
	  shouldSearchUseRegex: shouldSearchUseRegex,
	  trimSearchText: trimSearchText
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	
	var SvgIcon = function SvgIcon(_ref) {
	  var path = _ref.path,
	      style = _ref.style;
	  return React.createElement(
	    'svg',
	    {
	      style: _extends({}, DEFAULT_STYLE, style),
	      viewBox: '0 0 24 24'
	    },
	    React.createElement('path', { d: path })
	  );
	};
	
	var DEFAULT_STYLE = {
	  flex: '0 0 1rem',
	  width: '1rem',
	  height: '1rem',
	  fill: 'currentColor'
	};
	
	module.exports = SvgIcon;

/***/ },
/* 61 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var Icons = {
	  BACK: '\n    M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z\n  ',
	  BARS: '\n    M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z\n  ',
	  CHECK: '\n    M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z\n  ',
	  CLOSE: '\n    M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41\n    17.59 19 19 17.59 13.41 12z\n  ',
	  COPY: '\n    M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,\n    0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z\n  ',
	  DOM_ELEMENT: '\n    M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z\n  ',
	  EDIT: '\n    M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,\n    5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z\n  ',
	  FLAME_CHART: '\n    M10.0650893,21.5040462 C7.14020814,20.6850349 5,18.0558698 5,14.9390244 C5,14.017627\n    5,9.81707317 7.83333333,7.37804878 C7.83333333,7.37804878 7.58333333,11.199187 10,\n    10.6300813 C11.125,10.326087 13.0062497,7.63043487 8.91666667,2.5 C14.1666667,3.06910569\n    19,9.32926829 19,14.9390244 C19,18.0558698 16.8597919,20.6850349 13.9349107,21.5040462\n    C14.454014,21.0118505 14.7765152,20.3233394 14.7765152,19.5613412 C14.7765152,17.2826087\n    12,15.0875871 12,15.0875871 C12,15.0875871 9.22348485,17.2826087 9.22348485,19.5613412\n    C9.22348485,20.3233394 9.54598603,21.0118505 10.0650893,21.5040462 Z M12.0833333,20.6514763\n    C11.3814715,20.6514763 10.8125,20.1226027 10.8125,19.4702042 C10.8125,18.6069669\n    12.0833333,16.9347829 12.0833333,16.9347829 C12.0833333,16.9347829 13.3541667,18.6069669\n    13.3541667,19.4702042 C13.3541667,20.1226027 12.7851952,20.6514763 12.0833333,20.6514763 Z\n  ',
	  FORWARD: '\n    M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z\n  ',
	  INSPECT: '\n    M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M3.05,\n    13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,\n    11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,\n    13M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5Z\n  ',
	  INTERACTION: '\n    M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2\n    2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55\n    4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02\n    9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55\n    2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z\n  ',
	  RANKED_CHART: '\n    M3 5h18v3H3zM3 10.5h13v3H3zM3 16h8v3H3z\n  ',
	  RECORD: '\n    M4,12a8,8 0 1,0 16,0a8,8 0 1,0 -16,0\n  ',
	  REFRESH: '\n    M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0\n    6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0\n    3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z\n  ',
	  SEARCH: '\n    M31.008 27.231l-7.58-6.447c-0.784-0.705-1.622-1.029-2.299-0.998 1.789-2.096 2.87-4.815\n    2.87-7.787 0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12c2.972 0 5.691-1.081\n    7.787-2.87-0.031 0.677 0.293 1.515 0.998 2.299l6.447 7.58c1.104 1.226 2.907 1.33 4.007\n    0.23s0.997-2.903-0.23-4.007zM12 20c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582\n    8-8 8z\n  ',
	  SETTINGS: '\n    M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,\n    1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,\n    11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,\n    5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,\n    2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,\n    4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,\n    11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,\n    15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,\n    18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,\n    18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,\n    18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z\n  ',
	  SHARE: '\n    M18,16.08C17.24,16.08 16.56,16.38 16.04,16.85L8.91,12.7C8.96,12.47 9,12.24 9,12C9,\n    11.76 8.96,11.53 8.91,11.3L15.96,7.19C16.5,7.69 17.21,8 18,8A3,3 0 0,0 21,5A3,\n    3 0 0,0 18,2A3,3 0 0,0 15,5C15,5.24 15.04,5.47 15.09,5.7L8.04,9.81C7.5,9.31 6.79,\n    9 6,9A3,3 0 0,0 3,12A3,3 0 0,0 6,15C6.79,15 7.5,14.69 8.04,14.19L15.16,18.34C15.11,\n    18.55 15.08,18.77 15.08,19C15.08,20.61 16.39,21.91 18,21.91C19.61,21.91 20.92,\n    20.61 20.92,19A2.92,2.92 0 0,0 18,16.08Z\n  ',
	  VIEW_DETAILS: '\n    M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5\n    5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01\n    14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\n  '
	};
	
	module.exports = Icons;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(11);
	
	var Hoverable = function Hoverable(Component) {
	  var HoverableImplementation = function (_React$Component) {
	    _inherits(HoverableImplementation, _React$Component);
	
	    function HoverableImplementation() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, HoverableImplementation);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HoverableImplementation.__proto__ || Object.getPrototypeOf(HoverableImplementation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        isHovered: false,
	        isPressed: false
	      }, _this._onMouseDown = function (event) {
	        _this.setState({ isPressed: true });
	      }, _this._onMouseEnter = function (event) {
	        _this.setState({ isHovered: true });
	      }, _this._onMouseLeave = function (event) {
	        _this.setState({ isHovered: false, isPressed: false });
	      }, _this._onMouseUp = function (event) {
	        _this.setState({ isPressed: false });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(HoverableImplementation, [{
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            isHovered = _state.isHovered,
	            isPressed = _state.isPressed;
	
	
	        return React.createElement(Component, _extends({}, this.props, {
	          isHovered: isHovered,
	          isPressed: isPressed,
	          onMouseDown: this._onMouseDown,
	          onMouseEnter: this._onMouseEnter,
	          onMouseLeave: this._onMouseLeave,
	          onMouseUp: this._onMouseUp
	        }));
	      }
	    }]);
	
	    return HoverableImplementation;
	  }(React.Component);
	
	  return HoverableImplementation;
	};
	
	module.exports = Hoverable;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Node = __webpack_require__(64);
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	var SearchUtils = __webpack_require__(59);
	var Breadcrumb = __webpack_require__(66);
	
	var decorate = __webpack_require__(20);
	
	var _require = __webpack_require__(17),
	    monospace = _require.monospace,
	    sansSerif = _require.sansSerif;
	
	var MAX_SEARCH_ROOTS = 200;
	
	var TreeView = function (_React$Component) {
	  _inherits(TreeView, _React$Component);
	
	  function TreeView() {
	    _classCallCheck(this, TreeView);
	
	    return _possibleConstructorReturn(this, (TreeView.__proto__ || Object.getPrototypeOf(TreeView)).apply(this, arguments));
	  }
	
	  _createClass(TreeView, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        scrollTo: this.scrollTo.bind(this)
	      };
	    }
	  }, {
	    key: 'scrollTo',
	    value: function scrollTo(toNode) {
	      if (!this.node) {
	        return;
	      }
	      var val = 0;
	      var height = toNode.offsetHeight;
	      while (toNode && this.node.contains(toNode)) {
	        val += toNode.offsetTop;
	        toNode = toNode.offsetParent;
	      }
	      var top = this.node.scrollTop;
	      var rel = val - this.node.offsetTop;
	      var margin = 40;
	      if (top > rel - margin) {
	        this.node.scrollTop = rel - margin;
	      } else if (top + this.node.offsetHeight < rel + height + margin) {
	        this.node.scrollTop = rel - this.node.offsetHeight + height + margin;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var theme = this.context.theme;
	
	
	      if (!this.props.roots.count()) {
	        if (this.props.searching) {
	          return React.createElement(
	            'div',
	            { style: styles.container },
	            React.createElement(
	              'span',
	              { style: noSearchResultsStyle(theme) },
	              'No search results'
	            )
	          );
	        } else {
	          return React.createElement(
	            'div',
	            { style: styles.container },
	            React.createElement(
	              'div',
	              { ref: function ref(n) {
	                  return _this2.node = n;
	                }, style: styles.scroll },
	              React.createElement(
	                'div',
	                { style: styles.scrollContents },
	                'Waiting for roots to load...',
	                this.props.reload && React.createElement(
	                  'span',
	                  null,
	                  'to reload the inspector ',
	                  React.createElement(
	                    'button',
	                    { onClick: this.props.reload },
	                    ' click here'
	                  )
	                )
	              )
	            )
	          );
	        }
	      }
	
	      // Convert search text into a case-insensitive regex for match-highlighting.
	      var searchText = this.props.searchText;
	      var searchRegExp = SearchUtils.isValidRegex(searchText) ? SearchUtils.searchTextToRegExp(searchText) : null;
	
	      if (this.props.searching && this.props.roots.count() > MAX_SEARCH_ROOTS) {
	        return React.createElement(
	          'div',
	          { style: styles.container },
	          React.createElement(
	            'div',
	            { ref: function ref(n) {
	                return _this2.node = n;
	              }, style: styles.scroll },
	            React.createElement(
	              'div',
	              { style: styles.scrollContents },
	              this.props.roots.slice(0, MAX_SEARCH_ROOTS).map(function (id) {
	                return React.createElement(Node, {
	                  depth: 0,
	                  id: id,
	                  key: id,
	                  searchRegExp: searchRegExp
	                });
	              }).toJS(),
	              React.createElement(
	                'span',
	                null,
	                'Some results not shown. Narrow your search criteria to find them'
	              )
	            )
	          )
	        );
	      }
	
	      return React.createElement(
	        'div',
	        { style: styles.container },
	        React.createElement(
	          'div',
	          { ref: function ref(n) {
	              return _this2.node = n;
	            }, style: styles.scroll },
	          React.createElement(
	            'div',
	            { style: styles.scrollContents },
	            this.props.roots.map(function (id) {
	              return React.createElement(Node, {
	                depth: 0,
	                id: id,
	                key: id,
	                searchRegExp: searchRegExp
	              });
	            }).toJS()
	          )
	        ),
	        React.createElement(Breadcrumb, null)
	      );
	    }
	  }]);
	
	  return TreeView;
	}(React.Component);
	
	TreeView.childContextTypes = {
	  scrollTo: PropTypes.func
	};
	
	TreeView.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	var noSearchResultsStyle = function noSearchResultsStyle(theme) {
	  return {
	    color: theme.base04,
	    fontFamily: sansSerif.family,
	    fontSize: sansSerif.sizes.large,
	    fontStyle: 'italic',
	    padding: '0.5rem'
	  };
	};
	
	var styles = {
	  container: {
	    fontFamily: monospace.family,
	    fontSize: monospace.sizes.normal,
	    lineHeight: 1.5,
	    flex: 1,
	    display: 'flex',
	    flexDirection: 'column',
	    minHeight: 0,
	
	    WebkitUserSelect: 'none',
	    MozUserSelect: 'none',
	    userSelect: 'none'
	  },
	
	  scroll: {
	    overflow: 'auto',
	    minHeight: 0,
	    flex: 1,
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'flex-start',
	    padding: '0.5rem 0.25rem'
	  },
	
	  scrollContents: {
	    flexDirection: 'column',
	    flex: 1,
	    display: 'flex',
	    alignItems: 'stretch',
	    width: '100%'
	  }
	};
	
	var WrappedTreeView = decorate({
	  listeners: function listeners(props) {
	    return ['searchRoots', 'roots'];
	  },
	  props: function props(store, _props) {
	    return {
	      roots: store.searchRoots || store.roots,
	      searching: !!store.searchRoots,
	      searchText: store.searchText
	    };
	  }
	}, TreeView);
	
	module.exports = WrappedTreeView;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	var nullthrows = __webpack_require__(16).default;
	
	var decorate = __webpack_require__(20);
	var Props = __webpack_require__(65);
	
	var _require = __webpack_require__(55),
	    getInvertedWeak = _require.getInvertedWeak,
	    hexToRgba = _require.hexToRgba;
	
	var Fragment = React.Fragment;
	
	var Node = function (_React$Component) {
	  _inherits(Node, _React$Component);
	
	  function Node() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Node);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Node.__proto__ || Object.getPrototypeOf(Node)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isWindowFocused: true
	    }, _this._handleWindowFocus = function () {
	      // We're coming from a global window event handler so React
	      // hasn't processed the events yet. We likely have a click
	      // selecting another node, which would cause flicker if we update
	      // right now. So instead we wait just enough for UI to process
	      // events and update the selected note. (I know it's not pretty.)
	      setTimeout(function () {
	        if (!_this._ownerWindow) {
	          return;
	        }
	        var doc = _this._ownerWindow.document;
	        _this.setState({ isWindowFocused: doc.hasFocus() });
	      }, 50);
	    }, _this._handleWindowBlur = function () {
	      _this.setState({ isWindowFocused: false });
	    }, _this._setTailRef = function (tail) {
	      _this._tail = tail;
	    }, _this._setHeadRef = function (head) {
	      _this._head = head;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Node, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return nextProps !== this.props || nextState.isWindowFocused !== this.state.isWindowFocused;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.selected) {
	        this.ensureInView();
	        // This is done lazily so we only have one subscription at a time at most.
	        // We'll unsubscribe and resubscribe depending on props.selected in componentDidUpdate().
	        this.subscribeToWindowFocus();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.selected && !prevProps.selected) {
	        // Gaining selection.
	        this.ensureInView();
	        this.subscribeToWindowFocus();
	      } else if (!this.props.selected && prevProps.selected) {
	        // Losing selection.
	        this.unsubscribeFromWindowFocus();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.selected) {
	        this.unsubscribeFromWindowFocus();
	      }
	      this._ownerWindow = null;
	    }
	  }, {
	    key: 'findOwnerWindow',
	    value: function findOwnerWindow() {
	      if (!this._head) {
	        return null;
	      }
	      var doc = this._head.ownerDocument;
	      if (!doc) {
	        return null;
	      }
	      var win = doc.defaultView;
	      if (!win) {
	        return null;
	      }
	      return win;
	    }
	  }, {
	    key: 'subscribeToWindowFocus',
	    value: function subscribeToWindowFocus() {
	      if (!this._ownerWindow) {
	        // Lazily find the window first time we subscribed.
	        this._ownerWindow = this.findOwnerWindow();
	        if (!this._ownerWindow) {
	          return;
	        }
	      }
	      var win = this._ownerWindow;
	      win.addEventListener('focus', this._handleWindowFocus);
	      win.addEventListener('blur', this._handleWindowBlur);
	      // Make sure our initial state is right.
	      if (this.props.selected) {
	        this.setState({
	          isWindowFocused: win.document.hasFocus()
	        });
	      }
	    }
	  }, {
	    key: 'unsubscribeFromWindowFocus',
	    value: function unsubscribeFromWindowFocus() {
	      if (!this._ownerWindow) {
	        return;
	      }
	      var win = this._ownerWindow;
	      win.removeEventListener('focus', this._handleWindowFocus);
	      win.removeEventListener('blur', this._handleWindowBlur);
	    }
	  }, {
	    key: 'ensureInView',
	    value: function ensureInView() {
	      var node = this.props.isBottomTagSelected ? this._tail : this._head;
	      if (node != null) {
	        if (typeof node.scrollIntoViewIfNeeded === 'function') {
	          node.scrollIntoViewIfNeeded();
	        } else if (typeof node.scrollIntoView === 'function') {
	          node.scrollIntoView({
	            // $FlowFixMe Flow does not realize block:"nearest" is a valid option
	            block: 'nearest',
	            inline: 'start'
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var theme = this.context.theme;
	      var _props = this.props,
	          depth = _props.depth,
	          hovered = _props.hovered,
	          isBottomTagHovered = _props.isBottomTagHovered,
	          isBottomTagSelected = _props.isBottomTagSelected,
	          node = _props.node,
	          onContextMenu = _props.onContextMenu,
	          onHover = _props.onHover,
	          onHoverBottom = _props.onHoverBottom,
	          onSelect = _props.onSelect,
	          onSelectBottom = _props.onSelectBottom,
	          onToggleCollapse = _props.onToggleCollapse,
	          searchRegExp = _props.searchRegExp,
	          selected = _props.selected,
	          wrappedChildren = _props.wrappedChildren;
	      var isWindowFocused = this.state.isWindowFocused;
	
	
	      if (!node) {
	        return 'Node was deleted';
	      }
	
	      var children = node.get('children');
	
	      if (node.get('nodeType') === 'Wrapper') {
	        return children.map(function (child) {
	          return React.createElement(WrappedNode, { key: child, id: child, depth: depth });
	        });
	      }
	
	      if (node.get('nodeType') === 'NativeWrapper') {
	        children = wrappedChildren;
	      }
	
	      var collapsed = node.get('collapsed');
	      var inverted = selected && isWindowFocused;
	
	      var headWrapperStyle = wrapperStyle(depth, inverted && !isBottomTagSelected, theme);
	
	      var sharedHeadStyle = headStyle({
	        depth: depth,
	        isBottomTagHovered: isBottomTagHovered,
	        isBottomTagSelected: isBottomTagSelected,
	        isCollapsed: collapsed,
	        isHovered: hovered,
	        isSelected: selected,
	        isWindowFocused: isWindowFocused,
	        theme: theme
	      });
	
	      var headEvents = {
	        onContextMenu: onContextMenu,
	        onDoubleClick: onToggleCollapse,
	        onMouseOver: function onMouseOver() {
	          return onHover(true);
	        },
	        onMouseOut: function onMouseOut() {
	          return onHover(false);
	        },
	        onMouseDown: onSelect
	      };
	      var tailEvents = {
	        onContextMenu: onContextMenu,
	        onDoubleClick: onToggleCollapse,
	        onMouseOver: function onMouseOver() {
	          return onHoverBottom(true);
	        },
	        onMouseOut: function onMouseOut() {
	          return onHoverBottom(false);
	        },
	        onMouseDown: onSelectBottom
	      };
	
	      var nodeType = node.get('nodeType');
	      if (nodeType === 'Text' || nodeType === 'Empty') {
	        var tag = void 0;
	        if (nodeType === 'Text') {
	          var text = node.get('text');
	          tag = React.createElement(
	            'span',
	            { style: tagTextStyle(inverted, theme) },
	            '"',
	            text,
	            '"'
	          );
	        } else if (nodeType === 'Empty') {
	          tag = React.createElement(
	            'span',
	            { style: tagTextStyle(inverted, theme) },
	            React.createElement(
	              'span',
	              { style: styles.falseyLiteral },
	              'null'
	            )
	          );
	        }
	        return React.createElement(
	          'div',
	          _extends({
	            ref: this._setHeadRef,
	            style: sharedHeadStyle
	          }, headEvents),
	          tag
	        );
	      }
	
	      var name = node.get('name') + '';
	
	      // If the user's filtering then highlight search terms in the tag name.
	      // This will serve as a visual reminder that the visible tree is filtered.
	      if (searchRegExp) {
	        var unmatched = name.split(searchRegExp);
	        var matched = name.match(searchRegExp);
	        var pieces = [React.createElement(
	          'span',
	          { key: 0 },
	          unmatched.shift()
	        )];
	        while (unmatched.length > 0) {
	          pieces.push(React.createElement(
	            'span',
	            { key: pieces.length, style: highlightStyle(theme) },
	            nullthrows(matched).shift()
	          ));
	          pieces.push(React.createElement(
	            'span',
	            { key: pieces.length },
	            unmatched.shift()
	          ));
	        }
	
	        name = pieces;
	      }
	
	      var dollarRStyle = {
	        color: isWindowFocused ? getInvertedWeak(theme.state02) : 'inherit'
	      };
	
	      // Single-line tag (collapsed / simple content / no content)
	      if (!children || typeof children === 'string' || !children.length) {
	        var jsxSingleLineTagStyle = jsxTagStyle(inverted, nodeType, theme);
	        var content = children;
	        var _isCollapsed = content === null || content === undefined;
	        return React.createElement(
	          'div',
	          { style: headWrapperStyle },
	          React.createElement(
	            'div',
	            _extends({ style: sharedHeadStyle }, headEvents),
	            '<',
	            React.createElement(
	              'span',
	              { ref: this._setHeadRef, style: jsxSingleLineTagStyle },
	              name
	            ),
	            node.get('key') && React.createElement(Props, { key: 'key', props: { 'key': node.get('key') }, inverted: inverted }),
	            node.get('props') && React.createElement(Props, { key: 'props', props: node.get('props'), inverted: inverted }),
	            _isCollapsed ? ' />' : '>',
	            !_isCollapsed && [React.createElement(
	              Fragment,
	              { key: 'content' },
	              content
	            ), React.createElement(
	              'span',
	              { key: 'close' },
	              '</',
	              React.createElement(
	                'span',
	                { style: jsxSingleLineTagStyle },
	                name
	              ),
	              '>'
	            )],
	            selected && React.createElement(
	              'span',
	              { style: dollarRStyle },
	              '\xA0== $r'
	            )
	          )
	        );
	      }
	
	      var jsxCloseTagStyle = jsxTagStyle(inverted && (isBottomTagSelected || collapsed), nodeType, theme);
	      var closeTag = React.createElement(
	        Fragment,
	        null,
	        '</',
	        React.createElement(
	          'span',
	          { ref: this._setTailRef, style: jsxCloseTagStyle },
	          name
	        ),
	        '>',
	        selected && (collapsed && !this.props.isBottomTagSelected || this.props.isBottomTagSelected) && React.createElement(
	          'span',
	          { style: dollarRStyle },
	          '\xA0== $r'
	        )
	      );
	
	      var headInverted = inverted && (!isBottomTagSelected || collapsed);
	
	      var jsxOpenTagStyle = jsxTagStyle(inverted && (!isBottomTagSelected || collapsed), nodeType, theme);
	      var head = React.createElement(
	        'div',
	        _extends({ style: sharedHeadStyle }, headEvents),
	        React.createElement(
	          'span',
	          {
	            onClick: onToggleCollapse,
	            style: {
	              width: '1rem',
	              textAlign: 'center',
	              marginLeft: '-1rem'
	            }
	          },
	          collapsed ? '▶' : '▼'
	        ),
	        '<',
	        React.createElement(
	          'span',
	          { ref: this._setHeadRef, style: jsxOpenTagStyle },
	          name
	        ),
	        node.get('key') && React.createElement(Props, { key: 'key', props: { 'key': node.get('key') }, inverted: headInverted }),
	        node.get('props') && React.createElement(Props, { key: 'props', props: node.get('props'), inverted: headInverted }),
	        '>',
	        selected && !collapsed && !this.props.isBottomTagSelected && React.createElement(
	          'span',
	          { style: dollarRStyle },
	          '\xA0== $r'
	        ),
	        collapsed && '…',
	        collapsed && closeTag
	      );
	
	      if (collapsed) {
	        return head;
	      }
	
	      var tailStyleActual = tailStyle({
	        depth: depth,
	        isBottomTagHovered: isBottomTagHovered,
	        isBottomTagSelected: isBottomTagSelected,
	        isHovered: hovered,
	        isSelected: selected,
	        isWindowFocused: isWindowFocused,
	        theme: theme
	      });
	
	      return React.createElement(
	        'div',
	        { style: headWrapperStyle },
	        head,
	        React.createElement('div', { style: guidelineStyle(depth, selected, hovered, isBottomTagHovered, theme) }),
	        React.createElement(
	          'div',
	          { style: {
	              paddingLeft: '1rem',
	              color: theme.special07,
	
	              // Ensure children wrap correctly and viewport boundary for narrow trees,
	              // But expand to fill the available width for deep trees.
	              display: 'inline-flex',
	              flexDirection: 'column',
	              minWidth: '100%',
	              boxSizing: 'border-box'
	            } },
	          children.map(function (id) {
	            return React.createElement(WrappedNode, { key: id, depth: depth + 1, id: id });
	          })
	        ),
	        React.createElement(
	          'div',
	          _extends({ style: tailStyleActual }, tailEvents),
	          closeTag
	        )
	      );
	    }
	  }]);
	
	  return Node;
	}(React.Component);
	
	Node.contextTypes = {
	  scrollTo: PropTypes.func,
	  theme: PropTypes.object.isRequired
	};
	
	var WrappedNode = decorate({
	  listeners: function listeners(props) {
	    return [props.id];
	  },
	  props: function props(store, _props2) {
	    var node = store.get(_props2.id);
	    var wrappedChildren = null;
	    if (node && node.get('nodeType') === 'NativeWrapper') {
	      var child = store.get(node.get('children')[0]);
	      wrappedChildren = child && child.get('children');
	    }
	    return {
	      node: node,
	      wrappedChildren: wrappedChildren,
	      selected: store.selected === _props2.id,
	      isBottomTagSelected: store.isBottomTagSelected,
	      isBottomTagHovered: store.isBottomTagHovered,
	      hovered: store.hovered === _props2.id,
	      searchRegExp: _props2.searchRegExp,
	      onToggleCollapse: function onToggleCollapse(e) {
	        e.preventDefault();
	        store.toggleCollapse(_props2.id);
	      },
	      onHover: function onHover(isHovered) {
	        return store.setHover(_props2.id, isHovered, false);
	      },
	      onHoverBottom: function onHoverBottom(isHovered) {
	        return store.setHover(_props2.id, isHovered, true);
	      },
	      onSelect: function onSelect(e) {
	        store.selectTop(_props2.id);
	      },
	      onSelectBottom: function onSelectBottom(e) {
	        store.selectBottom(_props2.id);
	      },
	      onContextMenu: function onContextMenu(e) {
	        store.showContextMenu('tree', e, _props2.id, node);
	      }
	    };
	  },
	  shouldUpdate: function shouldUpdate(nextProps, prevProps) {
	    return nextProps.id !== prevProps.id || nextProps.searchRegExp !== prevProps.searchRegExp;
	  }
	}, Node);
	
	var paddingRight = 5;
	
	var headStyle = function headStyle(_ref2) {
	  var depth = _ref2.depth,
	      isBottomTagHovered = _ref2.isBottomTagHovered,
	      isBottomTagSelected = _ref2.isBottomTagSelected,
	      isCollapsed = _ref2.isCollapsed,
	      isHovered = _ref2.isHovered,
	      isSelected = _ref2.isSelected,
	      isWindowFocused = _ref2.isWindowFocused,
	      theme = _ref2.theme;
	
	  var backgroundColor = void 0;
	  if (isSelected && (isCollapsed || !isBottomTagSelected)) {
	    backgroundColor = isWindowFocused ? theme.state00 : theme.state01;
	  } else if (isHovered && (isCollapsed || !isBottomTagHovered)) {
	    backgroundColor = theme.state03;
	  }
	
	  var isInverted = isSelected && isWindowFocused && (isCollapsed || !isBottomTagSelected);
	  var color = isInverted ? theme.state02 : undefined;
	
	  return {
	    cursor: 'default',
	    borderTop: '1px solid transparent',
	    position: 'relative',
	    display: 'flex',
	    flexShrink: 0,
	    flexWrap: 'wrap',
	    borderRadius: '0.125rem',
	    paddingLeft: '1rem',
	    paddingRight: paddingRight,
	    backgroundColor: backgroundColor,
	    color: color
	  };
	};
	
	var jsxTagStyle = function jsxTagStyle(inverted, nodeType, theme) {
	  var color = void 0;
	  if (inverted) {
	    color = theme.state02;
	  } else if (nodeType === 'Special') {
	    color = theme.special01;
	  } else if (nodeType === 'Composite') {
	    color = theme.special00;
	  } else {
	    color = theme.special07;
	  }
	
	  return {
	    color: color
	  };
	};
	
	var tagTextStyle = function tagTextStyle(inverted, theme) {
	  return {
	    flex: 1,
	    color: inverted ? getInvertedWeak(theme.state02) : theme.special06
	  };
	};
	
	var wrapperStyle = function wrapperStyle(depth, inverted, theme) {
	  return {
	    position: 'relative',
	    color: inverted ? getInvertedWeak(theme.state02) : theme.special07
	  };
	};
	
	var highlightStyle = function highlightStyle(theme) {
	  return {
	    backgroundColor: theme.state04,
	    color: theme.state05
	  };
	};
	
	var tailStyle = function tailStyle(_ref3) {
	  var depth = _ref3.depth,
	      isBottomTagHovered = _ref3.isBottomTagHovered,
	      isBottomTagSelected = _ref3.isBottomTagSelected,
	      isHovered = _ref3.isHovered,
	      isSelected = _ref3.isSelected,
	      isWindowFocused = _ref3.isWindowFocused,
	      theme = _ref3.theme;
	
	  var backgroundColor = void 0;
	  if (isSelected && isBottomTagSelected) {
	    backgroundColor = isWindowFocused ? theme.state00 : theme.state01;
	  } else if (isHovered && isBottomTagHovered) {
	    backgroundColor = theme.state03;
	  }
	
	  var isInverted = isSelected && isWindowFocused && isBottomTagSelected;
	  var color = isInverted ? theme.state02 : theme.base04;
	
	  return {
	    borderTop: '1px solid transparent',
	    cursor: 'default',
	    paddingLeft: '1rem',
	    paddingRight: paddingRight,
	    backgroundColor: backgroundColor,
	    color: color
	  };
	};
	
	var guidelineStyle = function guidelineStyle(depth, isSelected, isHovered, isBottomTagHovered, theme) {
	  var borderLeftColor = 'transparent';
	  if (isSelected) {
	    borderLeftColor = hexToRgba(theme.state00, 0.45);
	  } else if (isHovered && !isBottomTagHovered) {
	    // Only show hover for the top tag, or it gets too noisy.
	    borderLeftColor = hexToRgba(theme.base04, 0.2);
	  }
	
	  return {
	    position: 'absolute',
	    width: '1px',
	    borderLeft: '1px solid ' + borderLeftColor,
	    top: '1rem',
	    bottom: 0,
	    left: '0.5rem',
	    // Bring it in front of the hovered children, but make sure
	    // hovering over parents doesn't draw on top of selected
	    // guideline even when we've selected the closing tag.
	    // When unsure, refer to how Chrome does it (it's subtle!)
	    zIndex: isSelected ? 1 : 0
	  };
	};
	
	// Static styles
	var styles = {
	  falseyLiteral: {
	    fontStyle: 'italic'
	  }
	};
	
	module.exports = WrappedNode;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	
	var _require = __webpack_require__(55),
	    getInvertedMid = _require.getInvertedMid,
	    getInvertedWeak = _require.getInvertedWeak;
	
	var Fragment = React.Fragment;
	
	var Props = function (_React$Component) {
	  _inherits(Props, _React$Component);
	
	  function Props() {
	    _classCallCheck(this, Props);
	
	    return _possibleConstructorReturn(this, (Props.__proto__ || Object.getPrototypeOf(Props)).apply(this, arguments));
	  }
	
	  _createClass(Props, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.props !== this.props.props || nextProps.inverted !== this.props.inverted;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var theme = this.context.theme;
	      var _props = this.props,
	          inverted = _props.inverted,
	          props = _props.props;
	
	      if (!props || (typeof props === 'undefined' ? 'undefined' : _typeof(props)) !== 'object') {
	        return null;
	      }
	
	      var propKeys = Object.keys(props);
	      var names = propKeys.filter(function (name) {
	        var value = props[name];
	        return name[0] !== '_' && name !== 'children' && (typeof value === 'boolean' || typeof value === 'string' || typeof value === 'number' || value == null);
	      });
	
	      var items = [];
	
	      names.forEach(function (name) {
	        var valueIsString = typeof props[name] === 'string';
	
	        var displayValue = props[name];
	        if (displayValue === undefined) {
	          displayValue = 'undefined';
	        } else if (displayValue === null) {
	          displayValue = 'null';
	        } else if (typeof displayValue === 'boolean') {
	          displayValue = displayValue ? 'true' : 'false';
	        } else if (valueIsString && displayValue.length > 50) {
	          displayValue = displayValue.slice(0, 50) + '…';
	        }
	
	        items.push(React.createElement(
	          Fragment,
	          { key: 'prop-' + name },
	          '\xA0',
	          React.createElement(
	            'span',
	            { style: {
	                color: inverted ? getInvertedMid(theme.state02) : theme.special06
	              } },
	            name
	          ),
	          valueIsString ? '="' : '={',
	          React.createElement(
	            'span',
	            { style: {
	                color: inverted ? getInvertedWeak(theme.state02) : theme.special02
	              } },
	            displayValue
	          ),
	          valueIsString ? '"' : '}'
	        ));
	      });
	
	      return items;
	    }
	  }]);
	
	  return Props;
	}(React.Component);
	
	Props.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	module.exports = Props;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(17),
	    sansSerif = _require.sansSerif;
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	var decorate = __webpack_require__(20);
	
	var Breadcrumb = function (_React$Component) {
	  _inherits(Breadcrumb, _React$Component);
	
	  function Breadcrumb(props) {
	    _classCallCheck(this, Breadcrumb);
	
	    var _this = _possibleConstructorReturn(this, (Breadcrumb.__proto__ || Object.getPrototypeOf(Breadcrumb)).call(this, props));
	
	    _this.selectedListItem = React.createRef();
	
	    _this.state = { hovered: null };
	    return _this;
	  }
	  // $FlowFixMe createRef()
	
	
	  _createClass(Breadcrumb, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.selected) {
	        this.ensureInView();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.selected !== prevProps.selected) {
	        this.ensureInView();
	      }
	    }
	  }, {
	    key: 'handleCrumbMouseOver',
	    value: function handleCrumbMouseOver(id) {
	      this.setState({ hovered: id });
	      this.props.hover(id, true);
	    }
	  }, {
	    key: 'handleCrumbMouseOut',
	    value: function handleCrumbMouseOut(id) {
	      this.setState({ hovered: null });
	      this.props.hover(id, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var theme = this.context.theme;
	      var _props = this.props,
	          path = _props.path,
	          selected = _props.selected;
	
	
	      return React.createElement(
	        'ul',
	        { style: containerStyle(theme) },
	        path.map(function (_ref) {
	          var id = _ref.id,
	              node = _ref.node;
	
	          var isSelected = id === selected;
	          var style = itemStyle(isSelected, node.get('nodeType'), theme);
	
	          return React.createElement(
	            'li',
	            {
	              style: style,
	              key: id,
	              onMouseOver: function onMouseOver() {
	                return _this2.handleCrumbMouseOver(id);
	              },
	              onMouseOut: function onMouseOut() {
	                return _this2.handleCrumbMouseOut(id);
	              },
	              onClick: isSelected ? null : function () {
	                return _this2.props.select(id);
	              },
	              ref: isSelected ? _this2.selectedListItem : undefined
	            },
	            node.get('name') || '"' + node.get('text') + '"'
	          );
	        })
	      );
	    }
	  }, {
	    key: 'ensureInView',
	    value: function ensureInView() {
	      var selectedListItem = this.selectedListItem.current;
	      if (selectedListItem != null) {
	        if (typeof selectedListItem.scrollIntoViewIfNeeded === 'function') {
	          selectedListItem.scrollIntoViewIfNeeded({
	            inline: 'nearest'
	          });
	        } else if (typeof selectedListItem.scrollIntoView === 'function') {
	          selectedListItem.scrollIntoView({
	            inline: 'nearest'
	          });
	        }
	      }
	    }
	  }]);
	
	  return Breadcrumb;
	}(React.Component);
	
	Breadcrumb.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	var containerStyle = function containerStyle(theme) {
	  return {
	    fontFamily: sansSerif.family,
	    listStyle: 'none',
	    padding: '0 0.5rem',
	    margin: 0,
	    maxHeight: '80px',
	    backgroundColor: theme.base01,
	    borderTop: '1px solid ' + theme.base03,
	    whiteSpace: 'nowrap',
	    overflow: 'auto'
	  };
	};
	
	var itemStyle = function itemStyle(isSelected, nodeType, theme) {
	  var color = void 0;
	  if (isSelected) {
	    color = theme.state02;
	  } else if (nodeType === 'Special') {
	    color = theme.special01;
	  } else if (nodeType === 'Composite') {
	    color = theme.special05;
	  }
	
	  return {
	    backgroundColor: isSelected ? theme.state00 : 'transparent',
	    color: color,
	    cursor: isSelected ? 'default' : 'pointer',
	    padding: '0.25rem 0.5rem',
	    WebkitUserSelect: 'none',
	    MozUserSelect: 'none',
	    userSelect: 'none',
	    display: 'inline-block'
	  };
	};
	
	function getBreadcrumbPath(store) {
	  var path = [];
	  var current = store.breadcrumbHead;
	  while (current) {
	    path.unshift({
	      id: current,
	      node: store.get(current)
	    });
	    current = store.skipWrapper(store.getParent(current), true);
	  }
	  return path;
	}
	
	module.exports = decorate({
	  listeners: function listeners() {
	    return ['breadcrumbHead', 'selected'];
	  },
	  props: function props(store, _props2) {
	    return {
	      select: function select(id) {
	        return store.selectBreadcrumb(id);
	      },
	      hover: function hover(id, isHovered) {
	        return store.setHover(id, isHovered, false);
	      },
	      selected: store.selected,
	      path: getBreadcrumbPath(store)
	    };
	  }
	}, Breadcrumb);

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	
	var decorate = __webpack_require__(20);
	
	var _require = __webpack_require__(17),
	    sansSerif = _require.sansSerif;
	
	var _require2 = __webpack_require__(68),
	    CUSTOM_THEME_NAME = _require2.CUSTOM_THEME_NAME;
	
	var Icons = __webpack_require__(61);
	var SvgIcon = __webpack_require__(60);
	var ThemeEditor = __webpack_require__(69);
	var Hoverable = __webpack_require__(62);
	var TraceUpdatesFrontendControl = __webpack_require__(319);
	var ColorizerFrontendControl = __webpack_require__(321);
	
	var PreferencesPanel = function (_React$Component) {
	  _inherits(PreferencesPanel, _React$Component);
	
	  function PreferencesPanel(props, context) {
	    _classCallCheck(this, PreferencesPanel);
	
	    var _this = _possibleConstructorReturn(this, (PreferencesPanel.__proto__ || Object.getPrototypeOf(PreferencesPanel)).call(this, props, context));
	
	    _this._changeTheme = function (event) {
	      var changeTheme = _this.props.changeTheme;
	
	
	      changeTheme(event.target.value);
	    };
	
	    _this._hide = function () {
	      var hide = _this.props.hide;
	      var editMode = _this.state.editMode;
	
	
	      if (editMode) {
	        _this.setState({
	          editMode: false
	        });
	      } else {
	        hide();
	      }
	    };
	
	    _this._onEditCustomThemeClick = function () {
	      _this.setState({
	        editMode: true
	      });
	    };
	
	    _this._onKeyUp = function (_ref) {
	      var key = _ref.key;
	
	      if (key === 'Escape') {
	        _this.props.hide();
	      }
	    };
	
	    _this._setSelectRef = function (ref) {
	      _this._selectRef = ref;
	    };
	
	    _this.state = {
	      editMode: false
	    };
	    return _this;
	  }
	
	  _createClass(PreferencesPanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount(prevProps, prevState) {
	      if (this.props.open) {
	        this._selectRef.focus();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.open && !prevProps.open) {
	        this._selectRef.focus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context = this.context,
	          browserName = _context.browserName,
	          showHiddenThemes = _context.showHiddenThemes,
	          theme = _context.theme,
	          themeName = _context.themeName,
	          themes = _context.themes;
	      var _props = this.props,
	          hasCustomTheme = _props.hasCustomTheme,
	          hide = _props.hide,
	          open = _props.open;
	      var editMode = this.state.editMode;
	
	
	      if (!open) {
	        return null;
	      }
	
	      var content = void 0;
	      if (editMode) {
	        content = React.createElement(ThemeEditor, { hide: this._hide, theme: theme });
	      } else {
	        var themeNames = Object.keys(themes);
	        if (!showHiddenThemes) {
	          themeNames = themeNames.filter(function (key) {
	            return !themes[key].hidden;
	          });
	        }
	
	        content = React.createElement(
	          'div',
	          { style: panelStyle(theme), onClick: blockClick },
	          React.createElement(
	            'h4',
	            { style: styles.header },
	            'Preferences'
	          ),
	          React.createElement(
	            'div',
	            { style: styles.preference },
	            React.createElement(TraceUpdatesFrontendControl, null)
	          ),
	          React.createElement(
	            'div',
	            { style: styles.preference },
	            React.createElement(ColorizerFrontendControl, null)
	          ),
	          React.createElement(
	            'h4',
	            { style: styles.header },
	            'Theme'
	          ),
	          React.createElement(
	            'div',
	            { style: styles.selectAndPreviewRow },
	            React.createElement(
	              'select',
	              {
	                onChange: this._changeTheme,
	                onKeyUp: this._onKeyUp,
	                ref: this._setSelectRef,
	                value: themeName
	              },
	              browserName && React.createElement(
	                'option',
	                { value: '' },
	                browserName
	              ),
	              hasCustomTheme && React.createElement(
	                'option',
	                { value: CUSTOM_THEME_NAME },
	                'Custom'
	              ),
	              (browserName || hasCustomTheme) && React.createElement(
	                'option',
	                { disabled: 'disabled' },
	                '---'
	              ),
	              themeNames.map(function (key) {
	                return React.createElement(
	                  'option',
	                  { key: key, value: key },
	                  themes[key].displayName
	                );
	              })
	            ),
	            React.createElement(
	              EditButton,
	              {
	                onClick: this._onEditCustomThemeClick,
	                theme: theme
	              },
	              React.createElement(EditIcon, null)
	            )
	          ),
	          React.createElement(
	            'div',
	            { style: styles.buttonBar },
	            React.createElement(
	              'button',
	              {
	                onClick: hide,
	                style: styles.button
	              },
	              'Close'
	            )
	          )
	        );
	      }
	
	      return React.createElement(
	        'div',
	        { style: styles.backdrop, onClick: this._hide },
	        content
	      );
	    }
	  }]);
	
	  return PreferencesPanel;
	}(React.Component);
	
	PreferencesPanel.contextTypes = {
	  browserName: PropTypes.string.isRequired,
	  showHiddenThemes: PropTypes.bool.isRequired,
	  theme: PropTypes.object.isRequired,
	  themeName: PropTypes.string.isRequired,
	  themes: PropTypes.object.isRequired
	};
	PreferencesPanel.propTypes = {
	  changeTheme: PropTypes.func,
	  hide: PropTypes.func,
	  open: PropTypes.bool
	};
	
	var EditButton = Hoverable(function (_ref2) {
	  var isHovered = _ref2.isHovered,
	      onClick = _ref2.onClick,
	      onMouseEnter = _ref2.onMouseEnter,
	      onMouseLeave = _ref2.onMouseLeave,
	      theme = _ref2.theme;
	  return React.createElement(
	    'button',
	    {
	      onClick: onClick,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      style: buttonStyle(isHovered, theme)
	    },
	    React.createElement(EditIcon, null)
	  );
	});
	
	var EditIcon = function EditIcon() {
	  return React.createElement(SvgIcon, { path: Icons.EDIT });
	};
	
	var blockClick = function blockClick(event) {
	  return event.stopPropagation();
	};
	
	var WrappedPreferencesPanel = decorate({
	  listeners: function listeners() {
	    return ['preferencesPanelShown'];
	  },
	  props: function props(store, _props2) {
	    return {
	      changeTheme: function changeTheme(themeName) {
	        return store.changeTheme(themeName);
	      },
	      hasCustomTheme: !!store.themeStore.customTheme,
	      hide: function hide() {
	        return store.hidePreferencesPanel();
	      },
	      open: store.preferencesPanelShown
	    };
	  }
	}, PreferencesPanel);
	
	var panelStyle = function panelStyle(theme) {
	  return {
	    maxWidth: '100%',
	    margin: '0.5rem',
	    padding: '0.5rem',
	    borderRadius: '0.25rem',
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'flex-start',
	    zIndex: 1,
	    fontFamily: sansSerif.family,
	    backgroundColor: theme.base01,
	    border: '1px solid ' + theme.base03,
	    color: theme.base05
	  };
	};
	
	var buttonStyle = function buttonStyle(isHovered, theme) {
	  return {
	    padding: '0.25rem',
	    marginLeft: '0.25rem',
	    height: '1.5rem',
	    background: 'none',
	    border: 'none',
	    color: isHovered ? theme.state06 : 'inherit'
	  };
	};
	
	var styles = {
	  backdrop: {
	    position: 'fixed',
	    zIndex: 1,
	    width: '100%',
	    height: '100%',
	    top: 0,
	    left: 0,
	    display: 'flex',
	    justifyContent: 'center',
	    alignItems: 'center',
	    backgroundColor: 'rgba(0,0,0,0)'
	  },
	  header: {
	    margin: '0 0 0.5rem'
	  },
	  buttonBar: {
	    flexDirection: 'row'
	  },
	  button: {
	    marginTop: '0.5rem',
	    marginRight: '0.25rem',
	    padding: '0.25rem'
	  },
	  preference: {
	    margin: '0 0 0.5rem',
	    fontSize: sansSerif.sizes.normal
	  },
	  selectAndPreviewRow: {
	    display: 'flex',
	    direction: 'row',
	    alignItems: 'center'
	  }
	};
	
	module.exports = WrappedPreferencesPanel;

/***/ },
/* 68 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var CUSTOM_THEME_NAME = 'Custom';
	
	module.exports = {
	  CUSTOM_THEME_NAME: CUSTOM_THEME_NAME
	};

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(70),
	    copy = _require.copy;
	
	var decorate = __webpack_require__(20);
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	var ColorInput = __webpack_require__(71);
	var ColorGroups = __webpack_require__(313);
	var Hoverable = __webpack_require__(62);
	var Icons = __webpack_require__(61);
	var Input = __webpack_require__(23);
	
	var _require2 = __webpack_require__(17),
	    monospace = _require2.monospace,
	    sansSerif = _require2.sansSerif;
	
	var Preview = __webpack_require__(314);
	var SvgIcon = __webpack_require__(60);
	var Themes = __webpack_require__(316);
	var TimerSafe = __webpack_require__(317);
	
	var _require3 = __webpack_require__(318),
	    deserialize = _require3.deserialize,
	    serialize = _require3.serialize;
	
	var _require4 = __webpack_require__(68),
	    CUSTOM_THEME_NAME = _require4.CUSTOM_THEME_NAME;
	
	var THEME_SITE_URL = 'http://facebook.github.io/react-devtools/?theme=';
	
	// The editor itself should use a known safe theme,
	// In case a user messes up a custom theme and renders it unusable.
	// The editor should remain usable in this case.
	var safeTheme = Themes.ChromeDefault;
	
	var colors = Object.assign({}, ColorGroups.Base, ColorGroups.Selection, ColorGroups.Syntax);
	
	var Editor = function (_React$Component) {
	  _inherits(Editor, _React$Component);
	
	  function Editor(props, context) {
	    _classCallCheck(this, Editor);
	
	    var _this = _possibleConstructorReturn(this, (Editor.__proto__ || Object.getPrototypeOf(Editor)).call(this, props, context));
	
	    _this._copyTheme = function () {
	      var serializedTheme = encodeURI(serialize(_this._customTheme));
	
	      copy(THEME_SITE_URL + serializedTheme);
	
	      // Give (temporary) UI confirmation that the URL has been copied.
	      _this.setState({ showCopyConfirmation: true }, function () {
	        _this.props.setTimeout(function () {
	          return _this.setState({ showCopyConfirmation: false });
	        }, 2500);
	      });
	    };
	
	    _this._onShareChange = function (event) {
	      _this._customTheme = deserialize(event.target.value, _this.props.theme);
	      _this._sanitizeCustomTheme();
	      _this._udpatePreview();
	    };
	
	    _this._udpatePreview = function () {
	      _this.setState(function (state) {
	        return {
	          isResetEnabled: _this._serializedPropsTheme !== serialize(_this._customTheme),
	          updateCounter: state.updateCounter + 1
	        };
	      });
	    };
	
	    _this._reset = function () {
	      _this._customTheme = Object.assign({}, _this.props.theme);
	      _this._udpatePreview();
	    };
	
	    _this._save = function () {
	      var _this$props = _this.props,
	          changeTheme = _this$props.changeTheme,
	          hide = _this$props.hide,
	          saveTheme = _this$props.saveTheme;
	
	
	      saveTheme(_this._customTheme);
	      changeTheme(CUSTOM_THEME_NAME);
	      hide();
	    };
	
	    _this.state = {
	      isResetEnabled: false,
	      showCopyConfirmation: false,
	      updateCounter: 0
	    };
	
	    _this._serializedPropsTheme = serialize(props.theme);
	
	    _this._reset();
	    _this._sanitizeCustomTheme();
	    return _this;
	  }
	
	  _createClass(Editor, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        theme: this._customTheme
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var hide = this.props.hide;
	      var _state = this.state,
	          isResetEnabled = _state.isResetEnabled,
	          showCopyConfirmation = _state.showCopyConfirmation,
	          updateCounter = _state.updateCounter;
	
	
	      return React.createElement(
	        'div',
	        {
	          onClick: function onClick(event) {
	            return event.stopPropagation();
	          },
	          style: editorStyle(safeTheme)
	        },
	        React.createElement(
	          'h3',
	          { style: styles.header },
	          'Custom Theme'
	        ),
	        React.createElement(
	          'div',
	          { style: styles.middleRow },
	          React.createElement(
	            'div',
	            { style: groupStyle(safeTheme) },
	            Object.keys(colors).map(function (key) {
	              return React.createElement(ColorInput, {
	                descriptions: colors[key],
	                customTheme: _this2._customTheme,
	                key: key,
	                label: colors[key],
	                propertyName: key,
	                udpatePreview: _this2._udpatePreview,
	                theme: safeTheme
	              });
	            })
	          ),
	          React.createElement(
	            'div',
	            { style: previewWrapperStyle(this._customTheme) },
	            React.createElement(Preview, {
	              key: updateCounter,
	              theme: this._customTheme
	            })
	          )
	        ),
	        React.createElement(
	          'div',
	          { style: styles.bottomRow },
	          React.createElement(
	            'div',
	            { style: styles.buttons },
	            React.createElement(
	              'button',
	              { onClick: hide },
	              'Cancel'
	            ),
	            ' ',
	            React.createElement(
	              'button',
	              { disabled: !isResetEnabled, onClick: this._reset },
	              'Reset'
	            ),
	            ' ',
	            React.createElement(
	              'button',
	              { onClick: this._save },
	              'Save'
	            )
	          ),
	          React.createElement(
	            'div',
	            { style: styles.importExportRow },
	            React.createElement(CopyThemeButton, {
	              onClick: this._copyTheme,
	              showCopyConfirmation: showCopyConfirmation,
	              title: 'Copy theme to clipboard',
	              theme: safeTheme
	            }),
	            React.createElement(SvgIcon, { path: Icons.SHARE }),
	            React.createElement(
	              'label',
	              { style: styles.shareLabel },
	              'Import/export:'
	            ),
	            React.createElement(Input, {
	              onChange: this._onShareChange,
	              style: shareInput(safeTheme),
	              theme: safeTheme,
	              type: 'text',
	              value: serialize(this._customTheme)
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: '_sanitizeCustomTheme',
	    value: function _sanitizeCustomTheme() {
	      this._customTheme.displayName = CUSTOM_THEME_NAME;
	
	      delete this._customTheme.hidden;
	    }
	  }]);
	
	  return Editor;
	}(React.Component);
	
	Editor.childContextTypes = {
	  theme: PropTypes.object
	};
	
	var WrappedEditor = decorate({
	  listeners: function listeners() {
	    return [];
	  },
	  props: function props(store, _props) {
	    return {
	      changeTheme: function changeTheme(themeName) {
	        return store.changeTheme(themeName);
	      },
	      defaultThemeName: store.themeStore.defaultThemeName,
	      saveTheme: function saveTheme(theme) {
	        return store.saveCustomTheme(theme);
	      }
	    };
	  }
	}, TimerSafe(Editor));
	
	var CopyThemeButton = Hoverable(function (_ref) {
	  var isHovered = _ref.isHovered,
	      isPressed = _ref.isPressed,
	      onClick = _ref.onClick,
	      onMouseDown = _ref.onMouseDown,
	      onMouseEnter = _ref.onMouseEnter,
	      onMouseLeave = _ref.onMouseLeave,
	      onMouseUp = _ref.onMouseUp,
	      showCopyConfirmation = _ref.showCopyConfirmation,
	      theme = _ref.theme;
	  return React.createElement(
	    'button',
	    {
	      onClick: onClick,
	      onMouseDown: onMouseDown,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      onMouseUp: onMouseUp,
	      style: copyThemeButtonStyle(isHovered, isPressed, theme),
	      title: 'Copy theme to clipboard'
	    },
	    React.createElement(SvgIcon, { path: showCopyConfirmation ? Icons.CHECK : Icons.COPY }),
	    React.createElement(
	      'label',
	      { style: styles.copyLabel },
	      showCopyConfirmation ? 'Copied' : 'Copy'
	    )
	  );
	});
	
	var editorStyle = function editorStyle(theme) {
	  return {
	    display: 'flex',
	    flexDirection: 'column',
	    maxWidth: 'calc(100vw - 2rem)',
	    maxHeight: 'calc(100vh - 2rem)',
	    boxSizing: 'border-box',
	    zIndex: 1,
	    padding: '0.5rem',
	    borderRadius: '0.25rem',
	    backgroundColor: theme.base01,
	    color: theme.base05,
	    border: '1px solid ' + theme.base03,
	    fontFamily: sansSerif.family,
	    fontSize: sansSerif.sizes.normal
	  };
	};
	
	var groupStyle = function groupStyle(theme) {
	  return {
	    display: 'flex',
	    flexDirection: 'row',
	    flexWrap: 'wrap',
	    overflowY: 'auto',
	    borderRadius: '0.25rem'
	  };
	};
	
	var previewWrapperStyle = function previewWrapperStyle(theme) {
	  return {
	    display: 'inline-flex',
	    flex: '1 0 auto',
	    marginLeft: '0.5rem',
	    alignItems: 'stretch',
	    borderRadius: '0.25rem',
	    border: '1px solid ' + theme.base03
	  };
	};
	
	var shareInput = function shareInput(theme) {
	  return {
	    flex: '0 1 15rem',
	    padding: '0.25rem',
	    border: '1px solid ' + theme.base03,
	    borderRadius: '0.25rem',
	    fontFamily: monospace.family,
	    fontSize: monospace.sizes.normal,
	    color: 'inherit'
	  };
	};
	
	var copyThemeButtonStyle = function copyThemeButtonStyle(isHovered, isPressed, theme) {
	  return {
	    flex: '0 0 auto',
	    display: 'flex',
	    alignItems: 'center',
	    padding: '0.25rem',
	    margin: '0 0.25rem',
	    height: '1.5rem',
	    background: isPressed ? theme.state01 : 'none',
	    border: 'none',
	    color: isHovered ? theme.state06 : 'inherit'
	  };
	};
	
	var styles = {
	  header: {
	    flex: '0 0 auto',
	    marginTop: 0,
	    marginBottom: '0.5rem'
	  },
	  bottomRow: {
	    flex: '0 0 auto',
	    display: 'flex',
	    flexDirection: 'row',
	    alignItems: 'center',
	    marginTop: '0.5rem'
	  },
	  buttons: {
	    flex: '1 0 auto',
	    marginTop: '0.5rem'
	  },
	  copyLabel: {
	    flex: '0 0 auto',
	    marginLeft: '0.25rem'
	  },
	  middleRow: {
	    display: 'flex',
	    flexDirection: 'row',
	    flex: '0 1 auto',
	    overflowY: 'auto'
	  },
	  column: {
	    display: 'flex',
	    flexDirection: 'column'
	  },
	  importExportRow: {
	    display: 'flex',
	    flexDirection: 'row',
	    alignItems: 'center',
	    flex: '0 0 auto',
	    marginTop: '0.5rem'
	  },
	  shareLabel: {
	    flex: '0 0 auto',
	    margin: '0 0.25rem'
	  }
	};
	
	module.exports = WrappedEditor;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	//  Import support https://stackoverflow.com/questions/13673346/supporting-both-commonjs-and-amd
	(function(name, definition) {
	    if (true) { module.exports = definition(); }
	    else if (typeof define === "function" && typeof define.amd === "object") { define(definition); }
	    else { this[name] = definition(); }
	}("clipboard", function() {
	  if (typeof document === 'undefined' || !document.addEventListener) {
	    return null;
	  }
	
	  var clipboard = {};
	
	  clipboard.copy = (function() {
	    var _intercept = false;
	    var _data = null; // Map from data type (e.g. "text/html") to value.
	    var _bogusSelection = false;
	
	    function cleanup() {
	      _intercept = false;
	      _data = null;
	      if (_bogusSelection) {
	        window.getSelection().removeAllRanges();
	      }
	      _bogusSelection = false;
	    }
	
	    document.addEventListener("copy", function(e) {
	      if (_intercept) {
	        for (var key in _data) {
	          e.clipboardData.setData(key, _data[key]);
	        }
	        e.preventDefault();
	      }
	    });
	
	    // Workaround for Safari: https://bugs.webkit.org/show_bug.cgi?id=156529
	    function bogusSelect() {
	      var sel = document.getSelection();
	      // If "nothing" is selected...
	      if (!document.queryCommandEnabled("copy") && sel.isCollapsed) {
	        // ... temporarily select the entire body.
	        //
	        // We select the entire body because:
	        // - it's guaranteed to exist,
	        // - it works (unlike, say, document.head, or phantom element that is
	        //   not inserted into the DOM),
	        // - it doesn't seem to flicker (due to the synchronous copy event), and
	        // - it avoids modifying the DOM (can trigger mutation observers).
	        //
	        // Because we can't do proper feature detection (we already checked
	        // document.queryCommandEnabled("copy") , which actually gives a false
	        // negative for Blink when nothing is selected) and UA sniffing is not
	        // reliable (a lot of UA strings contain "Safari"), this will also
	        // happen for some browsers other than Safari. :-()
	        var range = document.createRange();
	        range.selectNodeContents(document.body);
	        sel.removeAllRanges();
	        sel.addRange(range);
	        _bogusSelection = true;
	      }
	    };
	
	    return function(data) {
	      return new Promise(function(resolve, reject) {
	        _intercept = true;
	        if (typeof data === "string") {
	          _data = {"text/plain": data};
	        } else if (data instanceof Node) {
	          _data = {"text/html": new XMLSerializer().serializeToString(data)};
	        } else {
	          _data = data;
	        }
	
	        function triggerCopy(tryBogusSelect) {
	          try {
	            if (document.execCommand("copy")) {
	              // document.execCommand is synchronous: http://www.w3.org/TR/2015/WD-clipboard-apis-20150421/#integration-with-rich-text-editing-apis
	              // So we can call resolve() back here.
	              cleanup();
	              resolve();
	            }
	            else {
	              if (!tryBogusSelect) {
	                bogusSelect();
	                triggerCopy(true);
	              } else {
	                throw new Error("Unable to copy. Perhaps it's not available in your browser?");
	              }
	            }
	          } catch (e) {
	            cleanup();
	            reject(e);
	          }
	        }
	        triggerCopy(false);
	
	      });
	    };
	  })();
	
	  clipboard.paste = (function() {
	    var _intercept = false;
	    var _resolve;
	    var _dataType;
	
	    document.addEventListener("paste", function(e) {
	      if (_intercept) {
	        _intercept = false;
	        e.preventDefault();
	        var resolve = _resolve;
	        _resolve = null;
	        resolve(e.clipboardData.getData(_dataType));
	      }
	    });
	
	    return function(dataType) {
	      return new Promise(function(resolve, reject) {
	        _intercept = true;
	        _resolve = resolve;
	        _dataType = dataType || "text/plain";
	        try {
	          if (!document.execCommand("paste")) {
	            _intercept = false;
	            reject(new Error("Unable to paste. Pasting only works in Internet Explorer at the moment."));
	          }
	        } catch (e) {
	          _intercept = false;
	          reject(new Error(e));
	        }
	      });
	    };
	  })();
	
	  // Handle IE behaviour.
	  if (typeof ClipboardEvent === "undefined" &&
	      typeof window.clipboardData !== "undefined" &&
	      typeof window.clipboardData.setData !== "undefined") {
	
	    /*! promise-polyfill 2.0.1 */
	    (function(a){function b(a,b){return function(){a.apply(b,arguments)}}function c(a){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof a)throw new TypeError("not a function");this._state=null,this._value=null,this._deferreds=[],i(a,b(e,this),b(f,this))}function d(a){var b=this;return null===this._state?void this._deferreds.push(a):void j(function(){var c=b._state?a.onFulfilled:a.onRejected;if(null===c)return void(b._state?a.resolve:a.reject)(b._value);var d;try{d=c(b._value)}catch(e){return void a.reject(e)}a.resolve(d)})}function e(a){try{if(a===this)throw new TypeError("A promise cannot be resolved with itself.");if(a&&("object"==typeof a||"function"==typeof a)){var c=a.then;if("function"==typeof c)return void i(b(c,a),b(e,this),b(f,this))}this._state=!0,this._value=a,g.call(this)}catch(d){f.call(this,d)}}function f(a){this._state=!1,this._value=a,g.call(this)}function g(){for(var a=0,b=this._deferreds.length;b>a;a++)d.call(this,this._deferreds[a]);this._deferreds=null}function h(a,b,c,d){this.onFulfilled="function"==typeof a?a:null,this.onRejected="function"==typeof b?b:null,this.resolve=c,this.reject=d}function i(a,b,c){var d=!1;try{a(function(a){d||(d=!0,b(a))},function(a){d||(d=!0,c(a))})}catch(e){if(d)return;d=!0,c(e)}}var j=c.immediateFn||"function"==typeof setImmediate&&setImmediate||function(a){setTimeout(a,1)},k=Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)};c.prototype["catch"]=function(a){return this.then(null,a)},c.prototype.then=function(a,b){var e=this;return new c(function(c,f){d.call(e,new h(a,b,c,f))})},c.all=function(){var a=Array.prototype.slice.call(1===arguments.length&&k(arguments[0])?arguments[0]:arguments);return new c(function(b,c){function d(f,g){try{if(g&&("object"==typeof g||"function"==typeof g)){var h=g.then;if("function"==typeof h)return void h.call(g,function(a){d(f,a)},c)}a[f]=g,0===--e&&b(a)}catch(i){c(i)}}if(0===a.length)return b([]);for(var e=a.length,f=0;f<a.length;f++)d(f,a[f])})},c.resolve=function(a){return a&&"object"==typeof a&&a.constructor===c?a:new c(function(b){b(a)})},c.reject=function(a){return new c(function(b,c){c(a)})},c.race=function(a){return new c(function(b,c){for(var d=0,e=a.length;e>d;d++)a[d].then(b,c)})},"undefined"!=typeof module&&module.exports?module.exports=c:a.Promise||(a.Promise=c)})(this);
	
	    clipboard.copy = function(data) {
	      return new Promise(function(resolve, reject) {
	        // IE supports string and URL types: https://msdn.microsoft.com/en-us/library/ms536744(v=vs.85).aspx
	        // We only support the string type for now.
	        if (typeof data !== "string" && !("text/plain" in data)) {
	          throw new Error("You must provide a text/plain type.");
	        }
	
	        var strData = (typeof data === "string" ? data : data["text/plain"]);
	        var copySucceeded = window.clipboardData.setData("Text", strData);
	        if (copySucceeded) {
	          resolve();
	        } else {
	          reject(new Error("Copying was rejected."));
	        }
	      });
	    };
	
	    clipboard.paste = function() {
	      return new Promise(function(resolve, reject) {
	        var strData = window.clipboardData.getData("Text");
	        if (strData) {
	          resolve(strData);
	        } else {
	          // The user rejected the paste request.
	          reject(new Error("Pasting was rejected."));
	        }
	      });
	    };
	  }
	
	  return clipboard;
	}));


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(11);
	var Portal = __webpack_require__(72);
	var nullthrows = __webpack_require__(16).default;
	var ColorPicker = __webpack_require__(78);
	var Input = __webpack_require__(23);
	
	var _require = __webpack_require__(17),
	    monospace = _require.monospace;
	
	var _require2 = __webpack_require__(55),
	    getBrightness = _require2.getBrightness,
	    isBright = _require2.isBright;
	
	var ColorInput = function (_React$Component) {
	  _inherits(ColorInput, _React$Component);
	
	  function ColorInput(props, context) {
	    _classCallCheck(this, ColorInput);
	
	    var _this = _possibleConstructorReturn(this, (ColorInput.__proto__ || Object.getPrototypeOf(ColorInput)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var customTheme = props.customTheme,
	        propertyName = props.propertyName;
	
	
	    _this.state = {
	      color: customTheme[propertyName],
	      isColorPickerOpen: false,
	      maxHeight: null,
	      targetPosition: {
	        left: 0,
	        top: 0
	      }
	    };
	    return _this;
	  }
	
	  _createClass(ColorInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var customTheme = nextProps.customTheme,
	          propertyName = nextProps.propertyName;
	
	
	      this.setState({
	        color: customTheme[propertyName]
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          theme = _props.theme;
	      var _state = this.state,
	          color = _state.color,
	          isColorPickerOpen = _state.isColorPickerOpen,
	          maxHeight = _state.maxHeight,
	          targetPosition = _state.targetPosition;
	
	
	      var backgroundIsBright = isBright(theme.base00);
	      var chipIsBright = isBright(color);
	      var showColorChipBorder = backgroundIsBright === chipIsBright && getBrightness(color) > getBrightness(theme.base03);
	
	      return React.createElement(
	        'div',
	        {
	          ref: this._setContainerRef,
	          style: containerStyle(maxHeight)
	        },
	        React.createElement(
	          'label',
	          { style: styles.label },
	          label
	        ),
	        React.createElement(
	          'div',
	          { style: inputContainerStyle(theme) },
	          React.createElement('div', {
	            onClick: this._onClick,
	            ref: this._setColorChipRef,
	            style: colorChipStyle(theme, color, showColorChipBorder)
	          }),
	          React.createElement(Input, {
	            onChange: this._onChange,
	            style: styles.input,
	            theme: theme,
	            type: 'text',
	            value: color || ''
	          })
	        ),
	        React.createElement(
	          Portal,
	          {
	            closeOnEsc: true,
	            closeOnOutsideClick: true,
	            isOpened: isColorPickerOpen,
	            onClose: this._onClose
	          },
	          React.createElement(
	            'div',
	            { style: colorPickerPosition(targetPosition) },
	            React.createElement(ColorPicker, {
	              color: color,
	              theme: theme,
	              updateColor: this._updateColor
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ColorInput;
	}(React.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._onChange = function (_ref) {
	    var target = _ref.target;
	
	    _this2._updateColor(target.value);
	  };
	
	  this._onClick = function (event) {
	    var container = nullthrows(_this2._containerRef);
	    var targetPosition = nullthrows(_this2._colorChipRef).getBoundingClientRect();
	
	    _this2.setState({
	      isColorPickerOpen: true,
	      maxHeight: container.offsetHeight,
	      targetPosition: targetPosition
	    });
	  };
	
	  this._onClose = function () {
	    _this2.setState({
	      isColorPickerOpen: false
	    });
	  };
	
	  this._setColorChipRef = function (ref) {
	    _this2._colorChipRef = ref;
	  };
	
	  this._setContainerRef = function (ref) {
	    _this2._containerRef = ref;
	  };
	
	  this._updateColor = function (color) {
	    var _props2 = _this2.props,
	        customTheme = _props2.customTheme,
	        propertyName = _props2.propertyName,
	        udpatePreview = _props2.udpatePreview;
	
	
	    customTheme[propertyName] = color;
	
	    _this2.setState({
	      color: color
	    });
	
	    udpatePreview();
	  };
	};
	
	var colorPickerPosition = function colorPickerPosition(position) {
	  return {
	    position: 'absolute',
	    left: position.left + 'px',
	    top: position.top + 'px'
	  };
	};
	
	var containerStyle = function containerStyle(maxHeight) {
	  return {
	    margin: '0.25rem',
	    minWidth: '7.5rem',
	    maxHeight: maxHeight
	  };
	};
	
	var colorChipStyle = function colorChipStyle(theme) {
	  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var showBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  return {
	    height: '1.25rem',
	    width: '1.25rem',
	    borderRadius: '2px',
	    backgroundColor: color,
	    boxSizing: 'border-box',
	    border: showBorder ? '1px solid ' + theme.base03 : 'none'
	  };
	};
	
	var inputContainerStyle = function inputContainerStyle(theme) {
	  return {
	    display: 'flex',
	    flexDirection: 'row',
	    alignItems: 'center',
	    padding: '0.125rem',
	    flex: '0 0 1.25rem',
	    backgroundColor: theme.base00,
	    color: theme.base05,
	    border: '1px solid ' + theme.base03,
	    borderRadius: '0.25rem'
	  };
	};
	
	var styles = {
	  input: {
	    width: '5rem',
	    flex: '1 0 auto',
	    textTransform: 'lowercase',
	    boxSizing: 'border-box',
	    background: 'transparent',
	    border: 'none',
	    marginLeft: '0.25rem',
	    outline: 'none',
	    color: 'inherit',
	    fontFamily: monospace.family,
	    fontSize: monospace.sizes.large
	  },
	  label: {
	    marginBottom: '0.25rem',
	    display: 'inline-block'
	  },
	  small: {
	    fontWeight: 'normal'
	  }
	};
	
	module.exports = ColorInput;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(26);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(73);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));
	
	    _this.state = { active: false };
	    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    _this.portal = null;
	    _this.node = null;
	    return _this;
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('mouseup', this.handleOutsideMouseClick);
	        document.addEventListener('touchstart', this.handleOutsideMouseClick);
	      }
	
	      if (this.props.isOpened) {
	        this.openPortal();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      // portal's 'is open' state is handled through the prop isOpened
	      if (typeof newProps.isOpened !== 'undefined') {
	        if (newProps.isOpened) {
	          if (this.state.active) {
	            this.renderPortal(newProps);
	          } else {
	            this.openPortal(newProps);
	          }
	        }
	        if (!newProps.isOpened && this.state.active) {
	          this.closePortal();
	        }
	      }
	
	      // portal handles its own 'is open' state
	      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
	        this.renderPortal(newProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
	        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
	      }
	
	      this.closePortal(true);
	    }
	  }, {
	    key: 'handleWrapperClick',
	    value: function handleWrapperClick(e) {
	      e.preventDefault();
	      e.stopPropagation();
	      if (this.state.active) {
	        return;
	      }
	      this.openPortal();
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      this.setState({ active: true });
	      this.renderPortal(props);
	      this.props.onOpen(this.node);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      var _this2 = this;
	
	      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var resetPortalState = function resetPortalState() {
	        if (_this2.node) {
	          _reactDom2.default.unmountComponentAtNode(_this2.node);
	          document.body.removeChild(_this2.node);
	        }
	        _this2.portal = null;
	        _this2.node = null;
	        if (isUnmounted !== true) {
	          _this2.setState({ active: false });
	        }
	      };
	
	      if (this.state.active) {
	        if (this.props.beforeClose) {
	          this.props.beforeClose(this.node, resetPortalState);
	        } else {
	          resetPortalState();
	        }
	
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	
	      var root = (0, _reactDom.findDOMNode)(this.portal);
	      if (root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	
	      e.stopPropagation();
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.node) {
	        this.node = document.createElement('div');
	        document.body.appendChild(this.node);
	      }
	
	      var children = props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof props.children.type === 'function') {
	        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.openByClickOn) {
	        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
	      }
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.element.isRequired,
	  openByClickOn: _propTypes2.default.element,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  isOpened: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  beforeClose: _propTypes2.default.func,
	  onUpdate: _propTypes2.default.func
	};
	
	Portal.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {},
	  onUpdate: function onUpdate() {}
	};
	module.exports = exports['default'];


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(74)();
	}


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(75);
	var invariant = __webpack_require__(76);
	var ReactPropTypesSecret = __webpack_require__(77);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 75 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 77 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(11);
	
	var _require = __webpack_require__(79),
	    CustomPicker = _require.CustomPicker;
	
	var _require2 = __webpack_require__(247),
	    Hue = _require2.Hue,
	    Saturation = _require2.Saturation;
	
	var ColorPicker = function (_React$Component) {
	  _inherits(ColorPicker, _React$Component);
	
	  function ColorPicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ColorPicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeComplete = function (color) {
	      _this.props.updateColor(color.hex);
	    }, _this._setRef = function (ref) {
	      _this._ref = ref;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ColorPicker, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          color = _props.color,
	          theme = _props.theme;
	
	
	      return React.createElement(DecoratedCustomColorPicker, {
	        color: color,
	        disableAlpha: true,
	        onChangeComplete: this._onChangeComplete,
	        ref: this._setRef,
	        theme: theme
	      });
	    }
	  }]);
	
	  return ColorPicker;
	}(React.Component);
	
	var CustomColorPicker = function (_React$Component2) {
	  _inherits(CustomColorPicker, _React$Component2);
	
	  function CustomColorPicker() {
	    _classCallCheck(this, CustomColorPicker);
	
	    return _possibleConstructorReturn(this, (CustomColorPicker.__proto__ || Object.getPrototypeOf(CustomColorPicker)).apply(this, arguments));
	  }
	
	  _createClass(CustomColorPicker, [{
	    key: 'render',
	    value: function render() {
	      return React.createElement(
	        'div',
	        { style: customColorPicker(this.props.theme) },
	        React.createElement(
	          'div',
	          { style: styles.saturation },
	          React.createElement(Saturation, _extends({}, this.props, {
	            onChange: this.props.onChange,
	            pointer: CustomPointer
	          }))
	        ),
	        React.createElement(
	          'div',
	          { style: styles.hue },
	          React.createElement(Hue, _extends({}, this.props, {
	            direction: 'vertical',
	            onChange: this.props.onChange,
	            pointer: CustomPointer
	          }))
	        )
	      );
	    }
	  }]);
	
	  return CustomColorPicker;
	}(React.Component);
	
	var CustomPointer = function CustomPointer() {
	  return React.createElement('div', { style: styles.pointer });
	};
	
	var DecoratedCustomColorPicker = CustomPicker(CustomColorPicker);
	
	var customColorPicker = function customColorPicker(theme) {
	  return {
	    display: 'flex',
	    flexDirection: 'row',
	    padding: '0.125rem',
	    borderRadius: '0.25rem',
	    position: 'relative',
	    zIndex: 1,
	    background: theme.base00,
	    border: '1px solid ' + theme.base03
	  };
	};
	
	var styles = {
	  saturation: {
	    flex: '0 0 auto',
	    position: 'relative',
	    width: '6rem',
	    height: '6rem'
	  },
	  hue: {
	    flex: '1 0 auto',
	    position: 'relative',
	    width: '0.75rem',
	    height: '6rem',
	    marginLeft: '0.125rem'
	  },
	  pointer: {
	    width: '0.25rem',
	    height: '0.25rem',
	    borderRadius: '50%',
	    transform: 'translate(-0.125rem, -0.125rem)',
	    boxShadow: 'rgb(255, 255, 255) 0px 0px 0px 1.5px, rgba(0, 0, 0, 0.3) 0px 0px 1px 1px inset, rgba(0, 0, 0, 0.4) 0px 0px 1px 2px'
	  }
	};
	
	module.exports = ColorPicker;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomPicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;
	
	var _Alpha = __webpack_require__(80);
	
	Object.defineProperty(exports, 'AlphaPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Block = __webpack_require__(268);
	
	Object.defineProperty(exports, 'BlockPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Block).default;
	  }
	});
	
	var _Circle = __webpack_require__(270);
	
	Object.defineProperty(exports, 'CirclePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Circle).default;
	  }
	});
	
	var _Chrome = __webpack_require__(273);
	
	Object.defineProperty(exports, 'ChromePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chrome).default;
	  }
	});
	
	var _Compact = __webpack_require__(277);
	
	Object.defineProperty(exports, 'CompactPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Compact).default;
	  }
	});
	
	var _Github = __webpack_require__(291);
	
	Object.defineProperty(exports, 'GithubPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Github).default;
	  }
	});
	
	var _Hue = __webpack_require__(293);
	
	Object.defineProperty(exports, 'HuePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Material = __webpack_require__(295);
	
	Object.defineProperty(exports, 'MaterialPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Material).default;
	  }
	});
	
	var _Photoshop = __webpack_require__(296);
	
	Object.defineProperty(exports, 'PhotoshopPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Photoshop).default;
	  }
	});
	
	var _Sketch = __webpack_require__(302);
	
	Object.defineProperty(exports, 'SketchPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sketch).default;
	  }
	});
	
	var _Slider = __webpack_require__(305);
	
	Object.defineProperty(exports, 'SliderPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Slider).default;
	  }
	});
	
	var _Swatches = __webpack_require__(309);
	
	Object.defineProperty(exports, 'SwatchesPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatches).default;
	  }
	});
	
	var _Twitter = __webpack_require__(312);
	
	Object.defineProperty(exports, 'TwitterPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Twitter).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(261);
	
	Object.defineProperty(exports, 'CustomPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Chrome2 = _interopRequireDefault(_Chrome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chrome2.default;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(247);
	
	var _AlphaPointer = __webpack_require__(267);
	
	var _AlphaPointer2 = _interopRequireDefault(_AlphaPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
	  var rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      direction = _ref.direction,
	      style = _ref.style,
	      renderers = _ref.renderers,
	      pointer = _ref.pointer;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      alpha: {
	        radius: '2px',
	        style: style
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'alpha-picker' },
	    _react2.default.createElement(_common.Alpha, _extends({}, styles.alpha, {
	      rgb: rgb,
	      hsl: hsl,
	      pointer: pointer,
	      renderers: renderers,
	      onChange: onChange,
	      direction: direction
	    }))
	  );
	};
	
	AlphaPicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _AlphaPointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(AlphaPicker);

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;
	
	var _flattenNames = __webpack_require__(82);
	
	var _flattenNames2 = _interopRequireDefault(_flattenNames);
	
	var _mergeClasses = __webpack_require__(210);
	
	var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
	
	var _autoprefix = __webpack_require__(243);
	
	var _autoprefix2 = _interopRequireDefault(_autoprefix);
	
	var _hover2 = __webpack_require__(244);
	
	var _hover3 = _interopRequireDefault(_hover2);
	
	var _active = __webpack_require__(245);
	
	var _active2 = _interopRequireDefault(_active);
	
	var _loop2 = __webpack_require__(246);
	
	var _loop3 = _interopRequireDefault(_loop2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.hover = _hover3.default;
	exports.handleHover = _hover3.default;
	exports.handleActive = _active2.default;
	exports.loop = _loop3.default;
	var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
	  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    activations[_key - 1] = arguments[_key];
	  }
	
	  var activeNames = (0, _flattenNames2.default)(activations);
	  var merged = (0, _mergeClasses2.default)(classes, activeNames);
	  return (0, _autoprefix2.default)(merged);
	};
	
	exports.default = ReactCSS;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flattenNames = undefined;
	
	var _isString2 = __webpack_require__(83);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _forOwn2 = __webpack_require__(92);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _isPlainObject2 = __webpack_require__(119);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _map2 = __webpack_require__(121);
	
	var _map3 = _interopRequireDefault(_map2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flattenNames = exports.flattenNames = function flattenNames() {
	  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var names = [];
	
	  (0, _map3.default)(things, function (thing) {
	    if (Array.isArray(thing)) {
	      flattenNames(thing).map(function (name) {
	        return names.push(name);
	      });
	    } else if ((0, _isPlainObject3.default)(thing)) {
	      (0, _forOwn3.default)(thing, function (value, key) {
	        value === true && names.push(key);
	        names.push(key + '-' + value);
	      });
	    } else if ((0, _isString3.default)(thing)) {
	      names.push(thing);
	    }
	  });
	
	  return names;
	};
	
	exports.default = flattenNames;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(84),
	    isArray = __webpack_require__(90),
	    isObjectLike = __webpack_require__(91);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(85),
	    getRawTag = __webpack_require__(88),
	    objectToString = __webpack_require__(89);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(86);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(87);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 87 */
/***/ function(module, exports) {

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(85);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 89 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 90 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 91 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(93),
	    castFunction = __webpack_require__(117);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(94),
	    keys = __webpack_require__(96);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(95);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 95 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(97),
	    baseKeys = __webpack_require__(110),
	    isArrayLike = __webpack_require__(114);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(98),
	    isArguments = __webpack_require__(99),
	    isArray = __webpack_require__(90),
	    isBuffer = __webpack_require__(101),
	    isIndex = __webpack_require__(104),
	    isTypedArray = __webpack_require__(105);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 98 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(100),
	    isObjectLike = __webpack_require__(91);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(84),
	    isObjectLike = __webpack_require__(91);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(86),
	    stubFalse = __webpack_require__(103);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ },
/* 102 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 103 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 104 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(106),
	    baseUnary = __webpack_require__(108),
	    nodeUtil = __webpack_require__(109);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(84),
	    isLength = __webpack_require__(107),
	    isObjectLike = __webpack_require__(91);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 107 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 108 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(87);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(111),
	    nativeKeys = __webpack_require__(112);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 111 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(113);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 113 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(115),
	    isLength = __webpack_require__(107);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(84),
	    isObject = __webpack_require__(116);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 116 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(118);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(84),
	    getPrototype = __webpack_require__(120),
	    isObjectLike = __webpack_require__(91);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(113);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(122),
	    baseIteratee = __webpack_require__(123),
	    baseMap = __webpack_require__(207),
	    isArray = __webpack_require__(90);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 122 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(124),
	    baseMatchesProperty = __webpack_require__(189),
	    identity = __webpack_require__(118),
	    isArray = __webpack_require__(90),
	    property = __webpack_require__(204);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(125),
	    getMatchData = __webpack_require__(186),
	    matchesStrictComparable = __webpack_require__(188);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(126),
	    baseIsEqual = __webpack_require__(162);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(127),
	    stackClear = __webpack_require__(135),
	    stackDelete = __webpack_require__(136),
	    stackGet = __webpack_require__(137),
	    stackHas = __webpack_require__(138),
	    stackSet = __webpack_require__(139);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(128),
	    listCacheDelete = __webpack_require__(129),
	    listCacheGet = __webpack_require__(132),
	    listCacheHas = __webpack_require__(133),
	    listCacheSet = __webpack_require__(134);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 128 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(130);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(131);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 131 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(130);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(130);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(130);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(127);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 136 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 137 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 138 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(127),
	    Map = __webpack_require__(140),
	    MapCache = __webpack_require__(147);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(141),
	    root = __webpack_require__(86);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(142),
	    getValue = __webpack_require__(146);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(115),
	    isMasked = __webpack_require__(143),
	    isObject = __webpack_require__(116),
	    toSource = __webpack_require__(145);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(144);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(86);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 145 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 146 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(148),
	    mapCacheDelete = __webpack_require__(156),
	    mapCacheGet = __webpack_require__(159),
	    mapCacheHas = __webpack_require__(160),
	    mapCacheSet = __webpack_require__(161);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(149),
	    ListCache = __webpack_require__(127),
	    Map = __webpack_require__(140);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(150),
	    hashDelete = __webpack_require__(152),
	    hashGet = __webpack_require__(153),
	    hashHas = __webpack_require__(154),
	    hashSet = __webpack_require__(155);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(151);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(141);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 152 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(151);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(151);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(151);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(157);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(158);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(157);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(157);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(157);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(163),
	    isObjectLike = __webpack_require__(91);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(126),
	    equalArrays = __webpack_require__(164),
	    equalByTag = __webpack_require__(170),
	    equalObjects = __webpack_require__(174),
	    getTag = __webpack_require__(181),
	    isArray = __webpack_require__(90),
	    isBuffer = __webpack_require__(101),
	    isTypedArray = __webpack_require__(105);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(165),
	    arraySome = __webpack_require__(168),
	    cacheHas = __webpack_require__(169);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(147),
	    setCacheAdd = __webpack_require__(166),
	    setCacheHas = __webpack_require__(167);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 166 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 167 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 168 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 169 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(85),
	    Uint8Array = __webpack_require__(171),
	    eq = __webpack_require__(131),
	    equalArrays = __webpack_require__(164),
	    mapToArray = __webpack_require__(172),
	    setToArray = __webpack_require__(173);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(86);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 172 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(175);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(176),
	    getSymbols = __webpack_require__(178),
	    keys = __webpack_require__(96);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(177),
	    isArray = __webpack_require__(90);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 177 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(179),
	    stubArray = __webpack_require__(180);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 179 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 180 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(182),
	    Map = __webpack_require__(140),
	    Promise = __webpack_require__(183),
	    Set = __webpack_require__(184),
	    WeakMap = __webpack_require__(185),
	    baseGetTag = __webpack_require__(84),
	    toSource = __webpack_require__(145);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(141),
	    root = __webpack_require__(86);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(141),
	    root = __webpack_require__(86);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(141),
	    root = __webpack_require__(86);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(141),
	    root = __webpack_require__(86);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(187),
	    keys = __webpack_require__(96);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(116);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 188 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(162),
	    get = __webpack_require__(190),
	    hasIn = __webpack_require__(201),
	    isKey = __webpack_require__(193),
	    isStrictComparable = __webpack_require__(187),
	    matchesStrictComparable = __webpack_require__(188),
	    toKey = __webpack_require__(200);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(191);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(192),
	    toKey = __webpack_require__(200);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(90),
	    isKey = __webpack_require__(193),
	    stringToPath = __webpack_require__(195),
	    toString = __webpack_require__(198);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(90),
	    isSymbol = __webpack_require__(194);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(84),
	    isObjectLike = __webpack_require__(91);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(196);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(197);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(147);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(199);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(85),
	    arrayMap = __webpack_require__(122),
	    isArray = __webpack_require__(90),
	    isSymbol = __webpack_require__(194);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(194);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(202),
	    hasPath = __webpack_require__(203);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 202 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(192),
	    isArguments = __webpack_require__(99),
	    isArray = __webpack_require__(90),
	    isIndex = __webpack_require__(104),
	    isLength = __webpack_require__(107),
	    toKey = __webpack_require__(200);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(205),
	    basePropertyDeep = __webpack_require__(206),
	    isKey = __webpack_require__(193),
	    toKey = __webpack_require__(200);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 205 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(191);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(208),
	    isArrayLike = __webpack_require__(114);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(93),
	    createBaseEach = __webpack_require__(209);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(114);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeClasses = undefined;
	
	var _forOwn2 = __webpack_require__(92);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _cloneDeep2 = __webpack_require__(211);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
	  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
	  activeNames.map(function (name) {
	    var toMerge = classes[name];
	    if (toMerge) {
	      (0, _forOwn3.default)(toMerge, function (value, key) {
	        if (!styles[key]) {
	          styles[key] = {};
	        }
	
	        styles[key] = _extends({}, styles[key], toMerge[key]);
	      });
	    }
	
	    return name;
	  });
	  return styles;
	};
	
	exports.default = mergeClasses;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(212);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(126),
	    arrayEach = __webpack_require__(213),
	    assignValue = __webpack_require__(214),
	    baseAssign = __webpack_require__(217),
	    baseAssignIn = __webpack_require__(219),
	    cloneBuffer = __webpack_require__(223),
	    copyArray = __webpack_require__(224),
	    copySymbols = __webpack_require__(225),
	    copySymbolsIn = __webpack_require__(226),
	    getAllKeys = __webpack_require__(175),
	    getAllKeysIn = __webpack_require__(228),
	    getTag = __webpack_require__(181),
	    initCloneArray = __webpack_require__(229),
	    initCloneByTag = __webpack_require__(230),
	    initCloneObject = __webpack_require__(241),
	    isArray = __webpack_require__(90),
	    isBuffer = __webpack_require__(101),
	    isObject = __webpack_require__(116),
	    keys = __webpack_require__(96);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 213 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(215),
	    eq = __webpack_require__(131);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(216);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(141);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(218),
	    keys = __webpack_require__(96);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(214),
	    baseAssignValue = __webpack_require__(215);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(218),
	    keysIn = __webpack_require__(220);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(97),
	    baseKeysIn = __webpack_require__(221),
	    isArrayLike = __webpack_require__(114);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(116),
	    isPrototype = __webpack_require__(111),
	    nativeKeysIn = __webpack_require__(222);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 222 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(86);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ },
/* 224 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(218),
	    getSymbols = __webpack_require__(178);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(218),
	    getSymbolsIn = __webpack_require__(227);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(177),
	    getPrototype = __webpack_require__(120),
	    getSymbols = __webpack_require__(178),
	    stubArray = __webpack_require__(180);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(176),
	    getSymbolsIn = __webpack_require__(227),
	    keysIn = __webpack_require__(220);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 229 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(231),
	    cloneDataView = __webpack_require__(232),
	    cloneMap = __webpack_require__(233),
	    cloneRegExp = __webpack_require__(236),
	    cloneSet = __webpack_require__(237),
	    cloneSymbol = __webpack_require__(239),
	    cloneTypedArray = __webpack_require__(240);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(171);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(231);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(234),
	    arrayReduce = __webpack_require__(235),
	    mapToArray = __webpack_require__(172);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 234 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 235 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 236 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(238),
	    arrayReduce = __webpack_require__(235),
	    setToArray = __webpack_require__(173);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 238 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(85);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(231);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(242),
	    getPrototype = __webpack_require__(120),
	    isPrototype = __webpack_require__(111);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(116);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.autoprefix = undefined;
	
	var _forOwn2 = __webpack_require__(92);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transforms = {
	  borderRadius: function borderRadius(value) {
	    return {
	      msBorderRadius: value,
	      MozBorderRadius: value,
	      OBorderRadius: value,
	      WebkitBorderRadius: value,
	      borderRadius: value
	    };
	  },
	  boxShadow: function boxShadow(value) {
	    return {
	      msBoxShadow: value,
	      MozBoxShadow: value,
	      OBoxShadow: value,
	      WebkitBoxShadow: value,
	      boxShadow: value
	    };
	  },
	  userSelect: function userSelect(value) {
	    return {
	      WebkitTouchCallout: value,
	      KhtmlUserSelect: value,
	      MozUserSelect: value,
	      msUserSelect: value,
	      WebkitUserSelect: value,
	      userSelect: value
	    };
	  },
	
	  flex: function flex(value) {
	    return {
	      WebkitBoxFlex: value,
	      MozBoxFlex: value,
	      WebkitFlex: value,
	      msFlex: value,
	      flex: value
	    };
	  },
	  flexBasis: function flexBasis(value) {
	    return {
	      WebkitFlexBasis: value,
	      flexBasis: value
	    };
	  },
	  justifyContent: function justifyContent(value) {
	    return {
	      WebkitJustifyContent: value,
	      justifyContent: value
	    };
	  },
	
	  transition: function transition(value) {
	    return {
	      msTransition: value,
	      MozTransition: value,
	      OTransition: value,
	      WebkitTransition: value,
	      transition: value
	    };
	  },
	
	  transform: function transform(value) {
	    return {
	      msTransform: value,
	      MozTransform: value,
	      OTransform: value,
	      WebkitTransform: value,
	      transform: value
	    };
	  },
	  absolute: function absolute(value) {
	    var direction = value && value.split(' ');
	    return {
	      position: 'absolute',
	      top: direction && direction[0],
	      right: direction && direction[1],
	      bottom: direction && direction[2],
	      left: direction && direction[3]
	    };
	  },
	  extend: function extend(name, otherElementStyles) {
	    var otherStyle = otherElementStyles[name];
	    if (otherStyle) {
	      return otherStyle;
	    }
	    return {
	      'extend': name
	    };
	  }
	};
	
	var autoprefix = exports.autoprefix = function autoprefix(elements) {
	  var prefixed = {};
	  (0, _forOwn3.default)(elements, function (styles, element) {
	    var expanded = {};
	    (0, _forOwn3.default)(styles, function (value, key) {
	      var transform = transforms[key];
	      if (transform) {
	        expanded = _extends({}, expanded, transform(value));
	      } else {
	        expanded[key] = value;
	      }
	    });
	    prefixed[element] = expanded;
	  });
	  return prefixed;
	};
	
	exports.default = autoprefix;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hover = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hover = exports.hover = function hover(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Hover, _React$Component);
	
	    function Hover() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Hover);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
	        return _this.setState({ hover: true });
	      }, _this.handleMouseOut = function () {
	        return _this.setState({ hover: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Hover;
	  }(_react2.default.Component);
	};
	
	exports.default = hover;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.active = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var active = exports.active = function active(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Active, _React$Component);
	
	    function Active() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Active);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
	        return _this.setState({ active: true });
	      }, _this.handleMouseUp = function () {
	        return _this.setState({ active: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Active;
	  }(_react2.default.Component);
	};
	
	exports.default = active;

/***/ },
/* 246 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loopable = function loopable(i, length) {
	  var props = {};
	  var setProp = function setProp(name) {
	    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    props[name] = value;
	  };
	
	  i === 0 && setProp('first-child');
	  i === length - 1 && setProp('last-child');
	  (i === 0 || i % 2 === 0) && setProp('even');
	  Math.abs(i % 2) === 1 && setProp('odd');
	  setProp('nth-child', i);
	
	  return props;
	};
	
	exports.default = loopable;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alpha = __webpack_require__(248);
	
	Object.defineProperty(exports, 'Alpha', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Checkboard = __webpack_require__(250);
	
	Object.defineProperty(exports, 'Checkboard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkboard).default;
	  }
	});
	
	var _EditableInput = __webpack_require__(252);
	
	Object.defineProperty(exports, 'EditableInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EditableInput).default;
	  }
	});
	
	var _Hue = __webpack_require__(253);
	
	Object.defineProperty(exports, 'Hue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Saturation = __webpack_require__(255);
	
	Object.defineProperty(exports, 'Saturation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Saturation).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(261);
	
	Object.defineProperty(exports, 'ColorWrap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Swatch = __webpack_require__(266);
	
	Object.defineProperty(exports, 'Swatch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatch).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Alpha = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _alpha = __webpack_require__(249);
	
	var alpha = _interopRequireWildcard(_alpha);
	
	var _Checkboard = __webpack_require__(250);
	
	var _Checkboard2 = _interopRequireDefault(_Checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Alpha = exports.Alpha = function (_ref) {
	  _inherits(Alpha, _ref);
	
	  function Alpha() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Alpha);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
	      var change = alpha.calculateChange(e, skip, _this.props, _this.refs.container);
	      change && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleChange);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Alpha, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var rgb = this.props.rgb;
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          alpha: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          checkboard: {
	            absolute: '0px 0px 0px 0px',
	            overflow: 'hidden'
	          },
	          gradient: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          container: {
	            position: 'relative',
	            height: '100%',
	            margin: '0 3px'
	          },
	          pointer: {
	            position: 'absolute',
	            left: rgb.a * 100 + '%'
	          },
	          slider: {
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            marginTop: '1px',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          gradient: {
	            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
	          },
	          pointer: {
	            left: 0,
	            top: rgb.a * 100 + '%'
	          }
	        },
	        'overwrite': _extends({}, this.props.style)
	      }, {
	        vertical: this.props.direction === 'vertical',
	        overwrite: true
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.alpha },
	        _react2.default.createElement(
	          'div',
	          { style: styles.checkboard },
	          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
	        ),
	        _react2.default.createElement('div', { style: styles.gradient }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: styles.container,
	            ref: 'container',
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Alpha;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Alpha;

/***/ },
/* 249 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChange = calculateChange;
	function calculateChange(e, skip, props, container) {
	  !skip && e.preventDefault();
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (props.direction === 'vertical') {
	    var a = void 0;
	    if (top < 0) {
	      a = 0;
	    } else if (top > containerHeight) {
	      a = 1;
	    } else {
	      a = Math.round(top * 100 / containerHeight) / 100;
	    }
	
	    if (props.hsl.a !== a) {
	      return {
	        h: props.hsl.h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: a,
	        source: 'rgb'
	      };
	    }
	  } else {
	    var _a = void 0;
	    if (left < 0) {
	      _a = 0;
	    } else if (left > containerWidth) {
	      _a = 1;
	    } else {
	      _a = Math.round(left * 100 / containerWidth) / 100;
	    }
	
	    if (props.a !== _a) {
	      return {
	        h: props.hsl.h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: _a,
	        source: 'rgb'
	      };
	    }
	  }
	  return null;
	}

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkboard = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _checkboard = __webpack_require__(251);
	
	var checkboard = _interopRequireWildcard(_checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkboard = exports.Checkboard = function Checkboard(_ref) {
	  var white = _ref.white,
	      grey = _ref.grey,
	      size = _ref.size,
	      renderers = _ref.renderers;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      grid: {
	        absolute: '0px 0px 0px 0px',
	        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.grid });
	};
	
	Checkboard.defaultProps = {
	  size: 8,
	  white: 'transparent',
	  grey: 'rgba(0,0,0,.08)',
	  renderers: {}
	};
	
	exports.default = Checkboard;

/***/ },
/* 251 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.render = render;
	exports.get = get;
	var checkboardCache = {};
	
	function render(c1, c2, size, serverCanvas) {
	  if (typeof document === 'undefined' && !serverCanvas) return null;
	  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
	  canvas.width = size * 2;
	  canvas.height = size * 2;
	  var ctx = canvas.getContext('2d');
	  if (!ctx) return null; // If no context can be found, return early.
	  ctx.fillStyle = c1;
	  ctx.fillRect(0, 0, canvas.width, canvas.height);
	  ctx.fillStyle = c2;
	  ctx.fillRect(0, 0, size, size);
	  ctx.translate(size, size);
	  ctx.fillRect(0, 0, size, size);
	  return canvas.toDataURL();
	}
	
	function get(c1, c2, size, serverCanvas) {
	  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
	  var checkboard = render(c1, c2, size, serverCanvas);
	
	  if (checkboardCache[key]) {
	    return checkboardCache[key];
	  }
	  checkboardCache[key] = checkboard;
	  return checkboard;
	}

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditableInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditableInput = exports.EditableInput = function (_ref) {
	  _inherits(EditableInput, _ref);
	
	  function EditableInput(props) {
	    _classCallCheck(this, EditableInput);
	
	    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
	
	    _this.handleBlur = function () {
	      if (_this.state.blurValue) {
	        _this.setState({ value: _this.state.blurValue, blurValue: null });
	      }
	    };
	
	    _this.handleChange = function (e) {
	      if (!!_this.props.label) {
	        _this.props.onChange(_defineProperty({}, _this.props.label, e.target.value), e);
	      } else {
	        _this.props.onChange(e.target.value, e);
	      }
	
	      _this.setState({ value: e.target.value });
	    };
	
	    _this.handleKeyDown = function (e) {
	      var number = Number(e.target.value);
	      if (!isNaN(number)) {
	        var amount = _this.props.arrowOffset || 1;
	
	        // Up
	        if (e.keyCode === 38) {
	          if (_this.props.label !== null) {
	            _this.props.onChange(_defineProperty({}, _this.props.label, number + amount), e);
	          } else {
	            _this.props.onChange(number + amount, e);
	          }
	
	          _this.setState({ value: number + amount });
	        }
	
	        // Down
	        if (e.keyCode === 40) {
	          if (_this.props.label !== null) {
	            _this.props.onChange(_defineProperty({}, _this.props.label, number - amount), e);
	          } else {
	            _this.props.onChange(number - amount, e);
	          }
	
	          _this.setState({ value: number - amount });
	        }
	      }
	    };
	
	    _this.handleDrag = function (e) {
	      if (_this.props.dragLabel) {
	        var newValue = Math.round(_this.props.value + e.movementX);
	        if (newValue >= 0 && newValue <= _this.props.dragMax) {
	          _this.props.onChange(_defineProperty({}, _this.props.label, newValue), e);
	        }
	      }
	    };
	
	    _this.handleMouseDown = function (e) {
	      if (_this.props.dragLabel) {
	        e.preventDefault();
	        _this.handleDrag(e);
	        window.addEventListener('mousemove', _this.handleDrag);
	        window.addEventListener('mouseup', _this.handleMouseUp);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleDrag);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.state = {
	      value: String(props.value).toUpperCase(),
	      blurValue: String(props.value).toUpperCase()
	    };
	    return _this;
	  }
	
	  _createClass(EditableInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var input = this.refs.input;
	      if (nextProps.value !== this.state.value) {
	        if (input === document.activeElement) {
	          this.setState({ blurValue: String(nextProps.value).toUpperCase() });
	        } else {
	          this.setState({ value: String(nextProps.value).toUpperCase() });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            position: 'relative'
	          }
	        },
	        'user-override': {
	          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
	          input: this.props.style && this.props.style.input ? this.props.style.input : {},
	          label: this.props.style && this.props.style.label ? this.props.style.label : {}
	        },
	        'dragLabel-true': {
	          label: {
	            cursor: 'ew-resize'
	          }
	        }
	      }, {
	        'user-override': true
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap },
	        _react2.default.createElement('input', {
	          style: styles.input,
	          ref: 'input',
	          value: this.state.value,
	          onKeyDown: this.handleKeyDown,
	          onChange: this.handleChange,
	          onBlur: this.handleBlur,
	          placeholder: this.props.placeholder
	        }),
	        this.props.label ? _react2.default.createElement(
	          'span',
	          { style: styles.label, onMouseDown: this.handleMouseDown },
	          this.props.label
	        ) : null
	      );
	    }
	  }]);
	
	  return EditableInput;
	}(_react.PureComponent || _react.Component);
	
	exports.default = EditableInput;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hue = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _hue = __webpack_require__(254);
	
	var hue = _interopRequireWildcard(_hue);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hue = exports.Hue = function (_ref) {
	  _inherits(Hue, _ref);
	
	  function Hue() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hue);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
	      var change = hue.calculateChange(e, skip, _this.props, _this.refs.container);
	      change && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Hue, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          hue: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%,\n            #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)',
	            borderRadius: this.props.radius,
	            boxShadow: this.props.shadow
	          },
	          container: {
	            margin: '0 2px',
	            position: 'relative',
	            height: '100%'
	          },
	          pointer: {
	            position: 'absolute',
	            left: this.props.hsl.h * 100 / 360 + '%'
	          },
	          slider: {
	            marginTop: '1px',
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          hue: {
	            background: 'linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n            #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)'
	          },
	          pointer: {
	            left: '0px',
	            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
	          }
	        }
	      }, { vertical: this.props.direction === 'vertical' });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.hue },
	        _react2.default.createElement(
	          'div',
	          {
	            style: styles.container,
	            ref: 'container',
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Hue;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Hue;

/***/ },
/* 254 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChange = calculateChange;
	function calculateChange(e, skip, props, container) {
	  !skip && e.preventDefault();
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (props.direction === 'vertical') {
	    var h = void 0;
	    if (top < 0) {
	      h = 359;
	    } else if (top > containerHeight) {
	      h = 0;
	    } else {
	      var percent = -(top * 100 / containerHeight) + 100;
	      h = 360 * percent / 100;
	    }
	
	    if (props.hsl.h !== h) {
	      return {
	        h: h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: props.hsl.a,
	        source: 'rgb'
	      };
	    }
	  } else {
	    var _h = void 0;
	    if (left < 0) {
	      _h = 0;
	    } else if (left > containerWidth) {
	      _h = 359;
	    } else {
	      var _percent = left * 100 / containerWidth;
	      _h = 360 * _percent / 100;
	    }
	
	    if (props.hsl.h !== _h) {
	      return {
	        h: _h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: props.hsl.a,
	        source: 'rgb'
	      };
	    }
	  }
	  return null;
	}

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Saturation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _throttle = __webpack_require__(256);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _saturation = __webpack_require__(260);
	
	var saturation = _interopRequireWildcard(_saturation);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Saturation = exports.Saturation = function (_ref) {
	  _inherits(Saturation, _ref);
	
	  function Saturation(props) {
	    _classCallCheck(this, Saturation);
	
	    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
	
	    _this.handleChange = function (e, skip) {
	      _this.throttle(_this.props.onChange, saturation.calculateChange(e, skip, _this.props, _this.refs.container), e);
	    };
	
	    _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
	      fn(data, e);
	    }, 50);
	    return _this;
	  }
	
	  _createClass(Saturation, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _ref2 = this.props.style || {},
	          color = _ref2.color,
	          white = _ref2.white,
	          black = _ref2.black,
	          pointer = _ref2.pointer,
	          circle = _ref2.circle;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          color: {
	            absolute: '0px 0px 0px 0px',
	            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
	            borderRadius: this.props.radius
	          },
	          white: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, #fff, rgba(255,255,255,0))'
	          },
	          black: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to top, #000, rgba(0,0,0,0))',
	            boxShadow: this.props.shadow
	          },
	          pointer: {
	            position: 'absolute',
	            top: -(this.props.hsv.v * 100) + 100 + '%',
	            left: this.props.hsv.s * 100 + '%',
	            cursor: 'default'
	          },
	          circle: {
	            width: '4px',
	            height: '4px',
	            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
	            borderRadius: '50%',
	            cursor: 'hand',
	            transform: 'translate(-2px, -2px)'
	          }
	        },
	        'custom': {
	          color: color,
	          white: white,
	          black: black,
	          pointer: pointer,
	          circle: circle
	        }
	      }, { 'custom': !!this.props.style });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: styles.color,
	          ref: 'container',
	          onMouseDown: this.handleMouseDown,
	          onTouchMove: this.handleChange,
	          onTouchStart: this.handleChange
	        },
	        _react2.default.createElement(
	          'div',
	          { style: styles.white },
	          _react2.default.createElement('div', { style: styles.black }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Saturation;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Saturation;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(257),
	    isObject = __webpack_require__(116);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(116),
	    now = __webpack_require__(258),
	    toNumber = __webpack_require__(259);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(86);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(116),
	    isSymbol = __webpack_require__(194);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 260 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChange = calculateChange;
	function calculateChange(e, skip, props, container) {
	  !skip && e.preventDefault();
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (left < 0) {
	    left = 0;
	  } else if (left > containerWidth) {
	    left = containerWidth;
	  } else if (top < 0) {
	    top = 0;
	  } else if (top > containerHeight) {
	    top = containerHeight;
	  }
	
	  var saturation = left * 100 / containerWidth;
	  var bright = -(top * 100 / containerHeight) + 100;
	
	  return {
	    h: props.hsl.h,
	    s: saturation,
	    v: bright,
	    a: props.hsl.a,
	    source: 'rgb'
	  };
	}

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorWrap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _debounce = __webpack_require__(257);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _color = __webpack_require__(262);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
	  var ColorPicker = function (_ref) {
	    _inherits(ColorPicker, _ref);
	
	    function ColorPicker(props) {
	      _classCallCheck(this, ColorPicker);
	
	      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
	
	      _this.handleChange = function (data, event) {
	        var isValidColor = _color2.default.simpleCheckForValidColor(data);
	        if (isValidColor) {
	          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
	          _this.setState(colors);
	          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
	          _this.props.onChange && _this.props.onChange(colors, event);
	        }
	      };
	
	      _this.state = _extends({}, _color2.default.toState(props.color, 0), {
	        visible: props.display
	      });
	
	      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
	        fn(data, event);
	      }, 100);
	      return _this;
	    }
	
	    _createClass(ColorPicker, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        this.setState(_extends({}, _color2.default.toState(nextProps.color, this.state.oldHue), {
	          visible: nextProps.display
	        }));
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, { onChange: this.handleChange }));
	      }
	    }]);
	
	    return ColorPicker;
	  }(_react.PureComponent || _react.Component);
	
	  ColorPicker.defaultProps = {
	    color: {
	      h: 250,
	      s: 0.50,
	      l: 0.20,
	      a: 1
	    }
	  };
	
	  return ColorPicker;
	};
	
	exports.default = ColorWrap;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.red = undefined;
	
	var _each = __webpack_require__(263);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _tinycolor = __webpack_require__(265);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  simpleCheckForValidColor: function simpleCheckForValidColor(data) {
	    var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'a', 'v'];
	    var checked = 0;
	    var passed = 0;
	    (0, _each2.default)(keysToCheck, function (letter) {
	      if (data[letter]) {
	        checked += 1;
	        if (!isNaN(data[letter])) {
	          passed += 1;
	        }
	      }
	    });
	    return checked === passed ? data : false;
	  },
	  toState: function toState(data, oldHue) {
	    var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
	    var hsl = color.toHsl();
	    var hsv = color.toHsv();
	    if (hsl.s === 0) {
	      hsl.h = oldHue || 0;
	      hsv.h = oldHue || 0;
	    }
	
	    return {
	      hsl: hsl,
	      hex: '#' + color.toHex(),
	      rgb: color.toRgb(),
	      hsv: hsv,
	      oldHue: data.h || oldHue || hsl.h,
	      source: data.source
	    };
	  },
	  isValidHex: function isValidHex(hex) {
	    return (0, _tinycolor2.default)(hex).isValid();
	  }
	};
	var red = exports.red = {
	  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
	  hex: '#ff0000',
	  rgb: { r: 255, g: 0, b: 0, a: 1 },
	  hsv: { h: 0, s: 1, v: 1, a: 1 }
	};

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(264);


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(213),
	    baseEach = __webpack_require__(208),
	    castFunction = __webpack_require__(117),
	    isArray = __webpack_require__(90);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// jscs: disable
	
	// TinyColor v1.1.2
	// https://github.com/bgrins/TinyColor
	// Brian Grinstead, MIT License
	
	(function() {
	
	var trimLeft = /^[\s,#]+/;
	var trimRight = /\s+$/;
	var tinyCounter = 0;
	var math = Math;
	var mathRound = math.round;
	var mathMin = math.min;
	var mathMax = math.max;
	var mathRandom = math.random;
	
	function tinycolor(color, opts) {
	
			color = (color) ? color : '';
			opts = opts || { };
	
			// If input is already a tinycolor, return itself
			if (color instanceof tinycolor) {
				 return color;
			}
			// If we are called as a function, call using new instead
			if (!(this instanceof tinycolor)) {
					return new tinycolor(color, opts);
			}
	
			var rgb = inputToRGB(color);
			this._originalInput = color,
			this._r = rgb.r,
			this._g = rgb.g,
			this._b = rgb.b,
			this._a = rgb.a,
			this._roundA = mathRound(100*this._a) / 100,
			this._format = opts.format || rgb.format;
			this._gradientType = opts.gradientType;
	
			// Don't let the range of [0,255] come back in [0,1].
			// Potentially lose a little bit of precision here, but will fix issues where
			// .5 gets interpreted as half of the total, instead of half of 1
			// If it was supposed to be 128, this was already taken care of by `inputToRgb`
			if (this._r < 1) { this._r = mathRound(this._r); }
			if (this._g < 1) { this._g = mathRound(this._g); }
			if (this._b < 1) { this._b = mathRound(this._b); }
	
			this._ok = rgb.ok;
			this._tc_id = tinyCounter++;
	}
	
	tinycolor.prototype = {
			isDark: function() {
					return this.getBrightness() < 128;
			},
			isLight: function() {
					return !this.isDark();
			},
			isValid: function() {
					return this._ok;
			},
			getOriginalInput: function() {
				return this._originalInput;
			},
			getFormat: function() {
					return this._format;
			},
			getAlpha: function() {
					return this._a;
			},
			getBrightness: function() {
					//http://www.w3.org/TR/AERT#color-contrast
					var rgb = this.toRgb();
					return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
			},
			getLuminance: function() {
					//http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
					var rgb = this.toRgb();
					var RsRGB, GsRGB, BsRGB, R, G, B;
					RsRGB = rgb.r/255;
					GsRGB = rgb.g/255;
					BsRGB = rgb.b/255;
	
					if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
					if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
					if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
					return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
			},
			setAlpha: function(value) {
					this._a = boundAlpha(value);
					this._roundA = mathRound(100*this._a) / 100;
					return this;
			},
			toHsv: function() {
					var hsv = rgbToHsv(this._r, this._g, this._b);
					return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
			},
			toHsvString: function() {
					var hsv = rgbToHsv(this._r, this._g, this._b);
					var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
					return (this._a == 1) ?
						"hsv("	+ h + ", " + s + "%, " + v + "%)" :
						"hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
			},
			toHsl: function() {
					var hsl = rgbToHsl(this._r, this._g, this._b);
					return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
			},
			toHslString: function() {
					var hsl = rgbToHsl(this._r, this._g, this._b);
					var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
					return (this._a == 1) ?
						"hsl("	+ h + ", " + s + "%, " + l + "%)" :
						"hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
			},
			toHex: function(allow3Char) {
					return rgbToHex(this._r, this._g, this._b, allow3Char);
			},
			toHexString: function(allow3Char) {
					return '#' + this.toHex(allow3Char);
			},
			toHex8: function() {
					return rgbaToHex(this._r, this._g, this._b, this._a);
			},
			toHex8String: function() {
					return '#' + this.toHex8();
			},
			toRgb: function() {
					return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
			},
			toRgbString: function() {
					return (this._a == 1) ?
						"rgb("	+ mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
						"rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
			},
			toPercentageRgb: function() {
					return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
			},
			toPercentageRgbString: function() {
					return (this._a == 1) ?
						"rgb("	+ mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
						"rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
			},
			toName: function() {
					if (this._a === 0) {
							return "transparent";
					}
	
					if (this._a < 1) {
							return false;
					}
	
					return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
			},
			toFilter: function(secondColor) {
					var hex8String = '#' + rgbaToHex(this._r, this._g, this._b, this._a);
					var secondHex8String = hex8String;
					var gradientType = this._gradientType ? "GradientType = 1, " : "";
	
					if (secondColor) {
							var s = tinycolor(secondColor);
							secondHex8String = s.toHex8String();
					}
	
					return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
			},
			toString: function(format) {
					var formatSet = !!format;
					format = format || this._format;
	
					var formattedString = false;
					var hasAlpha = this._a < 1 && this._a >= 0;
					var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "name");
	
					if (needsAlphaFormat) {
							// Special case for "transparent", all other non-alpha formats
							// will return rgba when there is transparency.
							if (format === "name" && this._a === 0) {
									return this.toName();
							}
							return this.toRgbString();
					}
					if (format === "rgb") {
							formattedString = this.toRgbString();
					}
					if (format === "prgb") {
							formattedString = this.toPercentageRgbString();
					}
					if (format === "hex" || format === "hex6") {
							formattedString = this.toHexString();
					}
					if (format === "hex3") {
							formattedString = this.toHexString(true);
					}
					if (format === "hex8") {
							formattedString = this.toHex8String();
					}
					if (format === "name") {
							formattedString = this.toName();
					}
					if (format === "hsl") {
							formattedString = this.toHslString();
					}
					if (format === "hsv") {
							formattedString = this.toHsvString();
					}
	
					return formattedString || this.toHexString();
			},
	
			_applyModification: function(fn, args) {
					var color = fn.apply(null, [this].concat([].slice.call(args)));
					this._r = color._r;
					this._g = color._g;
					this._b = color._b;
					this.setAlpha(color._a);
					return this;
			},
			lighten: function() {
					return this._applyModification(lighten, arguments);
			},
			brighten: function() {
					return this._applyModification(brighten, arguments);
			},
			darken: function() {
					return this._applyModification(darken, arguments);
			},
			desaturate: function() {
					return this._applyModification(desaturate, arguments);
			},
			saturate: function() {
					return this._applyModification(saturate, arguments);
			},
			greyscale: function() {
					return this._applyModification(greyscale, arguments);
			},
			spin: function() {
					return this._applyModification(spin, arguments);
			},
	
			_applyCombination: function(fn, args) {
					return fn.apply(null, [this].concat([].slice.call(args)));
			},
			analogous: function() {
					return this._applyCombination(analogous, arguments);
			},
			complement: function() {
					return this._applyCombination(complement, arguments);
			},
			monochromatic: function() {
					return this._applyCombination(monochromatic, arguments);
			},
			splitcomplement: function() {
					return this._applyCombination(splitcomplement, arguments);
			},
			triad: function() {
					return this._applyCombination(triad, arguments);
			},
			tetrad: function() {
					return this._applyCombination(tetrad, arguments);
			}
	};
	
	// If input is an object, force 1 into "1.0" to handle ratios properly
	// String input requires "1.0" as input, so 1 will be treated as 1
	tinycolor.fromRatio = function(color, opts) {
			if (typeof color == "object") {
					var newColor = {};
					for (var i in color) {
							if (color.hasOwnProperty(i)) {
									if (i === "a") {
											newColor[i] = color[i];
									}
									else {
											newColor[i] = convertToPercentage(color[i]);
									}
							}
					}
					color = newColor;
			}
	
			return tinycolor(color, opts);
	};
	
	// Given a string or object, convert that input to RGB
	// Possible string inputs:
	//
	//		 "red"
	//		 "#f00" or "f00"
	//		 "#ff0000" or "ff0000"
	//		 "#ff000000" or "ff000000"
	//		 "rgb 255 0 0" or "rgb (255, 0, 0)"
	//		 "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	//		 "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	//		 "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	//		 "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	//		 "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	//		 "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	//
	function inputToRGB(color) {
	
			var rgb = { r: 0, g: 0, b: 0 };
			var a = 1;
			var ok = false;
			var format = false;
	
			if (typeof color == "string") {
					color = stringInputToObject(color);
			}
	
			if (typeof color == "object") {
					if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
							rgb = rgbToRgb(color.r, color.g, color.b);
							ok = true;
							format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
					}
					else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
							color.s = convertToPercentage(color.s, 1);
							color.v = convertToPercentage(color.v, 1);
							rgb = hsvToRgb(color.h, color.s, color.v);
							ok = true;
							format = "hsv";
					}
					else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
							color.s = convertToPercentage(color.s);
							color.l = convertToPercentage(color.l);
							rgb = hslToRgb(color.h, color.s, color.l);
							ok = true;
							format = "hsl";
					}
	
					if (color.hasOwnProperty("a")) {
							a = color.a;
					}
			}
	
			a = boundAlpha(a);
	
			return {
					ok: ok,
					format: color.format || format,
					r: mathMin(255, mathMax(rgb.r, 0)),
					g: mathMin(255, mathMax(rgb.g, 0)),
					b: mathMin(255, mathMax(rgb.b, 0)),
					a: a
			};
	}
	
	
	// Conversion Functions
	// --------------------
	
	// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	// `rgbToRgb`
	// Handle bounds / percentage checking to conform to CSS color spec
	// <http://www.w3.org/TR/css3-color/>
	// *Assumes:* r, g, b in [0, 255] or [0, 1]
	// *Returns:* { r, g, b } in [0, 255]
	function rgbToRgb(r, g, b){
			return {
					r: bound01(r, 255) * 255,
					g: bound01(g, 255) * 255,
					b: bound01(b, 255) * 255
			};
	}
	
	// `rgbToHsl`
	// Converts an RGB color value to HSL.
	// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	// *Returns:* { h, s, l } in [0,1]
	function rgbToHsl(r, g, b) {
	
			r = bound01(r, 255);
			g = bound01(g, 255);
			b = bound01(b, 255);
	
			var max = mathMax(r, g, b), min = mathMin(r, g, b);
			var h, s, l = (max + min) / 2;
	
			if(max == min) {
					h = s = 0; // achromatic
			}
			else {
					var d = max - min;
					s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
					switch(max) {
							case r: h = (g - b) / d + (g < b ? 6 : 0); break;
							case g: h = (b - r) / d + 2; break;
							case b: h = (r - g) / d + 4; break;
					}
	
					h /= 6;
			}
	
			return { h: h, s: s, l: l };
	}
	
	// `hslToRgb`
	// Converts an HSL color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	function hslToRgb(h, s, l) {
			var r, g, b;
	
			h = bound01(h, 360);
			s = bound01(s, 100);
			l = bound01(l, 100);
	
			function hue2rgb(p, q, t) {
					if(t < 0) t += 1;
					if(t > 1) t -= 1;
					if(t < 1/6) return p + (q - p) * 6 * t;
					if(t < 1/2) return q;
					if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
					return p;
			}
	
			if(s === 0) {
					r = g = b = l; // achromatic
			}
			else {
					var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
					var p = 2 * l - q;
					r = hue2rgb(p, q, h + 1/3);
					g = hue2rgb(p, q, h);
					b = hue2rgb(p, q, h - 1/3);
			}
	
			return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	function rgbToHsv(r, g, b) {
	
			r = bound01(r, 255);
			g = bound01(g, 255);
			b = bound01(b, 255);
	
			var max = mathMax(r, g, b), min = mathMin(r, g, b);
			var h, s, v = max;
	
			var d = max - min;
			s = max === 0 ? 0 : d / max;
	
			if(max == min) {
					h = 0; // achromatic
			}
			else {
					switch(max) {
							case r: h = (g - b) / d + (g < b ? 6 : 0); break;
							case g: h = (b - r) / d + 2; break;
							case b: h = (r - g) / d + 4; break;
					}
					h /= 6;
			}
			return { h: h, s: s, v: v };
	}
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	 function hsvToRgb(h, s, v) {
	
			h = bound01(h, 360) * 6;
			s = bound01(s, 100);
			v = bound01(v, 100);
	
			var i = math.floor(h),
					f = h - i,
					p = v * (1 - s),
					q = v * (1 - f * s),
					t = v * (1 - (1 - f) * s),
					mod = i % 6,
					r = [v, q, p, p, t, v][mod],
					g = [t, v, v, q, p, p][mod],
					b = [p, p, t, v, v, q][mod];
	
			return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHex`
	// Converts an RGB color to hex
	// Assumes r, g, and b are contained in the set [0, 255]
	// Returns a 3 or 6 character hex
	function rgbToHex(r, g, b, allow3Char) {
	
			var hex = [
					pad2(mathRound(r).toString(16)),
					pad2(mathRound(g).toString(16)),
					pad2(mathRound(b).toString(16))
			];
	
			// Return a 3 character hex if possible
			if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
					return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
			}
	
			return hex.join("");
	}
			// `rgbaToHex`
			// Converts an RGBA color plus alpha transparency to hex
			// Assumes r, g, b and a are contained in the set [0, 255]
			// Returns an 8 character hex
			function rgbaToHex(r, g, b, a) {
	
					var hex = [
							pad2(convertDecimalToHex(a)),
							pad2(mathRound(r).toString(16)),
							pad2(mathRound(g).toString(16)),
							pad2(mathRound(b).toString(16))
					];
	
					return hex.join("");
			}
	
	// `equals`
	// Can be called with any tinycolor input
	tinycolor.equals = function (color1, color2) {
			if (!color1 || !color2) { return false; }
			return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	};
	tinycolor.random = function() {
			return tinycolor.fromRatio({
					r: mathRandom(),
					g: mathRandom(),
					b: mathRandom()
			});
	};
	
	
	// Modification Functions
	// ----------------------
	// Thanks to less.js for some of the basics here
	// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	function desaturate(color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.s -= amount / 100;
			hsl.s = clamp01(hsl.s);
			return tinycolor(hsl);
	}
	
	function saturate(color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.s += amount / 100;
			hsl.s = clamp01(hsl.s);
			return tinycolor(hsl);
	}
	
	function greyscale(color) {
			return tinycolor(color).desaturate(100);
	}
	
	function lighten (color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.l += amount / 100;
			hsl.l = clamp01(hsl.l);
			return tinycolor(hsl);
	}
	
	function brighten(color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var rgb = tinycolor(color).toRgb();
			rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
			rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
			rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
			return tinycolor(rgb);
	}
	
	function darken (color, amount) {
			amount = (amount === 0) ? 0 : (amount || 10);
			var hsl = tinycolor(color).toHsl();
			hsl.l -= amount / 100;
			hsl.l = clamp01(hsl.l);
			return tinycolor(hsl);
	}
	
	// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	// Values outside of this range will be wrapped into this range.
	function spin(color, amount) {
			var hsl = tinycolor(color).toHsl();
			var hue = (mathRound(hsl.h) + amount) % 360;
			hsl.h = hue < 0 ? 360 + hue : hue;
			return tinycolor(hsl);
	}
	
	// Combination Functions
	// ---------------------
	// Thanks to jQuery xColor for some of the ideas behind these
	// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	function complement(color) {
			var hsl = tinycolor(color).toHsl();
			hsl.h = (hsl.h + 180) % 360;
			return tinycolor(hsl);
	}
	
	function triad(color) {
			var hsl = tinycolor(color).toHsl();
			var h = hsl.h;
			return [
					tinycolor(color),
					tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
					tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
			];
	}
	
	function tetrad(color) {
			var hsl = tinycolor(color).toHsl();
			var h = hsl.h;
			return [
					tinycolor(color),
					tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
					tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
					tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
			];
	}
	
	function splitcomplement(color) {
			var hsl = tinycolor(color).toHsl();
			var h = hsl.h;
			return [
					tinycolor(color),
					tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
					tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
			];
	}
	
	function analogous(color, results, slices) {
			results = results || 6;
			slices = slices || 30;
	
			var hsl = tinycolor(color).toHsl();
			var part = 360 / slices;
			var ret = [tinycolor(color)];
	
			for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
					hsl.h = (hsl.h + part) % 360;
					ret.push(tinycolor(hsl));
			}
			return ret;
	}
	
	function monochromatic(color, results) {
			results = results || 6;
			var hsv = tinycolor(color).toHsv();
			var h = hsv.h, s = hsv.s, v = hsv.v;
			var ret = [];
			var modification = 1 / results;
	
			while (results--) {
					ret.push(tinycolor({ h: h, s: s, v: v}));
					v = (v + modification) % 1;
			}
	
			return ret;
	}
	
	// Utility Functions
	// ---------------------
	
	tinycolor.mix = function(color1, color2, amount) {
			amount = (amount === 0) ? 0 : (amount || 50);
	
			var rgb1 = tinycolor(color1).toRgb();
			var rgb2 = tinycolor(color2).toRgb();
	
			var p = amount / 100;
			var w = p * 2 - 1;
			var a = rgb2.a - rgb1.a;
	
			var w1;
	
			if (w * a == -1) {
					w1 = w;
			} else {
					w1 = (w + a) / (1 + w * a);
			}
	
			w1 = (w1 + 1) / 2;
	
			var w2 = 1 - w1;
	
			var rgba = {
					r: rgb2.r * w1 + rgb1.r * w2,
					g: rgb2.g * w1 + rgb1.g * w2,
					b: rgb2.b * w1 + rgb1.b * w2,
					a: rgb2.a * p	+ rgb1.a * (1 - p)
			};
	
			return tinycolor(rgba);
	};
	
	
	// Readability Functions
	// ---------------------
	// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
	
	// `contrast`
	// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
	tinycolor.readability = function(color1, color2) {
			var c1 = tinycolor(color1);
			var c2 = tinycolor(color2);
			return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
	};
	
	// `isReadable`
	// Ensure that foreground and background color combinations meet WCAG2 guidelines.
	// The third argument is an optional Object.
	//			the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
	//			the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
	// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
	
	// *Example*
	//		tinycolor.isReadable("#000", "#111") => false
	//		tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
	
	tinycolor.isReadable = function(color1, color2, wcag2) {
			var readability = tinycolor.readability(color1, color2);
			var wcag2Parms, out;
	
			out = false;
	
			wcag2Parms = validateWCAG2Parms(wcag2);
			switch (wcag2Parms.level + wcag2Parms.size) {
					case "AAsmall":
					case "AAAlarge":
							out = readability >= 4.5;
							break;
					case "AAlarge":
							out = readability >= 3;
							break;
					case "AAAsmall":
							out = readability >= 7;
							break;
			}
			return out;
	
	};
	
	// `mostReadable`
	// Given a base color and a list of possible foreground or background
	// colors for that base, returns the most readable color.
	// Optionally returns Black or White if the most readable color is unreadable.
	// *Example*
	//		tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
	//		tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();	// "#ffffff"
	//		tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
	//		tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
	
	
	tinycolor.mostReadable = function(baseColor, colorList, args) {
			var bestColor = null;
			var bestScore = 0;
			var readability;
			var includeFallbackColors, level, size ;
			args = args || {};
			includeFallbackColors = args.includeFallbackColors ;
			level = args.level;
			size = args.size;
	
			for (var i= 0; i < colorList.length ; i++) {
					readability = tinycolor.readability(baseColor, colorList[i]);
					if (readability > bestScore) {
							bestScore = readability;
							bestColor = tinycolor(colorList[i]);
					}
			}
	
			if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
					return bestColor;
			}
			else {
					args.includeFallbackColors=false;
					return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
			}
	};
	
	
	// Big List of Colors
	// ------------------
	// <http://www.w3.org/TR/css3-color/#svg-color>
	var names = tinycolor.names = {
			aliceblue: "f0f8ff",
			antiquewhite: "faebd7",
			aqua: "0ff",
			aquamarine: "7fffd4",
			azure: "f0ffff",
			beige: "f5f5dc",
			bisque: "ffe4c4",
			black: "000",
			blanchedalmond: "ffebcd",
			blue: "00f",
			blueviolet: "8a2be2",
			brown: "a52a2a",
			burlywood: "deb887",
			burntsienna: "ea7e5d",
			cadetblue: "5f9ea0",
			chartreuse: "7fff00",
			chocolate: "d2691e",
			coral: "ff7f50",
			cornflowerblue: "6495ed",
			cornsilk: "fff8dc",
			crimson: "dc143c",
			cyan: "0ff",
			darkblue: "00008b",
			darkcyan: "008b8b",
			darkgoldenrod: "b8860b",
			darkgray: "a9a9a9",
			darkgreen: "006400",
			darkgrey: "a9a9a9",
			darkkhaki: "bdb76b",
			darkmagenta: "8b008b",
			darkolivegreen: "556b2f",
			darkorange: "ff8c00",
			darkorchid: "9932cc",
			darkred: "8b0000",
			darksalmon: "e9967a",
			darkseagreen: "8fbc8f",
			darkslateblue: "483d8b",
			darkslategray: "2f4f4f",
			darkslategrey: "2f4f4f",
			darkturquoise: "00ced1",
			darkviolet: "9400d3",
			deeppink: "ff1493",
			deepskyblue: "00bfff",
			dimgray: "696969",
			dimgrey: "696969",
			dodgerblue: "1e90ff",
			firebrick: "b22222",
			floralwhite: "fffaf0",
			forestgreen: "228b22",
			fuchsia: "f0f",
			gainsboro: "dcdcdc",
			ghostwhite: "f8f8ff",
			gold: "ffd700",
			goldenrod: "daa520",
			gray: "808080",
			green: "008000",
			greenyellow: "adff2f",
			grey: "808080",
			honeydew: "f0fff0",
			hotpink: "ff69b4",
			indianred: "cd5c5c",
			indigo: "4b0082",
			ivory: "fffff0",
			khaki: "f0e68c",
			lavender: "e6e6fa",
			lavenderblush: "fff0f5",
			lawngreen: "7cfc00",
			lemonchiffon: "fffacd",
			lightblue: "add8e6",
			lightcoral: "f08080",
			lightcyan: "e0ffff",
			lightgoldenrodyellow: "fafad2",
			lightgray: "d3d3d3",
			lightgreen: "90ee90",
			lightgrey: "d3d3d3",
			lightpink: "ffb6c1",
			lightsalmon: "ffa07a",
			lightseagreen: "20b2aa",
			lightskyblue: "87cefa",
			lightslategray: "789",
			lightslategrey: "789",
			lightsteelblue: "b0c4de",
			lightyellow: "ffffe0",
			lime: "0f0",
			limegreen: "32cd32",
			linen: "faf0e6",
			magenta: "f0f",
			maroon: "800000",
			mediumaquamarine: "66cdaa",
			mediumblue: "0000cd",
			mediumorchid: "ba55d3",
			mediumpurple: "9370db",
			mediumseagreen: "3cb371",
			mediumslateblue: "7b68ee",
			mediumspringgreen: "00fa9a",
			mediumturquoise: "48d1cc",
			mediumvioletred: "c71585",
			midnightblue: "191970",
			mintcream: "f5fffa",
			mistyrose: "ffe4e1",
			moccasin: "ffe4b5",
			navajowhite: "ffdead",
			navy: "000080",
			oldlace: "fdf5e6",
			olive: "808000",
			olivedrab: "6b8e23",
			orange: "ffa500",
			orangered: "ff4500",
			orchid: "da70d6",
			palegoldenrod: "eee8aa",
			palegreen: "98fb98",
			paleturquoise: "afeeee",
			palevioletred: "db7093",
			papayawhip: "ffefd5",
			peachpuff: "ffdab9",
			peru: "cd853f",
			pink: "ffc0cb",
			plum: "dda0dd",
			powderblue: "b0e0e6",
			purple: "800080",
			rebeccapurple: "663399",
			red: "f00",
			rosybrown: "bc8f8f",
			royalblue: "4169e1",
			saddlebrown: "8b4513",
			salmon: "fa8072",
			sandybrown: "f4a460",
			seagreen: "2e8b57",
			seashell: "fff5ee",
			sienna: "a0522d",
			silver: "c0c0c0",
			skyblue: "87ceeb",
			slateblue: "6a5acd",
			slategray: "708090",
			slategrey: "708090",
			snow: "fffafa",
			springgreen: "00ff7f",
			steelblue: "4682b4",
			tan: "d2b48c",
			teal: "008080",
			thistle: "d8bfd8",
			tomato: "ff6347",
			turquoise: "40e0d0",
			violet: "ee82ee",
			wheat: "f5deb3",
			white: "fff",
			whitesmoke: "f5f5f5",
			yellow: "ff0",
			yellowgreen: "9acd32"
	};
	
	// Make it easy to access colors via `hexNames[hex]`
	var hexNames = tinycolor.hexNames = flip(names);
	
	
	// Utilities
	// ---------
	
	// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	function flip(o) {
			var flipped = { };
			for (var i in o) {
					if (o.hasOwnProperty(i)) {
							flipped[o[i]] = i;
					}
			}
			return flipped;
	}
	
	// Return a valid alpha value [0,1] with all invalid values being set to 1
	function boundAlpha(a) {
			a = parseFloat(a);
	
			if (isNaN(a) || a < 0 || a > 1) {
					a = 1;
			}
	
			return a;
	}
	
	// Take input from [0, n] and return it as [0, 1]
	function bound01(n, max) {
			if (isOnePointZero(n)) { n = "100%"; }
	
			var processPercent = isPercentage(n);
			n = mathMin(max, mathMax(0, parseFloat(n)));
	
			// Automatically convert percentage into number
			if (processPercent) {
					n = parseInt(n * max, 10) / 100;
			}
	
			// Handle floating point rounding errors
			if ((math.abs(n - max) < 0.000001)) {
					return 1;
			}
	
			// Convert into [0, 1] range if it isn't already
			return (n % max) / parseFloat(max);
	}
	
	// Force a number between 0 and 1
	function clamp01(val) {
			return mathMin(1, mathMax(0, val));
	}
	
	// Parse a base-16 hex value into a base-10 integer
	function parseIntFromHex(val) {
			return parseInt(val, 16);
	}
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	function isOnePointZero(n) {
			return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
	}
	
	// Check to see if string passed in is a percentage
	function isPercentage(n) {
			return typeof n === "string" && n.indexOf('%') != -1;
	}
	
	// Force a hex value to have 2 characters
	function pad2(c) {
			return c.length == 1 ? '0' + c : '' + c;
	}
	
	// Replace a decimal with it's percentage value
	function convertToPercentage(n, multiplier) {
			multiplier = multiplier || 100;
			if (n <= 1) {
					n = (n * multiplier) + "%";
			}
	
			return n;
	}
	
	// Converts a decimal to a hex value
	function convertDecimalToHex(d) {
			return Math.round(parseFloat(d) * 255).toString(16);
	}
	// Converts a hex value to a decimal
	function convertHexToDecimal(h) {
			return (parseIntFromHex(h) / 255);
	}
	
	var matchers = (function() {
	
			// <http://www.w3.org/TR/css3-values/#integers>
			var CSS_INTEGER = "[-\\+]?\\d+%?";
	
			// <http://www.w3.org/TR/css3-values/#number-value>
			var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
			// Allow positive/negative integer/number.	Don't capture the either/or, just the entire outcome.
			var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
			// Actual matching.
			// Parentheses and commas are optional, but not required.
			// Whitespace can take the place of commas or opening paren
			var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
			var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	
			return {
					rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
					rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
					hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
					hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
					hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
					hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
					hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
					hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
					hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
			};
	})();
	
	// `stringInputToObject`
	// Permissive string parsing.	Take in a number of formats, and output an object
	// based on detected format.	Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	function stringInputToObject(color) {
	
			color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
			var named = false;
			if (names[color]) {
					color = names[color];
					named = true;
			}
			else if (color == 'transparent') {
					return { r: 0, g: 0, b: 0, a: 0, format: "name" };
			}
	
			// Try to match string input using regular expressions.
			// Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
			// Just return an object and let the conversion functions handle that.
			// This way the result will be the same whether the tinycolor is initialized with string or object.
			var match;
			if ((match = matchers.rgb.exec(color))) {
					return { r: match[1], g: match[2], b: match[3] };
			}
			if ((match = matchers.rgba.exec(color))) {
					return { r: match[1], g: match[2], b: match[3], a: match[4] };
			}
			if ((match = matchers.hsl.exec(color))) {
					return { h: match[1], s: match[2], l: match[3] };
			}
			if ((match = matchers.hsla.exec(color))) {
					return { h: match[1], s: match[2], l: match[3], a: match[4] };
			}
			if ((match = matchers.hsv.exec(color))) {
					return { h: match[1], s: match[2], v: match[3] };
			}
			if ((match = matchers.hsva.exec(color))) {
					return { h: match[1], s: match[2], v: match[3], a: match[4] };
			}
			if ((match = matchers.hex8.exec(color))) {
					return {
							a: convertHexToDecimal(match[1]),
							r: parseIntFromHex(match[2]),
							g: parseIntFromHex(match[3]),
							b: parseIntFromHex(match[4]),
							format: named ? "name" : "hex8"
					};
			}
			if ((match = matchers.hex6.exec(color))) {
					return {
							r: parseIntFromHex(match[1]),
							g: parseIntFromHex(match[2]),
							b: parseIntFromHex(match[3]),
							format: named ? "name" : "hex"
					};
			}
			if ((match = matchers.hex3.exec(color))) {
					return {
							r: parseIntFromHex(match[1] + '' + match[1]),
							g: parseIntFromHex(match[2] + '' + match[2]),
							b: parseIntFromHex(match[3] + '' + match[3]),
							format: named ? "name" : "hex"
					};
			}
	
			return false;
	}
	
	function validateWCAG2Parms(parms) {
			// return valid WCAG2 parms for isReadable.
			// If input parms are invalid, return {"level":"AA", "size":"small"}
			var level, size;
			parms = parms || {"level":"AA", "size":"small"};
			level = (parms.level || "AA").toUpperCase();
			size = (parms.size || "small").toLowerCase();
			if (level !== "AA" && level !== "AAA") {
					level = "AA";
			}
			if (size !== "small" && size !== "large") {
					size = "small";
			}
			return {"level":level, "size":size};
	}
	// Node: Export function
	if (typeof module !== "undefined" && module.exports) {
			module.exports = tinycolor;
	}
	// AMD/requirejs: Define the module
	else if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	// Browser: Expose to window
	else {
			window.tinycolor = tinycolor;
	}
	
	})();


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatch = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Swatch = exports.Swatch = function Swatch(_ref) {
	  var color = _ref.color,
	      style = _ref.style,
	      onClick = _ref.onClick,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? color : _ref$title;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        background: color,
	        height: '100%',
	        width: '100%',
	        cursor: 'pointer'
	      }
	    },
	    'custom': {
	      swatch: style
	    }
	  }, 'custom');
	
	  var handleClick = function handleClick(e) {
	    return onClick(color, e);
	  };
	
	  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick, title: title });
	};
	
	exports.default = Swatch;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPointer = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = AlphaPointer;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Block = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(262);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(247);
	
	var _BlockSwatches = __webpack_require__(269);
	
	var _BlockSwatches2 = _interopRequireDefault(_BlockSwatches);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Block = exports.Block = function Block(_ref) {
	  var onChange = _ref.onChange,
	      hex = _ref.hex,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle;
	
	  var handleChange = function handleChange(hexCode, e) {
	    _color2.default.isValidHex(hexCode) && onChange({
	      hex: hexCode,
	      source: 'hex'
	    }, e);
	  };
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        boxShadow: '0 1px rgba(0,0,0,.1)',
	        borderRadius: '6px',
	        position: 'relative'
	      },
	      head: {
	        height: '110px',
	        background: hex,
	        borderRadius: '6px 6px 0 0',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	      },
	      body: {
	        padding: '10px'
	      },
	      label: {
	        fontSize: '18px',
	        color: '#fff'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 10px 10px 10px',
	        borderColor: 'transparent transparent ' + hex + ' transparent',
	        position: 'absolute',
	        top: '-10px',
	        left: '50%',
	        marginLeft: '-10px'
	      },
	      input: {
	        width: '100%',
	        fontSize: '12px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '22px',
	        boxShadow: 'inset 0 0 0 1px #ddd',
	        borderRadius: '4px',
	        padding: '0 7px',
	        boxSizing: 'border-box'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      }
	    }
	  }, { 'hide-triangle': triangle === 'hide' });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'block-picker' },
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.head },
	      _react2.default.createElement(
	        'div',
	        { style: styles.label },
	        hex
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange }),
	      _react2.default.createElement(_common.EditableInput, {
	        placeholder: 'Hex Code',
	        style: { input: styles.input },
	        value: '',
	        onChange: handleChange
	      })
	    )
	  );
	};
	
	Block.defaultProps = {
	  width: '170px',
	  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
	  triangle: 'top'
	};
	
	exports.default = (0, _common.ColorWrap)(Block);

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BlockSwatches = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(121);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _common = __webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
	  var colors = _ref.colors,
	      onClick = _ref.onClick;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginRight: '-10px'
	      },
	      swatch: {
	        width: '22px',
	        height: '22px',
	        float: 'left',
	        marginRight: '10px',
	        marginBottom: '10px',
	        borderRadius: '4px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_common.Swatch, {
	        key: c,
	        color: c,
	        style: styles.swatch,
	        onClick: onClick
	      });
	    }),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = BlockSwatches;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Circle = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(121);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _materialColors = __webpack_require__(271);
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__(247);
	
	var _CircleSwatch = __webpack_require__(272);
	
	var _CircleSwatch2 = _interopRequireDefault(_CircleSwatch);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Circle = exports.Circle = function Circle(_ref) {
	  var width = _ref.width,
	      onChange = _ref.onChange,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      circleSize = _ref.circleSize,
	      circleSpacing = _ref.circleSpacing;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        display: 'flex',
	        flexWrap: 'wrap',
	        marginRight: -circleSpacing,
	        marginBottom: -circleSpacing
	      }
	    }
	  });
	
	  var handleChange = function handleChange(hexCode, e) {
	    return onChange({ hex: hexCode, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'circle-picker' },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_CircleSwatch2.default, {
	        key: c,
	        color: c,
	        onClick: handleChange,
	        active: hex === c.toLowerCase(),
	        circleSize: circleSize,
	        circleSpacing: circleSpacing
	      });
	    })
	  );
	};
	
	Circle.defaultProps = {
	  width: '252px',
	  circleSize: 28,
	  circleSpacing: 14,
	  colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']]
	};
	
	exports.default = (0, _common.ColorWrap)(Circle);

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.materialColors = factory();
	  }
	})(this, function() {
	  return {"red":{"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"},"pink":{"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"},"purple":{"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"},"deepPurple":{"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"},"indigo":{"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"},"blue":{"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"},"lightBlue":{"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"},"cyan":{"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"},"teal":{"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"},"green":{"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"},"lightGreen":{"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"},"lime":{"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"},"yellow":{"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"},"amber":{"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"},"orange":{"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"},"deepOrange":{"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"},"brown":{"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"},"grey":{"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"},"blueGrey":{"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"},"darkText":{"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"},"lightText":{"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"},"darkIcons":{"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"},"lightIcons":{"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"},"white":"#ffffff","black":"#000000"};
	});


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CircleSwatch = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
	  var color = _ref.color,
	      onClick = _ref.onClick,
	      hover = _ref.hover,
	      active = _ref.active,
	      circleSize = _ref.circleSize,
	      circleSpacing = _ref.circleSpacing;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: circleSize,
	        height: circleSize,
	        marginRight: circleSpacing,
	        marginBottom: circleSpacing,
	        transform: 'scale(1)',
	        transition: '100ms transform ease'
	      },
	      Swatch: {
	        borderRadius: '50%',
	        background: 'transparent',
	        boxShadow: 'inset 0 0 0 ' + circleSize / 2 + 'px ' + color,
	        transition: '100ms box-shadow ease'
	      }
	    },
	    'hover': {
	      swatch: {
	        transform: 'scale(1.2)'
	      }
	    },
	    'active': {
	      Swatch: {
	        boxShadow: 'inset 0 0 0 3px ' + color
	      }
	    }
	  }, { hover: hover, active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, { style: styles.Swatch, color: color, onClick: onClick })
	  );
	};
	
	CircleSwatch.defaultProps = {
	  circleSize: 28,
	  circleSpacing: 14
	};
	
	exports.default = (0, _reactcss.handleHover)(CircleSwatch);

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chrome = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(247);
	
	var _ChromeFields = __webpack_require__(274);
	
	var _ChromeFields2 = _interopRequireDefault(_ChromeFields);
	
	var _ChromePointer = __webpack_require__(275);
	
	var _ChromePointer2 = _interopRequireDefault(_ChromePointer);
	
	var _ChromePointerCircle = __webpack_require__(276);
	
	var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chrome = exports.Chrome = function Chrome(_ref) {
	  var onChange = _ref.onChange,
	      disableAlpha = _ref.disableAlpha,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hsv = _ref.hsv,
	      hex = _ref.hex,
	      renderers = _ref.renderers;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        background: '#fff',
	        borderRadius: '2px',
	        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
	        boxSizing: 'initial',
	        width: '225px',
	        fontFamily: 'Menlo'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '55%',
	        position: 'relative',
	        borderRadius: '2px 2px 0 0',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '2px 2px 0 0'
	      },
	      body: {
	        padding: '16px 16px 12px'
	      },
	      controls: {
	        display: 'flex'
	      },
	      color: {
	        width: '32px'
	      },
	      swatch: {
	        marginTop: '6px',
	        width: '16px',
	        height: '16px',
	        borderRadius: '8px',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      active: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '8px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
	        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
	        zIndex: '2'
	      },
	      toggles: {
	        flex: '1'
	      },
	      hue: {
	        height: '10px',
	        position: 'relative',
	        marginBottom: '8px'
	      },
	      Hue: {
	        radius: '2px'
	      },
	      alpha: {
	        height: '10px',
	        position: 'relative'
	      },
	      Alpha: {
	        radius: '2px'
	      }
	    },
	    'disableAlpha': {
	      color: {
	        width: '22px'
	      },
	      alpha: {
	        display: 'none'
	      },
	      hue: {
	        marginBottom: '0px'
	      },
	      swatch: {
	        width: '10px',
	        height: '10px',
	        marginTop: '0px'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'chrome-picker' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        pointer: _ChromePointerCircle2.default,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(
	        'div',
	        { style: styles.controls, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.color },
	          _react2.default.createElement(
	            'div',
	            { style: styles.swatch },
	            _react2.default.createElement('div', { style: styles.active }),
	            _react2.default.createElement(_common.Checkboard, { renderers: renderers })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggles },
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              style: styles.Hue,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              onChange: onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.Alpha, {
	              style: styles.Alpha,
	              rgb: rgb,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              renderers: renderers,
	              onChange: onChange
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_ChromeFields2.default, {
	        rgb: rgb,
	        hsl: hsl,
	        hex: hex,
	        onChange: onChange,
	        disableAlpha: disableAlpha
	      })
	    )
	  );
	};
	
	exports.default = (0, _common.ColorWrap)(Chrome);

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromeFields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(262);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */
	
	var ChromeFields = exports.ChromeFields = function (_React$Component) {
	  _inherits(ChromeFields, _React$Component);
	
	  function ChromeFields() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChromeFields);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      view: ''
	    }, _this.toggleViews = function () {
	      if (_this.state.view === 'hex') {
	        _this.setState({ view: 'rgb' });
	      } else if (_this.state.view === 'rgb') {
	        _this.setState({ view: 'hsl' });
	      } else if (_this.state.view === 'hsl') {
	        if (_this.props.hsl.a === 1) {
	          _this.setState({ view: 'hex' });
	        } else {
	          _this.setState({ view: 'rgb' });
	        }
	      }
	    }, _this.handleChange = function (data, e) {
	      if (data.hex) {
	        _color2.default.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        }, e);
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        }, e);
	      } else if (data.a) {
	        if (data.a < 0) {
	          data.a = 0;
	        } else if (data.a > 1) {
	          data.a = 1;
	        }
	
	        _this.props.onChange({
	          h: _this.props.hsl.h,
	          s: _this.props.hsl.s,
	          l: _this.props.hsl.l,
	          a: Math.round(data.a * 100) / 100,
	          source: 'rgb'
	        }, e);
	      } else if (data.h || data.s || data.l) {
	        _this.props.onChange({
	          h: data.h || _this.props.hsl.h,
	          s: data.s && data.s.replace('%', '') || _this.props.hsl.s,
	          l: data.l && data.l.replace('%', '') || _this.props.hsl.l,
	          source: 'hsl'
	        }, e);
	      }
	    }, _this.showHighlight = function (e) {
	      e.target.style.background = '#eee';
	    }, _this.hideHighlight = function (e) {
	      e.target.style.background = 'transparent';
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChromeFields, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.hsl.a === 1 && this.state.view !== 'hex') {
	        this.setState({ view: 'hex' });
	      } else if (this.state.view !== 'rgb' && this.state.view !== 'hsl') {
	        this.setState({ view: 'rgb' });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hsl.a !== 1 && this.state.view === 'hex') {
	        this.setState({ view: 'rgb' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            paddingTop: '16px',
	            display: 'flex'
	          },
	          fields: {
	            flex: '1',
	            display: 'flex',
	            marginLeft: '-6px'
	          },
	          field: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          alpha: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          toggle: {
	            width: '32px',
	            textAlign: 'right',
	            position: 'relative'
	          },
	          icon: {
	            marginRight: '-4px',
	            marginTop: '12px',
	            cursor: 'pointer',
	            position: 'relative'
	          },
	          iconHighlight: {
	            position: 'absolute',
	            width: '24px',
	            height: '28px',
	            background: '#eee',
	            borderRadius: '4px',
	            top: '10px',
	            left: '12px',
	            display: 'none'
	          },
	          input: {
	            fontSize: '11px',
	            color: '#333',
	            width: '100%',
	            borderRadius: '2px',
	            border: 'none',
	            boxShadow: 'inset 0 0 0 1px #dadada',
	            height: '21px',
	            textAlign: 'center'
	          },
	          label: {
	            textTransform: 'uppercase',
	            fontSize: '11px',
	            lineHeight: '11px',
	            color: '#969696',
	            textAlign: 'center',
	            display: 'block',
	            marginTop: '12px'
	          },
	          svg: {
	            width: '24px',
	            height: '24px',
	            border: '1px transparent solid',
	            borderRadius: '5px'
	          }
	        },
	        'disableAlpha': {
	          alpha: {
	            display: 'none'
	          }
	        }
	      }, this.props, this.state);
	
	      var fields = void 0;
	      if (this.state.view === 'hex') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'hex', value: this.props.hex,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'rgb') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'r',
	              value: this.props.rgb.r,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'g',
	              value: this.props.rgb.g,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'b',
	              value: this.props.rgb.b,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.rgb.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'hsl') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'h',
	              value: Math.round(this.props.hsl.h),
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 's',
	              value: Math.round(this.props.hsl.s * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'l',
	              value: Math.round(this.props.hsl.l * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.hsl.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap, className: 'flexbox-fix' },
	        fields,
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggle },
	          _react2.default.createElement(
	            'div',
	            { style: styles.icon, onClick: this.toggleViews, ref: 'icon' },
	            _react2.default.createElement(
	              'svg',
	              {
	                style: styles.svg,
	                viewBox: '0 0 24 24',
	                onMouseOver: this.showHighlight,
	                onMouseEnter: this.showHighlight,
	                onMouseOut: this.hideHighlight
	              },
	              _react2.default.createElement('path', {
	                ref: 'iconUp',
	                fill: '#333',
	                d: 'M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
	              }),
	              _react2.default.createElement('path', {
	                ref: 'iconDown',
	                fill: '#333',
	                d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15Z'
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChromeFields;
	}(_react2.default.Component);
	
	exports.default = ChromeFields;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointer = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointer = exports.ChromePointer = function ChromePointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        transform: 'translate(-6px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointer;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointerCircle = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointerCircle;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Compact = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(121);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _color = __webpack_require__(262);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactMaterialDesign = __webpack_require__(278);
	
	var _common = __webpack_require__(247);
	
	var _CompactColor = __webpack_require__(289);
	
	var _CompactColor2 = _interopRequireDefault(_CompactColor);
	
	var _CompactFields = __webpack_require__(290);
	
	var _CompactFields2 = _interopRequireDefault(_CompactFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Compact = exports.Compact = function Compact(_ref) {
	  var onChange = _ref.onChange,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      rgb = _ref.rgb;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      Compact: {
	        background: '#f6f6f6',
	        radius: '4px'
	      },
	      compact: {
	        paddingTop: '5px',
	        paddingLeft: '5px',
	        boxSizing: 'initial',
	        width: '240px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      _color2.default.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else {
	      onChange(data, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _reactMaterialDesign.Raised,
	    { style: styles.Compact },
	    _react2.default.createElement(
	      'div',
	      { style: styles.compact, className: 'compact-picker' },
	      _react2.default.createElement(
	        'div',
	        null,
	        (0, _map2.default)(colors, function (c) {
	          return _react2.default.createElement(_CompactColor2.default, {
	            key: c,
	            color: c,
	            active: c.toLowerCase() === hex,
	            onClick: handleChange
	          });
	        }),
	        _react2.default.createElement('div', { style: styles.clear })
	      ),
	      _react2.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
	    )
	  );
	};
	
	Compact.defaultProps = {
	  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E']
	};
	
	exports.default = (0, _common.ColorWrap)(Compact);

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true,
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _libComponentsRaised = __webpack_require__(279);
	
	var _libComponentsRaised2 = _interopRequireDefault(_libComponentsRaised);
	
	var _libComponentsTile = __webpack_require__(285);
	
	var _libComponentsTile2 = _interopRequireDefault(_libComponentsTile);
	
	var _libComponentsTabs = __webpack_require__(286);
	
	var _libComponentsTabs2 = _interopRequireDefault(_libComponentsTabs);
	
	exports.Raised = _libComponentsRaised2['default'];
	exports.Tile = _libComponentsTile2['default'];
	exports.Tabs = _libComponentsTabs2['default'];


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node: true, esnext: true */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(280);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Raised = function (_React$Component) {
	  _inherits(Raised, _React$Component);
	
	  function Raised() {
	    _classCallCheck(this, Raised);
	
	    return _possibleConstructorReturn(this, (Raised.__proto__ || Object.getPrototypeOf(Raised)).apply(this, arguments));
	  }
	
	  _createClass(Raised, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            position: 'relative'
	          },
	          content: {
	            position: 'relative'
	          },
	          bg: {
	            absolute: '0px 0px 0px 0px',
	            boxShadow: '0 ${ this.props.zDepth }px ${ this.props.zDepth * 4 }px rgba(0,0,0,.24)',
	            borderRadius: this.props.radius,
	            background: this.props.background
	          }
	        },
	        'zDepth-0': {
	          bg: {
	            boxShadow: 'none'
	          }
	        },
	
	        'zDepth-1': {
	          bg: {
	            boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
	          }
	        },
	        'zDepth-2': {
	          bg: {
	            boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
	          }
	        },
	        'zDepth-3': {
	          bg: {
	            boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
	          }
	        },
	        'zDepth-4': {
	          bg: {
	            boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
	          }
	        },
	        'zDepth-5': {
	          bg: {
	            boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
	          }
	        },
	        'square': {
	          bg: {
	            borderRadius: '0'
	          }
	        },
	        'circle': {
	          bg: {
	            borderRadius: '50%'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap },
	        _react2.default.createElement('div', { style: styles.bg }),
	        _react2.default.createElement(
	          'div',
	          { style: styles.content },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Raised;
	}(_react2.default.Component);
	
	Raised.propTypes = {
	  background: _propTypes2.default.string,
	  zDepth: _propTypes2.default.oneOf(['0', '1', '2', '3', '4', '5', 0, 1, 2, 3, 4, 5]),
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Raised.defaultProps = {
	  background: '#fff',
	  zDepth: '1',
	  radius: '2px'
	};
	
	exports.default = Raised;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(281)();
	}


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(282);
	var invariant = __webpack_require__(283);
	var ReactPropTypesSecret = __webpack_require__(284);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 282 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 284 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node: true, esnext: true */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tile = function (_React$Component) {
	  _inherits(Tile, _React$Component);
	
	  function Tile() {
	    _classCallCheck(this, Tile);
	
	    return _possibleConstructorReturn(this, (Tile.__proto__ || Object.getPrototypeOf(Tile)).apply(this, arguments));
	  }
	
	  _createClass(Tile, [{
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          tile: {
	            fontSize: '16px',
	            padding: '16px',
	            display: 'flex',
	            justifyContent: 'space-between',
	            color: this.props.color
	          },
	          primary: {
	            display: 'flex',
	            width: '100%'
	          },
	          sidebar: {
	            minWidth: '56px',
	            maxWidth: '56px',
	            flexBasis: '56px' },
	          content: {
	            background: 'none',
	            flex: '1',
	            overflow: 'auto'
	          },
	          secondary: {
	            flexBasis: '42',
	            textAlign: 'center'
	          },
	          sidebarIcon: {
	            marginTop: '-12px',
	            marginLeft: '-12px',
	            marginBottom: '-12px'
	          }
	        },
	        'divider': {
	          tile: {
	            boxShadow: 'inset 0 -1px 0 rgba(0,0,0,.12)'
	          }
	        },
	        'condensed': {
	          tile: {
	            paddingBottom: '0px',
	            paddingTop: '0px',
	            paddingRight: '0px'
	          },
	          sidebar: {
	            minWidth: '28px',
	            maxWidth: '28px',
	            flexBasis: '28px'
	          }
	        }
	      }, {
	        'clickable': this.props.onClick
	      }, this.props);
	
	      var _props$children = _slicedToArray(this.props.children, 2),
	          sidebar = _props$children[0],
	          content = _props$children[1];
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.tile, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.primary, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.sidebar, key: "sidebar-#{ sidebar }" },
	            sidebar
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.content, key: "content-#{ content }" },
	            content
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tile;
	}(_react2.default.Component);
	
	;
	
	exports.default = Tile;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _isString = __webpack_require__(83);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _Tab = __webpack_require__(287);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _Link = __webpack_require__(288);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// var Ink = require('./Ink');
	
	// var context = {
	//   primaryColor: '#2196F3',
	//   accentColor: '#E91E63',
	//   theme: 'light'
	// }
	
	var Tabs = function (_React$Component) {
	  _inherits(Tabs, _React$Component);
	
	  function Tabs(props) {
	    _classCallCheck(this, Tabs);
	
	    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this));
	
	    var selectedTab;
	    if (props.selectedTab < (props.tabs && props.tabs.length)) {
	      selectedTab = props.selectedTab;
	    } else {
	      selectedTab = 0;
	    }
	
	    _this.state = {
	      selectedTab: selectedTab
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.slide = _this.slide.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tabs, [{
	    key: 'handleClick',
	    value: function handleClick(tab) {
	      if (this.props.onChange) {
	        this.props.onChange(tab);
	      }
	
	      this.setState({
	        selectedTab: tab
	      });
	    }
	  }, {
	    key: 'slide',
	    value: function slide() {
	      if (this.props.tabs.length) {
	        var containerNode = this.refs.tabs.getDOMNode();
	        var containerLeft = containerNode.scrollLeft;
	        var containerRight = containerNode.offsetWidth + containerNode.scrollLeft;
	
	        var selectedNode = this.refs['tab-' + this.state.selectedTab] && this.refs['tab-' + this.state.selectedTab].getDOMNode();
	        var selectedLeft = selectedNode && selectedNode.getBoundingClientRect().left - containerNode.getBoundingClientRect().left + containerNode.scrollLeft;
	        var selectedRight = selectedNode && selectedLeft + selectedNode.offsetWidth;
	
	        // scroll right if tab is off screen
	        if (selectedRight > containerRight) {
	          containerNode.scrollLeft += selectedRight - containerRight;
	        }
	
	        // scroll left if tab is off screen
	        if (selectedLeft < containerLeft) {
	          containerNode.scrollLeft -= containerLeft - selectedLeft;
	        }
	
	        // slide the indicator
	        var indicator = this.refs.indicator;
	        indicator.style.left = selectedLeft + 'px';
	        indicator.style.width = selectedNode.offsetWidth + 'px';
	        indicator.style.height = '2px';
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.slide();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedTab !== this.state.selectedTab) {
	        this.setState({ selectedTab: nextProps.selectedTab });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (nextState.selectedTab >= (nextProps.tabs && nextProps.tabs.length)) {
	        nextState.selectedTab = nextProps.tabs.length - 1;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.slide();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          tabs: {
	            position: 'relative',
	            background: this.props.background
	          },
	          tabWrap: {
	            display: 'flex'
	          },
	          tab: {
	            justifyContent: 'flex-start',
	            minWidth: '68px',
	            maxWidth: '240px'
	          },
	          Tab: {
	            color: this.props.color,
	            inactive: this.props.inactive,
	            capitalize: this.props.capitalize
	          },
	          indicator: {
	            height: '0',
	            position: 'absolute',
	            bottom: '0',
	            left: '0',
	            background: this.props.color,
	            transition: 'all 200ms linear'
	          }
	        },
	        'scrollable': {
	          tabs: {
	            overflowX: 'scroll'
	          },
	          tabWrap: {
	            paddingLeft: '60px',
	            justifyContent: 'flex-start',
	            width: '400%'
	          },
	          tab: {
	            width: 'auto'
	          }
	        },
	        'align-justify': {
	          tabWrap: {
	            justifyContent: 'space-between'
	          },
	          tab: {
	            width: 100 / this.props.tabs.length + '%'
	          }
	        },
	        'align-left': {
	          tabWrap: {
	            paddingLeft: '60px',
	            justifyContent: 'flex-start'
	          },
	          tab: {
	            width: 'auto'
	          }
	        },
	        'align-center': {
	          tabWrap: {
	            justifyContent: 'center'
	          },
	          tab: {
	            width: 'auto'
	          }
	        }
	      }, {
	        'scrollable': this.props.width / this.props.tabs.length < 72
	      }, this.props, this.state);
	
	      var tabs = [];
	      for (var i = 0; i < this.props.tabs.length; i++) {
	        var tab = this.props.tabs[i];
	
	        var label;
	        var callback;
	        var callbackValue;
	        var newTab;
	        if ((0, _isString2.default)(tab)) {
	          label = tab;
	          callback = null;
	        } else {
	          label = tab.label;
	          callback = tab.onClick;
	          callbackValue = tab.callbackValue;
	          newTab = tab.newTab;
	        }
	
	        tabs.push(_react2.default.createElement(
	          'div',
	          { style: styles.tab, ref: 'tab-' + i, key: i },
	          _react2.default.createElement(
	            _Link2.default,
	            { onClick: callback, callbackValue: callbackValue, newTab: newTab },
	            _react2.default.createElement(
	              _Tab2.default,
	              { style: styles.Tab, tab: i, selected: this.state.selectedTab === i, selectable: tab.selectable, onClick: this.handleClick },
	              label
	            )
	          )
	        ));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.tabs, ref: 'tabs' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.tabWrap, className: 'flexbox-fix' },
	          tabs
	        ),
	        _react2.default.createElement('div', { style: styles.indicator, ref: 'indicator' })
	      );
	    }
	  }]);
	
	  return Tabs;
	}(_react2.default.Component);
	
	Tabs.defaultProps = {
	  selectedTab: 0,
	  background: 'transparent',
	  color: '#fff'
	};
	
	exports.default = Tabs;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(280);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tab = function (_React$Component) {
	  _inherits(Tab, _React$Component);
	
	  function Tab() {
	    _classCallCheck(this, Tab);
	
	    var _this = _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).call(this));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tab, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      if (this.props.selectable !== false) {
	        this.props.onClick(this.props.tab);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          tab: {
	            color: this.props.inactive || this.props.color,
	            cursor: 'pointer',
	            paddingLeft: '12px',
	            paddingRight: '12px',
	            height: '48px',
	            lineHeight: '48px',
	            textAlign: 'center',
	            fontSize: '14px',
	            textTransform: this.props.capitalize === false ? '' : 'uppercase',
	            fontWeight: '500',
	            whiteSpace: 'nowrap',
	            opacity: '.47',
	            transition: 'opacity 100ms linear'
	          }
	        },
	        'selected': {
	          tab: {
	            color: this.props.color,
	            opacity: '.87'
	          }
	        }
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.tab, onClick: this.handleClick },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Tab;
	}(_react2.default.Component);
	
	Tab.propTypes = {
	  selected: _propTypes2.default.bool
	};
	
	Tab.defaultProps = {
	  selected: false,
	  color: '#fff'
	};
	
	exports.default = Tab;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isString = __webpack_require__(83);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Link, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      if (this.props.onClick) {
	        this.props.onClick(e, this.props.callbackValue);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var a;
	      if ((0, _isString2.default)(this.props.onClick)) {
	        a = _react2.default.createElement(
	          'a',
	          { style: { textDecoration: 'none' }, href: this.props.onClick, target: this.props.newTab && '_blank' },
	          this.props.children
	        );
	      } else {
	        a = _react2.default.createElement(
	          'a',
	          { style: { textDecoration: 'none' }, onClick: this.handleClick },
	          this.props.children
	        );
	      }
	
	      return a;
	    }
	  }]);
	
	  return Link;
	}(_react2.default.Component);
	
	// Link.propTypes =
	//   onClick: PropTypes.oneOfType(
	//     PropTypes.string,
	//     PropTypes.func
	//   );
	
	Link.defaultProps = {
	  newTab: false
	};
	
	exports.default = Link;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactColor = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactColor = exports.CompactColor = function CompactColor(_ref) {
	  var color = _ref.color,
	      onClick = _ref.onClick,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        background: color,
	        width: '15px',
	        height: '15px',
	        float: 'left',
	        marginRight: '5px',
	        marginBottom: '5px',
	        position: 'relative',
	        cursor: 'pointer'
	      },
	      dot: {
	        absolute: '5px 5px 5px 5px',
	        background: '#fff',
	        borderRadius: '50%',
	        opacity: '0'
	      }
	    },
	    'active': {
	      dot: {
	        opacity: '1'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      dot: {
	        background: '#000'
	      }
	    }
	  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF' });
	
	  var handleClick = function handleClick(e) {
	    return onClick({ hex: color }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.color, onClick: handleClick },
	    _react2.default.createElement('div', { style: styles.dot })
	  );
	};
	
	exports.default = CompactColor;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactFields = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactFields = exports.CompactFields = function CompactFields(_ref) {
	  var hex = _ref.hex,
	      rgb = _ref.rgb,
	      onChange = _ref.onChange;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingBottom: '6px',
	        paddingRight: '5px',
	        position: 'relative'
	      },
	      active: {
	        position: 'absolute',
	        top: '6px',
	        left: '5px',
	        height: '9px',
	        width: '9px',
	        background: hex
	      },
	      HEXwrap: {
	        flex: '6',
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '80%',
	        padding: '0px',
	        paddingLeft: '20%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      HEXlabel: {
	        display: 'none'
	      },
	      RGBwrap: {
	        flex: '3',
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '70%',
	        padding: '0px',
	        paddingLeft: '30%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '3px',
	        left: '0px',
	        lineHeight: '16px',
	        textTransform: 'uppercase',
	        fontSize: '12px',
	        color: '#999'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else {
	      onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement('div', { style: styles.active }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: 'hex',
	      value: hex,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    })
	  );
	};
	
	exports.default = CompactFields;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Github = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(121);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _common = __webpack_require__(247);
	
	var _GithubSwatch = __webpack_require__(292);
	
	var _GithubSwatch2 = _interopRequireDefault(_GithubSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Github = exports.Github = function Github(_ref) {
	  var width = _ref.width,
	      colors = _ref.colors,
	      onChange = _ref.onChange,
	      triangle = _ref.triangle;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '1px solid rgba(0,0,0,0.2)',
	        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
	        borderRadius: '4px',
	        position: 'relative',
	        padding: '5px',
	        display: 'flex',
	        flexWrap: 'wrap'
	      },
	      triangle: {
	        position: 'absolute',
	        border: '7px solid transparent',
	        borderBottomColor: '#fff'
	      },
	      triangleShadow: {
	        position: 'absolute',
	        border: '8px solid transparent',
	        borderBottomColor: 'rgba(0,0,0,0.15)'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-14px',
	        left: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        left: '9px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-14px',
	        right: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        right: '9px'
	      }
	    },
	    'bottom-right-triangle': {
	      triangle: {
	        top: '35px',
	        right: '10px',
	        transform: 'rotate(180deg)'
	      },
	      triangleShadow: {
	        top: '37px',
	        right: '9px',
	        transform: 'rotate(180deg)'
	      }
	    }
	  }, {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right',
	    'bottom-right-triangle': triangle === 'bottom-right'
	  });
	
	  var handleChange = function handleChange(hex, e) {
	    return onChange({ hex: hex, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'github-picker' },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_GithubSwatch2.default, { color: c, key: c, onClick: handleChange });
	    })
	  );
	};
	
	Github.defaultProps = {
	  width: '200px',
	  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
	  triangle: 'top-left'
	};
	
	exports.default = (0, _common.ColorWrap)(Github);

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GithubSwatch = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
	  var hover = _ref.hover,
	      color = _ref.color,
	      onClick = _ref.onClick;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: '25px',
	        height: '25px'
	      }
	    },
	    'hover': {
	      swatch: {
	        position: 'relative',
	        zIndex: '2',
	        outline: '2px solid #fff',
	        boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
	      }
	    }
	  }, { hover: hover });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, { color: color, onClick: onClick })
	  );
	};
	
	exports.default = (0, _reactcss.handleHover)(GithubSwatch);

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HuePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(247);
	
	var _HuePointer = __webpack_require__(294);
	
	var _HuePointer2 = _interopRequireDefault(_HuePointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HuePicker = exports.HuePicker = function HuePicker(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      hsl = _ref.hsl,
	      direction = _ref.direction,
	      pointer = _ref.pointer;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      hue: {
	        radius: '2px'
	      }
	    }
	  });
	
	  // Overwrite to provide pure hue color
	  var handleChange = function handleChange(data) {
	    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'hue-picker' },
	    _react2.default.createElement(_common.Hue, _extends({}, styles.hue, {
	      hsl: hsl,
	      pointer: pointer,
	      onChange: handleChange,
	      direction: direction
	    }))
	  );
	};
	
	HuePicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _HuePointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(HuePicker);

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Material = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(262);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactMaterialDesign = __webpack_require__(278);
	
	var _common = __webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Material = exports.Material = function Material(_ref) {
	  var onChange = _ref.onChange,
	      hex = _ref.hex,
	      rgb = _ref.rgb;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      material: {
	        width: '98px',
	        height: '98px',
	        padding: '16px',
	        fontFamily: 'Roboto'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '2px solid ' + hex,
	        outline: 'none',
	        height: '30px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      Hex: {
	        style: {}
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '1px solid #eee',
	        outline: 'none',
	        height: '30px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      split: {
	        display: 'flex',
	        marginRight: '-10px',
	        paddingTop: '11px'
	      },
	      third: {
	        flex: '1',
	        paddingRight: '10px'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      _color2.default.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _reactMaterialDesign.Raised,
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: styles.material, className: 'material-picker' },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	        label: 'hex',
	        value: hex,
	        onChange: handleChange
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.split, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'r', value: rgb.r,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'g',
	            value: rgb.g,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'b',
	            value: rgb.b,
	            onChange: handleChange
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _common.ColorWrap)(Material);

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Photoshop = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(247);
	
	var _PhotoshopFields = __webpack_require__(297);
	
	var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);
	
	var _PhotoshopPointerCircle = __webpack_require__(298);
	
	var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);
	
	var _PhotoshopPointer = __webpack_require__(299);
	
	var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);
	
	var _PhotoshopButton = __webpack_require__(300);
	
	var _PhotoshopButton2 = _interopRequireDefault(_PhotoshopButton);
	
	var _PhotoshopPreviews = __webpack_require__(301);
	
	var _PhotoshopPreviews2 = _interopRequireDefault(_PhotoshopPreviews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Photoshop = exports.Photoshop = function (_React$Component) {
	  _inherits(Photoshop, _React$Component);
	
	  function Photoshop(props) {
	    _classCallCheck(this, Photoshop);
	
	    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
	
	    _this.state = {
	      currentColor: props.hex
	    };
	    return _this;
	  }
	
	  _createClass(Photoshop, [{
	    key: 'render',
	    value: function render() {
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            background: '#DCDCDC',
	            borderRadius: '4px',
	            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
	            boxSizing: 'initial',
	            width: '513px'
	          },
	          head: {
	            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
	            borderBottom: '1px solid #B1B1B1',
	            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
	            height: '23px',
	            lineHeight: '24px',
	            borderRadius: '4px 4px 0 0',
	            fontSize: '13px',
	            color: '#4D4D4D',
	            textAlign: 'center'
	          },
	          body: {
	            padding: '15px 15px 0',
	            display: 'flex'
	          },
	          saturation: {
	            width: '256px',
	            height: '256px',
	            position: 'relative',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0',
	            overflow: 'hidden'
	          },
	          hue: {
	            position: 'relative',
	            height: '256px',
	            width: '19px',
	            marginLeft: '10px',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0'
	          },
	          controls: {
	            width: '180px',
	            marginLeft: '10px'
	          },
	          top: {
	            display: 'flex'
	          },
	          previews: {
	            width: '60px'
	          },
	          actions: {
	            flex: '1',
	            marginLeft: '20px'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker, className: 'photoshop-picker' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.head },
	          this.props.header
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.body, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.saturation },
	            _react2.default.createElement(_common.Saturation, {
	              hsl: this.props.hsl,
	              hsv: this.props.hsv,
	              pointer: _PhotoshopPointerCircle2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              direction: 'vertical',
	              hsl: this.props.hsl,
	              pointer: _PhotoshopPointer2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.controls },
	            _react2.default.createElement(
	              'div',
	              { style: styles.top, className: 'flexbox-fix' },
	              _react2.default.createElement(
	                'div',
	                { style: styles.previews },
	                _react2.default.createElement(_PhotoshopPreviews2.default, {
	                  rgb: this.props.rgb,
	                  currentColor: this.state.currentColor
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: styles.actions },
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
	                _react2.default.createElement(_PhotoshopFields2.default, {
	                  onChange: this.props.onChange,
	                  rgb: this.props.rgb,
	                  hsv: this.props.hsv,
	                  hex: this.props.hex
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Photoshop;
	}(_react2.default.Component);
	
	Photoshop.defaultProps = {
	  header: 'Color Picker'
	};
	
	exports.default = (0, _common.ColorWrap)(Photoshop);

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPicker = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(262);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsv = _ref.hsv,
	      hex = _ref.hex;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        paddingTop: '5px',
	        paddingBottom: '9px',
	        width: '80px',
	        position: 'relative'
	      },
	      divider: {
	        height: '5px'
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        marginLeft: '40%',
	        width: '40%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '5px',
	        fontSize: '13px',
	        paddingLeft: '3px',
	        marginRight: '10px'
	      },
	      RGBlabel: {
	        left: '0px',
	        width: '34px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px',
	        position: 'absolute'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        marginLeft: '20%',
	        width: '80%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '6px',
	        fontSize: '13px',
	        paddingLeft: '3px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        width: '14px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px'
	      },
	      fieldSymbols: {
	        position: 'absolute',
	        top: '5px',
	        right: '-7px',
	        fontSize: '13px'
	      },
	      symbol: {
	        height: '20px',
	        lineHeight: '22px',
	        paddingBottom: '7px'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data['#']) {
	      _color2.default.isValidHex(data['#']) && onChange({
	        hex: data['#'],
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else if (data.h || data.s || data.v) {
	      onChange({
	        h: data.h || hsv.h,
	        s: data.s || hsv.s,
	        v: data.v || hsv.v,
	        source: 'hsv'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields },
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'h',
	      value: Math.round(hsv.h),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 's',
	      value: Math.round(hsv.s * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'v',
	      value: Math.round(hsv.v * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: '#',
	      value: hex.replace('#', ''),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.fieldSymbols },
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '\xB0'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      )
	    )
	  );
	};
	
	exports.default = PhotoshopPicker;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
	  var hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    },
	    'black-outline': {
	      picker: {
	        boxShadow: 'inset 0 0 0 1px #000'
	      }
	    }
	  }, { 'black-outline': hsl.l > 0.5 });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      triangle: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '4px 0 4px 6px',
	        borderColor: 'transparent transparent transparent #fff',
	        position: 'absolute',
	        top: '1px',
	        left: '1px'
	      },
	      triangleBorder: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '5px 0 5px 8px',
	        borderColor: 'transparent transparent transparent #555'
	      },
	
	      left: {
	        Extend: 'triangleBorder',
	        transform: 'translate(-13px, -4px)'
	      },
	      leftInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      },
	
	      right: {
	        Extend: 'triangleBorder',
	        transform: 'translate(20px, -14px) rotate(180deg)'
	      },
	      rightInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.pointer },
	    _react2.default.createElement(
	      'div',
	      { style: styles.left },
	      _react2.default.createElement('div', { style: styles.leftInside })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.right },
	      _react2.default.createElement('div', { style: styles.rightInside })
	    )
	  );
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopBotton = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopBotton = exports.PhotoshopBotton = function PhotoshopBotton(_ref) {
	  var onClick = _ref.onClick,
	      label = _ref.label,
	      children = _ref.children,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      button: {
	        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
	        border: '1px solid #878787',
	        borderRadius: '2px',
	        height: '20px',
	        boxShadow: '0 1px 0 0 #EAEAEA',
	        fontSize: '14px',
	        color: '#000',
	        lineHeight: '20px',
	        textAlign: 'center',
	        marginBottom: '10px',
	        cursor: 'pointer'
	      }
	    },
	    'active': {
	      button: {
	        boxShadow: '0 0 0 1px #878787'
	      }
	    }
	  }, { active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.button, onClick: onClick },
	    label || children
	  );
	};
	
	exports.default = PhotoshopBotton;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPreviews = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
	  var rgb = _ref.rgb,
	      currentColor = _ref.currentColor;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        border: '1px solid #B3B3B3',
	        borderBottom: '1px solid #F0F0F0',
	        marginBottom: '2px',
	        marginTop: '1px'
	      },
	      new: {
	        height: '34px',
	        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
	      },
	      current: {
	        height: '34px',
	        background: currentColor,
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
	      },
	      label: {
	        fontSize: '14px',
	        color: '#000',
	        textAlign: 'center'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'new'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement('div', { style: styles.new }),
	      _react2.default.createElement('div', { style: styles.current })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'current'
	    )
	  );
	};
	
	exports.default = PhotoshopPreviews;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sketch = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(247);
	
	var _SketchFields = __webpack_require__(303);
	
	var _SketchFields2 = _interopRequireDefault(_SketchFields);
	
	var _SketchPresetColors = __webpack_require__(304);
	
	var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sketch = exports.Sketch = function Sketch(_ref) {
	  var width = _ref.width,
	      rgb = _ref.rgb,
	      hex = _ref.hex,
	      hsv = _ref.hsv,
	      hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      disableAlpha = _ref.disableAlpha,
	      presetColors = _ref.presetColors,
	      renderers = _ref.renderers;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: width,
	        padding: '10px 10px 0',
	        boxSizing: 'initial',
	        background: '#fff',
	        borderRadius: '4px',
	        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '75%',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '3px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      controls: {
	        display: 'flex'
	      },
	      sliders: {
	        padding: '4px 0',
	        flex: '1'
	      },
	      color: {
	        width: '24px',
	        height: '24px',
	        position: 'relative',
	        marginTop: '4px',
	        marginLeft: '4px',
	        borderRadius: '3px'
	      },
	      activeColor: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '2px',
	        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      hue: {
	        position: 'relative',
	        height: '10px',
	        overflow: 'hidden'
	      },
	      Hue: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	
	      alpha: {
	        position: 'relative',
	        height: '10px',
	        marginTop: '4px',
	        overflow: 'hidden'
	      },
	      Alpha: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      }
	    },
	    'disableAlpha': {
	      color: {
	        height: '10px'
	      },
	      hue: {
	        height: '10px'
	      },
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'sketch-picker' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.controls, className: 'flexbox-fix' },
	      _react2.default.createElement(
	        'div',
	        { style: styles.sliders },
	        _react2.default.createElement(
	          'div',
	          { style: styles.hue },
	          _react2.default.createElement(_common.Hue, {
	            style: styles.Hue,
	            hsl: hsl,
	            onChange: onChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.alpha },
	          _react2.default.createElement(_common.Alpha, {
	            style: styles.Alpha,
	            rgb: rgb,
	            hsl: hsl,
	            renderers: renderers,
	            onChange: onChange
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.color },
	        _react2.default.createElement(_common.Checkboard, null),
	        _react2.default.createElement('div', { style: styles.activeColor })
	      )
	    ),
	    _react2.default.createElement(_SketchFields2.default, {
	      rgb: rgb,
	      hsl: hsl,
	      hex: hex,
	      onChange: onChange,
	      disableAlpha: disableAlpha
	    }),
	    _react2.default.createElement(_SketchPresetColors2.default, { colors: presetColors, onClick: onChange })
	  );
	};
	
	Sketch.defaultProps = {
	  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF'],
	  width: 200
	};
	
	exports.default = (0, _common.ColorWrap)(Sketch);

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShetchFields = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(262);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-param-reassign */
	
	var ShetchFields = exports.ShetchFields = function ShetchFields(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hex = _ref.hex,
	      disableAlpha = _ref.disableAlpha;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingTop: '4px'
	      },
	      single: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      alpha: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      double: {
	        flex: '2'
	      },
	      input: {
	        width: '80%',
	        padding: '4px 10% 3px',
	        border: 'none',
	        boxShadow: 'inset 0 0 0 1px #ccc',
	        fontSize: '11px'
	      },
	      label: {
	        display: 'block',
	        textAlign: 'center',
	        fontSize: '11px',
	        color: '#222',
	        paddingTop: '3px',
	        paddingBottom: '4px',
	        textTransform: 'capitalize'
	      }
	    },
	    'disableAlpha': {
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      _color2.default.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        a: rgb.a,
	        source: 'rgb'
	      }, e);
	    } else if (data.a) {
	      if (data.a < 0) {
	        data.a = 0;
	      } else if (data.a > 100) {
	        data.a = 100;
	      }
	
	      data.a = data.a / 100;
	      onChange({
	        h: hsl.h,
	        s: hsl.s,
	        l: hsl.l,
	        a: data.a,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.double },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'hex',
	        value: hex.replace('#', ''),
	        onChange: handleChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'r',
	        value: rgb.r,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'g',
	        value: rgb.g,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'b',
	        value: rgb.b,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.alpha },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'a',
	        value: Math.round(rgb.a * 100),
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '100'
	      })
	    )
	  );
	};
	
	exports.default = ShetchFields;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchPresetColors = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(280);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
	  var colors = _ref.colors,
	      onClick = _ref.onClick;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      colors: {
	        margin: '0 -10px',
	        padding: '10px 0 0 10px',
	        borderTop: '1px solid #eee',
	        display: 'flex',
	        flexWrap: 'wrap',
	        position: 'relative'
	      },
	      swatchWrap: {
	        width: '16px',
	        height: '16px',
	        margin: '0 10px 10px 0'
	      },
	      swatch: {
	        borderRadius: '3px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
	      }
	    },
	    'no-presets': {
	      colors: {
	        display: 'none'
	      }
	    }
	  }, {
	    'no-presets': !colors || !colors.length
	  });
	
	  var handleClick = function handleClick(hex, e) {
	    onClick({
	      hex: hex,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.colors, className: 'flexbox-fix' },
	    colors.map(function (colorObjOrString) {
	      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
	      return _react2.default.createElement(
	        'div',
	        { key: c.color, style: styles.swatchWrap },
	        _react2.default.createElement(_common.Swatch, _extends({}, c, {
	          style: styles.swatch,
	          onClick: handleClick
	        }))
	      );
	    })
	  );
	};
	SketchPresetColors.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    color: _propTypes2.default.string,
	    title: _propTypes2.default.string
	  })]))
	};
	
	exports.default = SketchPresetColors;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(247);
	
	var _SliderSwatches = __webpack_require__(306);
	
	var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);
	
	var _SliderPointer = __webpack_require__(308);
	
	var _SliderPointer2 = _interopRequireDefault(_SliderPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Slider = exports.Slider = function Slider(_ref) {
	  var hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      pointer = _ref.pointer;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      hue: {
	        height: '12px',
	        position: 'relative'
	      },
	      Hue: {
	        radius: '2px'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'slider-picker' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.hue },
	      _react2.default.createElement(_common.Hue, {
	        style: styles.Hue,
	        hsl: hsl,
	        pointer: pointer,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
	    )
	  );
	};
	
	Slider.defaultProps = {
	  pointer: _SliderPointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(Slider);

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatches = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _SliderSwatch = __webpack_require__(307);
	
	var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
	  var onClick = _ref.onClick,
	      hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginTop: '20px'
	      },
	      swatch: {
	        boxSizing: 'border-box',
	        width: '20%',
	        paddingRight: '1px',
	        float: 'left'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.80',
	        active: Math.round(hsl.l * 100) / 100 === 0.80 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick,
	        first: true
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.65',
	        active: Math.round(hsl.l * 100) / 100 === 0.65 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.50',
	        active: Math.round(hsl.l * 100) / 100 === 0.50 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.35',
	        active: Math.round(hsl.l * 100) / 100 === 0.35 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.20',
	        active: Math.round(hsl.l * 100) / 100 === 0.20 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick,
	        last: true
	      })
	    ),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = SliderSwatches;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatch = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
	  var hsl = _ref.hsl,
	      offset = _ref.offset,
	      onClick = _ref.onClick,
	      active = _ref.active,
	      first = _ref.first,
	      last = _ref.last;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        height: '12px',
	        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
	        cursor: 'pointer'
	      }
	    },
	    'first': {
	      swatch: {
	        borderRadius: '2px 0 0 2px'
	      }
	    },
	    'last': {
	      swatch: {
	        borderRadius: '0 2px 2px 0'
	      }
	    },
	    'active': {
	      swatch: {
	        transform: 'scaleY(1.8)',
	        borderRadius: '3.6px/2px'
	      }
	    }
	  }, { active: active, first: first, last: last });
	
	  var handleClick = function handleClick(e) {
	    return onClick({
	      h: hsl.h,
	      s: 0.5,
	      l: offset,
	      source: 'hsl'
	    }, e);
	  };
	
	  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick });
	};
	
	exports.default = SliderSwatch;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '14px',
	        height: '14px',
	        borderRadius: '6px',
	        transform: 'translate(-7px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatches = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(121);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _color = __webpack_require__(262);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _materialColors = __webpack_require__(271);
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__(247);
	
	var _reactMaterialDesign = __webpack_require__(278);
	
	var _SwatchesGroup = __webpack_require__(310);
	
	var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Swatches = exports.Swatches = function Swatches(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      colors = _ref.colors,
	      hex = _ref.hex;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: width,
	        height: height
	      },
	      overflow: {
	        height: height,
	        overflowY: 'scroll'
	      },
	      body: {
	        padding: '16px 0 6px 16px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    _color2.default.isValidHex(data) && onChange({
	      hex: data,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'swatches-picker' },
	    _react2.default.createElement(
	      _reactMaterialDesign.Raised,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: styles.overflow },
	        _react2.default.createElement(
	          'div',
	          { style: styles.body },
	          (0, _map2.default)(colors, function (group) {
	            return _react2.default.createElement(_SwatchesGroup2.default, {
	              key: group.toString(),
	              group: group,
	              active: hex,
	              onClick: handleChange
	            });
	          }),
	          _react2.default.createElement('div', { style: styles.clear })
	        )
	      )
	    )
	  );
	};
	
	/* eslint-disable max-len */
	Swatches.defaultProps = {
	  width: 320,
	  height: 240,
	  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']]
	};
	
	exports.default = (0, _common.ColorWrap)(Swatches);

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesGroup = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(121);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _SwatchesColor = __webpack_require__(311);
	
	var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
	  var onClick = _ref.onClick,
	      group = _ref.group,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      group: {
	        paddingBottom: '10px',
	        width: '40px',
	        float: 'left',
	        marginRight: '10px'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.group },
	    (0, _map2.default)(group, function (color, i) {
	      return _react2.default.createElement(_SwatchesColor2.default, {
	        key: color,
	        color: color,
	        active: color.toLowerCase() === active,
	        first: i === 0,
	        last: i === group.length - 1,
	        onClick: onClick
	      });
	    })
	  );
	};
	
	exports.default = SwatchesGroup;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesColor = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
	  var color = _ref.color,
	      onClick = _ref.onClick,
	      first = _ref.first,
	      last = _ref.last,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        width: '40px',
	        height: '24px',
	        cursor: 'pointer',
	        background: color,
	        marginBottom: '1px'
	      },
	      check: {
	        fill: '#fff',
	        marginLeft: '8px',
	        display: 'none'
	      }
	    },
	    'first': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '2px 2px 0 0'
	      }
	    },
	    'last': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '0 0 2px 2px'
	      }
	    },
	    'active': {
	      check: {
	        display: 'block'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      check: {
	        fill: '#333'
	      }
	    }
	  }, { first: first, last: last, active: active, 'color-#FFFFFF': color === '#FFFFFF' });
	
	  var handleClick = function handleClick(e) {
	    return onClick(color, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.color, onClick: handleClick },
	    _react2.default.createElement(
	      'div',
	      { style: styles.check },
	      _react2.default.createElement(
	        'svg',
	        { style: { width: '24px', height: '24px' }, viewBox: '0 0 24 24' },
	        _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
	      )
	    )
	  );
	};
	
	exports.default = SwatchesColor;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Twitter = undefined;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(81);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(121);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _color = __webpack_require__(262);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Twitter = exports.Twitter = function Twitter(_ref) {
	  var onChange = _ref.onChange,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '0 solid rgba(0,0,0,0.25)',
	        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
	        borderRadius: '4px',
	        position: 'relative'
	      },
	      body: {
	        padding: '15px 9px 9px 15px'
	      },
	      label: {
	        fontSize: '18px',
	        color: '#fff'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent #fff transparent',
	        position: 'absolute'
	      },
	      triangleShadow: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
	        position: 'absolute'
	      },
	      hash: {
	        background: '#F0F0F0',
	        height: '30px',
	        width: '30px',
	        borderRadius: '4px 0 0 4px',
	        float: 'left',
	        color: '#98A1A4',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	      },
	      input: {
	        width: '100px',
	        fontSize: '14px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '28px',
	        boxShadow: 'inset 0 0 0 1px #F0F0F0',
	        borderRadius: '0 4px 4px 0',
	        float: 'left',
	        paddingLeft: '8px'
	      },
	      swatch: {
	        width: '30px',
	        height: '30px',
	        float: 'left',
	        borderRadius: '4px',
	        margin: '0 6px 6px 0'
	      },
	      clear: {
	        clear: 'both'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-10px',
	        left: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        left: '12px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-10px',
	        right: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        right: '12px'
	      }
	    }
	  }, {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right'
	  });
	
	  var handleChange = function handleChange(hex, e) {
	    _color2.default.isValidHex(hex) && onChange({
	      hex: hex,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'twitter-picker' },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      (0, _map2.default)(colors, function (c, i) {
	        return _react2.default.createElement(_common.Swatch, {
	          key: i,
	          color: c,
	          hex: c,
	          style: styles.swatch,
	          onClick: handleChange
	        });
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.hash },
	        '#'
	      ),
	      _react2.default.createElement(_common.EditableInput, {
	        placeholder: 'ff691f',
	        style: { input: styles.input },
	        value: '',
	        onChange: handleChange
	      }),
	      _react2.default.createElement('div', { style: styles.clear })
	    )
	  );
	};
	
	Twitter.defaultProps = {
	  width: '276px',
	  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
	  triangle: 'top-left'
	};
	
	exports.default = (0, _common.ColorWrap)(Twitter);

/***/ },
/* 313 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var Base = {
	  base00: 'Default Background',
	  base01: 'Soft Background',
	  base02: 'Soft Middle',
	  base03: 'Strong Middle',
	  base04: 'Soft Foreground',
	  base05: 'Default Foreground'
	};
	
	var Syntax = {
	  special00: 'Custom Components',
	  special01: 'Integers, Booleans',
	  special02: 'Strings, Arrays',
	  special03: 'Details Pane Text',
	  special04: 'Functions, Objects',
	  special05: 'Special Text',
	  special06: 'XML Attributes',
	  special07: 'Host Components'
	};
	
	var Selection = {
	  state00: 'Focused Background',
	  state01: 'Blurred Background',
	  state03: 'Hovered Background',
	  state02: 'Focused Foreground',
	  state04: 'Search Background',
	  state05: 'Search Foreground',
	  state06: 'Interactive Hover'
	};
	
	module.exports = {
	  Base: Base,
	  Selection: Selection,
	  Syntax: Syntax
	};

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _fauxRef;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(11);
	var PropTypes = __webpack_require__(6);
	
	var _require = __webpack_require__(315),
	    Map = _require.Map;
	
	var consts = __webpack_require__(32);
	var Node = __webpack_require__(64);
	
	var _require2 = __webpack_require__(17),
	    monospace = _require2.monospace;
	
	var Preview = function (_React$Component) {
	  _inherits(Preview, _React$Component);
	
	  function Preview() {
	    _classCallCheck(this, Preview);
	
	    return _possibleConstructorReturn(this, (Preview.__proto__ || Object.getPrototypeOf(Preview)).apply(this, arguments));
	  }
	
	  _createClass(Preview, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        scrollTo: function scrollTo() {},
	        store: fauxStore
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var theme = this.props.theme;
	
	
	      return React.createElement(
	        'div',
	        { style: panelStyle(theme) },
	        React.createElement(Node, {
	          depth: 0,
	          node: Map({
	            children: ['strictMode'],
	            name: 'div'
	          }),
	          searchRegExp: /iv/
	        })
	      );
	    }
	  }]);
	
	  return Preview;
	}(React.Component);
	
	Preview.childContextTypes = {
	  scrollTo: PropTypes.func,
	  store: PropTypes.object
	};
	
	var fauxRef = (_fauxRef = {}, _defineProperty(_fauxRef, consts.type, 'function'), _defineProperty(_fauxRef, consts.name, 'setRef'), _fauxRef);
	
	var childNode = Map({
	  id: 'child',
	  children: 'text',
	  name: 'div',
	  props: {
	    style: { color: 'red' }
	  },
	  ref: fauxRef
	});
	
	var strictModeNode = Map({
	  id: 'strictMode',
	  children: ['grandparent'],
	  name: 'StrictMode',
	  nodeType: 'Special'
	});
	
	var grandparentNode = Map({
	  id: 'grandparent',
	  children: ['parent'],
	  name: 'Grandparent',
	  nodeType: 'Composite',
	  props: {
	    depth: 0
	  }
	});
	
	var parentNode = Map({
	  id: 'parent',
	  children: ['child'],
	  name: 'Parent',
	  nodeType: 'Composite',
	  props: {
	    boolean: true,
	    integer: 123,
	    string: 'foobar'
	  }
	});
	
	var nodes = {
	  child: childNode,
	  grandparent: grandparentNode,
	  parent: parentNode,
	  strictMode: strictModeNode
	};
	
	var noop = function noop() {};
	
	var fauxStore = {
	  hovered: 'parent',
	  selected: 'grandparent',
	  get: function get(id) {
	    return nodes[id];
	  },
	  off: noop,
	  on: noop,
	  onContextMenu: noop,
	  onHover: noop,
	  onHoverBottom: noop,
	  onSelect: noop,
	  onSelectBottom: noop,
	  onToggleCollapse: noop,
	  setHover: noop,
	  selectBottom: noop,
	  selectTop: noop
	};
	
	var panelStyle = function panelStyle(theme) {
	  return {
	    maxWidth: '100%',
	    padding: '0.25rem 0',
	    zIndex: 1,
	    fontFamily: monospace.family,
	    fontSize: monospace.sizes.normal,
	    backgroundColor: theme.base00,
	    color: theme.base05
	  };
	};
	
	module.exports = Preview;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.Immutable = factory();
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step > 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    findEntry: function(predicate, context) {
	      var found;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findLastEntry: function(predicate, context) {
	      return this.toSeq().reverse().findEntry(predicate, context);
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  // Temporary warning about using length
	  (function () {
	    try {
	      Object.defineProperty(IterablePrototype, 'length', {
	        get: function () {
	          if (!Iterable.noLengthWarning) {
	            var stack;
	            try {
	              throw new Error();
	            } catch (error) {
	              stack = error.stack;
	            }
	            if (stack.indexOf('_wrapObject') === -1) {
	              console && console.warn && console.warn(
	                'iterable.length has been deprecated, '+
	                'use iterable.size or iterable.count(). '+
	                'This warning will become a silent error in a future version. ' +
	                stack
	              );
	              return this.size;
	            }
	          }
	        }
	      });
	    } catch (e) {}
	  })();
	
	
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toSeq().reverse().findKey(predicate, context);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.findLastKey(function(value ) {return is(value, searchValue)});
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.toKeyedSeq().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	
	      // var index =
	      // return this.toSeq().reverse().indexOf(searchValue);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var key = this.toKeyedSeq().findLastKey(predicate, context);
	      return key === undefined ? -1 : key;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : value;
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 316 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * A theme is a color template used throughout devtools.
	 * All devtools coloring is declared by themes, with one minor exception: status colors.
	 * Themes are user-selectable (via the preferences panel) and peristed between sessions.
	 *
	 * New themes may be safely added without user-facing impact.
	 * Renaming or removing a theme may cause user preferences to be reset on next devtools launch however.
	 *
	 * A few of the themes below are special purpose (ChromeDefault and ChromeDark, FirefoxDark).
	 * These are flagged as "hidden", meaning that they are not directly exposed to the user.
	 * Rather if the user chooses the "default" theme- they will be used to match the browser UI.
	 * These themes can be exposed to the UI directly by passing a "showHiddenThemes" flag to <Panel>.
	 * 
	 * Before adding a new theme, refer to the Theme docs in frontend/types.
	 * Each theme key has a purpose and guidelines should be followed to ensure legibility.
	 */
	
	var ApathyDark = {
	  displayName: 'Apathy (dark)',
	  base00: '#1b322e',
	  base01: '#30695f',
	  base02: '#184E45',
	  base03: '#2B685E',
	  base04: '#5F9C92',
	  base05: '#f5fcfb',
	  special00: '#3E9688',
	  special01: '#3E7996',
	  special02: '#883E96',
	  special03: '#963E4C',
	  special04: '#96883E',
	  special05: '#4C963E',
	  special06: '#3E965B',
	  special07: '#5F9C92',
	  state00: '#28423d',
	  state01: '#28423d',
	  state02: '#f5fcfb',
	  state03: '#28423d',
	  state04: '#3E4C96',
	  state05: '#f5fcfb',
	  state06: '#ffffff'
	};
	
	var ApathyLight = {
	  displayName: 'Apathy (light)',
	  base00: '#D2E7E4',
	  base01: '#fff',
	  base02: '#184E45',
	  base03: '#2B685E',
	  base04: '#5F9C92',
	  base05: 'rgba(0, 0, 0, .7)',
	  special00: '#3E9688',
	  special01: '#3E7996',
	  special02: '#883E96',
	  special03: '#963E4C',
	  special04: '#96883E',
	  special05: '#4C963E',
	  special06: '#3E965B',
	  special07: '#5F9C92',
	  state00: '#f5fcfb',
	  state01: '#f5fcfb',
	  state02: '#2b2d2d',
	  state03: '#f5fcfb',
	  state04: '#3E4C96',
	  state05: '#f5fcfb',
	  state06: '#000000'
	};
	
	var AtomDark = {
	  displayName: 'Atom (dark)',
	  hidden: true,
	  base00: '#1d1f21',
	  base01: '#292c2f',
	  base02: '#2e2e2e',
	  base03: '#303030',
	  base04: '#868989',
	  base05: '#c1c4c2',
	  special00: '#fffeba',
	  special01: '#f574f3',
	  special02: '#aafd6a',
	  special03: '#93c294',
	  special04: '#fed2aa',
	  special05: '#93c294',
	  special06: '#c5c5fb',
	  special07: '#98ccfc',
	  state00: '#4483c2',
	  state01: '#444444',
	  state02: '#ffffff',
	  state03: '#444444',
	  state04: '#4483c2',
	  state05: '#ffffff',
	  state06: '#e3e6e4'
	};
	
	var AtomLight = {
	  displayName: 'Atom (light)',
	  hidden: true,
	  base00: '#ffffff',
	  base01: '#f4f4f4',
	  base02: '#eeeeee',
	  base03: '#555555',
	  base04: '#999989',
	  base05: '#222222',
	  special00: '#11807f',
	  special01: '#db1847',
	  special02: '#db1847',
	  special03: '#11807f',
	  special04: '#97040c',
	  special05: '#616b9f',
	  special06: '#455686',
	  special07: '#11807f',
	  state00: '#b0c4d9',
	  state01: '#fffed8',
	  state02: '#222222',
	  state03: '#fffed8',
	  state04: '#6da6e7',
	  state05: '#ffffff',
	  state06: '#000000'
	};
	
	var ChromeDark = {
	  displayName: 'Chrome (dark)',
	  hidden: true,
	  base00: '#242424',
	  base01: '#2a2a2a',
	  base02: '#363636',
	  base03: '#404040',
	  base04: '#777777',
	  base05: '#a5a5a5',
	  special00: '#5db0d7',
	  special01: '#a1f7b5',
	  special02: '#f29766',
	  special03: '#d2c057',
	  special04: '#34d1c5',
	  special05: '#9a7fd5',
	  special06: '#9bbbdc',
	  special07: '#777777',
	  state00: '#c78626',
	  state01: '#363636',
	  state02: '#242424',
	  state03: '#342e24',
	  state04: '#66ff88',
	  state05: '#242424',
	  state06: '#cccccc'
	};
	
	var ChromeDefault = {
	  displayName: 'Chrome (default)',
	  hidden: true,
	  base00: '#ffffff',
	  base01: '#f3f3f3',
	  base02: '#eeeeee',
	  base03: '#dadada',
	  base04: '#888888',
	  base05: '#5a5a5a',
	  special00: '#881280',
	  special01: '#222222',
	  special02: '#1a1aa6',
	  special03: '#c80000',
	  special04: '#236e25',
	  special05: '#aa0d91',
	  special06: '#994500',
	  special07: '#888888',
	  state00: '#3879d9',
	  state01: '#dadada',
	  state02: '#ffffff',
	  state03: '#ebf1fb',
	  state04: '#FFFF00',
	  state05: '#222222',
	  state06: '#222222'
	};
	
	var Dracula = {
	  displayName: 'Dracula',
	  base00: '#282936',
	  base01: '#3a3c4e',
	  base02: '#4d4f68',
	  base03: '#626483',
	  base04: '#6f7191',
	  base05: '#e9e9f4',
	  special00: '#ff79c6',
	  special01: '#bd93f9',
	  special02: '#f1fa8c',
	  special03: '#a1efe4',
	  special04: '#4afa7b',
	  special05: '#ff79c6',
	  special06: '#f8f8f2',
	  special07: '#6f7191',
	  state00: '#181a21',
	  state01: '#323547',
	  state02: '#f7f7fb',
	  state03: '#323547',
	  state04: '#fafa8c',
	  state05: '#000000',
	  state06: '#ffffff'
	};
	
	var Eighties = {
	  displayName: 'Eighties',
	  base00: '#2d2d2d',
	  base01: '#393939',
	  base02: '#515151',
	  base03: '#747369',
	  base04: '#a09f93',
	  base05: '#d3d0c8',
	  special00: '#f2777a',
	  special01: '#f99157',
	  special02: '#99cc99',
	  special03: '#66cccc',
	  special04: '#4afa7b',
	  special05: '#cc99cc',
	  special06: '#d27b53',
	  special07: '#a09f93',
	  state00: '#f2f0ec',
	  state01: '#3f3e3e',
	  state02: '#2d2d2d',
	  state03: '#3f3e3e',
	  state04: '#4afa7b',
	  state05: '#121212',
	  state06: '#e3e0d8'
	};
	
	var FirefoxDark = {
	  displayName: 'Firefox (dark)',
	  hidden: true,
	  base00: '#393f4c',
	  base01: '#393f4c',
	  base02: '#454d5d',
	  base03: '#454D5D',
	  base04: '#8fa1b2',
	  base05: '#a9bacb',
	  special00: '#00ff7f',
	  special01: '#eb5368',
	  special02: '#e9f4fe',
	  special03: '#bcb8db',
	  special04: '#e9f4fe',
	  special05: '#e9f4fe',
	  special06: '#e9f4fe',
	  special07: '#8fa1b2',
	  state00: '#5675b9',
	  state01: '#475983',
	  state02: '#ffffff',
	  state03: '#475983',
	  state04: '#00ff7f',
	  state05: '#181d20',
	  state06: '#b9cadb'
	};
	
	var FirefoxFirebug = {
	  displayName: 'Firefox (firebug)',
	  hidden: true,
	  base00: '#ffffff',
	  base01: '#f5f5f5',
	  base02: '#dde1e4',
	  base03: '#c1c1c1',
	  base04: '#888888',
	  base05: '#2a2a2a',
	  special00: '#0000ff',
	  special01: '#ff0000',
	  special02: '#ff0000',
	  special03: '#292e33',
	  special04: '#ff0000',
	  special05: '#0000ff',
	  special06: '#000062',
	  special07: '#0000ff',
	  state00: '#3399ff',
	  state01: '#e4f1fa',
	  state02: '#ffffff',
	  state03: '#e6e6e6',
	  state04: '#ffee99',
	  state05: '#000000',
	  state06: '#000000'
	};
	
	var FirefoxLight = {
	  displayName: 'Firefox (light)',
	  hidden: true,
	  base00: '#ffffff',
	  base01: '#fcfcfc',
	  base02: '#dde1e4',
	  base03: '#c1c1c1',
	  base04: '#888888',
	  base05: '#767676',
	  special00: '#2e9dd5',
	  special01: '#676bff',
	  special02: '#5b5fff',
	  special03: '#393f4c',
	  special04: '#ed2655',
	  special05: '#4f88cc',
	  special06: '#393f4c',
	  special07: '#888888',
	  state00: '#4c9ed9',
	  state01: '#e4f1fa',
	  state02: '#f4f7fa',
	  state03: '#e4f1fa',
	  state04: '#FFFF00',
	  state05: '#585959',
	  state06: '#444444'
	};
	
	var Flat = {
	  displayName: 'Flat',
	  base00: '#2C3E50',
	  base01: '#34495E',
	  base02: '#7F8C8D',
	  base03: '#95A5A6',
	  base04: '#BDC3C7',
	  base05: '#e0e0e0',
	  special00: '#E74C3C',
	  special01: '#E67E22',
	  special02: '#2ECC71',
	  special03: '#1ABC9C',
	  special04: '#3498DB',
	  special05: '#b670d2',
	  special06: '#be643c',
	  special07: '#BDC3C7',
	  state00: '#6a8db1',
	  state01: '#364c62',
	  state02: '#2C3E50',
	  state03: '#364c62',
	  state04: '#64fa82',
	  state05: '#2C3E50',
	  state06: '#ffffff'
	};
	
	var GruvboxDark = {
	  displayName: 'Gruvbox (dark)',
	  base00: '#282828',
	  base01: '#3c3836',
	  base02: '#504945',
	  base03: '#928374',
	  base04: '#bdae93',
	  base05: '#ebdbb2',
	  special00: '#83a598',
	  special01: '#d3869b',
	  special02: '#b8bb26',
	  special03: '#689d6a',
	  special04: '#fabd2f',
	  special05: '#fe8019',
	  special06: '#fe8019',
	  special07: '#bdae93',
	  state00: '#504945',
	  state01: '#3c3836',
	  state02: '#fbf1c7',
	  state03: '#3c3836',
	  state04: '#7c6f64',
	  state05: '#fbf1c7',
	  state06: '#fbebc2'
	};
	
	var GruvboxLight = {
	  displayName: 'Gruvbox (light)',
	  base00: '#fbf1c7',
	  base01: '#ebdbb2',
	  base02: '#d5c4a1',
	  base03: '#928374',
	  base04: '#282828',
	  base05: '#3c3836',
	  special00: '#076678',
	  special01: '#8f3f71',
	  special02: '#98971a',
	  special03: '#af3a03',
	  special04: '#458588',
	  special05: '#fe8019',
	  special06: '#b57614',
	  special07: '#282828',
	  state00: '#bdae93',
	  state01: '#d5c4a1',
	  state02: '#282828',
	  state03: '#d5c4a1',
	  state04: '#d5c4a1',
	  state05: '#282828',
	  state06: '#000000'
	};
	
	var Halflife = {
	  displayName: 'Halflife',
	  base00: '#222222',
	  base01: '#f3f3f3',
	  base02: '#888888',
	  base03: '#282828',
	  base04: '#888888',
	  base05: '#aaaaaa',
	  special00: '#fc913a',
	  special01: '#f9d423',
	  special02: '#f9d423',
	  special03: '#cccccc',
	  special04: '#f9d423',
	  special05: '#3b3a32',
	  special06: '#cccccc',
	  special07: '#7d8991',
	  state00: '#f85931',
	  state01: '#dadada',
	  state02: '#ffffff',
	  state03: '#282828',
	  state04: '#ffe792',
	  state05: '#000000',
	  state06: '#222222'
	};
	
	var Materia = {
	  displayName: 'Materia',
	  base00: '#263238',
	  base01: '#2C393F',
	  base02: '#37474F',
	  base03: '#707880',
	  base04: '#C9CCD3',
	  base05: '#CDD3DE',
	  special00: '#EC5F67',
	  special01: '#EA9560',
	  special02: '#8BD649',
	  special03: '#80CBC4',
	  special04: '#89DDFF',
	  special05: '#82AAFF',
	  special06: '#EC5F67',
	  special07: '#C9CCD3',
	  state00: '#0084ff',
	  state01: '#314048',
	  state02: '#263238',
	  state03: '#314048',
	  state04: '#00ff84',
	  state05: '#263238',
	  state06: '#DDE3EE'
	};
	
	var MaterialDark = {
	  displayName: 'Material Dark',
	  base00: '#263239',
	  base01: '#373b41',
	  base02: '#3e4a51',
	  base03: '#445052',
	  base04: '#718184',
	  base05: '#B2CCD6',
	  special00: '#f95479',
	  special01: '#F78C6A',
	  special02: '#C3E88D',
	  special03: '#89DDF3',
	  special04: '#82AAFF',
	  special05: '#C792EA',
	  special06: '#FFCB6B',
	  special07: '#718184',
	  state00: '#4a55b9',
	  state01: '#3e4a50',
	  state02: '#ffffff',
	  state03: '#212b30',
	  state04: '#4a55b9',
	  state05: '#ffffff',
	  state06: '#D2ECF6'
	};
	
	var OceanDark = {
	  displayName: 'Ocean Dark',
	  base00: '#232730',
	  base01: '#2b303c',
	  base02: '#323943',
	  base03: '#414551',
	  base04: '#65727e',
	  base05: '#757984',
	  special00: '#b48bae',
	  special01: '#c0c5ce',
	  special02: '#a3c08a',
	  special03: '#ab7866',
	  special04: '#eccd88',
	  special05: '#d06a77',
	  special06: '#757a85',
	  special07: '#65727e',
	  state00: '#a0a4ae',
	  state01: '#314048',
	  state02: '#263238',
	  state03: '#314048',
	  state04: '#d06a77',
	  state05: '#1c1f27',
	  state06: '#A5A9B4'
	};
	
	var OneDark = {
	  displayName: 'One (dark)',
	  base00: '#282c34',
	  base01: '#21252b',
	  base02: '#568af2',
	  base03: '#3b4048',
	  base04: '#3e454f',
	  base05: '#abb2bf',
	  special00: '#e5c07b',
	  special01: '#abb2bf',
	  special02: '#98c379',
	  special03: '#9da5b4',
	  special04: '#e06c75',
	  special05: '#6b717e',
	  special06: '#d19a66',
	  special07: '#abb2bf',
	  state00: '#4d78cc',
	  state01: '#3e4450',
	  state02: '#ffffff',
	  state03: '#2c323c',
	  state04: '#4d78cc',
	  state05: '#ffffff',
	  state06: '#ffffff'
	};
	
	var OneLight = {
	  displayName: 'One (light)',
	  base00: '#fafafa',
	  base01: '#eaeaeb',
	  base02: '#eeeeee',
	  base03: '#dbdbdc',
	  base04: '#8e8e90',
	  base05: '#3e4048',
	  special00: '#c0831e',
	  special01: '#a42ea2',
	  special02: '#68ab68',
	  special03: '#447bef',
	  special04: '#e2574e',
	  special05: '#424242',
	  special06: '#976715',
	  special07: '#424242',
	  state00: '#447bef',
	  state01: '#f0f0f1',
	  state02: '#ffffff',
	  state03: '#f0f0f1',
	  state04: '#447bef',
	  state05: '#ffffff',
	  state06: '#1c2026'
	};
	
	var Phd = {
	  displayName: 'Phd',
	  base00: '#061229',
	  base01: '#2a3448',
	  base02: '#4d5666',
	  base03: '#717885',
	  base04: '#9a99a3',
	  base05: '#b8bbc2',
	  special00: '#d07346',
	  special01: '#f0a000',
	  special02: '#99bf52',
	  special03: '#72b9bf',
	  special04: '#5299bf',
	  special05: '#9989cc',
	  special06: '#b08060',
	  special07: '#9a99a3',
	  state00: '#4b73bf',
	  state01: '#112243',
	  state02: '#061229',
	  state03: '#112243',
	  state04: '#00c8fa',
	  state05: '#061229',
	  state06: '#d8dbe2'
	};
	
	var SolarizedDark = {
	  displayName: 'Solarized Dark',
	  base00: '#002b36',
	  base01: '#073642',
	  base02: '#586e75',
	  base03: '#657b83',
	  base04: '#93a1a1',
	  base05: '#839496',
	  special00: '#268bd2',
	  special01: '#268bd2',
	  special02: '#2aa198',
	  special03: '#839496',
	  special04: '#2aa198',
	  special05: '#b58900',
	  special06: '#859900',
	  special07: '#268bd2',
	  state00: '#073642',
	  state01: '#002b36',
	  state02: '#93a1a1',
	  state03: '#073642',
	  state04: '#859900',
	  state05: '#002b36',
	  state06: '#fdf6e3'
	};
	
	var SolarizedLight = {
	  'displayName': 'Solarized Light',
	  'base00': '#fdf6e3',
	  'base01': '#eee8d5',
	  'base02': '#586e75',
	  'base03': '#657b83',
	  'base04': '#93a1a1',
	  'base05': '#657b83',
	  'special00': '#268bd2',
	  'special01': '#268bd2',
	  'special02': '#2aa198',
	  'special03': '#839496',
	  'special04': '#2aa198',
	  'special05': '#b58900',
	  'special06': '#859900',
	  'special07': '#268bd2',
	  'state00': '#eee8d5',
	  'state01': '#eee8d5',
	  'state02': '#586e75',
	  'state03': '#eee8d5',
	  'state04': '#859900',
	  'state05': '#eee8d5',
	  'state06': '#073642'
	};
	
	var Tomorrow = {
	  displayName: 'Tomorrow',
	  base00: '#ffffff',
	  base01: '#e0e0e0',
	  base02: '#d6d6d6',
	  base03: '#8e908c',
	  base04: '#969896',
	  base05: '#4d4d4c',
	  special00: '#c82829',
	  special01: '#f5871f',
	  special02: '#718c00',
	  special03: '#3e999f',
	  special04: '#4271ae',
	  special05: '#8959a8',
	  special06: '#a3685a',
	  special07: '#969896',
	  state00: '#4271ae',
	  state01: '#e0e0e0',
	  state02: '#ffffff',
	  state03: '#e0e0e0',
	  state04: '#eab700',
	  state05: '#1d1f21',
	  state06: '#222222'
	};
	
	var TomorrowNight = {
	  displayName: 'Tomorrow Night',
	  base00: '#1d1f21',
	  base01: '#282a2e',
	  base02: '#373b41',
	  base03: '#969896',
	  base04: '#b4b7b4',
	  base05: '#c5c8c6',
	  special00: '#cc6666',
	  special01: '#de935f',
	  special02: '#b5bd68',
	  special03: '#8abeb7',
	  special04: '#81a2be',
	  special05: '#b294bb',
	  special06: '#a3685a',
	  special07: '#b4b7b4',
	  state00: '#0084ff',
	  state01: '#e0e0e0',
	  state02: '#282a2e',
	  state03: '#373b41',
	  state04: '#f0c674',
	  state05: '#1d1f21',
	  state06: '#e5e8e6'
	};
	
	module.exports = {
	  ApathyDark: ApathyDark,
	  ApathyLight: ApathyLight,
	  AtomDark: AtomDark,
	  AtomLight: AtomLight,
	  ChromeDark: ChromeDark,
	  ChromeDefault: ChromeDefault,
	  Dracula: Dracula,
	  Eighties: Eighties,
	  FirefoxDark: FirefoxDark,
	  FirefoxFirebug: FirefoxFirebug,
	  FirefoxLight: FirefoxLight,
	  Flat: Flat,
	  GruvboxDark: GruvboxDark,
	  GruvboxLight: GruvboxLight,
	  Halflife: Halflife,
	  Materia: Materia,
	  MaterialDark: MaterialDark,
	  OceanDark: OceanDark,
	  OneDark: OneDark,
	  OneLight: OneLight,
	  Phd: Phd,
	  SolarizedDark: SolarizedDark,
	  SolarizedLight: SolarizedLight,
	  Tomorrow: Tomorrow,
	  TomorrowNight: TomorrowNight
	};

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(11);
	
	var TimerSafe = function TimerSafe(Component) {
	  var TimerSafeImplementation = function (_React$Component) {
	    _inherits(TimerSafeImplementation, _React$Component);
	
	    function TimerSafeImplementation() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TimerSafeImplementation);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimerSafeImplementation.__proto__ || Object.getPrototypeOf(TimerSafeImplementation)).call.apply(_ref, [this].concat(args))), _this), _this._timeoutIds = {}, _this._clearTimeout = function (id) {
	        clearTimeout(id);
	
	        delete _this._timeoutIds[id];
	      }, _this._setTimeout = function (callback, delay) {
	        var id = setTimeout(function () {
	          delete _this._timeoutIds[id];
	
	          callback();
	        }, delay);
	
	        _this._timeoutIds[id] = true;
	
	        return id;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TimerSafeImplementation, [{
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        Object.keys(this._timeoutIds).forEach(this._clearTimeout);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return React.createElement(Component, _extends({}, this.props, {
	          clearTimeout: this._clearTimeout,
	          setTimeout: this._setTimeout
	        }));
	      }
	    }]);
	
	    return TimerSafeImplementation;
	  }(React.Component);
	
	  return TimerSafeImplementation;
	};
	
	module.exports = TimerSafe;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _require = __webpack_require__(316),
	    ChromeDefault = _require.ChromeDefault;
	
	var themeKeys = Object.keys(ChromeDefault);
	
	function deserialize(string) {
	  var fallbackTheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ChromeDefault;
	
	  var theme = {};
	
	  try {
	    (function () {
	      var maybeTheme = JSON.parse(string);
	
	      // Make sure serialized theme has no extra keys.
	      themeKeys.forEach(function (key) {
	        var maybeColor = maybeTheme[key];
	        if (isColorSet(maybeColor)) {
	          theme[key] = maybeColor;
	        }
	      });
	    })();
	  } catch (error) {
	    console.error('Could not deserialize theme', error);
	  }
	
	  // Update outdated custom theme formats and set reasonable defaults.
	  if (!isColorSet(theme.state06)) {
	    // Added in version > 2.3.0
	    theme.state06 = theme.base05;
	  }
	
	  // Make sure serialized theme has all of the required color values.
	  themeKeys.forEach(function (key) {
	    var maybeColor = theme[key];
	    if (!isColorSet(maybeColor)) {
	      theme[key] = fallbackTheme[key];
	    }
	  });
	
	  return theme;
	}
	
	function isColorSet(maybeColor) {
	  return typeof maybeColor === 'string' && maybeColor !== '';
	}
	
	function serialize(theme) {
	  return JSON.stringify(theme, null, 0);
	}
	
	module.exports = {
	  deserialize: deserialize,
	  serialize: serialize
	};

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var decorate = __webpack_require__(20);
	var SettingsCheckbox = __webpack_require__(320);
	
	var Wrapped = decorate({
	  listeners: function listeners() {
	    return ['traceupdatesstatechange'];
	  },
	  props: function props(store) {
	    return {
	      state: store.traceupdatesState,
	      text: 'Highlight Updates',
	      onChange: function onChange(state) {
	        return store.changeTraceUpdates(state);
	      }
	    };
	  }
	}, SettingsCheckbox);
	
	module.exports = Wrapped;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(11);
	var immutable = __webpack_require__(315);
	
	var _require = __webpack_require__(17),
	    sansSerif = _require.sansSerif;
	
	var StateRecord = immutable.Record({
	  enabled: false
	});
	
	var SettingsCheckbox = function (_React$Component) {
	  _inherits(SettingsCheckbox, _React$Component);
	
	  function SettingsCheckbox(props) {
	    _classCallCheck(this, SettingsCheckbox);
	
	    var _this = _possibleConstructorReturn(this, (SettingsCheckbox.__proto__ || Object.getPrototypeOf(SettingsCheckbox)).call(this, props));
	
	    _this._toggle = _this._toggle.bind(_this);
	    _this._defaultState = new StateRecord();
	    return _this;
	  }
	
	  _createClass(SettingsCheckbox, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.state !== this._defaultState) {
	        this.props.onChange(this._defaultState);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var state = this.props.state || this._defaultState;
	      return React.createElement(
	        'div',
	        { style: styles.container, onClick: this._toggle, tabIndex: 0 },
	        React.createElement('input', {
	          style: styles.checkbox,
	          type: 'checkbox',
	          checked: state.enabled,
	          readOnly: true
	        }),
	        React.createElement(
	          'span',
	          null,
	          this.props.text
	        )
	      );
	    }
	  }, {
	    key: '_toggle',
	    value: function _toggle() {
	      var state = this.props.state || this._defaultState;
	      var nextState = state.merge({
	        enabled: !state.enabled
	      });
	
	      this.props.onChange(nextState);
	    }
	  }]);
	
	  return SettingsCheckbox;
	}(React.Component);
	
	var styles = {
	  checkbox: {
	    pointerEvents: 'none',
	    marginRight: '5px'
	  },
	  container: {
	    WebkitUserSelect: 'none',
	    cursor: 'default',
	    display: 'inline-block',
	    outline: 'none',
	    fontFamily: sansSerif.family,
	    userSelect: 'none',
	    marginRight: '10px'
	  }
	};
	
	module.exports = SettingsCheckbox;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var decorate = __webpack_require__(20);
	var SettingsCheckbox = __webpack_require__(320);
	
	var Wrapped = decorate({
	  listeners: function listeners() {
	    return ['colorizerchange'];
	  },
	  props: function props(store) {
	    return {
	      state: store.colorizerState,
	      text: 'Highlight Search',
	      onChange: function onChange(state) {
	        return store.changeColorizer(state);
	      }
	    };
	  }
	}, SettingsCheckbox);
	
	module.exports = Wrapped;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(26);
	var Draggable = __webpack_require__(323);
	var nullthrows = __webpack_require__(16).default;
	
	var SplitPane = function (_React$Component) {
	  _inherits(SplitPane, _React$Component);
	
	  function SplitPane(props) {
	    _classCallCheck(this, SplitPane);
	
	    var _this = _possibleConstructorReturn(this, (SplitPane.__proto__ || Object.getPrototypeOf(SplitPane)).call(this, props));
	
	    _this.state = {
	      moving: false,
	      width: props.initialWidth,
	      height: props.initialHeight
	    };
	    return _this;
	  }
	
	  _createClass(SplitPane, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // $FlowFixMe use a ref on the root
	      var node = nullthrows(ReactDOM.findDOMNode(this));
	
	      var width = Math.floor(node.offsetWidth * (this.props.isVertical ? 0.6 : 0.3));
	
	      this.setState({
	        width: Math.min(250, width),
	        height: Math.floor(node.offsetHeight * 0.3)
	      });
	    }
	  }, {
	    key: 'onMove',
	    value: function onMove(x, y) {
	      var _this2 = this;
	
	      // $FlowFixMe use a ref on the root
	      var rect = ReactDOM.findDOMNode(this).getBoundingClientRect();
	
	      this.setState(function (prevState) {
	        return {
	          width: _this2.props.isVertical ? prevState.width : Math.floor(rect.left + rect.width - x),
	          height: !_this2.props.isVertical ? prevState.height : Math.floor(rect.top + rect.height - y)
	        };
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var theme = this.context.theme;
	      var isVertical = this.props.isVertical;
	      var _state = this.state,
	          height = _state.height,
	          width = _state.width;
	
	
	      return React.createElement(
	        'div',
	        { style: containerStyle(isVertical) },
	        React.createElement(
	          'div',
	          { style: styles.leftPane },
	          this.props.left()
	        ),
	        React.createElement(
	          'div',
	          { style: rightStyle(isVertical, width, height) },
	          React.createElement(
	            Draggable,
	            {
	              style: draggerStyle(isVertical),
	              onStart: function onStart() {
	                return _this3.setState({ moving: true });
	              },
	              onMove: function onMove(x, y) {
	                return _this3.onMove(x, y);
	              },
	              onStop: function onStop() {
	                return _this3.setState({ moving: false });
	              } },
	            React.createElement('div', { style: draggerInnerStyle(isVertical, theme) })
	          ),
	          React.createElement(
	            'div',
	            { style: styles.rightPane },
	            this.props.right()
	          )
	        )
	      );
	    }
	  }]);
	
	  return SplitPane;
	}(React.Component);
	
	SplitPane.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	var containerStyle = function containerStyle(isVertical) {
	  return {
	    display: 'flex',
	    minWidth: 0,
	    flex: 1,
	    flexDirection: isVertical ? 'column' : 'row',
	    maxWidth: '100vw'
	  };
	};
	
	var draggerInnerStyle = function draggerInnerStyle(isVertical, theme) {
	  return {
	    height: isVertical ? '1px' : '100%',
	    width: isVertical ? '100%' : '1px',
	    backgroundColor: theme.base04
	  };
	};
	
	var draggerStyle = function draggerStyle(isVertical) {
	  return {
	    position: 'relative',
	    zIndex: 1,
	    padding: isVertical ? '0.25rem 0' : '0 0.25rem',
	    margin: isVertical ? '-0.25rem 0' : '0 -0.25rem',
	    cursor: isVertical ? 'ns-resize' : 'ew-resize'
	  };
	};
	
	var rightStyle = function rightStyle(isVertical, width, height) {
	  return _extends({}, containerStyle(isVertical), {
	    width: isVertical ? null : width,
	    height: isVertical ? height : null,
	    flex: 'initial',
	    minHeight: 120,
	    minWidth: 150
	  });
	};
	
	var styles = {
	  rightPane: {
	    display: 'flex',
	    width: '100%',
	    overflow: 'auto'
	  },
	  leftPane: {
	    display: 'flex',
	    minWidth: '50%',
	    minHeight: '50%',
	    flex: 1,
	    overflow: 'hidden'
	  }
	};
	
	module.exports = SplitPane;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(26);
	
	var Draggable = function (_React$Component) {
	  _inherits(Draggable, _React$Component);
	
	  function Draggable() {
	    _classCallCheck(this, Draggable);
	
	    return _possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).apply(this, arguments));
	  }
	
	  _createClass(Draggable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._onMove = this.onMove.bind(this);
	      this._onUp = this.onUp.bind(this);
	    }
	  }, {
	    key: '_startDragging',
	    value: function _startDragging(evt) {
	      evt.preventDefault();
	      // $FlowFixMe use root ref
	      var doc = ReactDOM.findDOMNode(this).ownerDocument;
	      // $FlowFixMe
	      doc.addEventListener('mousemove', this._onMove);
	      // $FlowFixMe
	      doc.addEventListener('mouseup', this._onUp);
	      this.props.onStart();
	    }
	  }, {
	    key: 'onMove',
	    value: function onMove(evt) {
	      evt.preventDefault();
	      this.props.onMove(evt.pageX, evt.pageY);
	    }
	  }, {
	    key: 'onUp',
	    value: function onUp(evt) {
	      evt.preventDefault();
	      // $FlowFixMe use root ref
	      var doc = ReactDOM.findDOMNode(this).ownerDocument;
	      // $FlowFixMe
	      doc.removeEventListener('mousemove', this._onMove);
	      // $FlowFixMe
	      doc.removeEventListener('mouseup', this._onUp);
	      this.props.onStop();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return React.createElement(
	        'div',
	        {
	          style: this.props.style,
	          onMouseDown: this._startDragging.bind(this)
	        },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Draggable;
	}(React.Component);
	
	module.exports = Draggable;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	var decorate = __webpack_require__(20);
	
	var _require = __webpack_require__(17),
	    sansSerif = _require.sansSerif;
	
	var TabbedPane = function (_React$Component) {
	  _inherits(TabbedPane, _React$Component);
	
	  function TabbedPane() {
	    _classCallCheck(this, TabbedPane);
	
	    return _possibleConstructorReturn(this, (TabbedPane.__proto__ || Object.getPrototypeOf(TabbedPane)).apply(this, arguments));
	  }
	
	  _createClass(TabbedPane, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var theme = this.context.theme;
	
	      var tabs = Object.keys(this.props.tabs);
	      if (tabs.length === 1) {
	        return this.props.tabs[tabs[0]]();
	      }
	      return React.createElement(
	        'div',
	        { style: styles.container },
	        React.createElement(
	          'ul',
	          { style: tabsStyle(theme) },
	          tabs.map(function (name, i) {
	            return React.createElement(
	              'li',
	              {
	                key: name + i,
	                onClick: function onClick() {
	                  return _this2.props.setSelectedTab(name);
	                },
	                style: tabStyle(name === _this2.props.selected, theme)
	              },
	              name
	            );
	          })
	        ),
	        React.createElement(
	          'div',
	          { style: styles.body },
	          this.props.tabs[this.props.selected]()
	        )
	      );
	    }
	  }]);
	
	  return TabbedPane;
	}(React.Component);
	
	TabbedPane.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	var tabsStyle = function tabsStyle(theme) {
	  return {
	    display: 'flex',
	    flexShrink: 0,
	    listStyle: 'none',
	    margin: 0,
	    backgroundColor: theme.base01,
	    borderBottom: '1px solid ' + theme.base03,
	    padding: '0 0.25rem'
	  };
	};
	
	var tabStyle = function tabStyle(isSelected, theme) {
	  return {
	    padding: '0.25rem 0.75rem',
	    lineHeight: '15px',
	    fontSize: sansSerif.sizes.normal,
	    fontFamily: sansSerif.family,
	    cursor: 'pointer',
	    borderTop: '1px solid transparent',
	    borderBottom: isSelected ? '2px solid ' + theme.state00 : 'none',
	    marginBottom: isSelected ? '-1px' : '1px'
	  };
	};
	
	var styles = {
	  container: {
	    flex: 1,
	    display: 'flex',
	    flexDirection: 'column',
	    width: '100%'
	  },
	  body: {
	    flex: 1,
	    display: 'flex',
	    minHeight: 0
	  }
	};
	
	module.exports = decorate({
	  listeners: function listeners() {
	    return ['selectedTab'];
	  },
	  shouldUpdate: function shouldUpdate(props, prevProps) {
	    for (var name in props) {
	      if (props[name] !== prevProps[name]) {
	        return true;
	      }
	    }
	    return false;
	  },
	  props: function props(store) {
	    return {
	      selected: store.selectedTab,
	      setSelectedTab: function setSelectedTab(name) {
	        return store.setSelectedTab(name);
	      }
	    };
	  }
	}, TabbedPane);

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(326),
	    EventEmitter = _require.EventEmitter;
	
	var _require2 = __webpack_require__(315),
	    Map = _require2.Map,
	    Set = _require2.Set,
	    List = _require2.List;
	
	var assign = __webpack_require__(19);
	
	var _require3 = __webpack_require__(70),
	    copy = _require3.copy;
	
	var nodeMatchesText = __webpack_require__(327);
	var consts = __webpack_require__(32);
	var serializePropsForCopy = __webpack_require__(328);
	var invariant = __webpack_require__(56);
	var SearchUtils = __webpack_require__(59);
	var ThemeStore = __webpack_require__(329);
	
	/**
	 * This is the main frontend [fluxy?] Store, responsible for taking care of
	 * state. It emits events when things change that you can subscribe to. The
	 * best way to interact with the Store (if you are a React Component) is to
	 * use the decorator in `decorate.js`. The top-level component (defined
	 * by a shell) is generally responsible for creating the Store connecting it
	 * up to a bridge, and putting it on `context` so the decorator can access it.
	 *
	 * Public events:
	 *
	 * - connected / connection failed
	 * - roots
	 * - searchText
	 * - searchRoots
	 * - contextMenu
	 * - hover
	 * - selected
	 * - [node id]
	 *
	 * Public state:
	 *  see attrs / constructor
	 *
	 * Public actions:
	 * - scrollToNode(id)
	 * - changeTextContent(id, text)
	 * - changeSearch
	 * - hoverClass
	 * - selectFirstOfClass
	 * - showContextMenu
	 * - hideContextMenu
	 * - selectFirstSearchResult
	 * - toggleCollapse
	 * - toggleAllChildrenNodes
	 * - setProps/State/Context
	 * - makeGlobal(id, path)
	 * - setHover(id, isHovered, isBottomTag)
	 * - selectTop(id)
	 * - selectBottom(id)
	 * - select(id)
	 *
	 * Public methods:
	 * - get(id) => Map (the node)
	 * - getParent(id) => pid
	 * - skipWrapper(id, up?) => id
	 * - hasBottom(id) => bool
	 * - on / off
	 * - inspect(id, path, cb)
	 */
	var Store = function (_EventEmitter) {
	  _inherits(Store, _EventEmitter);
	
	  // Public state
	  function Store(bridge, themeStore) {
	    _classCallCheck(this, Store);
	
	    var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this));
	
	    _this.snapshotQueue = [];
	
	
	    _this._nodes = new Map();
	    _this._parents = new Map();
	    _this._nodesByName = new Map();
	    _this._bridge = bridge;
	
	    // Public state
	    _this.isInspectEnabled = false;
	    _this.roots = new List();
	    _this.contextMenu = null;
	    _this.searchRoots = null;
	    _this.hovered = null;
	    _this.selected = null;
	    _this.selectedTab = 'Elements';
	    _this.breadcrumbHead = null;
	    _this.isBottomTagHovered = false;
	    _this.isBottomTagSelected = false;
	    _this.searchText = '';
	    _this.capabilities = {};
	    _this.traceupdatesState = null;
	    _this.colorizerState = null;
	    _this.refreshSearch = false;
	    _this.themeStore = themeStore;
	
	    // for debugging
	    window.store = _this;
	
	    // events from the backend
	    _this._bridge.on('root', function (id) {
	      if (_this.roots.contains(id)) {
	        return;
	      }
	      _this.roots = _this.roots.push(id);
	      if (!_this.selected) {
	        _this.selected = _this.skipWrapper(id);
	        _this.breadcrumbHead = _this.selected;
	        _this.emit('selected');
	        _this.emit('breadcrumbHead');
	        _this._bridge.send('selected', _this.selected);
	      }
	      _this.emit('roots');
	    });
	    _this._bridge.on('mount', function (data) {
	      return _this._mountComponent(data);
	    });
	    _this._bridge.on('update', function (data) {
	      return _this._updateComponent(data);
	    });
	    _this._bridge.on('updateProfileTimes', function (data) {
	      return _this._updateComponentProfileTimes(data);
	    });
	    _this._bridge.on('unmount', function (id) {
	      return _this._unmountComponent(id);
	    });
	    _this._bridge.on('setInspectEnabled', function (data) {
	      return _this.setInspectEnabled(data);
	    });
	    _this._bridge.on('select', function (_ref) {
	      var id = _ref.id,
	          quiet = _ref.quiet,
	          _ref$offsetFromLeaf = _ref.offsetFromLeaf,
	          offsetFromLeaf = _ref$offsetFromLeaf === undefined ? 0 : _ref$offsetFromLeaf;
	
	      // Backtrack if we want to skip leaf nodes
	      while (offsetFromLeaf > 0) {
	        offsetFromLeaf--;
	        var pid = _this._parents.get(id);
	        if (pid) {
	          id = pid;
	        } else {
	          break;
	        }
	      }
	      _this._revealDeep(id);
	      _this.selectTop(_this.skipWrapper(id), quiet);
	      _this.setSelectedTab('Elements');
	    });
	    _this._bridge.on('storeSnapshot', function (storeSnapshot) {
	      // Store snapshot data for ProfilerStore to process later.
	      // It's important to store it as a queue, because events may be batched.
	      _this.snapshotQueue.push(_extends({}, storeSnapshot, {
	        nodes: _this._nodes
	      }));
	      _this.emit('storeSnapshot');
	    });
	    _this._bridge.on('clearSnapshots', function () {
	      _this.snapshotQueue.length = 0;
	      _this.emit('clearSnapshots');
	    });
	
	    _this._establishConnection();
	    _this._eventQueue = [];
	    _this._eventTimer = null;
	    return _this;
	  }
	  // an object describing the capabilities of the inspected runtime.
	
	  // eslint shouldn't error on type positions. TODO: update eslint
	  // eslint-disable-next-line no-undef
	
	
	  _createClass(Store, [{
	    key: 'emit',
	    value: function emit(event) {
	      var _this2 = this;
	
	      if (this._eventQueue.indexOf(event) !== -1) {
	        // to appease flow
	        return true;
	      }
	      this._eventQueue.push(event);
	      if (!this._eventTimer) {
	        this._eventTimer = setTimeout(function () {
	          return _this2.flush();
	        }, 50);
	      }
	      return true;
	    }
	  }, {
	    key: 'flush',
	    value: function flush() {
	      var _this3 = this;
	
	      if (this._eventTimer) {
	        clearTimeout(this._eventTimer);
	        this._eventTimer = null;
	      }
	      this._eventQueue.forEach(function (evt) {
	        EventEmitter.prototype.emit.call(_this3, evt);
	      });
	      this._eventQueue = [];
	    }
	
	    // Public actions
	
	  }, {
	    key: 'scrollToNode',
	    value: function scrollToNode(id) {
	      this._bridge.send('scrollToNode', id);
	    }
	  }, {
	    key: 'copyNodeName',
	    value: function copyNodeName(name) {
	      copy(name);
	    }
	  }, {
	    key: 'copyNodeProps',
	    value: function copyNodeProps(props) {
	      copy(serializePropsForCopy(props));
	    }
	  }, {
	    key: 'setSelectedTab',
	    value: function setSelectedTab(name) {
	      if (this.selectedTab === name) {
	        return;
	      }
	      this.selectedTab = name;
	      this.emit('selectedTab');
	    }
	
	    // TODO(jared): get this working for react native
	
	  }, {
	    key: 'changeTextContent',
	    value: function changeTextContent(id, text) {
	      this._bridge.send('changeTextContent', { id: id, text: text });
	      var node = this._nodes.get(id);
	      if (node.get('nodeType') === 'Text') {
	        this._nodes = this._nodes.set(id, node.set('text', text));
	      } else {
	        this._nodes = this._nodes.set(id, node.set('children', text));
	        var props = node.get('props');
	        props.children = text;
	      }
	      this.emit(id);
	    }
	  }, {
	    key: 'changeSearch',
	    value: function changeSearch(text) {
	      var _this4 = this;
	
	      var needle = text.toLowerCase();
	      if (needle === this.searchText.toLowerCase() && !this.refreshSearch) {
	        return;
	      }
	      if (!text || SearchUtils.trimSearchText(text).length === 0) {
	        this.searchRoots = null;
	      } else {
	        if (this.searchRoots && needle.indexOf(this.searchText.toLowerCase()) === 0 && !SearchUtils.shouldSearchUseRegex(text)) {
	          this.searchRoots = this.searchRoots.filter(function (item) {
	            var node = _this4.get(item);
	            return node.get('name') && node.get('name').toLowerCase().indexOf(needle) !== -1 || node.get('text') && node.get('text').toLowerCase().indexOf(needle) !== -1 || typeof node.get('children') === 'string' && node.get('children').toLowerCase().indexOf(needle) !== -1;
	          });
	        } else {
	          this.searchRoots = this._nodes.entrySeq().filter(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 2),
	                key = _ref3[0],
	                val = _ref3[1];
	
	            return nodeMatchesText(val, needle, key, _this4);
	          }).map(function (_ref4) {
	            var _ref5 = _slicedToArray(_ref4, 2),
	                key = _ref5[0],
	                val = _ref5[1];
	
	            return key;
	          }).toList();
	        }
	        this.searchRoots.forEach(function (id) {
	          if (_this4.hasBottom(id)) {
	            _this4._nodes = _this4._nodes.setIn([id, 'collapsed'], true);
	          }
	        });
	      }
	      this.searchText = text;
	      this.emit('searchText');
	      this.emit('searchRoots');
	      if (this.searchRoots && !this.searchRoots.contains(this.selected)) {
	        this.select(null, true);
	      } else if (!this.searchRoots) {
	        if (this.selected) {
	          this._revealDeep(this.selected);
	        } else {
	          this.select(this.roots.get(0));
	        }
	      }
	
	      this.highlightSearch();
	      this.refreshSearch = false;
	
	      // Search input depends on this change being flushed synchronously.
	      this.flush();
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(id) {
	      // Individual highlighting is disabled while colorizer is active
	      if (!this.colorizerState || !this.colorizerState.enabled) {
	        this._bridge.send('highlight', id);
	      }
	    }
	  }, {
	    key: 'highlightMany',
	    value: function highlightMany(ids) {
	      this._bridge.send('highlightMany', ids);
	    }
	  }, {
	    key: 'highlightSearch',
	    value: function highlightSearch() {
	      if (this.colorizerState && this.colorizerState.enabled) {
	        this._bridge.send('hideHighlight');
	        if (this.searchRoots) {
	          this.highlightMany(this.searchRoots.toArray());
	        }
	      }
	    }
	  }, {
	    key: 'hoverClass',
	    value: function hoverClass(name) {
	      if (name === null) {
	        this.hideHighlight();
	        return;
	      }
	      var ids = this._nodesByName.get(name);
	      if (!ids) {
	        return;
	      }
	      this.highlightMany(ids.toArray());
	    }
	  }, {
	    key: 'selectFirstOfClass',
	    value: function selectFirstOfClass(name) {
	      var ids = this._nodesByName.get(name);
	      if (!ids || !ids.size) {
	        return;
	      }
	      var id = ids.toSeq().first();
	      this._revealDeep(id);
	      this.selectTop(id);
	    }
	  }, {
	    key: 'showContextMenu',
	    value: function showContextMenu(type, evt) {
	      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        args[_key - 2] = arguments[_key];
	      }
	
	      evt.preventDefault();
	      this.contextMenu = { type: type, x: evt.pageX, y: evt.pageY, args: args };
	      this.emit('contextMenu');
	    }
	  }, {
	    key: 'hideContextMenu',
	    value: function hideContextMenu() {
	      this.contextMenu = null;
	      this.emit('contextMenu');
	    }
	  }, {
	    key: 'changeTheme',
	    value: function changeTheme(themeName) {
	      this.themeStore.update(themeName);
	      this.emit('theme');
	    }
	  }, {
	    key: 'changeDefaultTheme',
	    value: function changeDefaultTheme(defaultThemeName) {
	      this.themeStore.setDefaultTheme(defaultThemeName);
	      this.emit('theme');
	    }
	  }, {
	    key: 'saveCustomTheme',
	    value: function saveCustomTheme(theme) {
	      this.themeStore.saveCustomTheme(theme);
	      this.emit('theme');
	    }
	  }, {
	    key: 'showPreferencesPanel',
	    value: function showPreferencesPanel() {
	      this.preferencesPanelShown = true;
	      this.emit('preferencesPanelShown');
	    }
	  }, {
	    key: 'hidePreferencesPanel',
	    value: function hidePreferencesPanel() {
	      this.preferencesPanelShown = false;
	      this.emit('preferencesPanelShown');
	    }
	  }, {
	    key: 'selectFirstSearchResult',
	    value: function selectFirstSearchResult() {
	      if (this.searchRoots) {
	        this.select(this.searchRoots.get(0), true);
	      }
	    }
	  }, {
	    key: 'hasBottom',
	    value: function hasBottom(id) {
	      var node = this.get(id);
	      var children = node.get('children');
	      if (node.get('nodeType') === 'NativeWrapper') {
	        children = this.get(children[0]).get('children');
	      }
	      if (typeof children === 'string' || !children || !children.length || node.get('collapsed')) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'toggleCollapse',
	    value: function toggleCollapse(id) {
	      this._nodes = this._nodes.updateIn([id, 'collapsed'], function (c) {
	        return !c;
	      });
	      this.emit(id);
	    }
	  }, {
	    key: 'toggleAllChildrenNodes',
	    value: function toggleAllChildrenNodes(value) {
	      var id = this.selected;
	      if (!id) {
	        return;
	      }
	      this._toggleDeepChildren(id, value);
	    }
	  }, {
	    key: 'setProps',
	    value: function setProps(id, path, value) {
	      this._bridge.send('setProps', { id: id, path: path, value: value });
	    }
	  }, {
	    key: 'setState',
	    value: function setState(id, path, value) {
	      this._bridge.send('setState', { id: id, path: path, value: value });
	    }
	  }, {
	    key: 'setContext',
	    value: function setContext(id, path, value) {
	      this._bridge.send('setContext', { id: id, path: path, value: value });
	    }
	  }, {
	    key: 'makeGlobal',
	    value: function makeGlobal(id, path) {
	      this._bridge.send('makeGlobal', { id: id, path: path });
	    }
	  }, {
	    key: 'setHover',
	    value: function setHover(id, isHovered, isBottomTag) {
	      if (isHovered) {
	        var old = this.hovered;
	        this.hovered = id;
	        this.isBottomTagHovered = isBottomTag;
	        if (old) {
	          this.emit(old);
	        }
	        this.emit(id);
	        this.emit('hover');
	        this.highlight(id);
	      } else if (this.hovered === id) {
	        this.hideHighlight();
	        this.isBottomTagHovered = false;
	      }
	    }
	  }, {
	    key: 'hideHighlight',
	    value: function hideHighlight() {
	      if (this.colorizerState && this.colorizerState.enabled) {
	        return;
	      }
	      this._bridge.send('hideHighlight');
	      if (!this.hovered) {
	        return;
	      }
	      var id = this.hovered;
	      this.hovered = null;
	      this.emit(id);
	      this.emit('hover');
	    }
	  }, {
	    key: 'selectBreadcrumb',
	    value: function selectBreadcrumb(id) {
	      this._revealDeep(id);
	      this.changeSearch('');
	      this.isBottomTagSelected = false;
	      this.select(id, false, true);
	    }
	  }, {
	    key: 'selectTop',
	    value: function selectTop(id, noHighlight) {
	      this.isBottomTagSelected = false;
	      this.select(id, noHighlight);
	    }
	  }, {
	    key: 'selectBottom',
	    value: function selectBottom(id) {
	      this.isBottomTagSelected = true;
	      this.select(id);
	    }
	  }, {
	    key: 'select',
	    value: function select(id, noHighlight, keepBreadcrumb) {
	      var oldSel = this.selected;
	      this.selected = id;
	      if (oldSel) {
	        this.emit(oldSel);
	      }
	      if (id) {
	        this.emit(id);
	      }
	      if (!keepBreadcrumb) {
	        this.breadcrumbHead = id;
	        this.emit('breadcrumbHead');
	      }
	      this.emit('selected');
	      this._bridge.send('selected', id);
	      if (!noHighlight && id) {
	        this.highlight(id);
	      }
	    }
	
	    // Public methods
	
	  }, {
	    key: 'get',
	    value: function get(id) {
	      return this._nodes.get(id);
	    }
	  }, {
	    key: 'getParent',
	    value: function getParent(id) {
	      return this._parents.get(id);
	    }
	  }, {
	    key: 'skipWrapper',
	    value: function skipWrapper(id, up, end) {
	      if (!id) {
	        return undefined;
	      }
	      while (true) {
	        var node = this.get(id);
	        var nodeType = node.get('nodeType');
	
	        if (nodeType !== 'Wrapper' && nodeType !== 'Native') {
	          return id;
	        }
	        if (nodeType === 'Native' && (!up || this.get(this._parents.get(id)).get('nodeType') !== 'NativeWrapper')) {
	          return id;
	        }
	        if (up) {
	          var parentId = this._parents.get(id);
	          if (!parentId) {
	            // Don't show the Stack root wrapper in breadcrumbs
	            return undefined;
	          }
	          id = parentId;
	        } else {
	          var children = node.get('children');
	          if (children.length === 0) {
	            return undefined;
	          }
	          var index = end ? children.length - 1 : 0;
	          var childId = children[index];
	          id = childId;
	        }
	      }
	    }
	  }, {
	    key: 'off',
	    value: function off(evt, fn) {
	      this.removeListener(evt, fn);
	    }
	  }, {
	    key: 'inspect',
	    value: function inspect(id, path, cb) {
	      var _this5 = this;
	
	      invariant(path[0] === 'props' || path[0] === 'state' || path[0] === 'context', 'Inspected path must be one of props, state, or context');
	      this._bridge.inspect(id, path, function (value) {
	        var base = _this5.get(id).get(path[0]);
	        // $FlowFixMe
	        var inspected = path.slice(1).reduce(function (obj, attr) {
	          return obj ? obj[attr] : null;
	        }, base);
	        if (inspected) {
	          assign(inspected, value);
	          inspected[consts.inspected] = true;
	        }
	        cb();
	      });
	    }
	  }, {
	    key: 'changeTraceUpdates',
	    value: function changeTraceUpdates(state) {
	      this.traceupdatesState = state;
	      this.emit('traceupdatesstatechange');
	      invariant(state.toJS, 'state.toJS should exist');
	      this._bridge.send('traceupdatesstatechange', state.toJS());
	    }
	  }, {
	    key: 'changeColorizer',
	    value: function changeColorizer(state) {
	      this.colorizerState = state;
	      this.emit('colorizerchange');
	      this._bridge.send('colorizerchange', state.toJS());
	      if (this.colorizerState && this.colorizerState.enabled) {
	        this.highlightSearch();
	      } else {
	        this.hideHighlight();
	      }
	    }
	  }, {
	    key: 'setInspectEnabled',
	    value: function setInspectEnabled(isInspectEnabled) {
	      this.isInspectEnabled = isInspectEnabled;
	      this.emit('isInspectEnabled');
	      this._bridge.send('setInspectEnabled', isInspectEnabled);
	    }
	  }, {
	    key: 'setIsRecording',
	    value: function setIsRecording(isRecording) {
	      this._bridge.send('isRecording', isRecording);
	    }
	
	    // Private stuff
	
	  }, {
	    key: '_establishConnection',
	    value: function _establishConnection() {
	      var _this6 = this;
	
	      var tries = 0;
	      var requestInt;
	      this._bridge.once('capabilities', function (capabilities) {
	        clearInterval(requestInt);
	        _this6.capabilities = assign(_this6.capabilities, capabilities);
	        _this6.emit('connected');
	      });
	      this._bridge.send('requestCapabilities');
	      requestInt = setInterval(function () {
	        tries += 1;
	        if (tries > 100) {
	          console.error('failed to connect');
	          clearInterval(requestInt);
	          _this6.emit('connection failed');
	          return;
	        }
	        _this6._bridge.send('requestCapabilities');
	      }, 500);
	    }
	  }, {
	    key: '_revealDeep',
	    value: function _revealDeep(id) {
	      if (this.searchRoots && this.searchRoots.contains(id)) {
	        return;
	      }
	      var pid = this._parents.get(id);
	      while (pid) {
	        if (this._nodes.getIn([pid, 'collapsed'])) {
	          this._nodes = this._nodes.setIn([pid, 'collapsed'], false);
	          this.emit(pid);
	        }
	        if (this.searchRoots && this.searchRoots.contains(pid)) {
	          return;
	        }
	        pid = this._parents.get(pid);
	      }
	    }
	  }, {
	    key: '_toggleDeepChildren',
	    value: function _toggleDeepChildren(id, value) {
	      var _this7 = this;
	
	      var node = this._nodes.get(id);
	      if (!node) {
	        return;
	      }
	      if (node.get('collapsed') !== value) {
	        this._nodes = this._nodes.setIn([id, 'collapsed'], value);
	        this.emit(id);
	      }
	      var children = node.get('children');
	      if (children && children.forEach) {
	        children.forEach(function (cid) {
	          return _this7._toggleDeepChildren(cid, value);
	        });
	      }
	    }
	  }, {
	    key: '_mountComponent',
	    value: function _mountComponent(data) {
	      var _this8 = this;
	
	      var map = Map(data).set('renders', 1);
	      if (data.nodeType === 'Composite') {
	        map = map.set('collapsed', true);
	      }
	      this._nodes = this._nodes.set(data.id, map);
	      if (data.children && data.children.forEach) {
	        data.children.forEach(function (cid) {
	          _this8._parents = _this8._parents.set(cid, data.id);
	        });
	      }
	      var curNodes = this._nodesByName.get(data.name) || new Set();
	      this._nodesByName = this._nodesByName.set(data.name, curNodes.add(data.id));
	      this.emit(data.id);
	    }
	  }, {
	    key: '_updateComponent',
	    value: function _updateComponent(data) {
	      var _this9 = this;
	
	      var node = this.get(data.id);
	      if (!node) {
	        return;
	      }
	      data.renders = node.get('renders') + 1;
	      this._nodes = this._nodes.mergeIn([data.id], Map(data));
	      if (data.children && data.children.forEach) {
	        data.children.forEach(function (cid) {
	          if (!_this9._parents.get(cid)) {
	            _this9._parents = _this9._parents.set(cid, data.id);
	            var childNode = _this9._nodes.get(cid);
	            var childID = childNode.get('id');
	            if (_this9.searchRoots && nodeMatchesText(childNode, _this9.searchText.toLowerCase(), childID, _this9)) {
	              _this9.searchRoots = _this9.searchRoots.push(childID);
	              _this9.emit('searchRoots');
	              _this9.highlightSearch();
	            }
	          }
	        });
	      }
	      this.emit(data.id);
	    }
	  }, {
	    key: '_updateComponentProfileTimes',
	    value: function _updateComponentProfileTimes(data) {
	      var node = this.get(data.id);
	      if (!node) {
	        return;
	      }
	      this._nodes = this._nodes.mergeIn([data.id], Map(data));
	      this.emit(data.id);
	    }
	  }, {
	    key: '_unmountComponent',
	    value: function _unmountComponent(id) {
	      var pid = this._parents.get(id);
	      this._removeFromNodesByName(id);
	      this._parents = this._parents.delete(id);
	      this._nodes = this._nodes.delete(id);
	      if (pid) {
	        this.emit(pid);
	      } else {
	        var ix = this.roots.indexOf(id);
	        if (ix !== -1) {
	          this.roots = this.roots.delete(ix);
	          this.emit('roots');
	        }
	      }
	      if (id === this.selected) {
	        var newsel = pid ? this.skipWrapper(pid, true) : this.roots.get(0);
	        this.selectTop(newsel, true);
	      }
	      if (this.searchRoots && this.searchRoots.contains(id)) {
	        // $FlowFixMe flow things searchRoots might be null
	        this.searchRoots = this.searchRoots.delete(this.searchRoots.indexOf(id));
	        this.emit('searchRoots');
	        this.highlightSearch();
	      }
	    }
	  }, {
	    key: '_removeFromNodesByName',
	    value: function _removeFromNodesByName(id) {
	      var node = this._nodes.get(id);
	      if (node) {
	        this._nodesByName = this._nodesByName.set(node.get('name'), this._nodesByName.get(node.get('name')).delete(id));
	      }
	    }
	  }]);
	
	  return Store;
	}(EventEmitter);
	
	module.exports = Store;

/***/ },
/* 326 */
/***/ function(module, exports) {

	module.exports = require("events");

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var SearchUtils = __webpack_require__(59);
	
	function nodeMatchesText(node, needle, key, store) {
	  var name = node.get('name');
	  var wrapper = store.get(store.getParent(key));
	  if (node.get('nodeType') === 'Native' && wrapper && wrapper.get('nodeType') === 'NativeWrapper') {
	    return false;
	  }
	  var useRegex = SearchUtils.shouldSearchUseRegex(needle);
	  if (name) {
	    if (node.get('nodeType') !== 'Wrapper') {
	      return validString(name, needle, useRegex);
	    }
	  }
	  var text = node.get('text');
	  if (text) {
	    return validString(text, needle, useRegex);
	  }
	  var children = node.get('children');
	  if (typeof children === 'string') {
	    return validString(children, needle, useRegex);
	  }
	  return false;
	}
	
	function validString(str, needle, regex) {
	  if (regex) {
	    try {
	      var regExp = SearchUtils.searchTextToRegExp(needle);
	      return regExp.test(str.toLowerCase());
	    } catch (error) {
	      return false;
	    }
	  }
	  return str.toLowerCase().indexOf(needle) !== -1;
	}
	
	module.exports = nodeMatchesText;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var consts = __webpack_require__(32);
	
	function stripFunctions(props) {
	  for (var key in props) {
	    var value = props[key];
	    var type = value && value[consts.type] || (typeof value === 'undefined' ? 'undefined' : _typeof(value));
	
	    if (type === 'function') {
	      var name = value[consts.name];
	
	      props[key] = '[function ' + name + ']';
	    }
	  }
	}
	
	function serializePropsForCopy(props) {
	  var cloned = Object.assign({}, props);
	
	  // Don't try to copy 'children'; the data is probably not meaningful.
	  delete cloned.children;
	
	  // Convert functions to '[function]'
	  stripFunctions(cloned);
	
	  try {
	    return JSON.stringify(cloned, null, 2);
	  } catch (error) {
	    return '';
	  }
	}
	
	module.exports = serializePropsForCopy;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(318),
	    deserialize = _require.deserialize,
	    serialize = _require.serialize;
	
	var Themes = __webpack_require__(316);
	
	var _require2 = __webpack_require__(68),
	    CUSTOM_THEME_NAME = _require2.CUSTOM_THEME_NAME;
	
	var _require3 = __webpack_require__(330),
	    get = _require3.get,
	    set = _require3.set;
	
	var LOCAL_STORAGE_CUSTOM_THEME_KEY = 'customTheme';
	var LOCAL_STORAGE_THEME_NAME_KEY = 'themeName';
	
	var Store = function () {
	  function Store(defaultThemeName) {
	    _classCallCheck(this, Store);
	
	    this.themes = Themes;
	
	    // Load previous custom theme from localStorage.
	    // If there isn't one in local storage, start by cloning the default theme.
	    var customTheme = get(LOCAL_STORAGE_CUSTOM_THEME_KEY);
	    if (customTheme) {
	      this.customTheme = deserialize(customTheme);
	    }
	
	    this.setDefaultTheme(defaultThemeName);
	  }
	
	  _createClass(Store, [{
	    key: 'setDefaultTheme',
	    value: function setDefaultTheme(defaultThemeName) {
	      // Don't accept an invalid themeName as a default.
	      this.defaultThemeName = getSafeThemeName(defaultThemeName);
	
	      // Don't restore an invalid themeName.
	      // This guards against themes being removed or renamed.
	      var themeName = getSafeThemeName(get(LOCAL_STORAGE_THEME_NAME_KEY), this.defaultThemeName);
	
	      // The user's active theme is either their custom one,
	      // Or one of the built-in sets (based on the default).
	      this.theme = themeName === CUSTOM_THEME_NAME ? this.customTheme : Themes[themeName];
	      this.themeName = themeName;
	    }
	  }, {
	    key: 'update',
	    value: function update(themeName) {
	      if (themeName === CUSTOM_THEME_NAME) {
	        this.theme = this.customTheme;
	        this.themeName = CUSTOM_THEME_NAME;
	      } else {
	        // Only apply a valid theme.
	        var safeThemeKey = getSafeThemeName(themeName, this.defaultThemeName);
	
	        this.theme = this.themes[safeThemeKey];
	        this.themeName = safeThemeKey;
	      }
	
	      // But allow users to restore "default" mode by selecting an empty theme.
	      set(LOCAL_STORAGE_THEME_NAME_KEY, themeName || null);
	    }
	  }, {
	    key: 'saveCustomTheme',
	    value: function saveCustomTheme(theme) {
	      this.customTheme = theme;
	      this.theme = theme;
	
	      set(LOCAL_STORAGE_CUSTOM_THEME_KEY, serialize(theme));
	    }
	  }]);
	
	  return Store;
	}();
	
	function getSafeThemeName(themeName, fallbackThemeName) {
	  if (themeName === CUSTOM_THEME_NAME) {
	    return CUSTOM_THEME_NAME;
	  } else if (themeName && Themes.hasOwnProperty(themeName)) {
	    return themeName;
	  } else if (fallbackThemeName && Themes.hasOwnProperty(fallbackThemeName)) {
	    return fallbackThemeName;
	  } else {
	    return 'ChromeDefault';
	  }
	}
	
	module.exports = Store;

/***/ },
/* 330 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.get = get;
	exports.set = set;
	function get(key) {
	  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  var value = void 0;
	  try {
	    value = JSON.parse(localStorage.getItem(key));
	  } catch (error) {
	    console.error('Could not read from localStorage.', error);
	  }
	  return value !== null ? value : defaultValue;
	}
	
	function set(key, value) {
	  try {
	    localStorage.setItem(key, JSON.stringify(value));
	    return true;
	  } catch (error) {
	    console.error('Could not write to localStorage.', error);
	  }
	  return false;
	}

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * A helper method for the store, to deal with navigating the tree.
	 *
	 * 
	 */
	'use strict';
	
	var dirToDest = __webpack_require__(332);
	
	
	var keyCodes = {
	  '72': 'left', // 'h',
	  '74': 'down', // 'j',
	  '75': 'up', // 'k',
	  '76': 'right', // 'l',
	
	  '37': 'left',
	  '38': 'up',
	  '39': 'right',
	  '40': 'down'
	};
	
	module.exports = function keyboardNav(store, win) {
	  win = win || window;
	  return function (e) {
	    if (win.document.activeElement !== win.document.body) {
	      return;
	    }
	    if (e.shiftKey || e.metaKey) {
	      return;
	    }
	
	    var direction = keyCodes[e.keyCode];
	    if (!direction) {
	      return;
	    }
	    e.preventDefault();
	    if (e.altKey && direction === 'right') {
	      store.toggleAllChildrenNodes(false);
	      return;
	    }
	    if (e.altKey && direction === 'left') {
	      store.toggleAllChildrenNodes(true);
	      return;
	    }
	    if (e.ctrlKey || e.altKey) {
	      return;
	    }
	    var dest = getDest(direction, store);
	    if (!dest) {
	      return;
	    }
	    var move = getNewSelection(dest, store);
	    if (move && move !== store.selected) {
	      store.select(move);
	    }
	  };
	};
	
	function getDest(dir, store) {
	  var id = store.selected;
	  if (!id) {
	    return null;
	  }
	  var bottom = store.isBottomTagSelected;
	  var node = store.get(id);
	  var collapsed = node.get('collapsed');
	  var children = node.get('children');
	  if (node.get('nodeType') === 'NativeWrapper') {
	    children = store.get(children[0]).get('children');
	  }
	  var hasChildren = children && typeof children !== 'string' && children.length;
	
	  return dirToDest(dir, bottom, collapsed, hasChildren);
	}
	
	function getRootSelection(dest, store, id) {
	  var roots = store.searchRoots || store.roots;
	  var ix = roots.indexOf(id);
	  if (ix === -1) {
	    ix = roots.indexOf(store._parents.get(id));
	  }
	  if (dest === 'prevSibling') {
	    // prev root
	    if (ix === 0) {
	      return null;
	    }
	    var prev = store.skipWrapper(roots.get(ix - 1), false, true);
	    store.isBottomTagSelected = prev ? store.hasBottom(prev) : false; // flowtype requires the ternary
	    return prev;
	  } else if (dest === 'nextSibling') {
	    if (ix >= roots.size - 1) {
	      return null;
	    }
	    store.isBottomTagSelected = false;
	    return store.skipWrapper(roots.get(ix + 1));
	  }
	  return null;
	}
	
	function getNewSelection(dest, store) {
	  var id = store.selected;
	  if (!id) {
	    return undefined;
	  }
	  var node = store.get(id);
	  var pid = store.getParent(id);
	
	  if (pid) {
	    var lastId = id;
	    if (dest === 'parent') {
	      var parentNode = store.get(pid);
	      if (parentNode.get('nodeType') !== 'Wrapper') {
	        return pid;
	      }
	      while (parentNode.get('nodeType') === 'Wrapper') {
	        lastId = id;
	        id = pid;
	        pid = store.getParent(id);
	        // we keep traversing up each parent until we have
	        // a non wrapper. if we find an empty parent, that means
	        // we've hit the top of the tree, meaning we need to
	        // use the root as the pid (so we get the roots)
	        if (!pid) {
	          pid = id;
	          id = lastId;
	          break;
	        }
	        parentNode = store.get(pid);
	      }
	      dest = 'prevSibling';
	    } else if (dest === 'parentBottom') {
	      var _parentNode = store.get(pid);
	      if (_parentNode.get('nodeType') !== 'Wrapper') {
	        store.isBottomTagSelected = true;
	        return pid;
	      }
	      while (_parentNode.get('nodeType') === 'Wrapper') {
	        lastId = id;
	        id = pid;
	        pid = store.getParent(id);
	        // we keep traversing up each parent until we have
	        // a non wrapper. if we find an empty parent, that means
	        // we've hit the top of the tree, meaning we need to
	        // use the root as the pid (so we get the roots)        
	        if (!pid) {
	          pid = id;
	          id = lastId;
	          break;
	        }
	        _parentNode = store.get(pid);
	      }
	      dest = 'nextSibling';
	    }
	  }
	  if (!id) {
	    return undefined;
	  }
	  // if the parent is a root node, we should set pid to null
	  // so we go through the getRootSelection() route below
	  if (store.searchRoots && store.searchRoots.contains(pid)) {
	    pid = null;
	  }
	  if (dest === 'collapse' || dest === 'uncollapse') {
	    if (dest === 'collapse') {
	      store.isBottomTagSelected = false;
	    }
	    store.toggleCollapse(id);
	    return undefined;
	  }
	
	  if (dest === 'selectTop') {
	    store.selectTop(id);
	  }
	
	  var children = node.get('children');
	  if (node.get('nodeType') === 'NativeWrapper') {
	    children = store.get(children[0]).get('children');
	  }
	
	  // Children
	  var cid;
	  if (dest === 'firstChild') {
	    if (typeof children === 'string') {
	      return getNewSelection('nextSibling', store);
	    }
	    for (var i = 0; i < children.length; i++) {
	      cid = store.skipWrapper(children[i]);
	      if (cid) {
	        store.isBottomTagSelected = false;
	        return cid;
	      }
	    }
	  }
	  if (dest === 'lastChild') {
	    if (typeof children === 'string') {
	      return getNewSelection('prevSibling', store);
	    }
	    cid = store.skipWrapper(children[children.length - 1], false, true);
	    if (cid && !store.hasBottom(cid)) {
	      store.isBottomTagSelected = false;
	    }
	    return cid;
	  }
	
	  // Siblings at the root node
	  if (!pid) {
	    return getRootSelection(dest, store, id);
	  }
	
	  // Siblings
	  var parent = store.get(store.getParent(id));
	  var pchildren = parent.get('children');
	  var pix = pchildren.indexOf(id);
	  if (pix === -1) {
	    pix = pchildren.indexOf(store._parents.get(id));
	  }
	  if (dest === 'prevSibling') {
	    while (pix > 0) {
	      var _childId = pchildren[pix - 1];
	      var _child = store.get(_childId);
	      var prevCid = store.skipWrapper(_childId, false, _child.get('nodeType') === 'Wrapper');
	      if (prevCid) {
	        if (store.hasBottom(prevCid)) {
	          store.isBottomTagSelected = true;
	        }
	        return prevCid;
	      }
	      pix--;
	    }
	    var roots = store.searchRoots || store.roots;
	    // if the the previous sibling is a root, we need
	    // to go the getRootSelection() route to select it
	    if (roots.indexOf(store.getParent(id)) > -1) {
	      return getRootSelection(dest, store, id);
	    }
	    var childId = pchildren[pix];
	    var child = store.get(childId);
	    if (child.get('nodeType') === 'Wrapper') {
	      return store.getParent(id);
	    }
	    return getNewSelection('parent', store);
	  }
	  if (dest === 'nextSibling') {
	    // check if we're at the end of the children array
	    if (pix === pchildren.length - 1) {
	      var _roots = store.searchRoots || store.roots;
	      // if the the next sibling is a root, we need
	      // to go the getRootSelection() route to select it
	      if (_roots.indexOf(store.getParent(id)) > -1) {
	        return getRootSelection(dest, store, id);
	      }
	      var _childId2 = pchildren[pix];
	      var _child2 = store.get(_childId2);
	      if (_child2.get('nodeType') === 'Wrapper') {
	        store.isBottomTagSelected = true;
	        return store.getParent(id);
	      }
	      return getNewSelection('parentBottom', store);
	    }
	    store.isBottomTagSelected = false;
	    return store.skipWrapper(pchildren[pix + 1]);
	  }
	
	  return null;
	}

/***/ },
/* 332 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * A helper method for the store, to deal with navigating the tree.
	 *
	 * 
	 */
	'use strict';
	
	module.exports = function (dir, bottom, collapsed, hasChildren) {
	  if (dir === 'down') {
	    if (bottom || collapsed || !hasChildren) {
	      return 'nextSibling';
	    }
	    return 'firstChild';
	  }
	
	  if (dir === 'up') {
	    if (!bottom || collapsed || !hasChildren) {
	      return 'prevSibling';
	    }
	    return 'lastChild';
	  }
	
	  if (dir === 'left') {
	    if (!collapsed && hasChildren) {
	      return bottom ? 'selectTop' : 'collapse';
	    }
	    return 'parent';
	  }
	
	  if (dir === 'right') {
	    if (collapsed && hasChildren) {
	      return 'uncollapse';
	    }
	    if (hasChildren) {
	      if (bottom) {
	        return null;
	      } else {
	        return 'firstChild';
	      }
	    }
	  }
	
	  return null;
	};

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var consts = __webpack_require__(32);
	var hydrate = __webpack_require__(334);
	var dehydrate = __webpack_require__(335);
	var getIn = __webpack_require__(336);
	var performanceNow = __webpack_require__(337);
	
	// Use the polyfill if the function is not native implementation
	function getWindowFunction(name, polyfill) {
	  if (String(window[name]).indexOf('[native code]') === -1) {
	    return polyfill;
	  }
	  return window[name];
	}
	
	// Custom polyfill that runs the queue with a backoff.
	// If you change it, make sure it behaves reasonably well in Firefox.
	var lastRunTimeMS = 5;
	var cancelIdleCallback = getWindowFunction('cancelIdleCallback', clearTimeout);
	var requestIdleCallback = getWindowFunction('requestIdleCallback', function (cb, options) {
	  // Magic numbers determined by tweaking in Firefox.
	  // There is no special meaning to them.
	  var delayMS = 3000 * lastRunTimeMS;
	  if (delayMS > 500) {
	    delayMS = 500;
	  }
	
	  return setTimeout(function () {
	    var startTime = performanceNow();
	    cb({
	      didTimeout: false,
	      timeRemaining: function timeRemaining() {
	        return Infinity;
	      }
	    });
	    var endTime = performanceNow();
	    lastRunTimeMS = (endTime - startTime) / 1000;
	  }, delayMS);
	});
	
	/**
	 * The bridge is responsible for serializing requests between the Agent and
	 * the Frontend Store. It needs to be connected to a Wall object that can send
	 * JSONable data to the bridge on the other side.
	 *
	 * complex data
	 *     |
	 *     v
	 *  [Bridge]
	 *     |
	 * jsonable data
	 *     |
	 *     v
	 *   [wall]
	 *     |
	 *     v
	 * ~ some barrier ~
	 *     |
	 *     v
	 *   [wall]
	 *     |
	 *     v
	 *  [Bridge]
	 *     |
	 *     v
	 * "hydrated" data
	 *
	 * When an item is passed in that can't be serialized (anything other than a
	 * plain array, object, or literal value), the object is "cleaned", and
	 * rehydrated on the other side with `Symbol` attributes indicating that the
	 * object needs to be inspected for more detail.
	 *
	 * Example:
	 *
	 * bridge.send('evname', {id: 'someid', foo: MyCoolObjectInstance})
	 * ->
	 * shows up, hydrated as
	 * {
	 *   id: 'someid',
	 *   foo: {
	 *     [consts.name]: 'MyCoolObjectInstance',
	 *     [consts.type]: 'object',
	 *     [consts.meta]: {},
	 *     [consts.inspected]: false,
	 *   }
	 * }
	 *
	 * The `consts` variables are Symbols, and as such are non-ennumerable.
	 * The front-end therefore needs to check for `consts.inspected` on received
	 * objects, and can thereby display object proxies and inspect them.
	 *
	 * Complex objects that are passed are expected to have a top-level `id`
	 * attribute, which is used for later lookup + inspection. Once it has been
	 * determined that an object is no longer needed, call `.forget(id)` to clean
	 * up.
	 */
	var Bridge = function () {
	  function Bridge(wall) {
	    _classCallCheck(this, Bridge);
	
	    this._cbs = new Map();
	    this._inspectables = new Map();
	    this._cid = 0;
	    this._listeners = {};
	    this._buffer = [];
	    this._flushHandle = null;
	    this._callers = {};
	    this._paused = false;
	    this._wall = wall;
	
	    wall.listen(this._handleMessage.bind(this));
	  }
	
	  _createClass(Bridge, [{
	    key: 'inspect',
	    value: function inspect(id, path, cb) {
	      var _cid = this._cid++;
	      this._cbs.set(_cid, function (data, cleaned, proto, protoclean) {
	        if (cleaned.length) {
	          hydrate(data, cleaned);
	        }
	        if (proto && protoclean.length) {
	          hydrate(proto, protoclean);
	        }
	        if (proto) {
	          data[consts.proto] = proto;
	        }
	        cb(data);
	      });
	
	      this._wall.send({
	        type: 'inspect',
	        callback: _cid,
	        path: path,
	        id: id
	      });
	    }
	  }, {
	    key: 'call',
	    value: function call(name, args, cb) {
	      var _cid = this._cid++;
	      this._cbs.set(_cid, cb);
	
	      this._wall.send({
	        type: 'call',
	        callback: _cid,
	        args: args,
	        name: name
	      });
	    }
	  }, {
	    key: 'onCall',
	    value: function onCall(name, handler) {
	      if (this._callers[name]) {
	        throw new Error('only one call handler per call name allowed');
	      }
	      this._callers[name] = handler;
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this._wall.send({
	        type: 'pause'
	      });
	    }
	  }, {
	    key: 'resume',
	    value: function resume() {
	      this._wall.send({
	        type: 'resume'
	      });
	    }
	  }, {
	    key: 'setInspectable',
	    value: function setInspectable(id, data) {
	      var prev = this._inspectables.get(id);
	      if (!prev) {
	        this._inspectables.set(id, data);
	        return;
	      }
	      this._inspectables.set(id, _extends({}, prev, data));
	    }
	  }, {
	    key: 'send',
	    value: function send(evt, data) {
	      this._buffer.push({ evt: evt, data: data });
	      this.scheduleFlush();
	    }
	  }, {
	    key: 'scheduleFlush',
	    value: function scheduleFlush() {
	      if (!this._flushHandle && this._buffer.length) {
	        var timeout = this._paused ? 5000 : 500;
	        this._flushHandle = requestIdleCallback(this.flushBufferWhileIdle.bind(this), { timeout: timeout });
	      }
	    }
	  }, {
	    key: 'cancelFlush',
	    value: function cancelFlush() {
	      if (this._flushHandle) {
	        cancelIdleCallback(this._flushHandle);
	        this._flushHandle = null;
	      }
	    }
	  }, {
	    key: 'flushBufferWhileIdle',
	    value: function flushBufferWhileIdle(deadline) {
	      this._flushHandle = null;
	
	      // Magic numbers were determined by tweaking in a heavy UI and seeing
	      // what performs reasonably well both when DevTools are hidden and visible.
	      // The goal is that we try to catch up but avoid blocking the UI.
	      // When paused, it's okay to lag more, but not forever because otherwise
	      // when user activates React tab, it will freeze syncing.
	      var chunkCount = this._paused ? 20 : 10;
	      var chunkSize = Math.round(this._buffer.length / chunkCount);
	      var minChunkSize = this._paused ? 50 : 100;
	
	      while (this._buffer.length && (deadline.timeRemaining() > 0 || deadline.didTimeout)) {
	        var take = Math.min(this._buffer.length, Math.max(minChunkSize, chunkSize));
	        var currentBuffer = this._buffer.splice(0, take);
	        this.flushBufferSlice(currentBuffer);
	      }
	
	      if (this._buffer.length) {
	        this.scheduleFlush();
	      }
	    }
	  }, {
	    key: 'flushBufferSlice',
	    value: function flushBufferSlice(bufferSlice) {
	      var _this = this;
	
	      var events = bufferSlice.map(function (_ref) {
	        var evt = _ref.evt,
	            data = _ref.data;
	
	        var cleaned = [];
	        var san = dehydrate(data, cleaned);
	        if (cleaned.length) {
	          _this.setInspectable(data.id, data);
	        }
	        return { type: 'event', evt: evt, data: san, cleaned: cleaned };
	      });
	      this._wall.send({ type: 'many-events', events: events });
	    }
	  }, {
	    key: 'forget',
	    value: function forget(id) {
	      this._inspectables.delete(id);
	    }
	  }, {
	    key: 'on',
	    value: function on(evt, fn) {
	      if (!this._listeners[evt]) {
	        this._listeners[evt] = [fn];
	      } else {
	        this._listeners[evt].push(fn);
	      }
	    }
	  }, {
	    key: 'off',
	    value: function off(evt, fn) {
	      if (!this._listeners[evt]) {
	        return;
	      }
	      var ix = this._listeners[evt].indexOf(fn);
	      if (ix !== -1) {
	        this._listeners[evt].splice(ix, 1);
	      }
	    }
	  }, {
	    key: 'once',
	    value: function once(evt, fn) {
	      var self = this;
	      var listener = function listener() {
	        fn.apply(this, arguments);
	        self.off(evt, listener);
	      };
	      this.on(evt, listener);
	    }
	  }, {
	    key: '_handleMessage',
	    value: function _handleMessage(payload) {
	      var _this2 = this;
	
	      if (payload.type === 'resume') {
	        this._paused = false;
	        this.scheduleFlush();
	        return;
	      }
	
	      if (payload.type === 'pause') {
	        this._paused = true;
	        this.cancelFlush();
	        return;
	      }
	
	      if (payload.type === 'callback') {
	        var callback = this._cbs.get(payload.id);
	        if (callback) {
	          callback.apply(undefined, _toConsumableArray(payload.args));
	          this._cbs.delete(payload.id);
	        }
	        return;
	      }
	
	      if (payload.type === 'call') {
	        this._handleCall(payload.name, payload.args, payload.callback);
	        return;
	      }
	
	      if (payload.type === 'inspect') {
	        this._inspectResponse(payload.id, payload.path, payload.callback);
	        return;
	      }
	
	      if (payload.type === 'event') {
	        // console.log('[bridge<-]', payload.evt);
	        if (payload.cleaned) {
	          hydrate(payload.data, payload.cleaned);
	        }
	        var fns = this._listeners[payload.evt];
	        var data = payload.data;
	        if (fns) {
	          fns.forEach(function (fn) {
	            return fn(data);
	          });
	        }
	      }
	
	      if (payload.type === 'many-events') {
	        payload.events.forEach(function (event) {
	          // console.log('[bridge<-]', payload.evt);
	          if (event.cleaned) {
	            hydrate(event.data, event.cleaned);
	          }
	          var handlers = _this2._listeners[event.evt];
	          if (handlers) {
	            handlers.forEach(function (fn) {
	              return fn(event.data);
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: '_handleCall',
	    value: function _handleCall(name, args, callback) {
	      if (!this._callers[name]) {
	        console.warn('unknown call: "' + name + '"');
	        return;
	      }
	      args = !Array.isArray(args) ? [args] : args;
	      var result;
	      try {
	        result = this._callers[name].apply(null, args);
	      } catch (e) {
	        console.error('Failed to call', e);
	        return;
	      }
	      this._wall.send({
	        type: 'callback',
	        id: callback,
	        args: [result]
	      });
	    }
	  }, {
	    key: '_inspectResponse',
	    value: function _inspectResponse(id, path, callback) {
	      var inspectable = this._inspectables.get(id);
	      var result = {};
	      var cleaned = [];
	      var proto = null;
	      var protoclean = [];
	
	      if (inspectable) {
	        var val = getIn(inspectable, path);
	        var protod = false;
	        var isFn = typeof val === 'function';
	
	        if (val && typeof val[Symbol.iterator] === 'function') {
	          var iterVal = Object.create({}); // flow throws "object literal incompatible with object type"
	          var count = 0;
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = val[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var entry = _step.value;
	
	              if (count > 100) {
	                // TODO: replace this if block with better logic to handle large iterables
	                break;
	              }
	              iterVal[count] = entry;
	              count++;
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          val = iterVal;
	        }
	
	        Object.getOwnPropertyNames(val).forEach(function (name) {
	          if (name === '__proto__') {
	            protod = true;
	          }
	          if (isFn && (name === 'arguments' || name === 'callee' || name === 'caller')) {
	            return;
	          }
	          // $FlowIgnore This is intentional
	          result[name] = dehydrate(val[name], cleaned, [name]);
	        });
	
	        /* eslint-disable no-proto */
	        if (!protod && val.__proto__ && val.constructor.name !== 'Object') {
	          var newProto = {};
	          var pIsFn = typeof val.__proto__ === 'function';
	          Object.getOwnPropertyNames(val.__proto__).forEach(function (name) {
	            if (pIsFn && (name === 'arguments' || name === 'callee' || name === 'caller')) {
	              return;
	            }
	            newProto[name] = dehydrate(val.__proto__[name], protoclean, [name]);
	          });
	          proto = newProto;
	        }
	        /* eslint-enable no-proto */
	      }
	
	      this._wall.send({
	        type: 'callback',
	        id: callback,
	        args: [result, cleaned, proto, protoclean]
	      });
	    }
	  }]);
	
	  return Bridge;
	}();
	
	module.exports = Bridge;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var consts = __webpack_require__(32);
	
	function hydrate(data, cleaned) {
	  cleaned.forEach(function (path) {
	    var last = path.pop();
	    var obj = path.reduce(function (obj_, attr) {
	      return obj_ ? obj_[attr] : null;
	    }, data);
	    if (!obj || !obj[last]) {
	      return;
	    }
	    var replace = {};
	    replace[consts.name] = obj[last].name;
	    replace[consts.type] = obj[last].type;
	    replace[consts.meta] = obj[last].meta;
	    replace[consts.inspected] = false;
	    obj[last] = replace;
	  });
	}
	
	module.exports = hydrate;

/***/ },
/* 335 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * Get a enhanced/artificial type string based on the object instance
	 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function getPropType(data) {
	  if (!data) {
	    return null;
	  }
	  var type = typeof data === 'undefined' ? 'undefined' : _typeof(data);
	
	  if (type === 'object') {
	    if (data._reactFragment) {
	      return 'react_fragment';
	    }
	    if (Array.isArray(data)) {
	      return 'array';
	    }
	    if (ArrayBuffer.isView(data)) {
	      if (data instanceof DataView) {
	        return 'data_view';
	      }
	      return 'typed_array';
	    }
	    if (data instanceof ArrayBuffer) {
	      return 'array_buffer';
	    }
	    if (typeof data[Symbol.iterator] === 'function') {
	      return 'iterator';
	    }
	    if (Object.prototype.toString.call(data) === '[object Date]') {
	      return 'date';
	    }
	  }
	
	  return type;
	}
	
	/**
	 * Generate the dehydrated metadata for complex object instances
	 */
	function createDehydrated(type, data, cleaned, path) {
	  var meta = {};
	
	  if (type === 'array' || type === 'typed_array') {
	    meta.length = data.length;
	  }
	  if (type === 'iterator' || type === 'typed_array') {
	    meta.readOnly = true;
	  }
	
	  cleaned.push(path);
	
	  return {
	    type: type,
	    meta: meta,
	    name: !data.constructor || data.constructor.name === 'Object' ? '' : data.constructor.name
	  };
	}
	
	/**
	 * Strip out complex data (instances, functions, and data nested > 2 levels
	 * deep). The paths of the stripped out objects are appended to the `cleaned`
	 * list. On the other side of the barrier, the cleaned list is used to
	 * "re-hydrate" the cleaned representation into an object with symbols as
	 * attributes, so that a sanitized object can be distinguished from a normal
	 * object.
	 *
	 * Input: {"some": {"attr": fn()}, "other": AnInstance}
	 * Output: {
	 *   "some": {
	 *     "attr": {"name": the fn.name, type: "function"}
	 *   },
	 *   "other": {
	 *     "name": "AnInstance",
	 *     "type": "object",
	 *   },
	 * }
	 * and cleaned = [["some", "attr"], ["other"]]
	 */
	function dehydrate(data, cleaned) {
	  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	
	  var type = getPropType(data);
	
	  switch (type) {
	
	    case 'function':
	      cleaned.push(path);
	      return {
	        name: data.name,
	        type: 'function'
	      };
	
	    case 'string':
	      return data.length <= 500 ? data : data.slice(0, 500) + '...';
	
	    // We have to do this assignment b/c Flow doesn't think "symbol" is
	    // something typeof would return. Error 'unexpected predicate "symbol"'
	    case 'symbol':
	      cleaned.push(path);
	      return {
	        type: 'symbol',
	        name: data.toString()
	      };
	
	    // React Fragments error if you try to inspect them.
	    case 'react_fragment':
	      return 'A React Fragment';
	
	    // ArrayBuffers error if you try to inspect them.
	    case 'array_buffer':
	    case 'data_view':
	      cleaned.push(path);
	      return {
	        type: type,
	        name: type === 'data_view' ? 'DataView' : 'ArrayBuffer',
	        meta: {
	          length: data.byteLength,
	          uninspectable: true
	        }
	      };
	
	    case 'array':
	      if (level > 2) {
	        return createDehydrated(type, data, cleaned, path);
	      }
	      return data.map(function (item, i) {
	        return dehydrate(item, cleaned, path.concat([i]), level + 1);
	      });
	
	    case 'typed_array':
	    case 'iterator':
	      return createDehydrated(type, data, cleaned, path);
	    case 'date':
	      cleaned.push(path);
	      return {
	        name: data.toString(),
	        type: 'date',
	        meta: {
	          uninspectable: true
	        }
	      };
	    case 'object':
	      if (level > 2 || data.constructor && typeof data.constructor === 'function' && data.constructor.name !== 'Object') {
	        return createDehydrated(type, data, cleaned, path);
	      } else {
	
	        var res = {};
	        for (var name in data) {
	          res[name] = dehydrate(data[name], cleaned, path.concat([name]), level + 1);
	        }
	        return res;
	      }
	
	    default:
	      return data;
	  }
	}
	
	module.exports = dehydrate;

/***/ },
/* 336 */
/***/ function(module, exports) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Retrieves the value from the path of nested objects
	 * @param  {Object} base Base or root object for path
	 * @param  {Array<String>} path nested path
	 * @return {any}      Value at end of path or `mull`
	 */
	function getIn(base, path) {
	  return path.reduce(function (obj, attr) {
	    if (obj) {
	      if (hasOwnProperty.call(obj, attr)) {
	        return obj[attr];
	      }
	      if (typeof obj[Symbol.iterator] === 'function') {
	        // Convert iterable to array and return array[index]
	        return [].concat(_toConsumableArray(obj))[attr];
	      }
	    }
	
	    return null;
	  }, base);
	}
	
	module.exports = getIn;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule performanceNow
	 * @typechecks
	 */
	
	'use strict';
	
	var performance = __webpack_require__(338);
	
	var performanceNow;
	
	/**
	 * Detect if we can use `window.performance.now()` and gracefully fallback to
	 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
	 * because of Facebook's testing infrastructure.
	 */
	if (performance.now) {
	  performanceNow = function () {
	    return performance.now();
	  };
	} else {
	  performanceNow = function () {
	    return Date.now();
	  };
	}
	
	module.exports = performanceNow;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule performance
	 * @typechecks
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(339);
	
	var performance;
	
	if (ExecutionEnvironment.canUseDOM) {
	  performance = window.performance || window.msPerformance || window.webkitPerformance;
	}
	
	module.exports = performance || {};

/***/ },
/* 339 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(11);
	var StyleEdit = __webpack_require__(341);
	var BoxInspector = __webpack_require__(343);
	
	function shallowClone(obj) {
	  var nobj = {};
	  for (var n in obj) {
	    nobj[n] = obj[n];
	  }
	  return nobj;
	}
	
	var NativeStyler = function (_React$Component) {
	  _inherits(NativeStyler, _React$Component);
	
	  function NativeStyler(props) {
	    _classCallCheck(this, NativeStyler);
	
	    var _this = _possibleConstructorReturn(this, (NativeStyler.__proto__ || Object.getPrototypeOf(NativeStyler)).call(this, props));
	
	    _this.state = { style: null, measuredLayout: null };
	    return _this;
	  }
	
	  _createClass(NativeStyler, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this._styleGet = this._styleGet.bind(this);
	      if (this.props.supportsMeasure) {
	        this.props.bridge.on('rn-style:measure', this._styleGet);
	        this.props.bridge.send('rn-style:measure', this.props.id);
	      } else {
	        this.props.bridge.call('rn-style:get', this.props.id, function (style) {
	          _this2.setState({ style: style });
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.supportsMeasure) {
	        this.props.bridge.off('rn-style:measure', this._styleGet);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      if (nextProps.id === this.props.id) {
	        return;
	      }
	      this.setState({ style: null });
	      this.props.bridge.send('rn-style:get', nextProps.id);
	
	      if (this.props.supportsMeasure) {
	        this.props.bridge.send('rn-style:measure', nextProps.id);
	      } else {
	        this.props.bridge.call('rn-style:get', nextProps.id, function (style) {
	          _this3.setState({ style: style });
	        });
	      }
	    }
	  }, {
	    key: '_styleGet',
	    value: function _styleGet(result) {
	      var style = result.style,
	          measuredLayout = result.measuredLayout;
	
	      this.setState({ style: style, measuredLayout: measuredLayout });
	    }
	  }, {
	    key: '_handleStyleChange',
	    value: function _handleStyleChange(attr, val) {
	      if (this.state.style) {
	        this.state.style[attr] = val;
	      }
	      this.props.bridge.send('rn-style:set', { id: this.props.id, attr: attr, val: val });
	      this.setState({ style: this.state.style });
	    }
	  }, {
	    key: '_handleStyleRename',
	    value: function _handleStyleRename(oldName, newName, val) {
	      var style = shallowClone(this.state.style);
	      delete style[oldName];
	      style[newName] = val;
	      this.props.bridge.send('rn-style:rename', { id: this.props.id, oldName: oldName, newName: newName, val: val });
	      this.setState({ style: style });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.style) {
	        return React.createElement(
	          'em',
	          null,
	          'loading'
	        );
	      }
	      return React.createElement(
	        'div',
	        { style: styles.container },
	        this.state.measuredLayout && React.createElement(BoxInspector, this.state.measuredLayout),
	        React.createElement(StyleEdit, {
	          style: this.state.style,
	          onRename: this._handleStyleRename.bind(this),
	          onChange: this._handleStyleChange.bind(this)
	        })
	      );
	    }
	  }]);
	
	  return NativeStyler;
	}(React.Component);
	
	var styles = {
	  container: {
	    display: 'flex',
	    flexDirection: 'column'
	  }
	};
	
	module.exports = NativeStyler;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	
	var React = __webpack_require__(11);
	var AutoSizeInput = __webpack_require__(342);
	
	var StyleEdit = function (_React$Component) {
	  _inherits(StyleEdit, _React$Component);
	
	  function StyleEdit(props) {
	    _classCallCheck(this, StyleEdit);
	
	    var _this = _possibleConstructorReturn(this, (StyleEdit.__proto__ || Object.getPrototypeOf(StyleEdit)).call(this, props));
	
	    _this.state = { showNew: false, newAttr: '', newValue: '' };
	    return _this;
	  }
	
	  _createClass(StyleEdit, [{
	    key: 'onChange',
	    value: function onChange(name, val) {
	      var num = Number(val);
	      this.props.onChange(name, num === Number(val) ? num : val);
	    }
	  }, {
	    key: 'onNewSubmit',
	    value: function onNewSubmit(val) {
	      this.onChange(this.state.newAttr, val);
	      this.setState({ showNew: false, newAttr: '', newValue: '' });
	    }
	  }, {
	    key: 'onNewAttr',
	    value: function onNewAttr(attr) {
	      if (attr === '') {
	        this.setState({ showNew: false });
	      } else {
	        this.setState({ newAttr: '' + attr });
	      }
	    }
	  }, {
	    key: 'onListClick',
	    value: function onListClick(e) {
	      if (e.target instanceof Element) {
	        if (e.target.tagName === 'INPUT') {
	          return;
	        }
	      }
	      this.setState({ showNew: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var attrs = Object.keys(this.props.style);
	      return React.createElement(
	        'ul',
	        { style: styles.list, onClick: function onClick(e) {
	            return _this2.onListClick(e);
	          } },
	        React.createElement(
	          'span',
	          { style: tagStyle(this.context.theme) },
	          'style'
	        ),
	        React.createElement(
	          'span',
	          null,
	          ' {'
	        ),
	        attrs.map(function (name) {
	          return React.createElement(
	            'li',
	            { key: 'style-' + name, style: styles.listItem, onClick: blockClick },
	            React.createElement(AutoSizeInput, {
	              type: 'attr',
	              value: name,
	              onChange: function onChange(newName) {
	                return _this2.props.onRename(name, '' + newName, _this2.props.style[name]);
	              }
	            }),
	            React.createElement(
	              'span',
	              { style: styles.colon },
	              ':'
	            ),
	            React.createElement(AutoSizeInput, {
	              value: _this2.props.style[name],
	              onChange: function onChange(val) {
	                return _this2.onChange(name, val);
	              }
	            }),
	            React.createElement(
	              'span',
	              { style: styles.colon },
	              ';'
	            )
	          );
	        }),
	        this.state.showNew && React.createElement(
	          'li',
	          { style: styles.listItem },
	          React.createElement(AutoSizeInput, {
	            isNew: true,
	            type: 'attr',
	            value: this.state.newAttr,
	            onChange: function onChange(newAttr) {
	              return _this2.onNewAttr(newAttr);
	            }
	          }),
	          React.createElement(
	            'span',
	            { style: styles.colon },
	            ':'
	          ),
	          React.createElement(AutoSizeInput, {
	            value: '',
	            onChange: function onChange(val) {
	              return _this2.onNewSubmit(val);
	            }
	          }),
	          React.createElement(
	            'span',
	            { style: styles.colon },
	            ';'
	          )
	        ),
	        React.createElement(
	          'span',
	          null,
	          '}'
	        )
	      );
	    }
	  }]);
	
	  return StyleEdit;
	}(React.Component);
	
	StyleEdit.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	var blockClick = function blockClick(event) {
	  return event.stopPropagation();
	};
	
	var tagStyle = function tagStyle(theme) {
	  return {
	    color: theme.base04
	  };
	};
	
	var styles = {
	  list: {
	    listStyle: 'none',
	    padding: 0,
	    margin: '5px 0px',
	    cursor: 'text'
	  },
	  colon: {
	    margin: '-3px'
	  },
	  listItem: {
	    margin: 0,
	    display: 'flex',
	    alignItems: 'center',
	    cursor: 'default'
	  }
	};
	
	module.exports = StyleEdit;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	
	var React = __webpack_require__(11);
	var nullthrows = __webpack_require__(16).default;
	
	var _require = __webpack_require__(17),
	    monospace = _require.monospace;
	
	var Input = __webpack_require__(23);
	
	var AutoSizeInput = function (_React$Component) {
	  _inherits(AutoSizeInput, _React$Component);
	
	  function AutoSizeInput(props, context) {
	    _classCallCheck(this, AutoSizeInput);
	
	    var _this = _possibleConstructorReturn(this, (AutoSizeInput.__proto__ || Object.getPrototypeOf(AutoSizeInput)).call(this, props, context));
	
	    _this.state = {
	      text: '' + _this.props.value,
	      inputWidth: 1
	    };
	    return _this;
	  }
	
	  _createClass(AutoSizeInput, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.copyInputStyles();
	      this.updateInputWidth();
	      if (this.props.isNew) {
	        this.input.focus();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      this.updateInputWidth();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ text: '' + nextProps.value });
	    }
	  }, {
	    key: 'copyInputStyles',
	    value: function copyInputStyles() {
	      if (!window.getComputedStyle) {
	        return;
	      }
	      var inputStyle = this.input && window.getComputedStyle(this.input);
	      if (!inputStyle) {
	        return;
	      }
	      var sizerNode = nullthrows(this.sizer);
	      sizerNode.style.fontSize = inputStyle.fontSize;
	      sizerNode.style.fontFamily = inputStyle.fontFamily;
	      sizerNode.style.fontWeight = inputStyle.fontWeight;
	      sizerNode.style.fontStyle = inputStyle.fontStyle;
	      sizerNode.style.letterSpacing = inputStyle.letterSpacing;
	    }
	  }, {
	    key: 'updateInputWidth',
	    value: function updateInputWidth() {
	      if (!this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
	        return;
	      }
	      var width = this.sizer.scrollWidth + 1;
	      if (width !== this.state.inputWidth) {
	        this.setState({
	          inputWidth: width
	        });
	      }
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e) {
	      if (e.key === 'Enter' || e.key === 'Escape') {
	        this.done();
	        return;
	      } else if (e.key === 'ArrowUp') {
	        if (+this.state.text + '' === this.state.text) {
	          this.props.onChange(+this.state.text + 1);
	        }
	      } else if (e.key === 'ArrowDown') {
	        if (+this.state.text + '' === this.state.text) {
	          this.props.onChange(+this.state.text - 1);
	        }
	      }
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus() {
	      var theme = this.context.theme;
	
	
	      var input = this.input;
	      input.selectionStart = 0;
	      input.selectionEnd = input.value.length;
	      input.style.color = theme.base05;
	      input.style.boxShadow = '0 0 3px ' + theme.base03;
	      input.style.border = '1px solid ' + theme.base03;
	      input.style.padding = '0px 1px';
	    }
	  }, {
	    key: 'done',
	    value: function done() {
	      var input = this.input;
	      input.style.color = this.getColor();
	      input.style.boxShadow = 'none';
	      input.style.border = 'none';
	      input.style.padding = '1px 2px';
	      if (this.state.text !== '' + this.props.value || this.props.isNew) {
	        this.props.onChange(this.state.text);
	      }
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      var theme = this.context.theme;
	
	      return this.props.type === 'attr' ? theme.special06 : theme.base05;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var style = inputStyle(this.state.text);
	      style.color = this.getColor();
	      style.width = this.state.inputWidth + 'px';
	      return React.createElement(
	        'div',
	        { style: styles.wrapper },
	        React.createElement(Input, {
	          innerRef: function innerRef(i) {
	            return _this2.input = i;
	          },
	          value: this.state.text,
	          style: style,
	          onChange: function onChange(e) {
	            return _this2.setState({ text: e.target.value });
	          },
	          onFocus: function onFocus() {
	            return _this2.onFocus();
	          },
	          onBlur: function onBlur() {
	            return _this2.done();
	          },
	          onKeyDown: function onKeyDown(e) {
	            return _this2.onKeyDown(e);
	          }
	        }),
	        React.createElement(
	          'div',
	          { ref: function ref(el) {
	              return _this2.sizer = el;
	            }, style: styles.sizer },
	          this.state.text
	        )
	      );
	    }
	  }]);
	
	  return AutoSizeInput;
	}(React.Component);
	
	AutoSizeInput.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	var inputStyle = function inputStyle(text) {
	  return {
	    fontFamily: monospace.family,
	    fontSize: monospace.sizes.normal,
	    boxSizing: 'content-box',
	    border: 'none',
	    padding: '1px 2px',
	    marginLeft: '0.75rem',
	    outline: 'none',
	    width: '0px',
	    minWidth: text ? '0' : '1rem' };
	};
	
	var styles = {
	  wrapper: {
	    display: 'inline-block'
	  },
	  sizer: {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    visibility: 'hidden',
	    height: 0,
	    overflow: 'scroll',
	    whiteSpace: 'pre'
	  }
	};
	
	module.exports = AutoSizeInput;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	
	var React = __webpack_require__(11);
	
	var _require = __webpack_require__(17),
	    sansSerif = _require.sansSerif;
	
	var Box = function Box(props) {
	  var title = props.title,
	      children = props.children,
	      top = props.top,
	      left = props.left,
	      right = props.right,
	      bottom = props.bottom,
	      theme = props.theme;
	
	  return React.createElement(
	    'div',
	    { style: boxStyle(theme) },
	    React.createElement(
	      'span',
	      { style: labelStyle(theme) },
	      title
	    ),
	    React.createElement(
	      'div',
	      { style: styles.boxText },
	      +top.toFixed(3)
	    ),
	    React.createElement(
	      'div',
	      { style: styles.row },
	      React.createElement(
	        'span',
	        { style: styles.boxText },
	        +left.toFixed(3)
	      ),
	      children,
	      React.createElement(
	        'span',
	        { style: styles.boxText },
	        +right.toFixed(3)
	      )
	    ),
	    React.createElement(
	      'div',
	      { style: styles.boxText },
	      +bottom.toFixed(3)
	    )
	  );
	};
	
	var BoxInspector = function (_React$Component) {
	  _inherits(BoxInspector, _React$Component);
	
	  function BoxInspector() {
	    _classCallCheck(this, BoxInspector);
	
	    return _possibleConstructorReturn(this, (BoxInspector.__proto__ || Object.getPrototypeOf(BoxInspector)).apply(this, arguments));
	  }
	
	  _createClass(BoxInspector, [{
	    key: 'render',
	    value: function render() {
	      var theme = this.context.theme;
	      var _props = this.props,
	          left = _props.left,
	          top = _props.top,
	          width = _props.width,
	          height = _props.height,
	          margin = _props.margin,
	          padding = _props.padding;
	
	      return React.createElement(
	        Box,
	        _extends({ theme: theme, title: 'margin' }, margin),
	        React.createElement(
	          Box,
	          _extends({ theme: theme, title: 'padding' }, padding),
	          React.createElement(
	            'div',
	            { style: styles.measureLayout },
	            React.createElement(
	              'span',
	              { style: positionTextStyle(theme) },
	              '(',
	              +left.toFixed(3),
	              ', ',
	              +top.toFixed(3),
	              ')'
	            ),
	            React.createElement(
	              'span',
	              { style: dimenTextStyle(theme) },
	              +width.toFixed(3),
	              ' \xD7 ',
	              +height.toFixed(3)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BoxInspector;
	}(React.Component);
	
	BoxInspector.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	var labelStyle = function labelStyle(theme) {
	  return {
	    flex: 1,
	    color: theme.special03
	  };
	};
	
	var positionTextStyle = function positionTextStyle(theme) {
	  return {
	    color: theme.base03,
	    fontSize: sansSerif.sizes.normal,
	    textAlign: 'center'
	  };
	};
	
	var dimenTextStyle = function dimenTextStyle(theme) {
	  return {
	    color: theme.special02,
	    textAlign: 'center'
	  };
	};
	
	var boxStyle = function boxStyle(theme) {
	  return {
	    position: 'relative',
	    padding: 8,
	    margin: 8,
	    width: 184,
	    border: '1px dashed ' + theme.base05,
	    alignItems: 'center',
	    alignSelf: 'center'
	  };
	};
	
	var styles = {
	  row: {
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'space-between'
	  },
	  measureLayout: {
	    display: 'flex',
	    flexDirection: 'column',
	    margin: 4
	  },
	  boxText: {
	    textAlign: 'center'
	  }
	};
	
	module.exports = BoxInspector;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var React = __webpack_require__(11);
	var provideStore = __webpack_require__(345);
	var ProfilerStore = __webpack_require__(346);
	var ProfilerTab = __webpack_require__(352).default;
	var StoreWrapper = provideStore('profilerStore');
	
	var ProfilerPlugin = function () {
	  function ProfilerPlugin(store, bridge, refresh) {
	    var _this = this;
	
	    _classCallCheck(this, ProfilerPlugin);
	
	    this.bridge = bridge;
	    this.store = store;
	    this.profilingIsSupported = false;
	    this.profilerStore = new ProfilerStore(bridge, store);
	
	    // The Profiler backend will notify us if/when it detects a profiling capable React build.
	    // This is an async check, because roots may not have been registered yet at this time.
	    bridge.onCall('profiler:update', function (profilingIsSupported) {
	      if (_this.profilingIsSupported !== profilingIsSupported) {
	        _this.profilingIsSupported = profilingIsSupported;
	        refresh();
	      }
	    });
	  }
	
	  _createClass(ProfilerPlugin, [{
	    key: 'panes',
	    value: function panes() {
	      return [];
	    }
	  }, {
	    key: 'teardown',
	    value: function teardown() {}
	  }, {
	    key: 'tabs',
	    value: function tabs() {
	      var _this2 = this;
	
	      if (!this.profilingIsSupported) {
	        return null;
	      }
	
	      return {
	        Profiler: function Profiler() {
	          return React.createElement(
	            StoreWrapper,
	            { store: _this2.profilerStore },
	            function () {
	              return React.createElement(ProfilerTab, null);
	            }
	          );
	        }
	      };
	    }
	  }]);
	
	  return ProfilerPlugin;
	}();
	
	module.exports = ProfilerPlugin;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	
	module.exports = function (name) {
	  var Wrapper = function (_React$Component) {
	    _inherits(Wrapper, _React$Component);
	
	    function Wrapper() {
	      _classCallCheck(this, Wrapper);
	
	      return _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).apply(this, arguments));
	    }
	
	    _createClass(Wrapper, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        return _defineProperty({}, name, this.props.store);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return this.props.children();
	      }
	    }]);
	
	    return Wrapper;
	  }(React.Component);
	
	  Wrapper.childContextTypes = _defineProperty({}, name, PropTypes.object);
	  Wrapper.displayName = 'StoreProvider(' + name + ')';
	  return Wrapper;
	};

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(315),
	    List = _require.List;
	
	var _require2 = __webpack_require__(326),
	    EventEmitter = _require2.EventEmitter;
	
	var _require3 = __webpack_require__(330),
	    get = _require3.get,
	    set = _require3.set;
	
	var LRU = __webpack_require__(347);
	
	var LOCAL_STORAGE_COMMIT_THRESHOLD = 'profiler:commitThreshold';
	var LOCAL_STORAGE_HIDE_COMMITS_BELOW_THRESHOLD = 'profiler:hideCommitsBelowThreshold';
	var LOCAL_STORAGE_SHOW_NATIVE_NODES_KEY = 'profiler:showNativeNodes';
	
	var ProfilerStore = function (_EventEmitter) {
	  _inherits(ProfilerStore, _EventEmitter);
	
	  // Evict items from the cache after this number
	  function ProfilerStore(bridge, mainStore) {
	    _classCallCheck(this, ProfilerStore);
	
	    var _this = _possibleConstructorReturn(this, (ProfilerStore.__proto__ || Object.getPrototypeOf(ProfilerStore)).call(this));
	
	    _this.cachedData = LRU(50);
	    _this.commitThreshold = get(LOCAL_STORAGE_COMMIT_THRESHOLD, 0);
	    _this.hideCommitsBelowThreshold = get(LOCAL_STORAGE_HIDE_COMMITS_BELOW_THRESHOLD, false);
	    _this.isRecording = false;
	    _this.isSettingsPanelActive = false;
	    _this.processedInteractions = {};
	    _this.rootsToProfilerData = new Map();
	    _this.roots = new List();
	    _this.selectedChartType = 'flamegraph';
	    _this.selectedRoot = null;
	    _this.showNativeNodes = get(LOCAL_STORAGE_SHOW_NATIVE_NODES_KEY, false);
	
	    _this.clearSnapshots = function () {
	      _this.cachedData.reset();
	      _this.processedInteractions = {};
	      _this.rootsToProfilerData = new Map();
	      _this.emit('profilerData', _this.rootsToProfilerData);
	    };
	
	    _this.saveRoots = function () {
	      _this.roots = _this._mainStore.roots;
	      _this.emit('roots', _this._mainStore.roots);
	    };
	
	    _this.setCommitThrehsold = function (commitThreshold) {
	      _this.commitThreshold = commitThreshold;
	      _this.emit('commitThreshold', commitThreshold);
	      set(LOCAL_STORAGE_COMMIT_THRESHOLD, commitThreshold);
	    };
	
	    _this.storeSnapshot = function () {
	      _this._mainStore.snapshotQueue.forEach(function (snapshot) {
	        var root = snapshot.root;
	
	        if (!_this.rootsToProfilerData.has(root)) {
	          _this.rootsToProfilerData.set(root, {
	            interactionsToSnapshots: new Map(),
	            snapshots: [],
	            timestampsToInteractions: new Map()
	          });
	        }
	
	        var _ref = _this.rootsToProfilerData.get(root),
	            interactionsToSnapshots = _ref.interactionsToSnapshots,
	            snapshots = _ref.snapshots,
	            timestampsToInteractions = _ref.timestampsToInteractions;
	
	        snapshots.push(snapshot);
	
	        // Restore Interaction instance equality between commits,
	        // Since this will be lost due to Bridge serialization.
	        snapshot.memoizedInteractions = snapshot.memoizedInteractions.map(function (interaction) {
	          return _this.processInteraction(interaction);
	        });
	
	        snapshot.memoizedInteractions.forEach(function (interaction) {
	          if (interactionsToSnapshots.has(interaction)) {
	            interactionsToSnapshots.get(interaction).add(snapshot);
	          } else {
	            interactionsToSnapshots.set(interaction, new Set([snapshot]));
	          }
	
	          if (timestampsToInteractions.has(interaction.timestamp)) {
	            timestampsToInteractions.get(interaction.timestamp).add(interaction);
	          } else {
	            timestampsToInteractions.set(interaction.timestamp, new Set([interaction]));
	          }
	        });
	      });
	
	      // Clear the queue once we've processed it.
	      _this._mainStore.snapshotQueue.length = 0;
	
	      _this.emit('profilerData', _this.rootsToProfilerData);
	    };
	
	    _this.updateSelected = function () {
	      var currentID = _this._mainStore.selected;
	
	      while (true) {
	        var parentID = _this._mainStore.getParent(currentID);
	        if (parentID != null) {
	          currentID = parentID;
	        } else {
	          break;
	        }
	      }
	
	      _this.selectedRoot = currentID;
	      _this.emit('selectedRoot', _this.selectedRoot);
	    };
	
	    _this._bridge = bridge;
	    _this._mainStore = mainStore;
	    _this._mainStore.on('clearSnapshots', _this.clearSnapshots);
	    _this._mainStore.on('roots', _this.saveRoots);
	    _this._mainStore.on('selected', _this.updateSelected);
	    _this._mainStore.on('storeSnapshot', _this.storeSnapshot);
	    return _this;
	  }
	
	  _createClass(ProfilerStore, [{
	    key: 'off',
	    value: function off() {
	      // Noop
	    }
	  }, {
	    key: 'cacheDataForSnapshot',
	    value: function cacheDataForSnapshot(snapshotIndex, snapshotRootID, key, data) {
	      this.cachedData.set(snapshotIndex + '-' + snapshotRootID + '-' + key, data);
	    }
	  }, {
	    key: 'cacheInteractionData',
	    value: function cacheInteractionData(rootID, data) {
	      this.cachedData.set(rootID + '-interactions', data);
	    }
	  }, {
	    key: 'getCachedDataForSnapshot',
	    value: function getCachedDataForSnapshot(snapshotIndex, snapshotRootID, key) {
	      return this.cachedData.get(snapshotIndex + '-' + snapshotRootID + '-' + key) || null;
	    }
	  }, {
	    key: 'getCachedInteractionData',
	    value: function getCachedInteractionData(rootID) {
	      return this.cachedData.get(rootID + '-interactions') || null;
	    }
	  }, {
	    key: 'processInteraction',
	    value: function processInteraction(interaction) {
	      var key = interaction.name + ' at ' + interaction.timestamp;
	      if (this.processedInteractions.hasOwnProperty(key)) {
	        return this.processedInteractions[key];
	      } else {
	        this.processedInteractions[key] = interaction;
	        return interaction;
	      }
	    }
	  }, {
	    key: 'setHideCommitsBelowThreshold',
	    value: function setHideCommitsBelowThreshold(hideCommitsBelowThreshold) {
	      this.hideCommitsBelowThreshold = hideCommitsBelowThreshold;
	      this.emit('hideCommitsBelowThreshold', hideCommitsBelowThreshold);
	      set(LOCAL_STORAGE_HIDE_COMMITS_BELOW_THRESHOLD, hideCommitsBelowThreshold);
	    }
	  }, {
	    key: 'setIsRecording',
	    value: function setIsRecording(isRecording) {
	      this.isRecording = isRecording;
	      this.emit('isRecording', isRecording);
	      this._mainStore.setIsRecording(isRecording);
	    }
	  }, {
	    key: 'setIsSettingsPanelActive',
	    value: function setIsSettingsPanelActive(isSettingsPanelActive) {
	      this.isSettingsPanelActive = isSettingsPanelActive;
	      this.emit('isSettingsPanelActive', isSettingsPanelActive);
	    }
	  }, {
	    key: 'setSelectedChartType',
	    value: function setSelectedChartType(selectedChartType) {
	      this.selectedChartType = selectedChartType;
	      this.emit('selectedChartType', selectedChartType);
	    }
	  }, {
	    key: 'setShowNativeNodes',
	    value: function setShowNativeNodes(showNativeNodes) {
	      this.showNativeNodes = showNativeNodes;
	      this.emit('showNativeNodes', showNativeNodes);
	      set(LOCAL_STORAGE_SHOW_NATIVE_NODES_KEY, showNativeNodes);
	    }
	  }]);
	
	  return ProfilerStore;
	}(EventEmitter);
	
	module.exports = ProfilerStore;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = LRUCache
	
	// This will be a proper iterable 'Map' in engines that support it,
	// or a fakey-fake PseudoMap in older versions.
	var Map = __webpack_require__(348)
	var util = __webpack_require__(350)
	
	// A linked list to keep track of recently-used-ness
	var Yallist = __webpack_require__(351)
	
	// use symbols if possible, otherwise just _props
	var hasSymbol = typeof Symbol === 'function'
	var makeSymbol
	if (hasSymbol) {
	  makeSymbol = function (key) {
	    return Symbol(key)
	  }
	} else {
	  makeSymbol = function (key) {
	    return '_' + key
	  }
	}
	
	var MAX = makeSymbol('max')
	var LENGTH = makeSymbol('length')
	var LENGTH_CALCULATOR = makeSymbol('lengthCalculator')
	var ALLOW_STALE = makeSymbol('allowStale')
	var MAX_AGE = makeSymbol('maxAge')
	var DISPOSE = makeSymbol('dispose')
	var NO_DISPOSE_ON_SET = makeSymbol('noDisposeOnSet')
	var LRU_LIST = makeSymbol('lruList')
	var CACHE = makeSymbol('cache')
	
	function naiveLength () { return 1 }
	
	// lruList is a yallist where the head is the youngest
	// item, and the tail is the oldest.  the list contains the Hit
	// objects as the entries.
	// Each Hit object has a reference to its Yallist.Node.  This
	// never changes.
	//
	// cache is a Map (or PseudoMap) that matches the keys to
	// the Yallist.Node object.
	function LRUCache (options) {
	  if (!(this instanceof LRUCache)) {
	    return new LRUCache(options)
	  }
	
	  if (typeof options === 'number') {
	    options = { max: options }
	  }
	
	  if (!options) {
	    options = {}
	  }
	
	  var max = this[MAX] = options.max
	  // Kind of weird to have a default max of Infinity, but oh well.
	  if (!max ||
	      !(typeof max === 'number') ||
	      max <= 0) {
	    this[MAX] = Infinity
	  }
	
	  var lc = options.length || naiveLength
	  if (typeof lc !== 'function') {
	    lc = naiveLength
	  }
	  this[LENGTH_CALCULATOR] = lc
	
	  this[ALLOW_STALE] = options.stale || false
	  this[MAX_AGE] = options.maxAge || 0
	  this[DISPOSE] = options.dispose
	  this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false
	  this.reset()
	}
	
	// resize the cache when the max changes.
	Object.defineProperty(LRUCache.prototype, 'max', {
	  set: function (mL) {
	    if (!mL || !(typeof mL === 'number') || mL <= 0) {
	      mL = Infinity
	    }
	    this[MAX] = mL
	    trim(this)
	  },
	  get: function () {
	    return this[MAX]
	  },
	  enumerable: true
	})
	
	Object.defineProperty(LRUCache.prototype, 'allowStale', {
	  set: function (allowStale) {
	    this[ALLOW_STALE] = !!allowStale
	  },
	  get: function () {
	    return this[ALLOW_STALE]
	  },
	  enumerable: true
	})
	
	Object.defineProperty(LRUCache.prototype, 'maxAge', {
	  set: function (mA) {
	    if (!mA || !(typeof mA === 'number') || mA < 0) {
	      mA = 0
	    }
	    this[MAX_AGE] = mA
	    trim(this)
	  },
	  get: function () {
	    return this[MAX_AGE]
	  },
	  enumerable: true
	})
	
	// resize the cache when the lengthCalculator changes.
	Object.defineProperty(LRUCache.prototype, 'lengthCalculator', {
	  set: function (lC) {
	    if (typeof lC !== 'function') {
	      lC = naiveLength
	    }
	    if (lC !== this[LENGTH_CALCULATOR]) {
	      this[LENGTH_CALCULATOR] = lC
	      this[LENGTH] = 0
	      this[LRU_LIST].forEach(function (hit) {
	        hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key)
	        this[LENGTH] += hit.length
	      }, this)
	    }
	    trim(this)
	  },
	  get: function () { return this[LENGTH_CALCULATOR] },
	  enumerable: true
	})
	
	Object.defineProperty(LRUCache.prototype, 'length', {
	  get: function () { return this[LENGTH] },
	  enumerable: true
	})
	
	Object.defineProperty(LRUCache.prototype, 'itemCount', {
	  get: function () { return this[LRU_LIST].length },
	  enumerable: true
	})
	
	LRUCache.prototype.rforEach = function (fn, thisp) {
	  thisp = thisp || this
	  for (var walker = this[LRU_LIST].tail; walker !== null;) {
	    var prev = walker.prev
	    forEachStep(this, fn, walker, thisp)
	    walker = prev
	  }
	}
	
	function forEachStep (self, fn, node, thisp) {
	  var hit = node.value
	  if (isStale(self, hit)) {
	    del(self, node)
	    if (!self[ALLOW_STALE]) {
	      hit = undefined
	    }
	  }
	  if (hit) {
	    fn.call(thisp, hit.value, hit.key, self)
	  }
	}
	
	LRUCache.prototype.forEach = function (fn, thisp) {
	  thisp = thisp || this
	  for (var walker = this[LRU_LIST].head; walker !== null;) {
	    var next = walker.next
	    forEachStep(this, fn, walker, thisp)
	    walker = next
	  }
	}
	
	LRUCache.prototype.keys = function () {
	  return this[LRU_LIST].toArray().map(function (k) {
	    return k.key
	  }, this)
	}
	
	LRUCache.prototype.values = function () {
	  return this[LRU_LIST].toArray().map(function (k) {
	    return k.value
	  }, this)
	}
	
	LRUCache.prototype.reset = function () {
	  if (this[DISPOSE] &&
	      this[LRU_LIST] &&
	      this[LRU_LIST].length) {
	    this[LRU_LIST].forEach(function (hit) {
	      this[DISPOSE](hit.key, hit.value)
	    }, this)
	  }
	
	  this[CACHE] = new Map() // hash of items by key
	  this[LRU_LIST] = new Yallist() // list of items in order of use recency
	  this[LENGTH] = 0 // length of items in the list
	}
	
	LRUCache.prototype.dump = function () {
	  return this[LRU_LIST].map(function (hit) {
	    if (!isStale(this, hit)) {
	      return {
	        k: hit.key,
	        v: hit.value,
	        e: hit.now + (hit.maxAge || 0)
	      }
	    }
	  }, this).toArray().filter(function (h) {
	    return h
	  })
	}
	
	LRUCache.prototype.dumpLru = function () {
	  return this[LRU_LIST]
	}
	
	LRUCache.prototype.inspect = function (n, opts) {
	  var str = 'LRUCache {'
	  var extras = false
	
	  var as = this[ALLOW_STALE]
	  if (as) {
	    str += '\n  allowStale: true'
	    extras = true
	  }
	
	  var max = this[MAX]
	  if (max && max !== Infinity) {
	    if (extras) {
	      str += ','
	    }
	    str += '\n  max: ' + util.inspect(max, opts)
	    extras = true
	  }
	
	  var maxAge = this[MAX_AGE]
	  if (maxAge) {
	    if (extras) {
	      str += ','
	    }
	    str += '\n  maxAge: ' + util.inspect(maxAge, opts)
	    extras = true
	  }
	
	  var lc = this[LENGTH_CALCULATOR]
	  if (lc && lc !== naiveLength) {
	    if (extras) {
	      str += ','
	    }
	    str += '\n  length: ' + util.inspect(this[LENGTH], opts)
	    extras = true
	  }
	
	  var didFirst = false
	  this[LRU_LIST].forEach(function (item) {
	    if (didFirst) {
	      str += ',\n  '
	    } else {
	      if (extras) {
	        str += ',\n'
	      }
	      didFirst = true
	      str += '\n  '
	    }
	    var key = util.inspect(item.key).split('\n').join('\n  ')
	    var val = { value: item.value }
	    if (item.maxAge !== maxAge) {
	      val.maxAge = item.maxAge
	    }
	    if (lc !== naiveLength) {
	      val.length = item.length
	    }
	    if (isStale(this, item)) {
	      val.stale = true
	    }
	
	    val = util.inspect(val, opts).split('\n').join('\n  ')
	    str += key + ' => ' + val
	  })
	
	  if (didFirst || extras) {
	    str += '\n'
	  }
	  str += '}'
	
	  return str
	}
	
	LRUCache.prototype.set = function (key, value, maxAge) {
	  maxAge = maxAge || this[MAX_AGE]
	
	  var now = maxAge ? Date.now() : 0
	  var len = this[LENGTH_CALCULATOR](value, key)
	
	  if (this[CACHE].has(key)) {
	    if (len > this[MAX]) {
	      del(this, this[CACHE].get(key))
	      return false
	    }
	
	    var node = this[CACHE].get(key)
	    var item = node.value
	
	    // dispose of the old one before overwriting
	    // split out into 2 ifs for better coverage tracking
	    if (this[DISPOSE]) {
	      if (!this[NO_DISPOSE_ON_SET]) {
	        this[DISPOSE](key, item.value)
	      }
	    }
	
	    item.now = now
	    item.maxAge = maxAge
	    item.value = value
	    this[LENGTH] += len - item.length
	    item.length = len
	    this.get(key)
	    trim(this)
	    return true
	  }
	
	  var hit = new Entry(key, value, len, now, maxAge)
	
	  // oversized objects fall out of cache automatically.
	  if (hit.length > this[MAX]) {
	    if (this[DISPOSE]) {
	      this[DISPOSE](key, value)
	    }
	    return false
	  }
	
	  this[LENGTH] += hit.length
	  this[LRU_LIST].unshift(hit)
	  this[CACHE].set(key, this[LRU_LIST].head)
	  trim(this)
	  return true
	}
	
	LRUCache.prototype.has = function (key) {
	  if (!this[CACHE].has(key)) return false
	  var hit = this[CACHE].get(key).value
	  if (isStale(this, hit)) {
	    return false
	  }
	  return true
	}
	
	LRUCache.prototype.get = function (key) {
	  return get(this, key, true)
	}
	
	LRUCache.prototype.peek = function (key) {
	  return get(this, key, false)
	}
	
	LRUCache.prototype.pop = function () {
	  var node = this[LRU_LIST].tail
	  if (!node) return null
	  del(this, node)
	  return node.value
	}
	
	LRUCache.prototype.del = function (key) {
	  del(this, this[CACHE].get(key))
	}
	
	LRUCache.prototype.load = function (arr) {
	  // reset the cache
	  this.reset()
	
	  var now = Date.now()
	  // A previous serialized cache has the most recent items first
	  for (var l = arr.length - 1; l >= 0; l--) {
	    var hit = arr[l]
	    var expiresAt = hit.e || 0
	    if (expiresAt === 0) {
	      // the item was created without expiration in a non aged cache
	      this.set(hit.k, hit.v)
	    } else {
	      var maxAge = expiresAt - now
	      // dont add already expired items
	      if (maxAge > 0) {
	        this.set(hit.k, hit.v, maxAge)
	      }
	    }
	  }
	}
	
	LRUCache.prototype.prune = function () {
	  var self = this
	  this[CACHE].forEach(function (value, key) {
	    get(self, key, false)
	  })
	}
	
	function get (self, key, doUse) {
	  var node = self[CACHE].get(key)
	  if (node) {
	    var hit = node.value
	    if (isStale(self, hit)) {
	      del(self, node)
	      if (!self[ALLOW_STALE]) hit = undefined
	    } else {
	      if (doUse) {
	        self[LRU_LIST].unshiftNode(node)
	      }
	    }
	    if (hit) hit = hit.value
	  }
	  return hit
	}
	
	function isStale (self, hit) {
	  if (!hit || (!hit.maxAge && !self[MAX_AGE])) {
	    return false
	  }
	  var stale = false
	  var diff = Date.now() - hit.now
	  if (hit.maxAge) {
	    stale = diff > hit.maxAge
	  } else {
	    stale = self[MAX_AGE] && (diff > self[MAX_AGE])
	  }
	  return stale
	}
	
	function trim (self) {
	  if (self[LENGTH] > self[MAX]) {
	    for (var walker = self[LRU_LIST].tail;
	         self[LENGTH] > self[MAX] && walker !== null;) {
	      // We know that we're about to delete this one, and also
	      // what the next least recently used key will be, so just
	      // go ahead and set it now.
	      var prev = walker.prev
	      del(self, walker)
	      walker = prev
	    }
	  }
	}
	
	function del (self, node) {
	  if (node) {
	    var hit = node.value
	    if (self[DISPOSE]) {
	      self[DISPOSE](hit.key, hit.value)
	    }
	    self[LENGTH] -= hit.length
	    self[CACHE].delete(hit.key)
	    self[LRU_LIST].removeNode(node)
	  }
	}
	
	// classy, since V8 prefers predictable objects.
	function Entry (key, value, length, now, maxAge) {
	  this.key = key
	  this.value = value
	  this.length = length
	  this.now = now
	  this.maxAge = maxAge || 0
	}


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	if (process.env.npm_package_name === 'pseudomap' &&
	    process.env.npm_lifecycle_script === 'test')
	  process.env.TEST_PSEUDOMAP = 'true'
	
	if (typeof Map === 'function' && !process.env.TEST_PSEUDOMAP) {
	  module.exports = Map
	} else {
	  module.exports = __webpack_require__(349)
	}


/***/ },
/* 349 */
/***/ function(module, exports) {

	var hasOwnProperty = Object.prototype.hasOwnProperty
	
	module.exports = PseudoMap
	
	function PseudoMap (set) {
	  if (!(this instanceof PseudoMap)) // whyyyyyyy
	    throw new TypeError("Constructor PseudoMap requires 'new'")
	
	  this.clear()
	
	  if (set) {
	    if ((set instanceof PseudoMap) ||
	        (typeof Map === 'function' && set instanceof Map))
	      set.forEach(function (value, key) {
	        this.set(key, value)
	      }, this)
	    else if (Array.isArray(set))
	      set.forEach(function (kv) {
	        this.set(kv[0], kv[1])
	      }, this)
	    else
	      throw new TypeError('invalid argument')
	  }
	}
	
	PseudoMap.prototype.forEach = function (fn, thisp) {
	  thisp = thisp || this
	  Object.keys(this._data).forEach(function (k) {
	    if (k !== 'size')
	      fn.call(thisp, this._data[k].value, this._data[k].key)
	  }, this)
	}
	
	PseudoMap.prototype.has = function (k) {
	  return !!find(this._data, k)
	}
	
	PseudoMap.prototype.get = function (k) {
	  var res = find(this._data, k)
	  return res && res.value
	}
	
	PseudoMap.prototype.set = function (k, v) {
	  set(this._data, k, v)
	}
	
	PseudoMap.prototype.delete = function (k) {
	  var res = find(this._data, k)
	  if (res) {
	    delete this._data[res._index]
	    this._data.size--
	  }
	}
	
	PseudoMap.prototype.clear = function () {
	  var data = Object.create(null)
	  data.size = 0
	
	  Object.defineProperty(this, '_data', {
	    value: data,
	    enumerable: false,
	    configurable: true,
	    writable: false
	  })
	}
	
	Object.defineProperty(PseudoMap.prototype, 'size', {
	  get: function () {
	    return this._data.size
	  },
	  set: function (n) {},
	  enumerable: true,
	  configurable: true
	})
	
	PseudoMap.prototype.values =
	PseudoMap.prototype.keys =
	PseudoMap.prototype.entries = function () {
	  throw new Error('iterators are not implemented in this version')
	}
	
	// Either identical, or both NaN
	function same (a, b) {
	  return a === b || a !== a && b !== b
	}
	
	function Entry (k, v, i) {
	  this.key = k
	  this.value = v
	  this._index = i
	}
	
	function find (data, k) {
	  for (var i = 0, s = '_' + k, key = s;
	       hasOwnProperty.call(data, key);
	       key = s + i++) {
	    if (same(data[key].key, k))
	      return data[key]
	  }
	}
	
	function set (data, k, v) {
	  for (var i = 0, s = '_' + k, key = s;
	       hasOwnProperty.call(data, key);
	       key = s + i++) {
	    if (same(data[key].key, k)) {
	      data[key].value = v
	      return
	    }
	  }
	  data.size++
	  data[key] = new Entry(k, v, key)
	}


/***/ },
/* 350 */
/***/ function(module, exports) {

	module.exports = require("util");

/***/ },
/* 351 */
/***/ function(module, exports) {

	module.exports = Yallist
	
	Yallist.Node = Node
	Yallist.create = Yallist
	
	function Yallist (list) {
	  var self = this
	  if (!(self instanceof Yallist)) {
	    self = new Yallist()
	  }
	
	  self.tail = null
	  self.head = null
	  self.length = 0
	
	  if (list && typeof list.forEach === 'function') {
	    list.forEach(function (item) {
	      self.push(item)
	    })
	  } else if (arguments.length > 0) {
	    for (var i = 0, l = arguments.length; i < l; i++) {
	      self.push(arguments[i])
	    }
	  }
	
	  return self
	}
	
	Yallist.prototype.removeNode = function (node) {
	  if (node.list !== this) {
	    throw new Error('removing node which does not belong to this list')
	  }
	
	  var next = node.next
	  var prev = node.prev
	
	  if (next) {
	    next.prev = prev
	  }
	
	  if (prev) {
	    prev.next = next
	  }
	
	  if (node === this.head) {
	    this.head = next
	  }
	  if (node === this.tail) {
	    this.tail = prev
	  }
	
	  node.list.length--
	  node.next = null
	  node.prev = null
	  node.list = null
	}
	
	Yallist.prototype.unshiftNode = function (node) {
	  if (node === this.head) {
	    return
	  }
	
	  if (node.list) {
	    node.list.removeNode(node)
	  }
	
	  var head = this.head
	  node.list = this
	  node.next = head
	  if (head) {
	    head.prev = node
	  }
	
	  this.head = node
	  if (!this.tail) {
	    this.tail = node
	  }
	  this.length++
	}
	
	Yallist.prototype.pushNode = function (node) {
	  if (node === this.tail) {
	    return
	  }
	
	  if (node.list) {
	    node.list.removeNode(node)
	  }
	
	  var tail = this.tail
	  node.list = this
	  node.prev = tail
	  if (tail) {
	    tail.next = node
	  }
	
	  this.tail = node
	  if (!this.head) {
	    this.head = node
	  }
	  this.length++
	}
	
	Yallist.prototype.push = function () {
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    push(this, arguments[i])
	  }
	  return this.length
	}
	
	Yallist.prototype.unshift = function () {
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    unshift(this, arguments[i])
	  }
	  return this.length
	}
	
	Yallist.prototype.pop = function () {
	  if (!this.tail) {
	    return undefined
	  }
	
	  var res = this.tail.value
	  this.tail = this.tail.prev
	  if (this.tail) {
	    this.tail.next = null
	  } else {
	    this.head = null
	  }
	  this.length--
	  return res
	}
	
	Yallist.prototype.shift = function () {
	  if (!this.head) {
	    return undefined
	  }
	
	  var res = this.head.value
	  this.head = this.head.next
	  if (this.head) {
	    this.head.prev = null
	  } else {
	    this.tail = null
	  }
	  this.length--
	  return res
	}
	
	Yallist.prototype.forEach = function (fn, thisp) {
	  thisp = thisp || this
	  for (var walker = this.head, i = 0; walker !== null; i++) {
	    fn.call(thisp, walker.value, i, this)
	    walker = walker.next
	  }
	}
	
	Yallist.prototype.forEachReverse = function (fn, thisp) {
	  thisp = thisp || this
	  for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
	    fn.call(thisp, walker.value, i, this)
	    walker = walker.prev
	  }
	}
	
	Yallist.prototype.get = function (n) {
	  for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
	    // abort out of the list early if we hit a cycle
	    walker = walker.next
	  }
	  if (i === n && walker !== null) {
	    return walker.value
	  }
	}
	
	Yallist.prototype.getReverse = function (n) {
	  for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
	    // abort out of the list early if we hit a cycle
	    walker = walker.prev
	  }
	  if (i === n && walker !== null) {
	    return walker.value
	  }
	}
	
	Yallist.prototype.map = function (fn, thisp) {
	  thisp = thisp || this
	  var res = new Yallist()
	  for (var walker = this.head; walker !== null;) {
	    res.push(fn.call(thisp, walker.value, this))
	    walker = walker.next
	  }
	  return res
	}
	
	Yallist.prototype.mapReverse = function (fn, thisp) {
	  thisp = thisp || this
	  var res = new Yallist()
	  for (var walker = this.tail; walker !== null;) {
	    res.push(fn.call(thisp, walker.value, this))
	    walker = walker.prev
	  }
	  return res
	}
	
	Yallist.prototype.reduce = function (fn, initial) {
	  var acc
	  var walker = this.head
	  if (arguments.length > 1) {
	    acc = initial
	  } else if (this.head) {
	    walker = this.head.next
	    acc = this.head.value
	  } else {
	    throw new TypeError('Reduce of empty list with no initial value')
	  }
	
	  for (var i = 0; walker !== null; i++) {
	    acc = fn(acc, walker.value, i)
	    walker = walker.next
	  }
	
	  return acc
	}
	
	Yallist.prototype.reduceReverse = function (fn, initial) {
	  var acc
	  var walker = this.tail
	  if (arguments.length > 1) {
	    acc = initial
	  } else if (this.tail) {
	    walker = this.tail.prev
	    acc = this.tail.value
	  } else {
	    throw new TypeError('Reduce of empty list with no initial value')
	  }
	
	  for (var i = this.length - 1; walker !== null; i--) {
	    acc = fn(acc, walker.value, i)
	    walker = walker.prev
	  }
	
	  return acc
	}
	
	Yallist.prototype.toArray = function () {
	  var arr = new Array(this.length)
	  for (var i = 0, walker = this.head; walker !== null; i++) {
	    arr[i] = walker.value
	    walker = walker.next
	  }
	  return arr
	}
	
	Yallist.prototype.toArrayReverse = function () {
	  var arr = new Array(this.length)
	  for (var i = 0, walker = this.tail; walker !== null; i++) {
	    arr[i] = walker.value
	    walker = walker.prev
	  }
	  return arr
	}
	
	Yallist.prototype.slice = function (from, to) {
	  to = to || this.length
	  if (to < 0) {
	    to += this.length
	  }
	  from = from || 0
	  if (from < 0) {
	    from += this.length
	  }
	  var ret = new Yallist()
	  if (to < from || to < 0) {
	    return ret
	  }
	  if (from < 0) {
	    from = 0
	  }
	  if (to > this.length) {
	    to = this.length
	  }
	  for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
	    walker = walker.next
	  }
	  for (; walker !== null && i < to; i++, walker = walker.next) {
	    ret.push(walker.value)
	  }
	  return ret
	}
	
	Yallist.prototype.sliceReverse = function (from, to) {
	  to = to || this.length
	  if (to < 0) {
	    to += this.length
	  }
	  from = from || 0
	  if (from < 0) {
	    from += this.length
	  }
	  var ret = new Yallist()
	  if (to < from || to < 0) {
	    return ret
	  }
	  if (from < 0) {
	    from = 0
	  }
	  if (to > this.length) {
	    to = this.length
	  }
	  for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
	    walker = walker.prev
	  }
	  for (; walker !== null && i > from; i--, walker = walker.prev) {
	    ret.push(walker.value)
	  }
	  return ret
	}
	
	Yallist.prototype.reverse = function () {
	  var head = this.head
	  var tail = this.tail
	  for (var walker = head; walker !== null; walker = walker.prev) {
	    var p = walker.prev
	    walker.prev = walker.next
	    walker.next = p
	  }
	  this.head = tail
	  this.tail = head
	  return this
	}
	
	function push (self, item) {
	  self.tail = new Node(item, self.tail, null, self)
	  if (!self.head) {
	    self.head = self.tail
	  }
	  self.length++
	}
	
	function unshift (self, item) {
	  self.head = new Node(item, null, self.head, self)
	  if (!self.tail) {
	    self.tail = self.head
	  }
	  self.length++
	}
	
	function Node (value, prev, next, list) {
	  if (!(this instanceof Node)) {
	    return new Node(value, prev, next, list)
	  }
	
	  this.list = list
	  this.value = value
	
	  if (prev) {
	    prev.next = this
	    this.prev = prev
	  } else {
	    this.prev = null
	  }
	
	  if (next) {
	    next.prev = this
	    this.next = next
	  } else {
	    this.next = null
	  }
	}


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _decorate = __webpack_require__(20);
	
	var _decorate2 = _interopRequireDefault(_decorate);
	
	var _Fonts = __webpack_require__(17);
	
	var _constants = __webpack_require__(353);
	
	var _FiberRenderDurations = __webpack_require__(355);
	
	var _FiberRenderDurations2 = _interopRequireDefault(_FiberRenderDurations);
	
	var _InteractionTimeline = __webpack_require__(360);
	
	var _InteractionTimeline2 = _interopRequireDefault(_InteractionTimeline);
	
	var _NoProfilingDataMessage = __webpack_require__(362);
	
	var _NoProfilingDataMessage2 = _interopRequireDefault(_NoProfilingDataMessage);
	
	var _SnapshotFlamegraph = __webpack_require__(363);
	
	var _SnapshotFlamegraph2 = _interopRequireDefault(_SnapshotFlamegraph);
	
	var _SnapshotRanked = __webpack_require__(365);
	
	var _SnapshotRanked2 = _interopRequireDefault(_SnapshotRanked);
	
	var _ProfilerTabToolbar = __webpack_require__(366);
	
	var _ProfilerTabToolbar2 = _interopRequireDefault(_ProfilerTabToolbar);
	
	var _ProfilerFiberDetailPane = __webpack_require__(369);
	
	var _ProfilerFiberDetailPane2 = _interopRequireDefault(_ProfilerFiberDetailPane);
	
	var _ProfilerSnapshotDetailPane = __webpack_require__(370);
	
	var _ProfilerSnapshotDetailPane2 = _interopRequireDefault(_ProfilerSnapshotDetailPane);
	
	var _ProfilerInteractionDetailPane = __webpack_require__(371);
	
	var _ProfilerInteractionDetailPane2 = _interopRequireDefault(_ProfilerInteractionDetailPane);
	
	var _ProfilerSettings = __webpack_require__(372);
	
	var _ProfilerSettings2 = _interopRequireDefault(_ProfilerSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfilerTab = function (_React$Component) {
	  _inherits(ProfilerTab, _React$Component);
	
	  function ProfilerTab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ProfilerTab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProfilerTab.__proto__ || Object.getPrototypeOf(ProfilerTab)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isInspectingSelectedFiber: false,
	      prevIsRecording: _this.props.isRecording,
	      prevSelectedChartType: _this.props.selectedChartType,
	      prevShowNativeNodes: _this.props.showNativeNodes,
	      selectedFiberID: null,
	      selectedFiberName: null,
	      selectedInteraction: null,
	      snapshotIndex: 0
	    }, _this.deselectFiber = function () {
	      return _this.setState({
	        selectedFiberID: null,
	        selectedFiberName: null
	      });
	    }, _this.handleSnapshotSliderChange = function (event) {
	      return _this.setState({ snapshotIndex: parseInt(event.currentTarget.value, 10) });
	    }, _this.inspectFiber = function (id, name) {
	      return _this.setState({
	        isInspectingSelectedFiber: true,
	        selectedFiberID: id,
	        selectedFiberName: name
	      });
	    }, _this.selectFiber = function (id, name) {
	      return _this.setState({
	        selectedFiberID: id,
	        selectedFiberName: name
	      });
	    }, _this.selectInteraction = function (interaction) {
	      return _this.setState({
	        selectedInteraction: interaction
	      });
	    }, _this.selectSnapshot = function (snapshot) {
	      return _this.setState({
	        snapshotIndex: _this.props.snapshots.indexOf(snapshot)
	      });
	    }, _this.stopInspecting = function () {
	      return _this.setState({ isInspectingSelectedFiber: false });
	    }, _this.toggleInspectingSelectedFiber = function () {
	      return _this.setState(function (state) {
	        return {
	          isInspectingSelectedFiber: !state.isInspectingSelectedFiber
	        };
	      });
	    }, _this.viewInteraction = function (interaction) {
	      return _this.setState({
	        selectedInteraction: interaction
	      }, function () {
	        return _this.props.setSelectedChartType('interactions');
	      });
	    }, _this.viewSnapshot = function (snapshot) {
	      return _this.setState({
	        isInspectingSelectedFiber: false,
	        selectedFiberID: null,
	        selectedFiberName: null,
	        snapshotIndex: _this.props.snapshots.indexOf(snapshot)
	      }, function () {
	        return _this.props.setSelectedChartType('flamegraph');
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ProfilerTab, [{
	    key: 'render',
	    value: function render() {
	      var theme = this.context.theme;
	      var _props = this.props,
	          cacheDataForSnapshot = _props.cacheDataForSnapshot,
	          cacheInteractionData = _props.cacheInteractionData,
	          commitThreshold = _props.commitThreshold,
	          getCachedDataForSnapshot = _props.getCachedDataForSnapshot,
	          getCachedInteractionData = _props.getCachedInteractionData,
	          hasMultipleRoots = _props.hasMultipleRoots,
	          hideCommitsBelowThreshold = _props.hideCommitsBelowThreshold,
	          interactionsToSnapshots = _props.interactionsToSnapshots,
	          isRecording = _props.isRecording,
	          profilerData = _props.profilerData,
	          selectedChartType = _props.selectedChartType,
	          selectedRootID = _props.selectedRootID,
	          showNativeNodes = _props.showNativeNodes,
	          snapshots = _props.snapshots,
	          timestampsToInteractions = _props.timestampsToInteractions,
	          toggleIsRecording = _props.toggleIsRecording,
	          toggleIsSettingsPanelActive = _props.toggleIsSettingsPanelActive;
	      var _state = this.state,
	          isInspectingSelectedFiber = _state.isInspectingSelectedFiber,
	          selectedFiberID = _state.selectedFiberID,
	          selectedFiberName = _state.selectedFiberName,
	          selectedInteraction = _state.selectedInteraction,
	          snapshotIndex = _state.snapshotIndex;
	
	
	      var snapshot = snapshots[snapshotIndex];
	      var snapshotFiber = selectedFiberID && snapshot.nodes.get(selectedFiberID) || null;
	      var maxDuration = (0, _constants.getMaxDuration)(snapshots);
	
	      var content = void 0;
	      if (isRecording) {
	        content = _react2.default.createElement(RecordingInProgress, { theme: theme, stopRecording: toggleIsRecording });
	      } else if (selectedRootID === null || profilerData === null) {
	        // Edge case where keyboard up/down arrows change selected root in the Elements tab.
	        // This is a bug that should be fixed separately from the Profiler plug-in.
	        content = _react2.default.createElement(_NoProfilingDataMessage2.default, {
	          hasMultipleRoots: hasMultipleRoots,
	          startRecording: toggleIsRecording,
	          theme: theme
	        });
	      } else if (snapshots.length > 0) {
	        if (isInspectingSelectedFiber && selectedFiberID !== null) {
	          content = _react2.default.createElement(_FiberRenderDurations2.default, {
	            commitThreshold: commitThreshold,
	            hideCommitsBelowThreshold: hideCommitsBelowThreshold,
	            selectedFiberID: selectedFiberID,
	            selectedSnapshot: snapshot,
	            selectSnapshot: this.selectSnapshot,
	            snapshotIndex: snapshotIndex,
	            snapshots: snapshots,
	            stopInspecting: this.stopInspecting,
	            theme: theme
	          });
	        } else if (selectedChartType === 'interactions') {
	          content = _react2.default.createElement(_InteractionTimeline2.default, {
	            cacheInteractionData: cacheInteractionData,
	            getCachedInteractionData: getCachedInteractionData,
	            hasMultipleRoots: hasMultipleRoots,
	            interactionsToSnapshots: interactionsToSnapshots,
	            maxDuration: maxDuration,
	            selectedInteraction: selectedInteraction,
	            selectedSnapshot: snapshot,
	            selectInteraction: this.selectInteraction,
	            theme: theme,
	            timestampsToInteractions: timestampsToInteractions
	          });
	        } else {
	          var ChartComponent = selectedChartType === 'ranked' ? _SnapshotRanked2.default : _SnapshotFlamegraph2.default;
	
	          content = _react2.default.createElement(ChartComponent, {
	            cacheDataForSnapshot: cacheDataForSnapshot,
	            deselectFiber: this.deselectFiber,
	            getCachedDataForSnapshot: getCachedDataForSnapshot,
	            inspectFiber: this.inspectFiber,
	            selectedFiberID: selectedFiberID,
	            selectFiber: this.selectFiber,
	            showNativeNodes: showNativeNodes,
	            snapshot: snapshot,
	            snapshotIndex: snapshotIndex,
	            theme: theme
	          });
	        }
	      } else {
	        content = _react2.default.createElement(_NoProfilingDataMessage2.default, {
	          hasMultipleRoots: hasMultipleRoots,
	          startRecording: toggleIsRecording,
	          theme: theme
	        });
	      }
	
	      var details = void 0;
	      if (isRecording || selectedRootID === null || profilerData === null) {
	        // Edge case where keyboard up/down arrows change selected root in the Elements tab.
	        // This is a bug that should be fixed separately from the Profiler plug-in.
	        details = _react2.default.createElement(DetailsNoData, { theme: theme });
	      } else if ((selectedChartType === 'flamegraph' || selectedChartType === 'ranked') && selectedFiberName === null) {
	        details = _react2.default.createElement(_ProfilerSnapshotDetailPane2.default, {
	          selectedInteraction: selectedInteraction,
	          snapshot: snapshot,
	          theme: theme,
	          viewInteraction: this.viewInteraction
	        });
	      } else if (selectedChartType === 'interactions' && selectedInteraction !== null) {
	        details = _react2.default.createElement(_ProfilerInteractionDetailPane2.default, {
	          interaction: selectedInteraction,
	          maxDuration: (0, _constants.getMaxDuration)(snapshots),
	          selectedSnapshot: snapshot,
	          snapshots: interactionsToSnapshots.get(selectedInteraction),
	          theme: theme,
	          viewSnapshot: this.viewSnapshot
	        });
	      } else if (selectedChartType !== 'interactions' && selectedFiberName !== null) {
	        details = _react2.default.createElement(_ProfilerFiberDetailPane2.default, {
	          deselectFiber: this.deselectFiber,
	          isInspectingSelectedFiber: isInspectingSelectedFiber,
	          name: selectedFiberName,
	          snapshot: snapshot,
	          snapshotFiber: snapshotFiber,
	          toggleInspectingSelectedFiber: this.toggleInspectingSelectedFiber,
	          theme: theme
	        });
	      } else {
	        details = _react2.default.createElement(DetailsNoData, { theme: theme });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: {
	            width: '100%',
	            flex: 1,
	            display: 'flex',
	            alignItems: 'stretch',
	            justifyContent: 'stretch',
	            flexDirection: 'row',
	            color: theme.base05,
	            fontFamily: _Fonts.sansSerif.family,
	            fontSize: _Fonts.sansSerif.sizes.normal
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: {
	              flex: '1 1 200px',
	              display: 'flex',
	              flexDirection: 'column'
	            } },
	          _react2.default.createElement(
	            'div',
	            { style: {
	                position: 'relative',
	                backgroundColor: theme.base01,
	                borderBottom: '1px solid ' + theme.base03
	              } },
	            _react2.default.createElement(_ProfilerTabToolbar2.default, {
	              commitThreshold: commitThreshold,
	              hideCommitsBelowThreshold: hideCommitsBelowThreshold,
	              interactionsCount: interactionsToSnapshots.size,
	              isInspectingSelectedFiber: isInspectingSelectedFiber,
	              isRecording: isRecording,
	              selectChart: this.props.setSelectedChartType,
	              selectedChartType: selectedChartType,
	              selectedFiberID: selectedFiberID,
	              selectedSnapshot: snapshot,
	              selectSnapshot: this.selectSnapshot,
	              snapshotIndex: snapshotIndex,
	              snapshots: snapshots,
	              theme: theme,
	              toggleIsRecording: toggleIsRecording,
	              toggleIsSettingsPanelActive: toggleIsSettingsPanelActive
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: {
	                flex: 1,
	                padding: '0.5rem',
	                boxSizing: 'border-box',
	                position: 'relative'
	              } },
	            content,
	            _react2.default.createElement(_ProfilerSettings2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: {
	              flex: '1 1 100px',
	              maxWidth: '300px',
	              display: 'flex',
	              flexDirection: 'column',
	              alignItems: 'stretch',
	              justifyContent: 'stretch',
	              borderLeft: '1px solid ' + theme.base03,
	              boxSizing: 'border-box'
	            } },
	          details
	        )
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(props, state) {
	      if (props.isRecording !== state.prevIsRecording) {
	        return {
	          isInspectingSelectedFiber: false,
	          prevIsRecording: props.isRecording,
	          selectedFiberID: null,
	          selectedFiberName: null,
	          selectedInteraction: null,
	          snapshotIndex: 0
	        };
	      }
	      if (props.selectedChartType !== state.prevSelectedChartType) {
	        return {
	          isInspectingSelectedFiber: false,
	          prevSelectedChartType: props.selectedChartType,
	          selectedFiberID: null,
	          selectedFiberName: null
	        };
	      }
	      if (props.showNativeNodes !== state.prevShowNativeNodes) {
	        return {
	          isInspectingSelectedFiber: false,
	          prevShowNativeNodes: props.showNativeNodes,
	          selectedFiberID: null,
	          selectedFiberName: null
	        };
	      }
	      return null;
	    }
	
	    // We store the ID and name separately,
	    // Because a Fiber may not exist in all snapshots.
	    // In that case, it's still important to show the selected fiber (name) in the details pane.
	
	  }]);
	
	  return ProfilerTab;
	}(_react2.default.Component);
	
	ProfilerTab.contextTypes = {
	  theme: _propTypes2.default.object.isRequired
	};
	
	
	var DetailsNoData = function DetailsNoData(_ref2) {
	  var theme = _ref2.theme;
	  return _react2.default.createElement(
	    'div',
	    { style: {
	        color: theme.base04,
	        fontSize: _Fonts.sansSerif.sizes.large,
	        height: '100%',
	        flex: 1,
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center',
	        padding: '0.25rem'
	      } },
	    'Nothing selected'
	  );
	};
	
	var RecordingInProgress = function RecordingInProgress(_ref3) {
	  var stopRecording = _ref3.stopRecording,
	      theme = _ref3.theme;
	  return _react2.default.createElement(
	    'span',
	    { style: {
	        height: '100%',
	        flex: 1,
	        display: 'flex',
	        flexDirection: 'column',
	        alignItems: 'center',
	        justifyContent: 'center'
	      } },
	    'Recording profiling data...',
	    _react2.default.createElement(
	      'button',
	      {
	        onClick: stopRecording,
	        style: {
	          display: 'flex',
	          background: theme.state00,
	          border: 'none',
	          outline: 'none',
	          cursor: 'pointer',
	          color: theme.base00,
	          padding: '.5rem 0.75rem',
	          marginTop: '0.5rem'
	        },
	        title: 'Stop recording'
	      },
	      'Stop'
	    )
	  );
	};
	
	exports.default = (0, _decorate2.default)({
	  store: 'profilerStore',
	  listeners: function listeners() {
	    return ['commitThreshold', 'hideCommitsBelowThreshold', 'isRecording', 'profilerData', 'selectedChartType', 'selectedRoot', 'showNativeNodes'];
	  },
	  props: function props(store) {
	    var profilerData = store.rootsToProfilerData.has(store.selectedRoot) ? store.rootsToProfilerData.get(store.selectedRoot) : null;
	
	    return {
	      cacheDataForSnapshot: function cacheDataForSnapshot() {
	        return store.cacheDataForSnapshot.apply(store, arguments);
	      },
	      cacheInteractionData: function cacheInteractionData() {
	        return store.cacheInteractionData.apply(store, arguments);
	      },
	      getCachedDataForSnapshot: function getCachedDataForSnapshot() {
	        return store.getCachedDataForSnapshot.apply(store, arguments);
	      },
	      getCachedInteractionData: function getCachedInteractionData() {
	        return store.getCachedInteractionData.apply(store, arguments);
	      },
	      commitThreshold: store.commitThreshold,
	      hasMultipleRoots: store.roots.size > 1,
	      hideCommitsBelowThreshold: store.hideCommitsBelowThreshold,
	      interactionsToSnapshots: profilerData !== null ? profilerData.interactionsToSnapshots : new Map(),
	      isRecording: !!store.isRecording,
	      profilerData: profilerData,
	      selectedChartType: store.selectedChartType,
	      setSelectedChartType: function setSelectedChartType(chartType) {
	        return store.setSelectedChartType(chartType);
	      },
	      showNativeNodes: store.showNativeNodes,
	      snapshots: profilerData !== null ? profilerData.snapshots : [],
	      timestampsToInteractions: profilerData !== null ? profilerData.timestampsToInteractions : new Map(),
	      toggleIsRecording: function toggleIsRecording() {
	        return store.setIsRecording(!store.isRecording);
	      },
	      toggleIsSettingsPanelActive: function toggleIsSettingsPanelActive() {
	        return store.setIsSettingsPanelActive(!store.isSettingsPanelActive);
	      }
	    };
	  }
	}, ProfilerTab);

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateSelfDuration = exports.getFilteredSnapshotData = exports.getMaxDuration = exports.formatTime = exports.formatPercentage = exports.formatDuration = exports.getGradientColor = exports.scale = exports.textHeight = exports.minBarWidth = exports.minBarHeight = exports.barWidthThreshold = exports.barWidth = exports.barHeight = exports.didNotRender = exports.gradient = undefined;
	
	var _memoizeOne = __webpack_require__(354);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://gka.github.io/palettes/#colors=#37AFA9,#FEBC38|steps=10|bez=0|coL=0
	var gradient = exports.gradient = ['#37afa9', '#63b19e', '#80b393', '#97b488', '#abb67d', '#beb771', '#cfb965', '#dfba57', '#efbb49', '#febc38'];
	
	var didNotRender = exports.didNotRender = '#ddd';
	
	var barHeight = exports.barHeight = 20;
	var barWidth = exports.barWidth = 100;
	var barWidthThreshold = exports.barWidthThreshold = 2;
	var minBarHeight = exports.minBarHeight = 5;
	var minBarWidth = exports.minBarWidth = 5;
	var textHeight = exports.textHeight = 18;
	
	var scale = exports.scale = function scale(minValue, maxValue, minRange, maxRange) {
	  return function (value, fallbackValue) {
	    return maxValue - minValue === 0 ? fallbackValue : (value - minValue) / (maxValue - minValue) * (maxRange - minRange);
	  };
	};
	
	var gradientMaxIndex = gradient.length - 1;
	var getGradientColor = exports.getGradientColor = function getGradientColor(value) {
	  var index = void 0;
	  // Guard against commits with duration 0
	  if (Number.isNaN(value)) {
	    index = 0;
	  } else if (!Number.isFinite(value)) {
	    index = gradient.length - 1;
	  } else {
	    index = Math.max(0, Math.min(gradientMaxIndex, value)) * gradientMaxIndex;
	  }
	  return gradient[Math.round(index)];
	};
	
	var formatDuration = exports.formatDuration = function formatDuration(duration) {
	  return Math.round(duration * 10) / 10;
	};
	var formatPercentage = exports.formatPercentage = function formatPercentage(percentage) {
	  return Math.round(percentage * 100);
	};
	var formatTime = exports.formatTime = function formatTime(timestamp) {
	  return Math.round(Math.round(timestamp) / 100) / 10;
	};
	
	var getMaxDuration = exports.getMaxDuration = function getMaxDuration(snapshots) {
	  return snapshots.reduce(function (maxDuration, snapshot) {
	    return Math.max(maxDuration, snapshot.duration || 0);
	  }, 0);
	};
	
	/**
	 * Helper method to filter snapshots based on the current store state.
	 * This is a helper util so that its calculations are memoized and shared between multiple components.
	 */
	var getFilteredSnapshotData = exports.getFilteredSnapshotData = (0, _memoizeOne2.default)(function (commitThreshold, hideCommitsBelowThreshold, isInspectingSelectedFiber, selectedFiberID, selectedSnapshot, snapshotIndex, snapshots) {
	  var filteredSnapshots = snapshots;
	  if (isInspectingSelectedFiber) {
	    filteredSnapshots = filteredSnapshots.filter(function (snapshot) {
	      return snapshot.committedNodes.includes(selectedFiberID);
	    });
	  }
	  if (hideCommitsBelowThreshold) {
	    filteredSnapshots = filteredSnapshots.filter(function (snapshot) {
	      return snapshot.duration >= commitThreshold;
	    });
	  }
	
	  var filteredSnapshotIndex = filteredSnapshots.indexOf(selectedSnapshot);
	
	  return {
	    snapshotIndex: filteredSnapshotIndex,
	    snapshots: filteredSnapshots
	  };
	});
	
	var calculateSelfDuration = exports.calculateSelfDuration = function calculateSelfDuration(snapshot, nodeID) {
	  var nodes = snapshot.nodes;
	
	  var node = nodes.get(nodeID);
	  var actualDuration = node.get('actualDuration');
	
	  var selfDuration = actualDuration;
	
	  var children = node.get('children');
	  if (Array.isArray(children)) {
	    children.forEach(function (childID) {
	      var childActualDuration = nodes.getIn([childID, 'actualDuration']);
	      if (childActualDuration > 0) {
	        selfDuration -= childActualDuration;
	      }
	    });
	  }
	
	  return selfDuration;
	};

/***/ },
/* 354 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (resultFn) {
	  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;
	
	  var lastThis = void 0;
	  var lastArgs = [];
	  var lastResult = void 0;
	  var calledOnce = false;
	
	  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
	    return isEqual(newArg, lastArgs[index]);
	  };
	
	  var result = function result() {
	    for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
	      newArgs[_key] = arguments[_key];
	    }
	
	    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
	      return lastResult;
	    }
	
	    calledOnce = true;
	    lastThis = this;
	    lastArgs = newArgs;
	    lastResult = resultFn.apply(this, newArgs);
	    return lastResult;
	  };
	
	  return result;
	};
	
	var simpleIsEqual = function simpleIsEqual(a, b) {
	  return a === b;
	};

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _memoizeOne = __webpack_require__(354);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualizedAutoSizer = __webpack_require__(356);
	
	var _reactVirtualizedAutoSizer2 = _interopRequireDefault(_reactVirtualizedAutoSizer);
	
	var _reactWindow = __webpack_require__(357);
	
	var _ChartNode = __webpack_require__(358);
	
	var _ChartNode2 = _interopRequireDefault(_ChartNode);
	
	var _constants = __webpack_require__(353);
	
	var _NoRenderTimesMessage = __webpack_require__(359);
	
	var _NoRenderTimesMessage2 = _interopRequireDefault(_NoRenderTimesMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (_ref) {
	  var commitThreshold = _ref.commitThreshold,
	      hideCommitsBelowThreshold = _ref.hideCommitsBelowThreshold,
	      selectedFiberID = _ref.selectedFiberID,
	      selectedSnapshot = _ref.selectedSnapshot,
	      selectSnapshot = _ref.selectSnapshot,
	      snapshotIndex = _ref.snapshotIndex,
	      snapshots = _ref.snapshots,
	      stopInspecting = _ref.stopInspecting,
	      theme = _ref.theme;
	
	  var filteredData = (0, _constants.getFilteredSnapshotData)(commitThreshold, hideCommitsBelowThreshold, true, // If we're viewing this component
	  selectedFiberID, selectedSnapshot, snapshotIndex, snapshots);
	
	  return _react2.default.createElement(
	    _reactVirtualizedAutoSizer2.default,
	    null,
	    function (_ref2) {
	      var height = _ref2.height,
	          width = _ref2.width;
	      return _react2.default.createElement(RenderDurations, {
	        commitThreshold: commitThreshold,
	        height: height,
	        hideCommitsBelowThreshold: hideCommitsBelowThreshold,
	        selectedFiberID: selectedFiberID,
	        selectedSnapshot: selectedSnapshot,
	        selectSnapshot: selectSnapshot,
	        snapshots: filteredData.snapshots,
	        stopInspecting: stopInspecting,
	        theme: theme,
	        width: width
	      });
	    }
	  );
	};
	
	var RenderDurations = function RenderDurations(_ref3) {
	  var commitThreshold = _ref3.commitThreshold,
	      height = _ref3.height,
	      hideCommitsBelowThreshold = _ref3.hideCommitsBelowThreshold,
	      selectedFiberID = _ref3.selectedFiberID,
	      selectedSnapshot = _ref3.selectedSnapshot,
	      selectSnapshot = _ref3.selectSnapshot,
	      snapshots = _ref3.snapshots,
	      stopInspecting = _ref3.stopInspecting,
	      theme = _ref3.theme,
	      width = _ref3.width;
	
	  // getChartData() is memoized so it's okay to call them on every render.
	  var chartData = getChartData(selectedFiberID, snapshots, width);
	
	  var itemSize = chartData.itemSize,
	      maxValue = chartData.maxValue,
	      nodes = chartData.nodes;
	
	
	  if (maxValue === 0) {
	    return _react2.default.createElement(_NoRenderTimesMessage2.default, {
	      commitThreshold: commitThreshold,
	      height: height,
	      hideCommitsBelowThreshold: hideCommitsBelowThreshold,
	      stopInspecting: stopInspecting,
	      width: width
	    });
	  }
	
	  // Pass required contextual data down to the ListItem renderer.
	  // getItemData() is memoized so it's okay to call them on every render.
	  var itemData = getItemData(height, maxValue, nodes, selectedSnapshot, selectSnapshot, stopInspecting, theme);
	
	  return _react2.default.createElement(
	    _reactWindow.FixedSizeList,
	    {
	      direction: 'horizontal',
	      height: height,
	      innerTagName: 'svg',
	      itemCount: nodes.length,
	      itemData: itemData,
	      itemSize: itemSize,
	      width: width
	    },
	    ListItem
	  );
	};
	
	var ListItem = function (_PureComponent) {
	  _inherits(ListItem, _PureComponent);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }
	
	  _createClass(ListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          index = _props.index,
	          style = _props.style;
	
	      var itemData = this.props.data;
	
	      var height = itemData.height,
	          nodes = itemData.nodes,
	          scaleY = itemData.scaleY,
	          selectedSnapshot = itemData.selectedSnapshot,
	          selectSnapshot = itemData.selectSnapshot,
	          stopInspecting = itemData.stopInspecting,
	          theme = itemData.theme;
	
	
	      var node = nodes[index];
	      var safeHeight = Math.max(_constants.minBarHeight, scaleY(node.value, _constants.minBarHeight));
	
	      // List items are absolutely positioned using the CSS "left" attribute.
	      // The "top" value will always be 0.
	      // Since the height is based on the node's duration, we can ignore it also.
	      var left = parseInt(style.left, 10);
	      var width = parseInt(style.width, 10);
	
	      return _react2.default.createElement(_ChartNode2.default, {
	        color: (0, _constants.getGradientColor)(node.maxCommitValue === 0 ? 0 : node.value / node.maxCommitValue),
	        height: safeHeight,
	        isDimmed: node.parentSnapshot === selectedSnapshot,
	        key: index,
	        label: node.value.toFixed(1) + 'ms',
	        onClick: function onClick() {
	          return selectSnapshot(node.parentSnapshot);
	        },
	        onDoubleClick: stopInspecting,
	        theme: theme,
	        title: node.value.toFixed(3) + 'ms',
	        width: width,
	        x: left,
	        y: height - safeHeight
	      });
	    }
	  }]);
	
	  return ListItem;
	}(_react.PureComponent);
	
	var getChartData = (0, _memoizeOne2.default)(function (nodeID, snapshots, width) {
	  var maxValue = 0;
	
	  var nodes = snapshots.filter(function (snapshot) {
	    return snapshot.committedNodes.indexOf(nodeID) >= 0;
	  }).map(function (snapshot) {
	    // Filter out Text nodes; they won't have durations.
	    var maxCommitValue = snapshot.committedNodes.reduce(function (reduced, currentNodeID) {
	      return Math.max(reduced, snapshot.nodes.getIn([currentNodeID, 'actualDuration']) || 0);
	    }, 0);
	    var value = snapshot.nodes.getIn([nodeID, 'actualDuration']);
	
	    maxValue = Math.max(maxValue, value);
	
	    return { maxCommitValue: maxCommitValue, parentSnapshot: snapshot, value: value };
	  });
	
	  var itemSize = Math.max(_constants.minBarWidth, width / nodes.length);
	
	  return {
	    itemSize: itemSize,
	    maxValue: maxValue,
	    nodes: nodes
	  };
	});
	
	var getItemData = (0, _memoizeOne2.default)(function (height, maxValue, nodes, selectedSnapshot, selectSnapshot, stopInspecting, theme) {
	  return {
	    height: height,
	    nodes: nodes,
	    scaleY: (0, _constants.scale)(0, maxValue, 0, height),
	    selectedSnapshot: selectedSnapshot,
	    selectSnapshot: selectSnapshot,
	    stopInspecting: stopInspecting,
	    theme: theme
	  };
	});

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	
	/**
	 * Detect Element Resize.
	 * https://github.com/sdecima/javascript-detect-element-resize
	 * Sebastian Decima
	 *
	 * Forked from version 0.5.3; includes the following modifications:
	 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
	 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
	 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
	 * 4) Add nonce for style element.
	 **/
	
	function createDetectElementResize(nonce) {
	  // Check `document` and `window` in case of server-side rendering
	  var _window;
	  if (typeof window !== 'undefined') {
	    _window = window;
	  } else if (typeof self !== 'undefined') {
	    _window = self;
	  } else {
	    _window = global;
	  }
	
	  var attachEvent = typeof document !== 'undefined' && document.attachEvent;
	
	  if (!attachEvent) {
	    var requestFrame = function () {
	      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	        return _window.setTimeout(fn, 20);
	      };
	      return function (fn) {
	        return raf(fn);
	      };
	    }();
	
	    var cancelFrame = function () {
	      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	      return function (id) {
	        return cancel(id);
	      };
	    }();
	
	    var resetTriggers = function resetTriggers(element) {
	      var triggers = element.__resizeTriggers__,
	          expand = triggers.firstElementChild,
	          contract = triggers.lastElementChild,
	          expandChild = expand.firstElementChild;
	      contract.scrollLeft = contract.scrollWidth;
	      contract.scrollTop = contract.scrollHeight;
	      expandChild.style.width = expand.offsetWidth + 1 + 'px';
	      expandChild.style.height = expand.offsetHeight + 1 + 'px';
	      expand.scrollLeft = expand.scrollWidth;
	      expand.scrollTop = expand.scrollHeight;
	    };
	
	    var checkTriggers = function checkTriggers(element) {
	      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	    };
	
	    var scrollListener = function scrollListener(e) {
	      // Don't measure (which forces) reflow for scrolls that happen inside of children!
	      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
	        return;
	      }
	
	      var element = this;
	      resetTriggers(this);
	      if (this.__resizeRAF__) {
	        cancelFrame(this.__resizeRAF__);
	      }
	      this.__resizeRAF__ = requestFrame(function () {
	        if (checkTriggers(element)) {
	          element.__resizeLast__.width = element.offsetWidth;
	          element.__resizeLast__.height = element.offsetHeight;
	          element.__resizeListeners__.forEach(function (fn) {
	            fn.call(element, e);
	          });
	        }
	      });
	    };
	
	    /* Detect CSS Animations support to detect element display/re-attach */
	    var animation = false,
	        keyframeprefix = '',
	        animationstartevent = 'animationstart',
	        domPrefixes = 'Webkit Moz O ms'.split(' '),
	        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	        pfx = '';
	    {
	      var elm = document.createElement('fakeelement');
	      if (elm.style.animationName !== undefined) {
	        animation = true;
	      }
	
	      if (animation === false) {
	        for (var i = 0; i < domPrefixes.length; i++) {
	          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	            pfx = domPrefixes[i];
	            keyframeprefix = '-' + pfx.toLowerCase() + '-';
	            animationstartevent = startEvents[i];
	            animation = true;
	            break;
	          }
	        }
	      }
	    }
	
	    var animationName = 'resizeanim';
	    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	  }
	
	  var createStyles = function createStyles(doc) {
	    if (!doc.getElementById('detectElementResize')) {
	      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	          head = doc.head || doc.getElementsByTagName('head')[0],
	          style = doc.createElement('style');
	
	      style.id = 'detectElementResize';
	      style.type = 'text/css';
	
	      if (nonce != null) {
	        style.setAttribute('nonce', nonce);
	      }
	
	      if (style.styleSheet) {
	        style.styleSheet.cssText = css;
	      } else {
	        style.appendChild(doc.createTextNode(css));
	      }
	
	      head.appendChild(style);
	    }
	  };
	
	  var addResizeListener = function addResizeListener(element, fn) {
	    if (attachEvent) {
	      element.attachEvent('onresize', fn);
	    } else {
	      if (!element.__resizeTriggers__) {
	        var doc = element.ownerDocument;
	        var elementStyle = _window.getComputedStyle(element);
	        if (elementStyle && elementStyle.position == 'static') {
	          element.style.position = 'relative';
	        }
	        createStyles(doc);
	        element.__resizeLast__ = {};
	        element.__resizeListeners__ = [];
	        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
	        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	        element.appendChild(element.__resizeTriggers__);
	        resetTriggers(element);
	        element.addEventListener('scroll', scrollListener, true);
	
	        /* Listen for a css animation to detect element display/re-attach */
	        if (animationstartevent) {
	          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
	            if (e.animationName == animationName) {
	              resetTriggers(element);
	            }
	          };
	          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	        }
	      }
	      element.__resizeListeners__.push(fn);
	    }
	  };
	
	  var removeResizeListener = function removeResizeListener(element, fn) {
	    if (attachEvent) {
	      element.detachEvent('onresize', fn);
	    } else {
	      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	      if (!element.__resizeListeners__.length) {
	        element.removeEventListener('scroll', scrollListener, true);
	        if (element.__resizeTriggers__.__animationListener__) {
	          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	          element.__resizeTriggers__.__animationListener__ = null;
	        }
	        try {
	          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	        } catch (e) {
	          // Preact compat; see developit/preact-compat/issues/228
	        }
	      }
	    }
	  };
	
	  return {
	    addResizeListener: addResizeListener,
	    removeResizeListener: removeResizeListener
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var AutoSizer = function (_React$PureComponent) {
	  inherits(AutoSizer, _React$PureComponent);
	
	  function AutoSizer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, AutoSizer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: _this.props.defaultHeight || 0,
	      width: _this.props.defaultWidth || 0
	    }, _this._onResize = function () {
	      var _this$props = _this.props,
	          disableHeight = _this$props.disableHeight,
	          disableWidth = _this$props.disableWidth,
	          onResize = _this$props.onResize;
	
	
	      if (_this._parentNode) {
	        // Guard against AutoSizer component being removed from the DOM immediately after being added.
	        // This can result in invalid style values which can result in NaN values if we don't handle them.
	        // See issue #150 for more context.
	
	        var _height = _this._parentNode.offsetHeight || 0;
	        var _width = _this._parentNode.offsetWidth || 0;
	
	        var _style = window.getComputedStyle(_this._parentNode) || {};
	        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
	        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
	        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
	        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;
	
	        var newHeight = _height - paddingTop - paddingBottom;
	        var newWidth = _width - paddingLeft - paddingRight;
	
	        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
	          _this.setState({
	            height: _height - paddingTop - paddingBottom,
	            width: _width - paddingLeft - paddingRight
	          });
	
	          onResize({ height: _height, width: _width });
	        }
	      }
	    }, _this._setRef = function (autoSizer) {
	      _this._autoSizer = autoSizer;
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(AutoSizer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var nonce = this.props.nonce;
	
	      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
	        // Delay access of parentNode until mount.
	        // This handles edge-cases where the component has already been unmounted before its ref has been set,
	        // As well as libraries like react-lite which have a slightly different lifecycle.
	        this._parentNode = this._autoSizer.parentNode;
	
	        // Defer requiring resize handler in order to support server-side rendering.
	        // See issue #41
	        this._detectElementResize = createDetectElementResize(nonce);
	        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
	
	        this._onResize();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._detectElementResize && this._parentNode) {
	        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          disableHeight = _props.disableHeight,
	          disableWidth = _props.disableWidth,
	          style = _props.style;
	      var _state = this.state,
	          height = _state.height,
	          width = _state.width;
	
	      // Outer div should not force width/height since that may prevent containers from shrinking.
	      // Inner component should overflow and use calculated width/height.
	      // See issue #68 for more information.
	
	      var outerStyle = { overflow: 'visible' };
	      var childParams = {};
	
	      // Avoid rendering children before the initial measurements have been collected.
	      // At best this would just be wasting cycles.
	      var bailoutOnChildren = false;
	
	      if (!disableHeight) {
	        if (height === 0) {
	          bailoutOnChildren = true;
	        }
	        outerStyle.height = 0;
	        childParams.height = height;
	      }
	
	      if (!disableWidth) {
	        if (width === 0) {
	          bailoutOnChildren = true;
	        }
	        outerStyle.width = 0;
	        childParams.width = width;
	      }
	
	      return React.createElement(
	        'div',
	        {
	          className: className,
	          ref: this._setRef,
	          style: _extends({}, outerStyle, style) },
	        !bailoutOnChildren && children(childParams)
	      );
	    }
	  }]);
	  return AutoSizer;
	}(React.PureComponent);
	
	AutoSizer.defaultProps = {
	  onResize: function onResize() {},
	  disableHeight: false,
	  disableWidth: false,
	  style: {}
	};
	
	module.exports = AutoSizer;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoizeOne = _interopDefault(__webpack_require__(354));
	var react = __webpack_require__(11);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
	
	var defaultItemKey = function defaultItemKey(_ref) {
	  var columnIndex = _ref.columnIndex,
	      rowIndex = _ref.rowIndex;
	  return rowIndex + ':' + columnIndex;
	};
	
	function createGridComponent(_ref2) {
	  var _class, _temp;
	
	  var getColumnOffset = _ref2.getColumnOffset,
	      getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset,
	      getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex,
	      getColumnWidth = _ref2.getColumnWidth,
	      getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight,
	      getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth,
	      getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment,
	      getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment,
	      getRowHeight = _ref2.getRowHeight,
	      getRowOffset = _ref2.getRowOffset,
	      getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset,
	      getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex,
	      initInstanceProps = _ref2.initInstanceProps,
	      shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange,
	      validateProps = _ref2.validateProps;
	
	  return _temp = _class = function (_PureComponent) {
	    inherits(Grid, _PureComponent);
	
	    // Always use explicit constructor for React components.
	    // It produces less code after transpilation. (#26)
	    // eslint-disable-next-line no-useless-constructor
	    function Grid(props) {
	      classCallCheck(this, Grid);
	
	      var _this = possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	      _this._instanceProps = initInstanceProps(_this.props, _this);
	      _this._resetIsScrollingTimeoutId = null;
	      _this.state = {
	        isScrolling: false,
	        horizontalScrollDirection: 'forward',
	        scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
	        scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
	        scrollUpdateWasRequested: false,
	        verticalScrollDirection: 'forward'
	      };
	      _this._callOnItemsRendered = memoizeOne(function (overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
	        return _this.props.onItemsRendered({
	          overscanColumnStartIndex: overscanColumnStartIndex,
	          overscanColumnStopIndex: overscanColumnStopIndex,
	          overscanRowStartIndex: overscanRowStartIndex,
	          overscanRowStopIndex: overscanRowStopIndex,
	          visibleColumnStartIndex: visibleColumnStartIndex,
	          visibleColumnStopIndex: visibleColumnStopIndex,
	          visibleRowStartIndex: visibleRowStartIndex,
	          visibleRowStopIndex: visibleRowStopIndex
	        });
	      });
	      _this._callOnScroll = memoizeOne(function (scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
	        return _this.props.onScroll({
	          horizontalScrollDirection: horizontalScrollDirection,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          verticalScrollDirection: verticalScrollDirection,
	          scrollUpdateWasRequested: scrollUpdateWasRequested
	        });
	      });
	
	      _this._getItemStyle = function (rowIndex, columnIndex) {
	        var key = rowIndex + ':' + columnIndex;
	
	        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && _this.props.columnWidth, shouldResetStyleCacheOnItemSizeChange && _this.props.rowHeight);
	
	        var style = void 0;
	        if (itemStyleCache.hasOwnProperty(key)) {
	          style = itemStyleCache[key];
	        } else {
	          itemStyleCache[key] = style = {
	            position: 'absolute',
	            left: getColumnOffset(_this.props, columnIndex, _this._instanceProps),
	            top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
	            height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
	            width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
	          };
	        }
	
	        return style;
	      };
	
	      _this._getItemStyleCache = memoizeOne(function (_, __) {
	        return {};
	      });
	
	      _this._onScroll = function (event) {
	        var _event$currentTarget = event.currentTarget,
	            scrollLeft = _event$currentTarget.scrollLeft,
	            scrollTop = _event$currentTarget.scrollTop;
	
	        _this.setState(function (prevState) {
	          if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
	            // Scroll position may have been updated by cDM/cDU,
	            // In which case we don't need to trigger another render,
	            // And we don't want to update state.isScrolling.
	            return null;
	          }
	
	          return {
	            isScrolling: true,
	            horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
	            scrollUpdateWasRequested: false
	          };
	        }, _this._resetIsScrollingDebounced);
	      };
	
	      _this._outerRefSetter = function (ref) {
	        var outerRef = _this.props.outerRef;
	
	
	        _this._outerRef = ref;
	
	        if (typeof outerRef === 'function') {
	          outerRef(ref);
	        } else if (outerRef != null && (typeof outerRef === 'undefined' ? 'undefined' : _typeof(outerRef)) === 'object' && outerRef.hasOwnProperty('current')) {
	          outerRef.current = ref;
	        }
	      };
	
	      _this._resetIsScrollingDebounced = function () {
	        if (_this._resetIsScrollingTimeoutId !== null) {
	          clearTimeout(_this._resetIsScrollingTimeoutId);
	        }
	
	        _this._resetIsScrollingTimeoutId = setTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL);
	      };
	
	      _this._resetIsScrollingDebounced = function () {
	        if (_this._resetIsScrollingTimeoutId !== null) {
	          clearTimeout(_this._resetIsScrollingTimeoutId);
	        }
	
	        _this._resetIsScrollingTimeoutId = setTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL);
	      };
	
	      _this._resetIsScrolling = function () {
	        _this._resetIsScrollingTimeoutId = null;
	
	        _this.setState({ isScrolling: false }, function () {
	          // Clear style cache after state update has been committed.
	          // This way we don't break pure sCU for items that don't use isScrolling param.
	          _this._getItemStyleCache(-1);
	        });
	      };
	
	      return _this;
	    }
	
	    Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	      validateSharedProps(nextProps);
	      validateProps(nextProps);
	      return null;
	    };
	
	    Grid.prototype.scrollTo = function scrollTo(_ref3) {
	      var scrollLeft = _ref3.scrollLeft,
	          scrollTop = _ref3.scrollTop;
	
	      this.setState(function (prevState) {
	        return {
	          horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          scrollUpdateWasRequested: true,
	          verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
	        };
	      }, this._resetIsScrollingDebounced);
	    };
	
	    Grid.prototype.scrollToItem = function scrollToItem(_ref4) {
	      var _ref4$align = _ref4.align,
	          align = _ref4$align === undefined ? 'auto' : _ref4$align,
	          columnIndex = _ref4.columnIndex,
	          rowIndex = _ref4.rowIndex;
	      var _state = this.state,
	          scrollLeft = _state.scrollLeft,
	          scrollTop = _state.scrollTop;
	
	
	      this.scrollTo({
	        scrollLeft: getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps),
	        scrollTop: getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps)
	      });
	    };
	
	    Grid.prototype.componentDidMount = function componentDidMount() {
	      var _props = this.props,
	          initialScrollLeft = _props.initialScrollLeft,
	          initialScrollTop = _props.initialScrollTop;
	
	      if (typeof initialScrollLeft === 'number' && this._outerRef != null) {
	        this._outerRef.scrollLeft = initialScrollLeft;
	      }
	      if (typeof initialScrollTop === 'number' && this._outerRef != null) {
	        this._outerRef.scrollTop = initialScrollTop;
	      }
	
	      this._callPropsCallbacks();
	    };
	
	    Grid.prototype.componentDidUpdate = function componentDidUpdate() {
	      var _state2 = this.state,
	          scrollLeft = _state2.scrollLeft,
	          scrollTop = _state2.scrollTop,
	          scrollUpdateWasRequested = _state2.scrollUpdateWasRequested;
	
	      if (scrollUpdateWasRequested && this._outerRef !== null) {
	        this._outerRef.scrollLeft = scrollLeft;
	        this._outerRef.scrollTop = scrollTop;
	      }
	
	      this._callPropsCallbacks();
	    };
	
	    Grid.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this._resetIsScrollingTimeoutId !== null) {
	        clearTimeout(this._resetIsScrollingTimeoutId);
	      }
	    };
	
	    Grid.prototype.render = function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          columnCount = _props2.columnCount,
	          height = _props2.height,
	          innerRef = _props2.innerRef,
	          innerTagName = _props2.innerTagName,
	          itemData = _props2.itemData,
	          _props2$itemKey = _props2.itemKey,
	          itemKey = _props2$itemKey === undefined ? defaultItemKey : _props2$itemKey,
	          outerTagName = _props2.outerTagName,
	          rowCount = _props2.rowCount,
	          style = _props2.style,
	          useIsScrolling = _props2.useIsScrolling,
	          width = _props2.width;
	      var isScrolling = this.state.isScrolling;
	
	      var _getHorizontalRangeTo = this._getHorizontalRangeToRender(),
	          columnStartIndex = _getHorizontalRangeTo[0],
	          columnStopIndex = _getHorizontalRangeTo[1];
	
	      var _getVerticalRangeToRe = this._getVerticalRangeToRender(),
	          rowStartIndex = _getVerticalRangeToRe[0],
	          rowStopIndex = _getVerticalRangeToRe[1];
	
	      var items = [];
	      if (columnCount > 0 && rowCount) {
	        for (var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++) {
	          for (var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++) {
	            items.push(react.createElement(children, {
	              columnIndex: _columnIndex,
	              data: itemData,
	              isScrolling: useIsScrolling ? isScrolling : undefined,
	              key: itemKey({ columnIndex: _columnIndex, rowIndex: _rowIndex }),
	              rowIndex: _rowIndex,
	              style: this._getItemStyle(_rowIndex, _columnIndex)
	            }));
	          }
	        }
	      }
	
	      // Read this value AFTER items have been created,
	      // So their actual sizes (if variable) are taken into consideration.
	      var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
	      var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
	
	      return react.createElement(outerTagName, {
	        className: className,
	        onScroll: this._onScroll,
	        ref: this._outerRefSetter,
	        style: _extends({
	          position: 'relative',
	          height: height,
	          width: width,
	          overflow: 'auto',
	          WebkitOverflowScrolling: 'touch',
	          willChange: 'transform'
	        }, style)
	      }, react.createElement(innerTagName, {
	        children: items,
	        ref: innerRef,
	        style: {
	          height: estimatedTotalHeight,
	          overflow: 'hidden',
	          pointerEvents: isScrolling ? 'none' : '',
	          width: estimatedTotalWidth
	        }
	      }));
	    };
	
	    Grid.prototype._callPropsCallbacks = function _callPropsCallbacks() {
	      var _props3 = this.props,
	          columnCount = _props3.columnCount,
	          onItemsRendered = _props3.onItemsRendered,
	          onScroll = _props3.onScroll,
	          rowCount = _props3.rowCount;
	
	
	      if (typeof onItemsRendered === 'function') {
	        if (columnCount > 0 && rowCount > 0) {
	          var _getHorizontalRangeTo2 = this._getHorizontalRangeToRender(),
	              _overscanColumnStartIndex = _getHorizontalRangeTo2[0],
	              _overscanColumnStopIndex = _getHorizontalRangeTo2[1],
	              _visibleColumnStartIndex = _getHorizontalRangeTo2[2],
	              _visibleColumnStopIndex = _getHorizontalRangeTo2[3];
	
	          var _getVerticalRangeToRe2 = this._getVerticalRangeToRender(),
	              _overscanRowStartIndex = _getVerticalRangeToRe2[0],
	              _overscanRowStopIndex = _getVerticalRangeToRe2[1],
	              _visibleRowStartIndex = _getVerticalRangeToRe2[2],
	              _visibleRowStopIndex = _getVerticalRangeToRe2[3];
	
	          this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
	        }
	      }
	
	      if (typeof onScroll === 'function') {
	        var _state3 = this.state,
	            _horizontalScrollDirection = _state3.horizontalScrollDirection,
	            _scrollLeft = _state3.scrollLeft,
	            _scrollTop = _state3.scrollTop,
	            _scrollUpdateWasRequested = _state3.scrollUpdateWasRequested,
	            _verticalScrollDirection = _state3.verticalScrollDirection;
	
	        this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
	      }
	    };
	
	    // Lazily create and cache item styles while scrolling,
	    // So that pure component sCU will prevent re-renders.
	    // We maintain this cache, and pass a style prop rather than index,
	    // So that List can clear cached styles and force item re-render if necessary.
	
	
	    Grid.prototype._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
	      var _props4 = this.props,
	          columnCount = _props4.columnCount,
	          overscanCount = _props4.overscanCount;
	      var _state4 = this.state,
	          horizontalScrollDirection = _state4.horizontalScrollDirection,
	          scrollLeft = _state4.scrollLeft;
	
	
	      var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
	      var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps);
	
	      // Overscan by one item in each direction so that tab/focus works.
	      // If there isn't at least one extra item, tab loops back around.
	      var overscanBackward = horizontalScrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
	      var overscanForward = horizontalScrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
	
	      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
	    };
	
	    Grid.prototype._getVerticalRangeToRender = function _getVerticalRangeToRender() {
	      var _props5 = this.props,
	          rowCount = _props5.rowCount,
	          overscanCount = _props5.overscanCount;
	      var _state5 = this.state,
	          verticalScrollDirection = _state5.verticalScrollDirection,
	          scrollTop = _state5.scrollTop;
	
	
	      var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
	      var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps);
	
	      // Overscan by one item in each direction so that tab/focus works.
	      // If there isn't at least one extra item, tab loops back around.
	      var overscanBackward = verticalScrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
	      var overscanForward = verticalScrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
	
	      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
	    };
	
	    return Grid;
	  }(react.PureComponent), _class.defaultProps = {
	    innerTagName: 'div',
	    outerTagName: 'div',
	    overscanCount: 1,
	    useIsScrolling: false
	  }, _temp;
	}
	
	var validateSharedProps = function validateSharedProps(_ref5) {
	  var children = _ref5.children,
	      height = _ref5.height,
	      width = _ref5.width;
	
	  if (false) {
	    if (typeof children !== 'function') {
	      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a function that creates a React element. ' + ('"' + (children === null ? 'null' : typeof children === 'undefined' ? 'undefined' : _typeof(children)) + '" was specified.'));
	    }
	
	    if (typeof width !== 'number') {
	      throw Error('An invalid "width" prop has been specified. ' + 'Grids must specify a number for width. ' + ('"' + (width === null ? 'null' : typeof width === 'undefined' ? 'undefined' : _typeof(width)) + '" was specified.'));
	    }
	
	    if (typeof height !== 'number') {
	      throw Error('An invalid "height" prop has been specified. ' + 'Grids must specify a number for height. ' + ('"' + (height === null ? 'null' : typeof height === 'undefined' ? 'undefined' : _typeof(height)) + '" was specified.'));
	    }
	  }
	};
	
	var DEFAULT_ESTIMATED_ITEM_SIZE = 50;
	
	var getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
	  var rowCount = _ref.rowCount;
	  var rowMetadataMap = _ref2.rowMetadataMap,
	      estimatedRowHeight = _ref2.estimatedRowHeight,
	      lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
	
	  var totalSizeOfMeasuredRows = 0;
	
	  if (lastMeasuredRowIndex >= 0) {
	    var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
	    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
	  }
	
	  var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
	  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
	
	  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
	};
	
	var getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
	  var columnCount = _ref3.columnCount;
	  var columnMetadataMap = _ref4.columnMetadataMap,
	      estimatedColumnWidth = _ref4.estimatedColumnWidth,
	      lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
	
	  var totalSizeOfMeasuredRows = 0;
	
	  if (lastMeasuredColumnIndex >= 0) {
	    var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
	    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
	  }
	
	  var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
	  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
	
	  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
	};
	
	var getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
	  var itemMetadataMap = void 0,
	      itemSize = void 0,
	      lastMeasuredIndex = void 0;
	  if (itemType === 'column') {
	    itemMetadataMap = instanceProps.columnMetadataMap;
	    itemSize = props.columnWidth;
	    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
	  } else {
	    itemMetadataMap = instanceProps.rowMetadataMap;
	    itemSize = props.rowHeight;
	    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
	  }
	
	  if (index > lastMeasuredIndex) {
	    var _offset = 0;
	    if (lastMeasuredIndex >= 0) {
	      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
	      _offset = itemMetadata.offset + itemMetadata.size;
	    }
	
	    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
	      var _size = itemSize(i);
	
	      itemMetadataMap[i] = {
	        offset: _offset,
	        size: _size
	      };
	
	      _offset += _size;
	    }
	
	    if (itemType === 'column') {
	      instanceProps.lastMeasuredColumnIndex = index;
	    } else {
	      instanceProps.lastMeasuredRowIndex = index;
	    }
	  }
	
	  return itemMetadataMap[index];
	};
	
	var findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
	  var itemMetadataMap = void 0,
	      lastMeasuredIndex = void 0;
	  if (itemType === 'column') {
	    itemMetadataMap = instanceProps.columnMetadataMap;
	    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
	  } else {
	    itemMetadataMap = instanceProps.rowMetadataMap;
	    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
	  }
	
	  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
	
	  if (lastMeasuredItemOffset >= offset) {
	    // If we've already measured items within this range just use a binary search as it's faster.
	    return findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
	  } else {
	    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
	    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
	    // The overall complexity for this approach is O(log n).
	    return findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
	  }
	};
	
	var findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
	  while (low <= high) {
	    var middle = low + Math.floor((high - low) / 2);
	    var currentOffset = getItemMetadata(itemType, props, middle, instanceProps).offset;
	
	    if (currentOffset === offset) {
	      return middle;
	    } else if (currentOffset < offset) {
	      low = middle + 1;
	    } else if (currentOffset > offset) {
	      high = middle - 1;
	    }
	  }
	
	  if (low > 0) {
	    return low - 1;
	  } else {
	    return 0;
	  }
	};
	
	var findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
	  var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
	  var interval = 1;
	
	  while (index < itemCount && getItemMetadata(itemType, props, index, instanceProps).offset < offset) {
	    index += interval;
	    interval *= 2;
	  }
	
	  return findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
	};
	
	var getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps) {
	  var size = itemType === 'column' ? props.width : props.height;
	  var itemMetadata = getItemMetadata(itemType, props, index, instanceProps);
	
	  // Get estimated total size after ItemMetadata is computed,
	  // To ensure it reflects actual measurements instead of just estimates.
	  var estimatedTotalSize = itemType === 'column' ? getEstimatedTotalWidth(props, instanceProps) : getEstimatedTotalHeight(props, instanceProps);
	
	  var maxOffset = Math.min(estimatedTotalSize - size, itemMetadata.offset);
	  var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size);
	
	  switch (align) {
	    case 'start':
	      return maxOffset;
	    case 'end':
	      return minOffset;
	    case 'center':
	      return Math.round(minOffset + (maxOffset - minOffset) / 2);
	    case 'auto':
	    default:
	      if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
	        return scrollOffset;
	      } else if (scrollOffset - minOffset < maxOffset - scrollOffset) {
	        return minOffset;
	      } else {
	        return maxOffset;
	      }
	  }
	};
	
	var VariableSizeGrid = /*#__PURE__*/createGridComponent({
	  getColumnOffset: function getColumnOffset(props, index, instanceProps) {
	    return getItemMetadata('column', props, index, instanceProps).offset;
	  },
	
	  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
	    return findNearestItem('column', props, instanceProps, scrollLeft);
	  },
	
	  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
	    var columnCount = props.columnCount,
	        width = props.width;
	
	
	    var itemMetadata = getItemMetadata('column', props, startIndex, instanceProps);
	    var maxOffset = scrollLeft + width;
	
	    var offset = itemMetadata.offset + itemMetadata.size;
	    var stopIndex = startIndex;
	
	    while (stopIndex < columnCount - 1 && offset < maxOffset) {
	      stopIndex++;
	      offset += getItemMetadata('column', props, stopIndex, instanceProps).size;
	    }
	
	    return stopIndex;
	  },
	
	  getColumnWidth: function getColumnWidth(props, index, instanceProps) {
	    return instanceProps.columnMetadataMap[index].size;
	  },
	
	  getEstimatedTotalHeight: getEstimatedTotalHeight,
	  getEstimatedTotalWidth: getEstimatedTotalWidth,
	
	  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps) {
	    return getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps);
	  },
	
	  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps) {
	    return getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps);
	  },
	
	  getRowOffset: function getRowOffset(props, index, instanceProps) {
	    return getItemMetadata('row', props, index, instanceProps).offset;
	  },
	
	  getRowHeight: function getRowHeight(props, index, instanceProps) {
	    return instanceProps.rowMetadataMap[index].size;
	  },
	
	  getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
	    return findNearestItem('row', props, instanceProps, scrollTop);
	  },
	
	  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
	    var rowCount = props.rowCount,
	        height = props.height;
	
	
	    var itemMetadata = getItemMetadata('row', props, startIndex, instanceProps);
	    var maxOffset = scrollTop + height;
	
	    var offset = itemMetadata.offset + itemMetadata.size;
	    var stopIndex = startIndex;
	
	    while (stopIndex < rowCount - 1 && offset < maxOffset) {
	      stopIndex++;
	      offset += getItemMetadata('row', props, stopIndex, instanceProps).size;
	    }
	
	    return stopIndex;
	  },
	
	  initInstanceProps: function initInstanceProps(props, instance) {
	    var _this = this;
	
	    var _ref5 = props,
	        estimatedColumnWidth = _ref5.estimatedColumnWidth,
	        estimatedRowHeight = _ref5.estimatedRowHeight;
	
	
	    var instanceProps = {
	      columnMetadataMap: {},
	      estimatedColumnWidth: estimatedColumnWidth || DEFAULT_ESTIMATED_ITEM_SIZE,
	      estimatedRowHeight: estimatedRowHeight || DEFAULT_ESTIMATED_ITEM_SIZE,
	      lastMeasuredColumnIndex: -1,
	      lastMeasuredRowIndex: -1,
	      rowMetadataMap: {}
	    };
	
	    instance.resetAfterColumnIndex = function (columnIndex) {
	      var shouldForceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      _this.resetAfterIndices({ columnIndex: columnIndex, shouldForceUpdate: shouldForceUpdate });
	    };
	
	    instance.resetAfterRowIndex = function (rowIndex) {
	      var shouldForceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      _this.resetAfterIndices({ rowIndex: rowIndex, shouldForceUpdate: shouldForceUpdate });
	    };
	
	    instance.resetAfterIndices = function (_ref6) {
	      var columnIndex = _ref6.columnIndex,
	          rowIndex = _ref6.rowIndex,
	          _ref6$shouldForceUpda = _ref6.shouldForceUpdate,
	          shouldForceUpdate = _ref6$shouldForceUpda === undefined ? true : _ref6$shouldForceUpda;
	
	      if (typeof columnIndex === 'number') {
	        instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
	      }
	      if (typeof rowIndex === 'number') {
	        instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
	      }
	
	      // We could potentially optimize further by only evicting styles after this index,
	      // But since styles are only cached while scrolling is in progress-
	      // It seems an unnecessary optimization.
	      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
	      instance._getItemStyleCache(-1);
	
	      if (shouldForceUpdate) {
	        instance.forceUpdate();
	      }
	    };
	
	    return instanceProps;
	  },
	
	
	  shouldResetStyleCacheOnItemSizeChange: false,
	
	  validateProps: function validateProps(_ref7) {
	    var columnWidth = _ref7.columnWidth,
	        rowHeight = _ref7.rowHeight;
	
	    if (false) {
	      if (typeof columnWidth !== 'function') {
	        throw Error('An invalid "columnWidth" prop has been specified. ' + 'Value should be a function. ' + ('"' + (columnWidth === null ? 'null' : typeof columnWidth === 'undefined' ? 'undefined' : _typeof(columnWidth)) + '" was specified.'));
	      } else if (typeof rowHeight !== 'function') {
	        throw Error('An invalid "rowHeight" prop has been specified. ' + 'Value should be a function. ' + ('"' + (rowHeight === null ? 'null' : typeof rowHeight === 'undefined' ? 'undefined' : _typeof(rowHeight)) + '" was specified.'));
	      }
	    }
	  }
	});
	
	var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
	
	var defaultItemKey$1 = function defaultItemKey(index) {
	  return index;
	};
	
	function createListComponent(_ref) {
	  var _class, _temp;
	
	  var getItemOffset = _ref.getItemOffset,
	      getEstimatedTotalSize = _ref.getEstimatedTotalSize,
	      getItemSize = _ref.getItemSize,
	      getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment,
	      getStartIndexForOffset = _ref.getStartIndexForOffset,
	      getStopIndexForStartIndex = _ref.getStopIndexForStartIndex,
	      initInstanceProps = _ref.initInstanceProps,
	      shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange,
	      validateProps = _ref.validateProps;
	
	  return _temp = _class = function (_PureComponent) {
	    inherits(List, _PureComponent);
	
	    // Always use explicit constructor for React components.
	    // It produces less code after transpilation. (#26)
	    // eslint-disable-next-line no-useless-constructor
	    function List(props) {
	      classCallCheck(this, List);
	
	      var _this = possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	      _this._instanceProps = initInstanceProps(_this.props, _this);
	      _this._resetIsScrollingTimeoutId = null;
	      _this.state = {
	        isScrolling: false,
	        scrollDirection: 'forward',
	        scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
	        scrollUpdateWasRequested: false
	      };
	      _this._callOnItemsRendered = memoizeOne(function (overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
	        return _this.props.onItemsRendered({
	          overscanStartIndex: overscanStartIndex,
	          overscanStopIndex: overscanStopIndex,
	          visibleStartIndex: visibleStartIndex,
	          visibleStopIndex: visibleStopIndex
	        });
	      });
	      _this._callOnScroll = memoizeOne(function (scrollDirection, scrollOffset, scrollUpdateWasRequested) {
	        return _this.props.onScroll({
	          scrollDirection: scrollDirection,
	          scrollOffset: scrollOffset,
	          scrollUpdateWasRequested: scrollUpdateWasRequested
	        });
	      });
	
	      _this._getItemStyle = function (index) {
	        var _this$props = _this.props,
	            direction = _this$props.direction,
	            itemSize = _this$props.itemSize;
	
	
	        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize);
	
	        var style = void 0;
	        if (itemStyleCache.hasOwnProperty(index)) {
	          style = itemStyleCache[index];
	        } else {
	          itemStyleCache[index] = style = {
	            position: 'absolute',
	            left: direction === 'horizontal' ? getItemOffset(_this.props, index, _this._instanceProps) : 0,
	            top: direction === 'vertical' ? getItemOffset(_this.props, index, _this._instanceProps) : 0,
	            height: direction === 'vertical' ? getItemSize(_this.props, index, _this._instanceProps) : '100%',
	            width: direction === 'horizontal' ? getItemSize(_this.props, index, _this._instanceProps) : '100%'
	          };
	        }
	
	        return style;
	      };
	
	      _this._getItemStyleCache = memoizeOne(function (_) {
	        return {};
	      });
	
	      _this._onScrollHorizontal = function (event) {
	        var scrollLeft = event.currentTarget.scrollLeft;
	
	        _this.setState(function (prevState) {
	          if (prevState.scrollOffset === scrollLeft) {
	            // Scroll position may have been updated by cDM/cDU,
	            // In which case we don't need to trigger another render,
	            // And we don't want to update state.isScrolling.
	            return null;
	          }
	
	          return {
	            isScrolling: true,
	            scrollDirection: prevState.scrollOffset < scrollLeft ? 'forward' : 'backward',
	            scrollOffset: scrollLeft,
	            scrollUpdateWasRequested: false
	          };
	        }, _this._resetIsScrollingDebounced);
	      };
	
	      _this._onScrollVertical = function (event) {
	        var scrollTop = event.currentTarget.scrollTop;
	
	        _this.setState(function (prevState) {
	          if (prevState.scrollOffset === scrollTop) {
	            // Scroll position may have been updated by cDM/cDU,
	            // In which case we don't need to trigger another render,
	            // And we don't want to update state.isScrolling.
	            return null;
	          }
	
	          return {
	            isScrolling: true,
	            scrollDirection: prevState.scrollOffset < scrollTop ? 'forward' : 'backward',
	            scrollOffset: scrollTop,
	            scrollUpdateWasRequested: false
	          };
	        }, _this._resetIsScrollingDebounced);
	      };
	
	      _this._outerRefSetter = function (ref) {
	        var outerRef = _this.props.outerRef;
	
	
	        _this._outerRef = ref;
	
	        if (typeof outerRef === 'function') {
	          outerRef(ref);
	        } else if (outerRef != null && (typeof outerRef === 'undefined' ? 'undefined' : _typeof(outerRef)) === 'object' && outerRef.hasOwnProperty('current')) {
	          outerRef.current = ref;
	        }
	      };
	
	      _this._resetIsScrollingDebounced = function () {
	        if (_this._resetIsScrollingTimeoutId !== null) {
	          clearTimeout(_this._resetIsScrollingTimeoutId);
	        }
	
	        _this._resetIsScrollingTimeoutId = setTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
	      };
	
	      _this._resetIsScrolling = function () {
	        _this._resetIsScrollingTimeoutId = null;
	
	        _this.setState({ isScrolling: false }, function () {
	          // Clear style cache after state update has been committed.
	          // This way we don't break pure sCU for items that don't use isScrolling param.
	          _this._getItemStyleCache(-1);
	        });
	      };
	
	      return _this;
	    }
	
	    List.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	      validateSharedProps$1(props);
	      validateProps(props);
	      return null;
	    };
	
	    List.prototype.scrollTo = function scrollTo(scrollOffset) {
	      this.setState(function (prevState) {
	        return {
	          scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
	          scrollOffset: scrollOffset,
	          scrollUpdateWasRequested: true
	        };
	      }, this._resetIsScrollingDebounced);
	    };
	
	    List.prototype.scrollToItem = function scrollToItem(index) {
	      var align = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
	      var scrollOffset = this.state.scrollOffset;
	
	      this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps));
	    };
	
	    List.prototype.componentDidMount = function componentDidMount() {
	      var _props = this.props,
	          initialScrollOffset = _props.initialScrollOffset,
	          direction = _props.direction;
	
	
	      if (typeof initialScrollOffset === 'number' && this._outerRef !== null) {
	        if (direction === 'horizontal') {
	          this._outerRef.scrollLeft = initialScrollOffset;
	        } else {
	          this._outerRef.scrollTop = initialScrollOffset;
	        }
	      }
	
	      this._callPropsCallbacks();
	    };
	
	    List.prototype.componentDidUpdate = function componentDidUpdate() {
	      var direction = this.props.direction;
	      var _state = this.state,
	          scrollOffset = _state.scrollOffset,
	          scrollUpdateWasRequested = _state.scrollUpdateWasRequested;
	
	
	      if (scrollUpdateWasRequested && this._outerRef !== null) {
	        if (direction === 'horizontal') {
	          this._outerRef.scrollLeft = scrollOffset;
	        } else {
	          this._outerRef.scrollTop = scrollOffset;
	        }
	      }
	
	      this._callPropsCallbacks();
	    };
	
	    List.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this._resetIsScrollingTimeoutId !== null) {
	        clearTimeout(this._resetIsScrollingTimeoutId);
	      }
	    };
	
	    List.prototype.render = function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          direction = _props2.direction,
	          height = _props2.height,
	          innerRef = _props2.innerRef,
	          innerTagName = _props2.innerTagName,
	          itemCount = _props2.itemCount,
	          itemData = _props2.itemData,
	          _props2$itemKey = _props2.itemKey,
	          itemKey = _props2$itemKey === undefined ? defaultItemKey$1 : _props2$itemKey,
	          outerTagName = _props2.outerTagName,
	          style = _props2.style,
	          useIsScrolling = _props2.useIsScrolling,
	          width = _props2.width;
	      var isScrolling = this.state.isScrolling;
	
	
	      var onScroll = direction === 'vertical' ? this._onScrollVertical : this._onScrollHorizontal;
	
	      var _getRangeToRender2 = this._getRangeToRender(),
	          startIndex = _getRangeToRender2[0],
	          stopIndex = _getRangeToRender2[1];
	
	      var items = [];
	      if (itemCount > 0) {
	        for (var _index = startIndex; _index <= stopIndex; _index++) {
	          items.push(react.createElement(children, {
	            data: itemData,
	            key: itemKey(_index),
	            index: _index,
	            isScrolling: useIsScrolling ? isScrolling : undefined,
	            style: this._getItemStyle(_index)
	          }));
	        }
	      }
	
	      // Read this value AFTER items have been created,
	      // So their actual sizes (if variable) are taken into consideration.
	      var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
	
	      return react.createElement(outerTagName, {
	        className: className,
	        onScroll: onScroll,
	        ref: this._outerRefSetter,
	        style: _extends({
	          position: 'relative',
	          height: height,
	          width: width,
	          overflow: 'auto',
	          WebkitOverflowScrolling: 'touch',
	          willChange: 'transform'
	        }, style)
	      }, react.createElement(innerTagName, {
	        children: items,
	        ref: innerRef,
	        style: {
	          height: direction === 'horizontal' ? '100%' : estimatedTotalSize,
	          overflow: 'hidden',
	          pointerEvents: isScrolling ? 'none' : '',
	          width: direction === 'horizontal' ? estimatedTotalSize : '100%'
	        }
	      }));
	    };
	
	    List.prototype._callPropsCallbacks = function _callPropsCallbacks() {
	      if (typeof this.props.onItemsRendered === 'function') {
	        var _itemCount = this.props.itemCount;
	
	        if (_itemCount > 0) {
	          var _getRangeToRender3 = this._getRangeToRender(),
	              _overscanStartIndex = _getRangeToRender3[0],
	              _overscanStopIndex = _getRangeToRender3[1],
	              _visibleStartIndex = _getRangeToRender3[2],
	              _visibleStopIndex = _getRangeToRender3[3];
	
	          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
	        }
	      }
	
	      if (typeof this.props.onScroll === 'function') {
	        var _state2 = this.state,
	            _scrollDirection = _state2.scrollDirection,
	            _scrollOffset = _state2.scrollOffset,
	            _scrollUpdateWasRequested = _state2.scrollUpdateWasRequested;
	
	        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
	      }
	    };
	
	    // Lazily create and cache item styles while scrolling,
	    // So that pure component sCU will prevent re-renders.
	    // We maintain this cache, and pass a style prop rather than index,
	    // So that List can clear cached styles and force item re-render if necessary.
	
	
	    List.prototype._getRangeToRender = function _getRangeToRender() {
	      var _props3 = this.props,
	          itemCount = _props3.itemCount,
	          overscanCount = _props3.overscanCount;
	      var _state3 = this.state,
	          scrollDirection = _state3.scrollDirection,
	          scrollOffset = _state3.scrollOffset;
	
	
	      var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
	      var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps);
	
	      // Overscan by one item in each direction so that tab/focus works.
	      // If there isn't at least one extra item, tab loops back around.
	      var overscanBackward = scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
	      var overscanForward = scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
	
	      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
	    };
	
	    return List;
	  }(react.PureComponent), _class.defaultProps = {
	    direction: 'vertical',
	    innerTagName: 'div',
	    outerTagName: 'div',
	    overscanCount: 2,
	    useIsScrolling: false
	  }, _temp;
	}
	
	// NOTE: I considered further wrapping individual items with a pure ListItem component.
	// This would avoid ever calling the render function for the same index more than once,
	// But it would also add the overhead of a lot of components/fibers.
	// I assume people already do this (render function returning a class component),
	// So my doing it would just unnecessarily double the wrappers.
	
	var validateSharedProps$1 = function validateSharedProps(_ref2) {
	  var children = _ref2.children,
	      direction = _ref2.direction,
	      height = _ref2.height,
	      width = _ref2.width;
	
	  if (false) {
	    if (direction !== 'horizontal' && direction !== 'vertical') {
	      throw Error('An invalid "direction" prop has been specified. ' + 'Value should be either "horizontal" or "vertical". ' + ('"' + direction + '" was specified.'));
	    }
	
	    if (typeof children !== 'function') {
	      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a function that creates a React element. ' + ('"' + (children === null ? 'null' : typeof children === 'undefined' ? 'undefined' : _typeof(children)) + '" was specified.'));
	    }
	
	    if (direction === 'horizontal' && typeof width !== 'number') {
	      throw Error('An invalid "width" prop has been specified. ' + 'Horizontal lists must specify a number for width. ' + ('"' + (width === null ? 'null' : typeof width === 'undefined' ? 'undefined' : _typeof(width)) + '" was specified.'));
	    } else if (direction === 'vertical' && typeof height !== 'number') {
	      throw Error('An invalid "height" prop has been specified. ' + 'Vertical lists must specify a number for height. ' + ('"' + (height === null ? 'null' : typeof height === 'undefined' ? 'undefined' : _typeof(height)) + '" was specified.'));
	    }
	  }
	};
	
	var DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
	
	var getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
	  var _ref = props,
	      itemSize = _ref.itemSize;
	  var itemMetadataMap = instanceProps.itemMetadataMap,
	      lastMeasuredIndex = instanceProps.lastMeasuredIndex;
	
	
	  if (index > lastMeasuredIndex) {
	    var _offset = 0;
	    if (lastMeasuredIndex >= 0) {
	      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
	      _offset = itemMetadata.offset + itemMetadata.size;
	    }
	
	    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
	      var _size = itemSize(i);
	
	      itemMetadataMap[i] = {
	        offset: _offset,
	        size: _size
	      };
	
	      _offset += _size;
	    }
	
	    instanceProps.lastMeasuredIndex = index;
	  }
	
	  return itemMetadataMap[index];
	};
	
	var findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
	  var itemMetadataMap = instanceProps.itemMetadataMap,
	      lastMeasuredIndex = instanceProps.lastMeasuredIndex;
	
	
	  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
	
	  if (lastMeasuredItemOffset >= offset) {
	    // If we've already measured items within this range just use a binary search as it's faster.
	    return findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
	  } else {
	    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
	    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
	    // The overall complexity for this approach is O(log n).
	    return findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
	  }
	};
	
	var findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
	  while (low <= high) {
	    var middle = low + Math.floor((high - low) / 2);
	    var currentOffset = getItemMetadata$1(props, middle, instanceProps).offset;
	
	    if (currentOffset === offset) {
	      return middle;
	    } else if (currentOffset < offset) {
	      low = middle + 1;
	    } else if (currentOffset > offset) {
	      high = middle - 1;
	    }
	  }
	
	  if (low > 0) {
	    return low - 1;
	  } else {
	    return 0;
	  }
	};
	
	var findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
	  var itemCount = props.itemCount;
	
	  var interval = 1;
	
	  while (index < itemCount && getItemMetadata$1(props, index, instanceProps).offset < offset) {
	    index += interval;
	    interval *= 2;
	  }
	
	  return findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
	};
	
	var getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
	  var itemCount = _ref2.itemCount;
	  var itemMetadataMap = _ref3.itemMetadataMap,
	      estimatedItemSize = _ref3.estimatedItemSize,
	      lastMeasuredIndex = _ref3.lastMeasuredIndex;
	
	  var totalSizeOfMeasuredItems = 0;
	
	  if (lastMeasuredIndex >= 0) {
	    var itemMetadata = itemMetadataMap[lastMeasuredIndex];
	    totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
	  }
	
	  var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
	  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
	
	  return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
	};
	
	var VariableSizeList = /*#__PURE__*/createListComponent({
	  getItemOffset: function getItemOffset(props, index, instanceProps) {
	    return getItemMetadata$1(props, index, instanceProps).offset;
	  },
	
	  getItemSize: function getItemSize(props, index, instanceProps) {
	    return instanceProps.itemMetadataMap[index].size;
	  },
	
	  getEstimatedTotalSize: getEstimatedTotalSize,
	
	  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps) {
	    var direction = props.direction,
	        height = props.height,
	        width = props.width;
	
	
	    var size = direction === 'horizontal' ? width : height;
	    var itemMetadata = getItemMetadata$1(props, index, instanceProps);
	
	    // Get estimated total size after ItemMetadata is computed,
	    // To ensure it reflects actual measurements instead of just estimates.
	    var estimatedTotalSize = getEstimatedTotalSize(props, instanceProps);
	
	    var maxOffset = Math.min(estimatedTotalSize - size, itemMetadata.offset);
	    var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size);
	
	    switch (align) {
	      case 'start':
	        return maxOffset;
	      case 'end':
	        return minOffset;
	      case 'center':
	        return Math.round(minOffset + (maxOffset - minOffset) / 2);
	      case 'auto':
	      default:
	        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
	          return scrollOffset;
	        } else if (scrollOffset - minOffset < maxOffset - scrollOffset) {
	          return minOffset;
	        } else {
	          return maxOffset;
	        }
	    }
	  },
	
	  getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
	    return findNearestItem$1(props, instanceProps, offset);
	  },
	
	  getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
	    var direction = props.direction,
	        height = props.height,
	        itemCount = props.itemCount,
	        width = props.width;
	
	
	    var size = direction === 'horizontal' ? width : height;
	    var itemMetadata = getItemMetadata$1(props, startIndex, instanceProps);
	    var maxOffset = scrollOffset + size;
	
	    var offset = itemMetadata.offset + itemMetadata.size;
	    var stopIndex = startIndex;
	
	    while (stopIndex < itemCount - 1 && offset < maxOffset) {
	      stopIndex++;
	      offset += getItemMetadata$1(props, stopIndex, instanceProps).size;
	    }
	
	    return stopIndex;
	  },
	
	  initInstanceProps: function initInstanceProps(props, instance) {
	    var _ref4 = props,
	        estimatedItemSize = _ref4.estimatedItemSize;
	
	
	    var instanceProps = {
	      itemMetadataMap: {},
	      estimatedItemSize: estimatedItemSize || DEFAULT_ESTIMATED_ITEM_SIZE$1,
	      lastMeasuredIndex: -1
	    };
	
	    instance.resetAfterIndex = function (index) {
	      var shouldForceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1);
	
	      // We could potentially optimize further by only evicting styles after this index,
	      // But since styles are only cached while scrolling is in progress-
	      // It seems an unnecessary optimization.
	      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
	      instance._getItemStyleCache(-1);
	
	      if (shouldForceUpdate) {
	        instance.forceUpdate();
	      }
	    };
	
	    return instanceProps;
	  },
	
	
	  shouldResetStyleCacheOnItemSizeChange: false,
	
	  validateProps: function validateProps(_ref5) {
	    var itemSize = _ref5.itemSize;
	
	    if (false) {
	      if (typeof itemSize !== 'function') {
	        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a function. ' + ('"' + (itemSize === null ? 'null' : typeof itemSize === 'undefined' ? 'undefined' : _typeof(itemSize)) + '" was specified.'));
	      }
	    }
	  }
	});
	
	var FixedSizeGrid = /*#__PURE__*/createGridComponent({
	  getColumnOffset: function getColumnOffset(_ref, index) {
	    var columnWidth = _ref.columnWidth;
	    return index * columnWidth;
	  },
	
	  getColumnWidth: function getColumnWidth(_ref2, index) {
	    var columnWidth = _ref2.columnWidth;
	    return columnWidth;
	  },
	
	  getRowOffset: function getRowOffset(_ref3, index) {
	    var rowHeight = _ref3.rowHeight;
	    return index * rowHeight;
	  },
	
	  getRowHeight: function getRowHeight(_ref4, index) {
	    var rowHeight = _ref4.rowHeight;
	    return rowHeight;
	  },
	
	  getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
	    var rowCount = _ref5.rowCount,
	        rowHeight = _ref5.rowHeight;
	    return rowHeight * rowCount;
	  },
	
	  getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
	    var columnCount = _ref6.columnCount,
	        columnWidth = _ref6.columnWidth;
	    return columnWidth * columnCount;
	  },
	
	  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft) {
	    var columnCount = _ref7.columnCount,
	        columnWidth = _ref7.columnWidth,
	        width = _ref7.width;
	
	    var maxOffset = Math.min(columnCount * columnWidth - width, columnIndex * columnWidth);
	    var minOffset = Math.max(0, columnIndex * columnWidth - width + columnWidth);
	
	    switch (align) {
	      case 'start':
	        return maxOffset;
	      case 'end':
	        return minOffset;
	      case 'center':
	        return Math.round(minOffset + (maxOffset - minOffset) / 2);
	      case 'auto':
	      default:
	        if (scrollLeft >= minOffset && scrollLeft <= maxOffset) {
	          return scrollLeft;
	        } else if (scrollLeft - minOffset < maxOffset - scrollLeft) {
	          return minOffset;
	        } else {
	          return maxOffset;
	        }
	    }
	  },
	
	  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop) {
	    var rowHeight = _ref8.rowHeight,
	        height = _ref8.height,
	        rowCount = _ref8.rowCount;
	
	    var maxOffset = Math.min(rowCount * rowHeight - height, rowIndex * rowHeight);
	    var minOffset = Math.max(0, rowIndex * rowHeight - height + rowHeight);
	
	    switch (align) {
	      case 'start':
	        return maxOffset;
	      case 'end':
	        return minOffset;
	      case 'center':
	        return Math.round(minOffset + (maxOffset - minOffset) / 2);
	      case 'auto':
	      default:
	        if (scrollTop >= minOffset && scrollTop <= maxOffset) {
	          return scrollTop;
	        } else if (scrollTop - minOffset < maxOffset - scrollTop) {
	          return minOffset;
	        } else {
	          return maxOffset;
	        }
	    }
	  },
	
	  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
	    var columnWidth = _ref9.columnWidth,
	        columnCount = _ref9.columnCount;
	    return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
	  },
	
	  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
	    var columnWidth = _ref10.columnWidth,
	        columnCount = _ref10.columnCount,
	        width = _ref10.width;
	
	    var left = startIndex * columnWidth;
	    return Math.max(0, Math.min(columnCount - 1, startIndex + Math.floor((width + (scrollLeft - left)) / columnWidth)));
	  },
	
	  getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
	    var rowHeight = _ref11.rowHeight,
	        rowCount = _ref11.rowCount;
	    return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
	  },
	
	  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
	    var rowHeight = _ref12.rowHeight,
	        rowCount = _ref12.rowCount,
	        height = _ref12.height;
	
	    var left = startIndex * rowHeight;
	    return Math.max(0, Math.min(rowCount - 1, startIndex + Math.floor((height + (scrollTop - left)) / rowHeight)));
	  },
	
	  initInstanceProps: function initInstanceProps(props) {
	    // Noop
	  },
	
	
	  shouldResetStyleCacheOnItemSizeChange: true,
	
	  validateProps: function validateProps(_ref13) {
	    var columnWidth = _ref13.columnWidth,
	        rowHeight = _ref13.rowHeight;
	
	    if (false) {
	      if (typeof columnWidth !== 'number') {
	        throw Error('An invalid "columnWidth" prop has been specified. ' + 'Value should be a number. ' + ('"' + (columnWidth === null ? 'null' : typeof columnWidth === 'undefined' ? 'undefined' : _typeof(columnWidth)) + '" was specified.'));
	      }
	
	      if (typeof rowHeight !== 'number') {
	        throw Error('An invalid "rowHeight" prop has been specified. ' + 'Value should be a number. ' + ('"' + (rowHeight === null ? 'null' : typeof rowHeight === 'undefined' ? 'undefined' : _typeof(rowHeight)) + '" was specified.'));
	      }
	    }
	  }
	});
	
	var FixedSizeList = /*#__PURE__*/createListComponent({
	  getItemOffset: function getItemOffset(_ref, index) {
	    var itemSize = _ref.itemSize,
	        size = _ref.size;
	    return index * itemSize;
	  },
	
	  getItemSize: function getItemSize(_ref2, index) {
	    var itemSize = _ref2.itemSize,
	        size = _ref2.size;
	    return itemSize;
	  },
	
	  getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
	    var itemCount = _ref3.itemCount,
	        itemSize = _ref3.itemSize;
	    return itemSize * itemCount;
	  },
	
	  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset) {
	    var direction = _ref4.direction,
	        height = _ref4.height,
	        itemCount = _ref4.itemCount,
	        itemSize = _ref4.itemSize,
	        width = _ref4.width;
	
	    var size = direction === 'horizontal' ? width : height;
	    var maxOffset = Math.min(itemCount * itemSize - size, index * itemSize);
	    var minOffset = Math.max(0, index * itemSize - size + itemSize);
	
	    switch (align) {
	      case 'start':
	        return maxOffset;
	      case 'end':
	        return minOffset;
	      case 'center':
	        return Math.round(minOffset + (maxOffset - minOffset) / 2);
	      case 'auto':
	      default:
	        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
	          return scrollOffset;
	        } else if (scrollOffset - minOffset < maxOffset - scrollOffset) {
	          return minOffset;
	        } else {
	          return maxOffset;
	        }
	    }
	  },
	
	  getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
	    var itemCount = _ref5.itemCount,
	        itemSize = _ref5.itemSize;
	    return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
	  },
	
	  getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
	    var direction = _ref6.direction,
	        height = _ref6.height,
	        itemCount = _ref6.itemCount,
	        itemSize = _ref6.itemSize,
	        width = _ref6.width;
	
	    var offset = startIndex * itemSize;
	    var size = direction === 'horizontal' ? width : height;
	    return Math.max(0, Math.min(itemCount - 1, startIndex + Math.floor((size + (scrollOffset - offset)) / itemSize)));
	  },
	
	  initInstanceProps: function initInstanceProps(props) {
	    // Noop
	  },
	
	
	  shouldResetStyleCacheOnItemSizeChange: true,
	
	  validateProps: function validateProps(_ref7) {
	    var itemSize = _ref7.itemSize;
	
	    if (false) {
	      if (typeof itemSize !== 'number') {
	        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a number. ' + ('"' + (itemSize === null ? 'null' : typeof itemSize === 'undefined' ? 'undefined' : _typeof(itemSize)) + '" was specified.'));
	      }
	    }
	  }
	});
	
	exports.VariableSizeGrid = VariableSizeGrid;
	exports.VariableSizeList = VariableSizeList;
	exports.FixedSizeGrid = FixedSizeGrid;
	exports.FixedSizeList = FixedSizeList;


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(353);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var minWidthToDisplay = 35;
	
	var ChartNode = function ChartNode(_ref) {
	  var color = _ref.color,
	      height = _ref.height,
	      _ref$isDimmed = _ref.isDimmed,
	      isDimmed = _ref$isDimmed === undefined ? false : _ref$isDimmed,
	      label = _ref.label,
	      onClick = _ref.onClick,
	      onDoubleClick = _ref.onDoubleClick,
	      theme = _ref.theme,
	      title = _ref.title,
	      width = _ref.width,
	      x = _ref.x,
	      y = _ref.y;
	  return _react2.default.createElement(
	    'g',
	    {
	      style: ChartAnimatedNode,
	      transform: 'translate(' + x + ',' + y + ')'
	    },
	    _react2.default.createElement(
	      'title',
	      null,
	      title
	    ),
	    _react2.default.createElement('rect', {
	      width: width,
	      height: height,
	      fill: color,
	      onClick: onClick,
	      onDoubleClick: onDoubleClick,
	      style: ChartRect(theme, isDimmed)
	    }),
	    width >= minWidthToDisplay && _react2.default.createElement(
	      'foreignObject',
	      {
	        width: width,
	        height: height,
	        style: _extends({}, ChartAnimatedNode, {
	          opacity: isDimmed ? 0.75 : 1,
	          display: width < minWidthToDisplay ? 'none' : 'block',
	          paddingLeft: x < 0 ? -x : 0,
	          pointerEvents: 'none'
	        }),
	        y: height < _constants.textHeight ? -_constants.textHeight : 0
	      },
	      _react2.default.createElement(
	        'div',
	        { style: ChartLabel },
	        label
	      )
	    )
	  );
	};
	
	var ChartAnimatedNode = {
	  transition: 'all ease-in-out 250ms'
	};
	
	var ChartRect = function ChartRect(theme, isDimmed) {
	  return _extends({
	    cursor: 'pointer',
	    opacity: isDimmed ? 0.5 : 1,
	    stroke: theme.base00
	  }, ChartAnimatedNode);
	};
	
	var ChartLabel = _extends({
	  pointerEvents: 'none',
	  whiteSpace: 'nowrap',
	  textOverflow: 'ellipsis',
	  overflow: 'hidden',
	  fontSize: '12px',
	  fontFamily: 'sans-serif',
	  marginLeft: '4px',
	  marginRight: '4px',
	  lineHeight: '1.5',
	  padding: '0 0 0',
	  fontWeight: '400',
	  color: 'black',
	  textAlign: 'left'
	}, ChartAnimatedNode);
	
	exports.default = ChartNode;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Fonts = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var commitThreshold = _ref.commitThreshold,
	      height = _ref.height,
	      hideCommitsBelowThreshold = _ref.hideCommitsBelowThreshold,
	      stopInspecting = _ref.stopInspecting,
	      width = _ref.width;
	  return _react2.default.createElement(
	    'div',
	    { style: {
	        display: 'flex',
	        flexDirection: 'column',
	        alignItems: 'center',
	        justifyContent: 'center',
	        textAlign: 'center',
	        height: height,
	        width: width
	      } },
	    !hideCommitsBelowThreshold && _react2.default.createElement(
	      'p',
	      { style: { fontSize: _Fonts.sansSerif.sizes.large } },
	      'No render times were recorded for the selected element.'
	    ),
	    hideCommitsBelowThreshold && _react2.default.createElement(
	      'p',
	      { style: { fontSize: _Fonts.sansSerif.sizes.large } },
	      'No render times were recorded for the selected element based on the current commit threshold.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'button',
	        { onClick: stopInspecting },
	        'Return to the previous view'
	      )
	    )
	  );
	};

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _memoizeOne = __webpack_require__(354);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactWindow = __webpack_require__(357);
	
	var _reactVirtualizedAutoSizer = __webpack_require__(356);
	
	var _reactVirtualizedAutoSizer2 = _interopRequireDefault(_reactVirtualizedAutoSizer);
	
	var _NoInteractionsMessage = __webpack_require__(361);
	
	var _NoInteractionsMessage2 = _interopRequireDefault(_NoInteractionsMessage);
	
	var _constants = __webpack_require__(353);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INTERACTION_SIZE = 4;
	var ITEM_SIZE = 25;
	var SNAPSHOT_SIZE = 10;
	
	var InteractionTimeline = function InteractionTimeline(_ref) {
	  var cacheInteractionData = _ref.cacheInteractionData,
	      getCachedInteractionData = _ref.getCachedInteractionData,
	      hasMultipleRoots = _ref.hasMultipleRoots,
	      interactionsToSnapshots = _ref.interactionsToSnapshots,
	      maxDuration = _ref.maxDuration,
	      selectedInteraction = _ref.selectedInteraction,
	      selectedSnapshot = _ref.selectedSnapshot,
	      selectInteraction = _ref.selectInteraction,
	      theme = _ref.theme,
	      timestampsToInteractions = _ref.timestampsToInteractions;
	
	  // Cache data in ProfilerStore so we only have to compute it the first time the interactions tab is shown
	  var chartData = getCachedInteractionData(selectedSnapshot.root);
	  if (chartData === null) {
	    chartData = getChartData(interactionsToSnapshots, maxDuration, timestampsToInteractions);
	    cacheInteractionData(selectedSnapshot.root, chartData);
	  }
	
	  return _react2.default.createElement(
	    _reactVirtualizedAutoSizer2.default,
	    null,
	    function (_ref2) {
	      var height = _ref2.height,
	          width = _ref2.width;
	      return _react2.default.createElement(InteractionsList, {
	        chartData: chartData,
	        hasMultipleRoots: hasMultipleRoots,
	        height: height,
	        selectedInteraction: selectedInteraction,
	        selectedSnapshot: selectedSnapshot,
	        selectInteraction: selectInteraction,
	        theme: theme,
	        width: width
	      });
	    }
	  );
	};
	
	var InteractionsList = function (_PureComponent) {
	  _inherits(InteractionsList, _PureComponent);
	
	  function InteractionsList() {
	    var _ref3;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InteractionsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = InteractionsList.__proto__ || Object.getPrototypeOf(InteractionsList)).call.apply(_ref3, [this].concat(args))), _this), _this.handleKeyDown = function (event) {
	      if (event.keyCode === UP_ARROW || event.keyCode === DOWN_ARROW) {
	        (function () {
	          // Don't let the main Elements tab change root selection for keyboard arrows.
	          event.preventDefault();
	
	          var _this$props = _this.props,
	              chartData = _this$props.chartData,
	              selectedInteraction = _this$props.selectedInteraction,
	              selectInteraction = _this$props.selectInteraction;
	
	
	          var items = chartData.items;
	          var index = items.findIndex(function (_ref4) {
	            var interaction = _ref4.interaction;
	            return selectedInteraction === interaction;
	          });
	
	          // Select a new interaction...
	          var newIndex = 0;
	          if (event.keyCode === UP_ARROW) {
	            newIndex = index > 0 ? index - 1 : items.length - 1;
	          } else {
	            newIndex = index < items.length - 1 ? index + 1 : 0;
	          }
	
	          selectInteraction(items[newIndex].interaction);
	        })();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InteractionsList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          chartData = _props.chartData,
	          hasMultipleRoots = _props.hasMultipleRoots,
	          height = _props.height,
	          selectedInteraction = _props.selectedInteraction,
	          selectedSnapshot = _props.selectedSnapshot,
	          selectInteraction = _props.selectInteraction,
	          theme = _props.theme,
	          width = _props.width;
	
	      // If a commit contains no interactions, display a fallback message.
	
	      if (chartData.items.length === 0) {
	        return _react2.default.createElement(_NoInteractionsMessage2.default, {
	          hasMultipleRoots: hasMultipleRoots,
	          height: height,
	          width: width
	        });
	      }
	
	      // The following conversion methods are memoized,
	      // So it's okay to call them on every render.
	      var itemData = getItemData(chartData, selectedInteraction, selectedSnapshot, selectInteraction, theme, width);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onKeyDown: this.handleKeyDown,
	          style: {
	            outline: 'none',
	            height: height,
	            width: width
	          },
	          tabIndex: 0
	        },
	        _react2.default.createElement(
	          _reactWindow.FixedSizeList,
	          {
	            height: height,
	            itemCount: chartData.items.length,
	            itemData: itemData,
	            itemSize: ITEM_SIZE,
	            width: width
	          },
	          ListItem
	        )
	      );
	    }
	  }]);
	
	  return InteractionsList;
	}(_react.PureComponent);
	
	var UP_ARROW = 38;
	var DOWN_ARROW = 40;
	
	var ListItem = function (_PureComponent2) {
	  _inherits(ListItem, _PureComponent2);
	
	  function ListItem() {
	    var _ref5;
	
	    var _temp2, _this2, _ret3;
	
	    _classCallCheck(this, ListItem);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret3 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref5 = ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call.apply(_ref5, [this].concat(args))), _this2), _this2.state = {
	      isHovered: false
	    }, _this2.handleMouseEnter = function () {
	      return _this2.setState({ isHovered: true });
	    }, _this2.handleMouseLeave = function () {
	      return _this2.setState({ isHovered: false });
	    }, _temp2), _possibleConstructorReturn(_this2, _ret3);
	  }
	
	  _createClass(ListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          itemData = _props2.data,
	          itemIndex = _props2.index,
	          style = _props2.style;
	      var isHovered = this.state.isHovered;
	      var chartData = itemData.chartData,
	          labelColumnWidth = itemData.labelColumnWidth,
	          scaleX = itemData.scaleX,
	          selectedInteraction = itemData.selectedInteraction,
	          selectedSnapshot = itemData.selectedSnapshot,
	          theme = itemData.theme;
	      var items = chartData.items,
	          maxDuration = chartData.maxDuration;
	
	
	      var item = items[itemIndex];
	      var interaction = item.interaction,
	          lastSnapshotCommitTime = item.lastSnapshotCommitTime;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onClick: function onClick() {
	            return itemData.selectInteraction(interaction);
	          },
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: _extends({}, style, {
	            display: 'flex',
	            alignItems: 'center',
	            backgroundColor: isHovered ? theme.state03 : selectedInteraction === interaction ? theme.base01 : 'transparent',
	            borderBottom: '1px solid ' + theme.base01,
	            cursor: 'pointer'
	          })
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              width: labelColumnWidth,
	              overflow: 'hidden',
	              textOverflow: 'ellipsis',
	              whiteSpace: 'nowrap',
	              lineHeight: ITEM_SIZE + 'px',
	              boxSizing: 'border-box',
	              padding: '0 0.25rem',
	              color: isHovered ? theme.state00 : theme.base05,
	              textDecoration: isHovered ? 'underline' : 'none',
	              userSelect: 'none'
	            },
	            title: interaction.name
	          },
	          interaction.name
	        ),
	        _react2.default.createElement('div', {
	          style: {
	            position: 'absolute',
	            left: labelColumnWidth + scaleX(interaction.timestamp, 0) + 'px',
	            width: scaleX(lastSnapshotCommitTime - interaction.timestamp, 0) + SNAPSHOT_SIZE + 'px',
	            height: INTERACTION_SIZE + 'px',
	            backgroundColor: theme.base03,
	            borderRadius: '0.125rem'
	          }
	        }),
	        item.snapshots.map(function (snapshot, snapshotIndex) {
	          // Guard against commits with duration 0
	          var percentage = Math.min(1, Math.max(0, snapshot.duration / maxDuration)) || 0;
	
	          return _react2.default.createElement('div', {
	            key: snapshotIndex,
	            style: {
	              position: 'absolute',
	              left: labelColumnWidth + scaleX(snapshot.commitTime, 0) + 'px',
	              width: SNAPSHOT_SIZE + 'px',
	              height: SNAPSHOT_SIZE + 'px',
	              backgroundColor: selectedSnapshot === snapshot ? theme.state06 : (0, _constants.getGradientColor)(percentage),
	              boxSizing: 'border-box',
	              cursor: 'pointer'
	            }
	          });
	        })
	      );
	    }
	  }]);
	
	  return ListItem;
	}(_react.PureComponent);
	
	var getChartData = (0, _memoizeOne2.default)(function (interactionsToSnapshots, maxDuration, timestampsToInteractions) {
	  var items = [];
	  var stopTime = Number.MIN_VALUE;
	
	  // eslint-disable-next-line no-unused-vars
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = timestampsToInteractions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var _step$value = _slicedToArray(_step.value, 2),
	          timestamp = _step$value[0],
	          interactions = _step$value[1];
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = interactions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var _interaction = _step2.value;
	
	          var _snapshots = Array.from(interactionsToSnapshots.get(_interaction));
	          var _lastSnapshotCommitTime = _snapshots[_snapshots.length - 1].commitTime;
	
	          stopTime = Math.max(stopTime, _lastSnapshotCommitTime);
	
	          items.push({
	            interaction: _interaction,
	            lastSnapshotCommitTime: _lastSnapshotCommitTime,
	            snapshots: _snapshots
	          });
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return {
	    items: items,
	    maxDuration: maxDuration,
	    stopTime: stopTime
	  };
	});
	
	var getItemData = (0, _memoizeOne2.default)(function (chartData, selectedInteraction, selectedSnapshot, selectInteraction, theme, width) {
	  var labelColumnWidth = Math.min(200, width / 5);
	  var graphColumnWidth = width - labelColumnWidth - SNAPSHOT_SIZE;
	
	  return {
	    chartData: chartData,
	    graphColumnWidth: graphColumnWidth,
	    labelColumnWidth: labelColumnWidth,
	    scaleX: (0, _constants.scale)(0, chartData.stopTime, 0, graphColumnWidth),
	    selectedInteraction: selectedInteraction,
	    selectedSnapshot: selectedSnapshot,
	    selectInteraction: selectInteraction,
	    theme: theme
	  };
	});
	
	exports.default = InteractionTimeline;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Fonts = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var hasMultipleRoots = _ref.hasMultipleRoots,
	      height = _ref.height,
	      width = _ref.width;
	
	  var headerText = void 0;
	  if (hasMultipleRoots) {
	    headerText = 'No interactions were recorded for the selected root.';
	  } else {
	    headerText = 'No interactions were recorded.';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: {
	        height: height,
	        width: width,
	        flex: 1,
	        display: 'flex',
	        flexDirection: 'column',
	        alignItems: 'center',
	        justifyContent: 'center'
	      } },
	    _react2.default.createElement(
	      'p',
	      { style: {
	          fontSize: _Fonts.sansSerif.sizes.large
	        } },
	      headerText
	    ),
	    hasMultipleRoots && _react2.default.createElement(
	      'p',
	      null,
	      'You may want to select a different root in the ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Elements'
	      ),
	      ' panel.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: 'https://fb.me/react-interaction-tracking', target: '_blank' },
	        'Learn more about the interaction tracking API here'
	      ),
	      '.'
	    )
	  );
	};

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icons = __webpack_require__(61);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	var _SvgIcon = __webpack_require__(60);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	var _Fonts = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var hasMultipleRoots = _ref.hasMultipleRoots,
	      startRecording = _ref.startRecording,
	      theme = _ref.theme;
	
	  var buttonPreMessage = void 0;
	  var headerText = void 0;
	  if (hasMultipleRoots) {
	    buttonPreMessage = _react2.default.createElement(
	      _react.Fragment,
	      null,
	      'Select a different root in the ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Elements'
	      ),
	      ' panel, or click the record button'
	    );
	    headerText = 'No profiling data has been recorded for the selected root.';
	  } else {
	    buttonPreMessage = _react2.default.createElement(
	      _react.Fragment,
	      null,
	      'Click the record button'
	    );
	    headerText = 'No profiling data has been recorded.';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        height: '100%',
	        flex: 1,
	        display: 'flex',
	        flexDirection: 'column',
	        alignItems: 'center',
	        justifyContent: 'center'
	      }
	    },
	    _react2.default.createElement(
	      'p',
	      { style: {
	          fontSize: _Fonts.sansSerif.sizes.large
	        } },
	      headerText
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      buttonPreMessage,
	      _react2.default.createElement(
	        'button',
	        {
	          onClick: startRecording,
	          style: {
	            display: 'inline-block',
	            background: theme.base01,
	            outline: 'none',
	            cursor: 'pointer',
	            color: theme.base05,
	            padding: '.5rem',
	            margin: '0 0.25rem',
	            border: '1px solid ' + theme.base03
	          },
	          title: 'Start recording'
	        },
	        _react2.default.createElement(_SvgIcon2.default, {
	          path: _Icons2.default.RECORD,
	          style: {
	            flex: '0 0 1rem',
	            width: '1rem',
	            height: '1rem',
	            fill: 'currentColor',
	            display: 'inline',
	            verticalAlign: 'sub'
	          }
	        })
	      ),
	      'to start a new recording.'
	    )
	  );
	};

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _memoizeOne = __webpack_require__(354);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualizedAutoSizer = __webpack_require__(356);
	
	var _reactVirtualizedAutoSizer2 = _interopRequireDefault(_reactVirtualizedAutoSizer);
	
	var _reactWindow = __webpack_require__(357);
	
	var _ChartNode = __webpack_require__(358);
	
	var _ChartNode2 = _interopRequireDefault(_ChartNode);
	
	var _NoSnapshotDataMessage = __webpack_require__(364);
	
	var _NoSnapshotDataMessage2 = _interopRequireDefault(_NoSnapshotDataMessage);
	
	var _constants = __webpack_require__(353);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Mapping of depth (i.e. List row index) to flame graph Nodes.
	// Flamegraphs may contain a lot of data and pre-processing it all would be expensive.
	// This mapping is lazily created, so that we can defer most of the work until a row is needed.
	// Each row builds on the values of the previous row, (e.g. initial left offset, child Fiber ids, etc.)
	
	
	// List-level data that's cached (memoized) and passed to individual item renderers.
	var SnapshotFlamegraph = function SnapshotFlamegraph(_ref) {
	  var cacheDataForSnapshot = _ref.cacheDataForSnapshot,
	      deselectFiber = _ref.deselectFiber,
	      getCachedDataForSnapshot = _ref.getCachedDataForSnapshot,
	      inspectFiber = _ref.inspectFiber,
	      selectedFiberID = _ref.selectedFiberID,
	      selectFiber = _ref.selectFiber,
	      showNativeNodes = _ref.showNativeNodes,
	      snapshot = _ref.snapshot,
	      snapshotIndex = _ref.snapshotIndex,
	      theme = _ref.theme;
	
	  // Cache data in ProfilerStore so we only have to compute it the first time a Snapshot is shown.
	  var dataKey = showNativeNodes ? 'SnapshotFlamegraphWithNativeNodes' : 'SnapshotFlamegraphWithoutNativeNodes';
	  var flamegraphData = getCachedDataForSnapshot(snapshotIndex, snapshot.root, dataKey);
	  if (flamegraphData === null) {
	    flamegraphData = convertSnapshotToChartData(showNativeNodes, snapshot);
	    cacheDataForSnapshot(snapshotIndex, snapshot.root, dataKey, flamegraphData);
	  }
	
	  return _react2.default.createElement(
	    _reactVirtualizedAutoSizer2.default,
	    null,
	    function (_ref2) {
	      var height = _ref2.height,
	          width = _ref2.width;
	      return _react2.default.createElement(Flamegraph, {
	        deselectFiber: deselectFiber,
	        flamegraphData: flamegraphData,
	        height: height,
	        inspectFiber: inspectFiber,
	        selectedFiberID: selectedFiberID,
	        selectFiber: selectFiber,
	        showNativeNodes: showNativeNodes,
	        snapshot: snapshot,
	        theme: theme,
	        width: width
	      });
	    }
	  );
	};
	
	var Flamegraph = function Flamegraph(_ref3) {
	  var deselectFiber = _ref3.deselectFiber,
	      flamegraphData = _ref3.flamegraphData,
	      height = _ref3.height,
	      inspectFiber = _ref3.inspectFiber,
	      selectedFiberID = _ref3.selectedFiberID,
	      selectFiber = _ref3.selectFiber,
	      showNativeNodes = _ref3.showNativeNodes,
	      snapshot = _ref3.snapshot,
	      theme = _ref3.theme,
	      width = _ref3.width;
	  var flameGraphDepth = flamegraphData.flameGraphDepth,
	      lazyIDToDepthMap = flamegraphData.lazyIDToDepthMap,
	      lazyIDsByDepth = flamegraphData.lazyIDsByDepth;
	
	  // Initialize enough of the flamegraph to include the focused Fiber.
	  // Otherwise the horizontal scale will be off.
	
	  if (selectedFiberID !== null) {
	    var index = lazyIDsByDepth.length;
	    while (lazyIDToDepthMap[selectedFiberID] === undefined && index < flameGraphDepth) {
	      calculateFibersAtDepth(flamegraphData, index, snapshot);
	      index++;
	    }
	  }
	
	  // Pass required contextual data down to the ListItem renderer.
	  // (This method is memoized so it's safe to call on every render.)
	  var itemData = getItemData(flamegraphData, inspectFiber, selectedFiberID, selectFiber, snapshot, theme, width);
	
	  // If a commit is small and fast enough, it's possible for it to contain no base time values > 0.
	  // In this case, we could only display an empty graph.
	  if (flameGraphDepth === 0) {
	    return _react2.default.createElement(_NoSnapshotDataMessage2.default, { height: height, width: width });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    {
	      onClick: deselectFiber,
	      style: { height: height, width: width }
	    },
	    _react2.default.createElement(
	      _reactWindow.FixedSizeList,
	      {
	        height: height,
	        innerTagName: 'svg',
	        itemCount: flameGraphDepth,
	        itemData: itemData,
	        itemSize: _constants.barHeight,
	        width: width
	      },
	      ListItem
	    )
	  );
	};
	
	var ListItem = function (_PureComponent) {
	  _inherits(ListItem, _PureComponent);
	
	  function ListItem() {
	    var _ref4;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call.apply(_ref4, [this].concat(args))), _this), _this.handleClick = function (id, name, event) {
	      event.stopPropagation();
	      var itemData = _this.props.data;
	      itemData.selectFiber(id, name);
	    }, _this.handleDoubleClick = function (id, name, event) {
	      event.stopPropagation();
	      var itemData = _this.props.data;
	      itemData.inspectFiber(id, name);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ListItem, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          index = _props.index,
	          style = _props.style;
	
	      var itemData = this.props.data;
	
	      var flamegraphData = itemData.flamegraphData,
	          scaleX = itemData.scaleX,
	          selectedFiberID = itemData.selectedFiberID,
	          snapshot = itemData.snapshot,
	          width = itemData.width;
	      var lazyIDToDepthMap = flamegraphData.lazyIDToDepthMap,
	          lazyIDToXMap = flamegraphData.lazyIDToXMap,
	          maxSelfDuration = flamegraphData.maxSelfDuration,
	          selfDurations = flamegraphData.selfDurations;
	      var committedNodes = snapshot.committedNodes,
	          nodes = snapshot.nodes;
	
	      // List items are absolutely positioned using the CSS "top" attribute.
	      // The "left" value will always be 0.
	      // Since height is fixed, and width is based on the node's duration,
	      // We can ignore those values as well.
	
	      var top = parseInt(style.top, 10);
	
	      var ids = calculateFibersAtDepth(flamegraphData, index, snapshot);
	
	      var focusedNodeIndex = 0;
	      var focusedNodeX = 0;
	      if (selectedFiberID !== null) {
	        focusedNodeIndex = lazyIDToDepthMap[selectedFiberID] || 0;
	        focusedNodeX = scaleX(lazyIDToXMap[selectedFiberID], 0) || 0;
	      }
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        ids.map(function (id) {
	          var fiber = nodes.get(id);
	          var treeBaseDuration = fiber.get('treeBaseDuration');
	          var nodeWidth = scaleX(treeBaseDuration, width);
	
	          // Filter out nodes that are too small to see or click.
	          // This also helps render large trees faster.
	          if (nodeWidth < _constants.barWidthThreshold) {
	            return null;
	          }
	
	          var nodeX = scaleX(lazyIDToXMap[id], 0);
	
	          // Filter out nodes that are outside of the horizontal window.
	          if (nodeX + nodeWidth < focusedNodeX || nodeX > focusedNodeX + width) {
	            return null;
	          }
	
	          var actualDuration = fiber.get('actualDuration') || 0;
	          var selfDuration = selfDurations[id] || 0;
	          var name = fiber.get('name') || 'Unknown';
	          var didRender = committedNodes.includes(id);
	
	          var color = _constants.didNotRender;
	          var label = name;
	          if (didRender) {
	            color = (0, _constants.getGradientColor)(selfDuration / maxSelfDuration);
	            label = name + ' (' + selfDuration.toFixed(1) + 'ms of ' + actualDuration.toFixed(1) + 'ms)';
	          }
	
	          return _react2.default.createElement(_ChartNode2.default, {
	            color: color,
	            height: _constants.barHeight,
	            isDimmed: index < focusedNodeIndex,
	            key: id,
	            label: label,
	            onClick: _this2.handleClick.bind(_this2, id, name),
	            onDoubleClick: _this2.handleDoubleClick.bind(_this2, id, name),
	            theme: itemData.theme,
	            title: label,
	            width: nodeWidth,
	            x: nodeX - focusedNodeX,
	            y: top
	          });
	        })
	      );
	    }
	  }]);
	
	  return ListItem;
	}(_react.PureComponent);
	
	var convertSnapshotToChartData = function convertSnapshotToChartData(showNativeNodes, snapshot) {
	  var _computeSelfDurations = computeSelfDurations(snapshot, showNativeNodes),
	      _computeSelfDurations2 = _slicedToArray(_computeSelfDurations, 2),
	      selfDurations = _computeSelfDurations2[0],
	      maxSelfDuration = _computeSelfDurations2[1];
	
	  var flamegraphData = {
	    flameGraphDepth: calculateFlameGraphDepth(showNativeNodes, snapshot),
	    lazyIDToDepthMap: {},
	    lazyIDToXMap: {},
	    lazyIDsByDepth: [],
	    maxSelfDuration: maxSelfDuration,
	    selfDurations: selfDurations,
	    showNativeNodes: showNativeNodes
	  };
	
	  // Pre-calculate the first row in the List.
	  // Later calls to calculateFibersAtDepth() depend on this being initialized.
	  flamegraphData.lazyIDsByDepth[0] = calculateFibersAtDepthCrawler(0, flamegraphData, snapshot.root, 0, [], snapshot);
	
	  return flamegraphData;
	};
	
	var calculateFlameGraphDepth = function calculateFlameGraphDepth(showNativeNodes, snapshot) {
	  var maxDepth = 0;
	
	  var walkTree = function walkTree(nodeID) {
	    var currentDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    var nodeType = snapshot.nodes.getIn([nodeID, 'nodeType']);
	
	    if (nodeType === undefined) {
	      return;
	    } else if (nodeType === 'Composite' || showNativeNodes && nodeType === 'Native') {
	      currentDepth++;
	
	      maxDepth = Math.max(maxDepth, currentDepth);
	    }
	
	    var children = snapshot.nodes.getIn([nodeID, 'children']);
	    if (Array.isArray(children)) {
	      children.forEach(function (childID) {
	        return walkTree(childID, currentDepth);
	      });
	    } else if (children != null) {
	      walkTree(children, currentDepth);
	    }
	  };
	
	  walkTree(snapshot.root);
	
	  return maxDepth;
	};
	
	var getItemData = (0, _memoizeOne2.default)(function (flamegraphData, inspectFiber, selectedFiberID, selectFiber, snapshot, theme, width) {
	  var maxTreeBaseDuration = getMaxTreeBaseDuration(flamegraphData, selectedFiberID, snapshot);
	  return {
	    flamegraphData: flamegraphData,
	    inspectFiber: inspectFiber,
	    maxTreeBaseDuration: maxTreeBaseDuration,
	    scaleX: (0, _constants.scale)(0, maxTreeBaseDuration, 0, width),
	    selectedFiberID: selectedFiberID,
	    selectFiber: selectFiber,
	    snapshot: snapshot,
	    theme: theme,
	    width: width
	  };
	});
	
	var getMaxTreeBaseDuration = function getMaxTreeBaseDuration(flamegraphData, selectedFiberID, snapshot) {
	  var baseNodeID = flamegraphData.lazyIDsByDepth[0][0];
	
	  // If the selected fiber is in a different root,
	  // Just scale everything to the base node in this flamegraph.
	  // Even if the root matches, it's possible the Fiber won't be included in this commit though.
	  // (For example, it may have been removed.)
	  // In that case, we should still fallback to the base node time.
	  return snapshot.nodes.getIn([selectedFiberID, 'treeBaseDuration']) || snapshot.nodes.getIn([baseNodeID, 'treeBaseDuration']);
	};
	
	var computeSelfDurations = (0, _memoizeOne2.default)(function (snapshot, showNativeNodes) {
	  var committedNodes = snapshot.committedNodes,
	      nodes = snapshot.nodes;
	
	  var selfDurations = {};
	
	  var maxSelfDuration = 0;
	
	  committedNodes.filter(function (nodeID) {
	    var nodeType = nodes.getIn([nodeID, 'nodeType']);
	    return nodeType === 'Composite' || nodeType === 'Native' && showNativeNodes;
	  }).forEach(function (nodeID) {
	    var selfDuration = (0, _constants.calculateSelfDuration)(snapshot, nodeID);
	
	    selfDurations[nodeID] = selfDuration;
	    maxSelfDuration = Math.max(maxSelfDuration, selfDuration);
	  });
	
	  return [selfDurations, maxSelfDuration];
	});
	
	// This method depends on rows being initialized in-order.
	var calculateFibersAtDepth = function calculateFibersAtDepth(flamegraphData, depth, snapshot) {
	  var lazyIDsByDepth = flamegraphData.lazyIDsByDepth,
	      lazyIDToXMap = flamegraphData.lazyIDToXMap;
	
	  var _loop = function _loop(index) {
	    var nodesAtPreviousDepth = lazyIDsByDepth[index - 1];
	    lazyIDsByDepth[index] = nodesAtPreviousDepth.reduce(function (nodesAtDepth, parentID) {
	      return calculateFibersAtDepthCrawler(index, flamegraphData, parentID, lazyIDToXMap[parentID], nodesAtDepth, snapshot);
	    }, []);
	  };
	
	  for (var index = lazyIDsByDepth.length; index <= depth; index++) {
	    _loop(index);
	  }
	
	  return lazyIDsByDepth[depth];
	};
	
	var calculateFibersAtDepthCrawler = function calculateFibersAtDepthCrawler(depth, flamegraphData, id) {
	  var leftOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	  var nodesAtDepth = arguments[4];
	  var snapshot = arguments[5];
	  var lazyIDToDepthMap = flamegraphData.lazyIDToDepthMap,
	      lazyIDToXMap = flamegraphData.lazyIDToXMap,
	      showNativeNodes = flamegraphData.showNativeNodes;
	  var nodes = snapshot.nodes;
	
	
	  var children = nodes.getIn([id, 'children']);
	  var childArray = null;
	  if (Array.isArray(children)) {
	    childArray = children;
	  } else if (children != null) {
	    childArray = [children];
	  }
	
	  if (childArray !== null) {
	    childArray.forEach(function (childID) {
	      var fiber = nodes.get(childID);
	      if (fiber === undefined) {
	        // Bailout on Text nodes
	        return;
	      }
	
	      var nodeType = fiber.get('nodeType');
	
	      if (nodeType !== 'Composite' && (nodeType !== 'Native' || !showNativeNodes)) {
	        // Skip over native fibers if they are being filtered from the view
	        calculateFibersAtDepthCrawler(depth, flamegraphData, childID, leftOffset, nodesAtDepth, snapshot);
	      } else {
	        var prevID = nodesAtDepth.length ? nodesAtDepth[nodesAtDepth.length - 1] : null;
	        var prevNodeTreeBaseDuration = nodes.getIn([prevID, 'treeBaseDuration']) || 0;
	        var prevNodeX = prevID !== null ? lazyIDToXMap[prevID] : 0;
	
	        var x = Math.max(leftOffset, prevNodeX + prevNodeTreeBaseDuration);
	
	        nodesAtDepth.push(childID);
	
	        lazyIDToDepthMap[childID] = depth;
	        lazyIDToXMap[childID] = x;
	      }
	    });
	  }
	
	  return nodesAtDepth;
	};
	
	exports.default = SnapshotFlamegraph;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Fonts = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var height = _ref.height,
	      width = _ref.width;
	  return _react2.default.createElement(
	    'div',
	    { style: {
	        display: 'flex',
	        flexDirection: 'column',
	        alignItems: 'center',
	        justifyContent: 'center',
	        textAlign: 'center',
	        height: height,
	        width: width
	      } },
	    _react2.default.createElement(
	      'p',
	      { style: {
	          fontSize: _Fonts.sansSerif.sizes.large
	        } },
	      'There is no timing data to display for the currently selected commit.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This can indicate that a render occurred too quickly for the timing API to measure. Try selecting another commit in the upper, right-hand corner.'
	    )
	  );
	};

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _memoizeOne = __webpack_require__(354);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualizedAutoSizer = __webpack_require__(356);
	
	var _reactVirtualizedAutoSizer2 = _interopRequireDefault(_reactVirtualizedAutoSizer);
	
	var _reactWindow = __webpack_require__(357);
	
	var _ChartNode = __webpack_require__(358);
	
	var _ChartNode2 = _interopRequireDefault(_ChartNode);
	
	var _NoSnapshotDataMessage = __webpack_require__(364);
	
	var _NoSnapshotDataMessage2 = _interopRequireDefault(_NoSnapshotDataMessage);
	
	var _constants = __webpack_require__(353);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SnapshotRanked = function SnapshotRanked(_ref) {
	  var cacheDataForSnapshot = _ref.cacheDataForSnapshot,
	      deselectFiber = _ref.deselectFiber,
	      getCachedDataForSnapshot = _ref.getCachedDataForSnapshot,
	      inspectFiber = _ref.inspectFiber,
	      selectedFiberID = _ref.selectedFiberID,
	      selectFiber = _ref.selectFiber,
	      showNativeNodes = _ref.showNativeNodes,
	      snapshot = _ref.snapshot,
	      snapshotIndex = _ref.snapshotIndex,
	      theme = _ref.theme;
	
	  // Cache data in ProfilerStore so we only have to compute it the first time a Snapshot is shown.
	  var dataKey = showNativeNodes ? 'SnapshotRankedDataWithNativeNodes' : 'SnapshotRankedDataWithoutNativeNodes';
	  var rankedData = getCachedDataForSnapshot(snapshotIndex, snapshot.root, dataKey);
	  if (rankedData === null) {
	    rankedData = convertSnapshotToChartData(snapshot, showNativeNodes);
	    cacheDataForSnapshot(snapshotIndex, snapshot.root, dataKey, rankedData);
	  }
	
	  return _react2.default.createElement(
	    _reactVirtualizedAutoSizer2.default,
	    null,
	    function (_ref2) {
	      var height = _ref2.height,
	          width = _ref2.width;
	      return _react2.default.createElement(SnapshotRankedInner, {
	        deselectFiber: deselectFiber,
	        height: height,
	        inspectFiber: inspectFiber,
	        rankedData: rankedData,
	        selectedFiberID: selectedFiberID,
	        selectFiber: selectFiber,
	        snapshot: snapshot,
	        theme: theme,
	        width: width
	      });
	    }
	  );
	};
	
	var SnapshotRankedInner = function SnapshotRankedInner(_ref3) {
	  var deselectFiber = _ref3.deselectFiber,
	      height = _ref3.height,
	      inspectFiber = _ref3.inspectFiber,
	      rankedData = _ref3.rankedData,
	      selectedFiberID = _ref3.selectedFiberID,
	      selectFiber = _ref3.selectFiber,
	      snapshot = _ref3.snapshot,
	      theme = _ref3.theme,
	      width = _ref3.width;
	
	  // If a commit contains no fibers with an actualDuration > 0,
	  // Display a fallback message.
	  if (rankedData.nodes.length === 0) {
	    return _react2.default.createElement(_NoSnapshotDataMessage2.default, { height: height, width: width });
	  }
	
	  var focusedNodeIndex = getNodeIndex(rankedData, selectedFiberID);
	
	  // The following conversion methods are memoized,
	  // So it's okay to call them on every render.
	  var itemData = getItemData(focusedNodeIndex, inspectFiber, rankedData, selectFiber, snapshot, theme, width);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      onClick: deselectFiber,
	      style: { height: height, width: width }
	    },
	    _react2.default.createElement(
	      _reactWindow.FixedSizeList,
	      {
	        height: height,
	        innerTagName: 'svg',
	        itemCount: rankedData.nodes.length,
	        itemData: itemData,
	        itemSize: _constants.barHeight,
	        width: width
	      },
	      ListItem
	    )
	  );
	};
	
	var ListItem = function (_PureComponent) {
	  _inherits(ListItem, _PureComponent);
	
	  function ListItem() {
	    var _ref4;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call.apply(_ref4, [this].concat(args))), _this), _this.handleClick = function (event) {
	      event.stopPropagation();
	      var _this$props = _this.props,
	          data = _this$props.data,
	          index = _this$props.index;
	
	      var node = data.nodes[index];
	      data.selectFiber(node.id, node.name, data.snapshot.root);
	    }, _this.handleDoubleClick = function (event) {
	      event.stopPropagation();
	      var _this$props2 = _this.props,
	          data = _this$props2.data,
	          index = _this$props2.index;
	
	      var node = data.nodes[index];
	      data.inspectFiber(node.id, node.name, data.snapshot.root);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          index = _props.index,
	          style = _props.style;
	
	
	      var node = data.nodes[index];
	
	      var scaleX = data.scaleX,
	          width = data.width;
	
	      // List items are absolutely positioned using the CSS "top" attribute.
	      // The "left" value will always be 0.
	      // Since height is fixed, and width is based on the node's duration,
	      // We can ignore those values as well.
	
	      var top = parseInt(style.top, 10);
	
	      return _react2.default.createElement(_ChartNode2.default, {
	        color: (0, _constants.getGradientColor)(node.value / data.maxValue),
	        height: _constants.barHeight,
	        isDimmed: index < data.focusedNodeIndex,
	        key: node.id,
	        label: node.label,
	        onClick: this.handleClick,
	        onDoubleClick: this.handleDoubleClick,
	        theme: data.theme,
	        title: node.title,
	        width: Math.max(_constants.minBarWidth, scaleX(node.value, width)),
	        x: 0,
	        y: top
	      });
	    }
	  }]);
	
	  return ListItem;
	}(_react.PureComponent);
	
	var getItemData = (0, _memoizeOne2.default)(function (focusedNodeIndex, inspectFiber, rankedData, selectFiber, snapshot, theme, width) {
	  return {
	    focusedNode: rankedData.nodes[focusedNodeIndex],
	    focusedNodeIndex: focusedNodeIndex,
	    inspectFiber: inspectFiber,
	    nodes: rankedData.nodes,
	    maxValue: rankedData.maxValue,
	    scaleX: (0, _constants.scale)(0, rankedData.nodes[focusedNodeIndex].value, 0, width),
	    selectFiber: selectFiber,
	    snapshot: snapshot,
	    theme: theme,
	    width: width
	  };
	});
	
	var getNodeIndex = (0, _memoizeOne2.default)(function (rankedData, id) {
	  if (id === null) {
	    return 0;
	  }
	  var nodes = rankedData.nodes;
	
	  for (var index = 0; index < nodes.length; index++) {
	    if (nodes[index].id === id) {
	      return index;
	    }
	  }
	  return 0;
	});
	
	var convertSnapshotToChartData = function convertSnapshotToChartData(snapshot, showNativeNodes) {
	  var maxSelfDuration = 0;
	
	  var nodes = snapshot.committedNodes.filter(function (nodeID) {
	    var node = snapshot.nodes.get(nodeID);
	    var nodeType = node && node.get('nodeType');
	    return nodeType === 'Composite' || nodeType === 'Native' && showNativeNodes;
	  }).map(function (nodeID, index) {
	    var selfDuration = (0, _constants.calculateSelfDuration)(snapshot, nodeID);
	    maxSelfDuration = Math.max(maxSelfDuration, selfDuration);
	
	    var name = snapshot.nodes.getIn([nodeID, 'name']) || 'Unknown';
	    var label = name + ' (' + selfDuration.toFixed(1) + 'ms)';
	    return {
	      id: nodeID,
	      label: label,
	      name: name,
	      title: label,
	      value: selfDuration
	    };
	  }).sort(function (a, b) {
	    return b.value - a.value;
	  });
	
	  return {
	    maxValue: maxSelfDuration,
	    nodes: nodes
	  };
	};
	
	exports.default = SnapshotRanked;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualizedAutoSizer = __webpack_require__(356);
	
	var _reactVirtualizedAutoSizer2 = _interopRequireDefault(_reactVirtualizedAutoSizer);
	
	var _Hoverable = __webpack_require__(62);
	
	var _Hoverable2 = _interopRequireDefault(_Hoverable);
	
	var _SvgIcon = __webpack_require__(60);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	var _Icons = __webpack_require__(61);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	var _IconButton = __webpack_require__(367);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _SnapshotSelector = __webpack_require__(368);
	
	var _SnapshotSelector2 = _interopRequireDefault(_SnapshotSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CHART_RADIO_LABEL_WIDTH_THRESHOLD = 650;
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _reactVirtualizedAutoSizer2.default,
	    { disableHeight: true },
	    function (_ref) {
	      var width = _ref.width;
	      return _react2.default.createElement(ProfilerTabToolbar, _extends({}, props, { width: width }));
	    }
	  );
	};
	
	var ProfilerTabToolbar = function ProfilerTabToolbar(_ref2) {
	  var commitThreshold = _ref2.commitThreshold,
	      hideCommitsBelowThreshold = _ref2.hideCommitsBelowThreshold,
	      interactionsCount = _ref2.interactionsCount,
	      isInspectingSelectedFiber = _ref2.isInspectingSelectedFiber,
	      isRecording = _ref2.isRecording,
	      selectChart = _ref2.selectChart,
	      selectedChartType = _ref2.selectedChartType,
	      selectedFiberID = _ref2.selectedFiberID,
	      selectedSnapshot = _ref2.selectedSnapshot,
	      selectSnapshot = _ref2.selectSnapshot,
	      snapshotIndex = _ref2.snapshotIndex,
	      snapshots = _ref2.snapshots,
	      theme = _ref2.theme,
	      toggleIsRecording = _ref2.toggleIsRecording,
	      toggleIsSettingsPanelActive = _ref2.toggleIsSettingsPanelActive,
	      width = _ref2.width;
	  return _react2.default.createElement(
	    'div',
	    { style: {
	        display: 'flex',
	        flex: '0 0 auto',
	        padding: '0.25rem',
	        flexWrap: 'wrap',
	        alignItems: 'center',
	        position: 'relative',
	        boxSizing: 'border-box',
	        width: width,
	        userSelect: 'none'
	      } },
	    _react2.default.createElement(RecordButton, {
	      isActive: isRecording,
	      onClick: toggleIsRecording,
	      theme: theme
	    }),
	    _react2.default.createElement(HRule, { theme: theme }),
	    isRecording || snapshots.length === 0 && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement('div', { style: { flex: 1 } }),
	      _react2.default.createElement(_IconButton2.default, {
	        icon: _Icons2.default.SETTINGS,
	        isTransparent: true,
	        label: 'Profiler settings',
	        onClick: toggleIsSettingsPanelActive,
	        theme: theme
	      })
	    ),
	    !isRecording && snapshots.length > 0 && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(RadioOption, {
	        icon: _Icons2.default.FLAME_CHART,
	        isChecked: selectedChartType === 'flamegraph',
	        isDisabled: isInspectingSelectedFiber,
	        label: 'Flamegraph',
	        onChange: function onChange() {
	          return selectChart('flamegraph');
	        },
	        theme: theme,
	        width: width
	      }),
	      '\xA0',
	      _react2.default.createElement(RadioOption, {
	        icon: _Icons2.default.RANKED_CHART,
	        isChecked: selectedChartType === 'ranked',
	        isDisabled: isInspectingSelectedFiber,
	        label: 'Ranked',
	        onChange: function onChange() {
	          return selectChart('ranked');
	        },
	        theme: theme,
	        width: width
	      }),
	      '\xA0',
	      _react2.default.createElement(RadioOption, {
	        icon: _Icons2.default.INTERACTION,
	        isChecked: selectedChartType === 'interactions',
	        isDisabled: isInspectingSelectedFiber,
	        label: 'Interactions (' + interactionsCount + ')',
	        onChange: function onChange() {
	          return selectChart('interactions');
	        },
	        theme: theme,
	        width: width
	      }),
	      _react2.default.createElement('div', { style: { flex: 1 } }),
	      _react2.default.createElement(_IconButton2.default, {
	        icon: _Icons2.default.SETTINGS,
	        isTransparent: true,
	        label: 'Profiler settings',
	        onClick: toggleIsSettingsPanelActive,
	        theme: theme
	      }),
	      selectedChartType !== 'interactions' && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(HRule, { theme: theme }),
	        _react2.default.createElement(_SnapshotSelector2.default, {
	          commitThreshold: commitThreshold,
	          hideCommitsBelowThreshold: hideCommitsBelowThreshold,
	          isInspectingSelectedFiber: isInspectingSelectedFiber,
	          selectedFiberID: selectedFiberID,
	          selectedSnapshot: selectedSnapshot,
	          selectSnapshot: selectSnapshot,
	          snapshotIndex: snapshotIndex,
	          snapshots: snapshots,
	          theme: theme
	        })
	      )
	    )
	  );
	};
	
	var HRule = function HRule(_ref3) {
	  var theme = _ref3.theme;
	  return _react2.default.createElement('div', { style: {
	      height: '18px',
	      width: '1px',
	      backgroundColor: theme.base03,
	      margin: '0px 0.5rem 0 0.25rem'
	    } });
	};
	
	var RadioOption = (0, _Hoverable2.default)(function (_ref4) {
	  var icon = _ref4.icon,
	      isChecked = _ref4.isChecked,
	      _ref4$isDisabled = _ref4.isDisabled,
	      isDisabled = _ref4$isDisabled === undefined ? false : _ref4$isDisabled,
	      isHovered = _ref4.isHovered,
	      label = _ref4.label,
	      onChange = _ref4.onChange,
	      onMouseEnter = _ref4.onMouseEnter,
	      onMouseLeave = _ref4.onMouseLeave,
	      theme = _ref4.theme,
	      width = _ref4.width;
	  return _react2.default.createElement(
	    'label',
	    {
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      style: {
	        color: isHovered ? theme.state06 : 'inherit',
	        marginRight: '0.5rem',
	        cursor: 'pointer',
	        opacity: isDisabled ? 0.5 : 1,
	        pointerEvents: isDisabled ? 'none' : 'auto'
	      },
	      title: label
	    },
	    _react2.default.createElement('input', {
	      disabled: isDisabled,
	      type: 'radio',
	      checked: isChecked,
	      onChange: onChange
	    }),
	    _react2.default.createElement(_SvgIcon2.default, {
	      path: icon,
	      style: {
	        flex: '0 0 1rem',
	        width: '1rem',
	        height: '1rem',
	        fill: 'currentColor',
	        display: 'inline',
	        verticalAlign: 'sub',
	        margin: '0 0.25rem'
	      }
	    }),
	    width >= CHART_RADIO_LABEL_WIDTH_THRESHOLD && _react2.default.createElement(
	      'span',
	      null,
	      label
	    )
	  );
	});
	
	var RecordButton = (0, _Hoverable2.default)(function (_ref5) {
	  var isActive = _ref5.isActive,
	      isHovered = _ref5.isHovered,
	      onClick = _ref5.onClick,
	      onMouseEnter = _ref5.onMouseEnter,
	      onMouseLeave = _ref5.onMouseLeave,
	      theme = _ref5.theme;
	  return _react2.default.createElement(
	    'button',
	    {
	      onClick: onClick,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      style: {
	        background: 'none',
	        border: 'none',
	        outline: 'none',
	        cursor: 'pointer',
	        color: isActive ? theme.special03 : isHovered ? theme.state06 : theme.base05,
	        filter: isActive ? 'drop-shadow( 0 0 2px ' + theme.special03 + ' )' : 'none',
	        padding: '4px'
	      },
	      title: isActive ? 'Stop profiling' : 'Start profiling'
	    },
	    _react2.default.createElement(_SvgIcon2.default, {
	      path: _Icons2.default.RECORD,
	      style: {
	        flex: '0 0 1rem',
	        width: '1rem',
	        height: '1rem',
	        fill: 'currentColor',
	        display: 'inline',
	        verticalAlign: 'sub'
	      }
	    })
	  );
	});

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hoverable = __webpack_require__(62);
	
	var _Hoverable2 = _interopRequireDefault(_Hoverable);
	
	var _SvgIcon = __webpack_require__(60);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconButton = (0, _Hoverable2.default)(function (_ref) {
	  var disabled = _ref.disabled,
	      icon = _ref.icon,
	      _ref$isActive = _ref.isActive,
	      isActive = _ref$isActive === undefined ? false : _ref$isActive,
	      isHovered = _ref.isHovered,
	      _ref$isTransparent = _ref.isTransparent,
	      isTransparent = _ref$isTransparent === undefined ? false : _ref$isTransparent,
	      onClick = _ref.onClick,
	      onMouseEnter = _ref.onMouseEnter,
	      onMouseLeave = _ref.onMouseLeave,
	      style = _ref.style,
	      theme = _ref.theme,
	      title = _ref.title;
	  return _react2.default.createElement(
	    'button',
	    {
	      disabled: disabled,
	      onClick: onClick,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      style: _extends({
	        position: 'relative',
	        width: '1.5rem',
	        height: '1.5rem',
	        background: isTransparent ? 'none' : theme.base00,
	        border: 'none',
	        borderRadius: '0.125rem',
	        outline: 'none',
	        cursor: disabled ? 'default' : 'pointer',
	        color: isActive ? theme.state00 : isHovered ? theme.state06 : theme.base05,
	        opacity: disabled ? 0.5 : 1
	      }, style),
	      title: title
	    },
	    _react2.default.createElement(_SvgIcon2.default, {
	      path: icon,
	      style: {
	        position: 'absolute',
	        top: '50%',
	        bottom: '50%',
	        transform: 'translate(-50%, -50%)'
	      }
	    })
	  );
	});
	
	exports.default = IconButton;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _memoizeOne = __webpack_require__(354);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualizedAutoSizer = __webpack_require__(356);
	
	var _reactVirtualizedAutoSizer2 = _interopRequireDefault(_reactVirtualizedAutoSizer);
	
	var _reactWindow = __webpack_require__(357);
	
	var _constants = __webpack_require__(353);
	
	var _Icons = __webpack_require__(61);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	var _IconButton = __webpack_require__(367);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HEIGHT = 20;
	
	exports.default = function (_ref) {
	  var commitThreshold = _ref.commitThreshold,
	      hideCommitsBelowThreshold = _ref.hideCommitsBelowThreshold,
	      isInspectingSelectedFiber = _ref.isInspectingSelectedFiber,
	      selectedFiberID = _ref.selectedFiberID,
	      selectedSnapshot = _ref.selectedSnapshot,
	      selectSnapshot = _ref.selectSnapshot,
	      snapshotIndex = _ref.snapshotIndex,
	      snapshots = _ref.snapshots,
	      theme = _ref.theme;
	
	  var filteredData = (0, _constants.getFilteredSnapshotData)(commitThreshold, hideCommitsBelowThreshold, isInspectingSelectedFiber, selectedFiberID, selectedSnapshot, snapshotIndex, snapshots);
	
	  return _react2.default.createElement(SnapshotSelectorWrapper, {
	    commitThreshold: commitThreshold,
	    hideCommitsBelowThreshold: hideCommitsBelowThreshold,
	    isInspectingSelectedFiber: isInspectingSelectedFiber,
	    selectedFiberID: selectedFiberID,
	    selectedSnapshot: selectedSnapshot,
	    selectSnapshot: selectSnapshot,
	    snapshotIndex: filteredData.snapshotIndex,
	    snapshots: filteredData.snapshots,
	    theme: theme
	  });
	};
	
	var SnapshotSelectorWrapper = function (_PureComponent) {
	  _inherits(SnapshotSelectorWrapper, _PureComponent);
	
	  function SnapshotSelectorWrapper() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SnapshotSelectorWrapper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SnapshotSelectorWrapper.__proto__ || Object.getPrototypeOf(SnapshotSelectorWrapper)).call.apply(_ref2, [this].concat(args))), _this), _this.handleKeyDown = function (event) {
	      if (event.keyCode === LEFT_ARROW || event.keyCode === RIGHT_ARROW) {
	        event.preventDefault();
	
	        if (event.keyCode === LEFT_ARROW) {
	          _this.selectPreviousSnapshotIndex();
	        } else {
	          _this.selectNextSnapshotIndex();
	        }
	      }
	    }, _this.selectNextSnapshotIndex = function () {
	      var _this$props = _this.props,
	          selectSnapshot = _this$props.selectSnapshot,
	          snapshotIndex = _this$props.snapshotIndex,
	          snapshots = _this$props.snapshots;
	
	
	      if (snapshots.length > 0 && snapshotIndex < snapshots.length - 1) {
	        var newIndex = snapshotIndex + 1;
	        selectSnapshot(snapshots[newIndex]);
	      }
	    }, _this.selectPreviousSnapshotIndex = function () {
	      var _this$props2 = _this.props,
	          selectSnapshot = _this$props2.selectSnapshot,
	          snapshotIndex = _this$props2.snapshotIndex,
	          snapshots = _this$props2.snapshots;
	
	
	      if (snapshots.length > 0 && snapshotIndex > 0) {
	        var newIndex = snapshotIndex - 1;
	        selectSnapshot(snapshots[newIndex]);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SnapshotSelectorWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          commitThreshold = _props.commitThreshold,
	          hideCommitsBelowThreshold = _props.hideCommitsBelowThreshold,
	          isInspectingSelectedFiber = _props.isInspectingSelectedFiber,
	          selectedFiberID = _props.selectedFiberID,
	          selectedSnapshot = _props.selectedSnapshot,
	          selectSnapshot = _props.selectSnapshot,
	          snapshotIndex = _props.snapshotIndex,
	          snapshots = _props.snapshots,
	          theme = _props.theme;
	
	
	      var numSnapshots = snapshots.length;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onKeyDown: this.handleKeyDown,
	          style: {
	            display: 'flex',
	            flex: '1 0 auto',
	            alignItems: 'center',
	            outline: 'none'
	          },
	          tabIndex: 0
	        },
	        numSnapshots === 0 && _react2.default.createElement(
	          'span',
	          { style: { whiteSpace: 'nowrap' } },
	          '0 / 0'
	        ),
	        numSnapshots > 0 && _react2.default.createElement(
	          'span',
	          { style: { whiteSpace: 'nowrap' } },
	          ('' + (snapshotIndex >= 0 ? snapshotIndex + 1 : '-')).padStart(('' + numSnapshots).length, '0'),
	          ' / ',
	          numSnapshots
	        ),
	        _react2.default.createElement(_IconButton2.default, {
	          disabled: snapshotIndex <= 0,
	          icon: _Icons2.default.BACK,
	          isTransparent: true,
	          onClick: this.selectPreviousSnapshotIndex,
	          theme: theme,
	          title: 'Previous render'
	        }),
	        _react2.default.createElement(AutoSizedSnapshotSelector, {
	          commitThreshold: commitThreshold,
	          hideCommitsBelowThreshold: hideCommitsBelowThreshold,
	          isInspectingSelectedFiber: isInspectingSelectedFiber,
	          selectedFiberID: selectedFiberID,
	          selectedSnapshot: selectedSnapshot,
	          selectSnapshot: selectSnapshot,
	          snapshotIndex: snapshotIndex,
	          snapshots: snapshots,
	          theme: theme
	        }),
	        _react2.default.createElement(_IconButton2.default, {
	          disabled: numSnapshots === 0 || snapshotIndex >= numSnapshots - 1,
	          icon: _Icons2.default.FORWARD,
	          isTransparent: true,
	          onClick: this.selectNextSnapshotIndex,
	          theme: theme,
	          title: 'Next render'
	        })
	      );
	    }
	  }]);
	
	  return SnapshotSelectorWrapper;
	}(_react.PureComponent);
	
	var AutoSizedSnapshotSelector = function AutoSizedSnapshotSelector(_ref3) {
	  var isInspectingSelectedFiber = _ref3.isInspectingSelectedFiber,
	      selectedFiberID = _ref3.selectedFiberID,
	      selectedSnapshot = _ref3.selectedSnapshot,
	      selectSnapshot = _ref3.selectSnapshot,
	      snapshotIndex = _ref3.snapshotIndex,
	      snapshots = _ref3.snapshots,
	      theme = _ref3.theme;
	  return _react2.default.createElement(
	    'div',
	    { style: {
	        flex: '1 1 100px',
	        height: HEIGHT,
	        display: 'grid',
	        alignitems: 'flex-end',
	        gridGap: '1px',
	        gridAutoFlow: 'column',
	        backgroundColor: theme.base00
	      } },
	    _react2.default.createElement(
	      _reactVirtualizedAutoSizer2.default,
	      { disableHeight: true },
	      function (_ref4) {
	        var height = _ref4.height,
	            width = _ref4.width;
	        return _react2.default.createElement(SnapshotSelector, {
	          height: HEIGHT,
	          selectedFiberID: selectedFiberID,
	          selectedSnapshot: selectedSnapshot,
	          selectSnapshot: selectSnapshot,
	          snapshotIndex: snapshotIndex,
	          snapshots: snapshots,
	          theme: theme,
	          width: width
	        });
	      }
	    )
	  );
	};
	
	var LEFT_ARROW = 37;
	var RIGHT_ARROW = 39;
	
	var SnapshotSelector = function (_PureComponent2) {
	  _inherits(SnapshotSelector, _PureComponent2);
	
	  function SnapshotSelector() {
	    var _ref5;
	
	    var _temp2, _this2, _ret2;
	
	    _classCallCheck(this, SnapshotSelector);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref5 = SnapshotSelector.__proto__ || Object.getPrototypeOf(SnapshotSelector)).call.apply(_ref5, [this].concat(args))), _this2), _this2.listRef = _react2.default.createRef(), _this2.state = {
	      isMouseDown: false
	    }, _this2.handleMouseDown = function (event) {
	      return _this2.setState({ isMouseDown: true }, function () {
	        window.addEventListener('mouseup', _this2.handleMouseUp);
	      });
	    }, _this2.handleMouseUp = function (event) {
	      return _this2.setState({ isMouseDown: false });
	    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	  }
	  // $FlowFixMe createRef()
	
	
	  _createClass(SnapshotSelector, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // Make sure any newly selected snapshot is visible within the list.
	      if (this.props.snapshotIndex !== prevProps.snapshotIndex && this.listRef.current !== null) {
	        this.listRef.current.scrollToItem(this.props.snapshotIndex);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          height = _props2.height,
	          selectedSnapshot = _props2.selectedSnapshot,
	          selectSnapshot = _props2.selectSnapshot,
	          snapshots = _props2.snapshots,
	          theme = _props2.theme,
	          width = _props2.width;
	      var isMouseDown = this.state.isMouseDown;
	
	
	      var listData = getListData(snapshots, width);
	
	      // Pass required contextual data down to the ListItem renderer.
	      // (This method is memoized so it's safe to call on every render.)
	      var itemData = getItemData(isMouseDown, listData.maxDuration, selectSnapshot, selectedSnapshot, snapshots, theme);
	
	      var numSnapshots = snapshots.length;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseDown: this.handleMouseDown,
	          onMouseUp: this.handleMouseUp,
	          style: { height: height, width: width }
	        },
	        numSnapshots > 0 && _react2.default.createElement(
	          _reactWindow.FixedSizeList,
	          {
	            direction: 'horizontal',
	            height: height,
	            itemCount: snapshots.length,
	            itemData: itemData,
	            itemSize: listData.itemSize,
	            ref: this.listRef,
	            width: width
	          },
	          ListItem
	        )
	      );
	    }
	  }]);
	
	  return SnapshotSelector;
	}(_react.PureComponent);
	
	var ListItem = function (_PureComponent3) {
	  _inherits(ListItem, _PureComponent3);
	
	  function ListItem() {
	    var _ref6;
	
	    var _temp3, _this3, _ret3;
	
	    _classCallCheck(this, ListItem);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref6 = ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call.apply(_ref6, [this].concat(args))), _this3), _this3.handleMouseEnter = function () {
	      var itemData = _this3.props.data;
	      if (itemData.isMouseDown) {
	        itemData.selectSnapshot(itemData.snapshots[_this3.props.index]);
	      }
	    }, _temp3), _possibleConstructorReturn(_this3, _ret3);
	  }
	
	  _createClass(ListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          index = _props3.index,
	          style = _props3.style;
	
	      var itemData = this.props.data;
	
	      var maxDuration = itemData.maxDuration,
	          selectedSnapshot = itemData.selectedSnapshot,
	          selectSnapshot = itemData.selectSnapshot,
	          snapshots = itemData.snapshots,
	          theme = itemData.theme;
	
	
	      var snapshot = snapshots[index];
	      // Guard against commits with duration 0
	      var percentage = Math.min(1, Math.max(0, snapshot.duration / maxDuration)) || 0;
	      var isSelected = selectedSnapshot === snapshot;
	
	      var width = parseFloat(style.width) - 1;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onClick: function onClick() {
	            return selectSnapshot(snapshot);
	          },
	          onMouseEnter: this.handleMouseEnter,
	          style: _extends({}, style, {
	            width: width,
	            backgroundColor: isSelected ? theme.base01 : 'transparent',
	            userSelect: 'none',
	            cursor: 'pointer'
	          }),
	          title: 'Duration ' + (0, _constants.formatDuration)(snapshot.duration) + 'ms at ' + (0, _constants.formatTime)(snapshot.commitTime) + 's'
	        },
	        _react2.default.createElement('div', { style: {
	            position: 'absolute',
	            bottom: 0,
	            width: width,
	            height: Math.max(_constants.minBarHeight, percentage * HEIGHT),
	            backgroundColor: isSelected ? theme.state06 : percentage === 0 ? _constants.didNotRender : (0, _constants.getGradientColor)(percentage)
	          } })
	      );
	    }
	  }]);
	
	  return ListItem;
	}(_react.PureComponent);
	
	var getListData = (0, _memoizeOne2.default)(function (snapshots, width) {
	  return {
	    itemSize: Math.max(_constants.minBarWidth, width / snapshots.length),
	    maxDuration: snapshots.reduce(function (maxDuration, snapshot) {
	      return Math.max(maxDuration, snapshot.duration);
	    }, 0)
	  };
	});
	
	var getItemData = (0, _memoizeOne2.default)(function (isMouseDown, maxDuration, selectSnapshot, selectedSnapshot, snapshots, theme) {
	  return {
	    isMouseDown: isMouseDown,
	    maxDuration: maxDuration,
	    selectSnapshot: selectSnapshot,
	    selectedSnapshot: selectedSnapshot,
	    snapshots: snapshots,
	    theme: theme
	  };
	});

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Fonts = __webpack_require__(17);
	
	var _DataView = __webpack_require__(24);
	
	var _DataView2 = _interopRequireDefault(_DataView);
	
	var _DetailPane = __webpack_require__(52);
	
	var _DetailPane2 = _interopRequireDefault(_DetailPane);
	
	var _DetailPaneSection = __webpack_require__(53);
	
	var _DetailPaneSection2 = _interopRequireDefault(_DetailPaneSection);
	
	var _Icons = __webpack_require__(61);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	var _IconButton = __webpack_require__(367);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyFunction = function emptyFunction() {};
	
	var ProfilerFiberDetailPane = function ProfilerFiberDetailPane(_ref) {
	  var deselectFiber = _ref.deselectFiber,
	      isInspectingSelectedFiber = _ref.isInspectingSelectedFiber,
	      _ref$name = _ref.name,
	      name = _ref$name === undefined ? 'Unknown' : _ref$name,
	      snapshot = _ref.snapshot,
	      snapshotFiber = _ref.snapshotFiber,
	      theme = _ref.theme,
	      toggleInspectingSelectedFiber = _ref.toggleInspectingSelectedFiber;
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: {
	          height: '2rem',
	          lineHeight: '2rem',
	          backgroundColor: theme.base01,
	          borderBottom: '1px solid ' + theme.base03
	        } },
	      _react2.default.createElement(
	        'div',
	        { style: {
	            width: '100%',
	            height: '100%',
	            display: 'flex',
	            flexDirection: 'row',
	            alignItems: 'center',
	            padding: '0.25rem',
	            boxSizing: 'border-box'
	          } },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              fontFamily: _Fonts.monospace.family,
	              fontSize: _Fonts.monospace.sizes.large,
	              overflow: 'hidden',
	              textOverflow: 'ellipsis',
	              whiteSpace: 'nowrap',
	              flex: '1 1 auto'
	            },
	            title: name
	          },
	          name
	        ),
	        _react2.default.createElement(_IconButton2.default, {
	          disabled: isInspectingSelectedFiber,
	          icon: _Icons2.default.BARS,
	          onClick: toggleInspectingSelectedFiber,
	          style: {
	            backgroundColor: theme.state00,
	            color: theme.base00,
	            flex: '0 0 auto'
	          },
	          theme: theme,
	          title: 'Inspect ' + name
	        }),
	        _react2.default.createElement(_IconButton2.default, {
	          icon: _Icons2.default.CLOSE,
	          onClick: isInspectingSelectedFiber ? toggleInspectingSelectedFiber : deselectFiber,
	          style: {
	            marginLeft: '0.25rem',
	            backgroundColor: theme.base03,
	            color: theme.base05,
	            flex: '0 0 auto'
	          },
	          theme: theme,
	          title: 'Close'
	        })
	      )
	    ),
	    snapshotFiber !== null && _react2.default.createElement(
	      'div',
	      { style: {
	          flex: 1,
	          overflow: 'auto'
	        } },
	      _react2.default.createElement(
	        'div',
	        { style: {
	            padding: '0.25rem',
	            fontSize: _Fonts.monospace.sizes.normal,
	            fontFamily: _Fonts.monospace.family
	          } },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Total renders'
	        ),
	        ': ',
	        snapshotFiber.get('renders')
	      ),
	      _react2.default.createElement(
	        _DetailPane2.default,
	        { theme: theme },
	        _react2.default.createElement(
	          _DetailPaneSection2.default,
	          { title: 'Props' },
	          _react2.default.createElement(_DataView2.default, {
	            path: ['props'],
	            readOnly: true,
	            inspect: emptyFunction,
	            showMenu: emptyFunction,
	            data: snapshotFiber.get('props')
	          })
	        ),
	        snapshotFiber.get('state') && _react2.default.createElement(
	          _DetailPaneSection2.default,
	          { title: 'State' },
	          _react2.default.createElement(_DataView2.default, {
	            path: ['state'],
	            readOnly: true,
	            inspect: emptyFunction,
	            showMenu: emptyFunction,
	            data: snapshotFiber.get('state')
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProfilerFiberDetailPane;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(353);
	
	var _Fonts = __webpack_require__(17);
	
	var _Hoverable = __webpack_require__(62);
	
	var _Hoverable2 = _interopRequireDefault(_Hoverable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfilerSnapshotDetailPane = function ProfilerSnapshotDetailPane(_ref) {
	  var selectedInteraction = _ref.selectedInteraction,
	      snapshot = _ref.snapshot,
	      theme = _ref.theme,
	      viewInteraction = _ref.viewInteraction;
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          height: '2rem',
	          lineHeight: '2rem',
	          padding: '0 0.5rem',
	          backgroundColor: theme.base01,
	          borderBottom: '1px solid ' + theme.base03,
	          fontSize: _Fonts.sansSerif.sizes.large,
	          overflow: 'hidden',
	          textOverflow: 'ellipsis',
	          whiteSpace: 'nowrap'
	        }
	      },
	      'Commit information'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: {
	          padding: '0.5rem'
	        } },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Committed at'
	        ),
	        ': ',
	        (0, _constants.formatTime)(snapshot.commitTime),
	        's'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { marginTop: '0.5rem' } },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Render duration'
	        ),
	        ': ',
	        (0, _constants.formatDuration)(snapshot.duration),
	        'ms'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { margin: '0.5rem 0' } },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Interactions'
	        ),
	        ':'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { style: {
	            listStyle: 'none',
	            margin: 0,
	            padding: 0
	          } },
	        snapshot.memoizedInteractions.length === 0 && _react2.default.createElement(
	          'li',
	          { style: { padding: '0.5rem' } },
	          'None'
	        ),
	        snapshot.memoizedInteractions.map(function (interaction, index) {
	          return _react2.default.createElement(InteractionLink, {
	            interaction: interaction,
	            key: index,
	            onClick: function onClick() {
	              return viewInteraction(interaction);
	            },
	            selectedInteraction: selectedInteraction,
	            theme: theme
	          });
	        })
	      )
	    )
	  );
	};
	
	var InteractionLink = (0, _Hoverable2.default)(function (_ref2) {
	  var interaction = _ref2.interaction,
	      isHovered = _ref2.isHovered,
	      onClick = _ref2.onClick,
	      onMouseEnter = _ref2.onMouseEnter,
	      onMouseLeave = _ref2.onMouseLeave,
	      selectedInteraction = _ref2.selectedInteraction,
	      theme = _ref2.theme;
	  return _react2.default.createElement(
	    'li',
	    {
	      onClick: onClick,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      style: {
	        backgroundColor: isHovered ? theme.state03 : selectedInteraction === interaction ? theme.base01 : 'transparent',
	        color: isHovered ? theme.state00 : 'inherit',
	        textDecoration: isHovered ? 'underline' : 'none',
	        cursor: 'pointer',
	        padding: '0.5rem',
	        borderBottom: '1px solid ' + theme.base01
	      }
	    },
	    '"',
	    interaction.name,
	    '" at ',
	    (0, _constants.formatTime)(interaction.timestamp),
	    's'
	  );
	});
	
	exports.default = ProfilerSnapshotDetailPane;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(353);
	
	var _Fonts = __webpack_require__(17);
	
	var _Hoverable = __webpack_require__(62);
	
	var _Hoverable2 = _interopRequireDefault(_Hoverable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfilerInteractionDetailPane = function ProfilerInteractionDetailPane(_ref) {
	  var interaction = _ref.interaction,
	      maxDuration = _ref.maxDuration,
	      selectedSnapshot = _ref.selectedSnapshot,
	      snapshots = _ref.snapshots,
	      theme = _ref.theme,
	      viewSnapshot = _ref.viewSnapshot;
	
	  var currentTimestamp = interaction.timestamp;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          height: '2rem',
	          lineHeight: '2rem',
	          padding: '0 0.5rem',
	          backgroundColor: theme.base01,
	          borderBottom: '1px solid ' + theme.base03,
	          fontSize: _Fonts.sansSerif.sizes.large,
	          overflow: 'hidden',
	          textOverflow: 'ellipsis',
	          whiteSpace: 'nowrap',
	          display: 'flex',
	          justifyContent: 'space-between'
	        },
	        title: interaction.name
	      },
	      interaction.name,
	      ' at ',
	      (0, _constants.formatTime)(interaction.timestamp),
	      's'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: {
	          padding: '0.5rem'
	        } },
	      _react2.default.createElement(
	        'div',
	        { style: { marginBottom: '0.5rem' } },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Commits'
	        ),
	        ':'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { style: {
	            listStyle: 'none',
	            margin: 0,
	            padding: 0
	          } },
	        Array.from(snapshots).map(function (snapshot, index) {
	          var previousTimestamp = currentTimestamp;
	          currentTimestamp = snapshot.commitTime;
	
	          return _react2.default.createElement(SnapshotLink, {
	            key: index,
	            maxDuration: maxDuration,
	            onClick: function onClick() {
	              return viewSnapshot(snapshot);
	            },
	            previousTimestamp: previousTimestamp,
	            selectedSnapshot: selectedSnapshot,
	            snapshot: snapshot,
	            theme: theme,
	            viewSnapshot: viewSnapshot
	          });
	        })
	      )
	    )
	  );
	};
	
	var SnapshotLink = (0, _Hoverable2.default)(function (_ref2) {
	  var isHovered = _ref2.isHovered,
	      maxDuration = _ref2.maxDuration,
	      onClick = _ref2.onClick,
	      onMouseEnter = _ref2.onMouseEnter,
	      onMouseLeave = _ref2.onMouseLeave,
	      previousTimestamp = _ref2.previousTimestamp,
	      selectedSnapshot = _ref2.selectedSnapshot,
	      snapshot = _ref2.snapshot,
	      theme = _ref2.theme,
	      viewSnapshot = _ref2.viewSnapshot;
	
	  return _react2.default.createElement(
	    'li',
	    {
	      onClick: onClick,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      style: {
	        backgroundColor: isHovered ? theme.state03 : selectedSnapshot === snapshot ? theme.base01 : 'transparent',
	        color: isHovered ? theme.state00 : 'inherit',
	        textDecoration: isHovered ? 'underline' : 'none',
	        cursor: 'pointer',
	        display: 'flex',
	        alignItems: 'center',
	        padding: '0.5rem',
	        borderTop: '1px solid ' + theme.base01
	      }
	    },
	    _react2.default.createElement('div', {
	      style: {
	        width: '1rem',
	        height: '1rem',
	        backgroundColor: selectedSnapshot === snapshot ? theme.state06 : (0, _constants.getGradientColor)(snapshot.duration / maxDuration)
	      }
	    }),
	    _react2.default.createElement(
	      'ul',
	      { style: { paddingLeft: '1.5rem' } },
	      _react2.default.createElement(
	        'li',
	        { style: { marginBottom: '0.25rem' } },
	        'Timestamp: ',
	        (0, _constants.formatTime)(snapshot.commitTime),
	        's'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Duration: ',
	        (0, _constants.formatDuration)(snapshot.duration),
	        'ms'
	      )
	    )
	  );
	});
	
	exports.default = ProfilerInteractionDetailPane;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _decorate = __webpack_require__(20);
	
	var _decorate2 = _interopRequireDefault(_decorate);
	
	var _Fonts = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfilerSettings = function (_PureComponent) {
	  _inherits(ProfilerSettings, _PureComponent);
	
	  function ProfilerSettings() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ProfilerSettings);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProfilerSettings.__proto__ || Object.getPrototypeOf(ProfilerSettings)).call.apply(_ref, [this].concat(args))), _this), _this.handleCommitThresholdChange = function (event) {
	      var _this$props = _this.props,
	          hideCommitsBelowThreshold = _this$props.hideCommitsBelowThreshold,
	          setCommitThrehsold = _this$props.setCommitThrehsold,
	          toggleHideCommitsBelowThreshold = _this$props.toggleHideCommitsBelowThreshold;
	
	
	      var commitThreshold = parseFloat(event.currentTarget.value);
	      if (!Number.isNaN(commitThreshold)) {
	        setCommitThrehsold(commitThreshold);
	
	        // For convenience, enable the hide-commits feature if the threshold is being changed.
	        // This seems likely to be what the user wants.
	        if (!hideCommitsBelowThreshold) {
	          toggleHideCommitsBelowThreshold();
	        }
	      }
	    }, _this.stopClickEventFromBubbling = function (event) {
	      return event.stopPropagation();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ProfilerSettings, [{
	    key: 'render',
	    value: function render() {
	      var theme = this.context.theme;
	      var _props = this.props,
	          commitThreshold = _props.commitThreshold,
	          hideCommitsBelowThreshold = _props.hideCommitsBelowThreshold,
	          isSettingsPanelActive = _props.isSettingsPanelActive,
	          toggleHideCommitsBelowThreshold = _props.toggleHideCommitsBelowThreshold,
	          toggleIsSettingsPanelActive = _props.toggleIsSettingsPanelActive,
	          toggleShowNativeNodes = _props.toggleShowNativeNodes,
	          showNativeNodes = _props.showNativeNodes;
	
	
	      if (!isSettingsPanelActive) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onClick: toggleIsSettingsPanelActive,
	          style: {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: '100%',
	            height: '100%',
	            display: 'flex',
	            alignItems: 'center',
	            justifyContent: 'center'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            onClick: this.stopClickEventFromBubbling,
	            style: {
	              fontFamily: _Fonts.sansSerif.family,
	              backgroundColor: theme.base01,
	              border: '1px solid ' + theme.base03,
	              color: theme.base05,
	              borderRadius: '0.25rem',
	              maxWidth: '100%',
	              minWidth: '250px',
	              padding: '0.5rem',
	              margin: '0.5rem'
	            }
	          },
	          _react2.default.createElement(
	            'h4',
	            { style: { margin: '0 0 0.5rem' } },
	            'Profiler settings'
	          ),
	          _react2.default.createElement(
	            'label',
	            {
	              style: {
	                display: 'flex',
	                alignItems: 'center',
	                cursor: 'pointer',
	                marginBottom: '0.25rem'
	              },
	              title: 'Show native elements'
	            },
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              checked: showNativeNodes,
	              onChange: toggleShowNativeNodes
	            }),
	            ' Show native elements'
	          ),
	          _react2.default.createElement(
	            'label',
	            {
	              style: {
	                display: 'flex',
	                alignItems: 'center',
	                cursor: 'pointer'
	              },
	              title: 'Hide commits below threshold'
	            },
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              checked: hideCommitsBelowThreshold,
	              onChange: toggleHideCommitsBelowThreshold
	            }),
	            ' Hide commits below ',
	            _react2.default.createElement('input', {
	              type: 'number',
	              style: {
	                width: '3rem'
	              },
	              defaultValue: commitThreshold,
	              min: 1,
	              onChange: this.handleCommitThresholdChange
	            }),
	            ' ms'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfilerSettings;
	}(_react.PureComponent);
	
	ProfilerSettings.contextTypes = {
	  theme: _propTypes2.default.object.isRequired
	};
	exports.default = (0, _decorate2.default)({
	  store: 'profilerStore',
	  listeners: function listeners() {
	    return ['commitThreshold', 'hideCommitsBelowThreshold', 'isSettingsPanelActive', 'showNativeNodes'];
	  },
	  props: function props(store) {
	    return {
	      commitThreshold: store.commitThreshold,
	      hideCommitsBelowThreshold: store.hideCommitsBelowThreshold,
	      isSettingsPanelActive: store.isSettingsPanelActive,
	      showNativeNodes: store.showNativeNodes,
	      setCommitThrehsold: store.setCommitThrehsold,
	      toggleHideCommitsBelowThreshold: function toggleHideCommitsBelowThreshold() {
	        return store.setHideCommitsBelowThreshold(!store.hideCommitsBelowThreshold);
	      },
	      toggleIsSettingsPanelActive: function toggleIsSettingsPanelActive() {
	        return store.setIsSettingsPanelActive(!store.isSettingsPanelActive);
	      },
	      toggleShowNativeNodes: function toggleShowNativeNodes() {
	        return store.setShowNativeNodes(!store.showNativeNodes);
	      }
	    };
	  }
	}, ProfilerSettings);

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var React = __webpack_require__(11);
	var provideStore = __webpack_require__(345);
	
	var RelayStore = __webpack_require__(374);
	var QueriesTab = __webpack_require__(375);
	// var StoreTab = require('./StoreTab');
	var ElementPanel = __webpack_require__(380);
	
	var StoreWrapper = provideStore('relayStore');
	
	var RelayPlugin = function () {
	  function RelayPlugin(store, bridge, refresh) {
	    var _this = this;
	
	    _classCallCheck(this, RelayPlugin);
	
	    this.bridge = bridge;
	    this.store = store;
	    this.hasRelay = false;
	    this.relayStore = new RelayStore(bridge, store);
	    // TODO (kassens): There's a race condition here. The Relay backend
	    // implements this call and is initialized from the injected script whereas
	    // this file is called from the Panel.
	    setTimeout(function () {
	      bridge.call('relay:check', [], function (hasRelay) {
	        _this.hasRelay = hasRelay;
	        refresh();
	      });
	    }, 1000);
	  }
	
	  _createClass(RelayPlugin, [{
	    key: 'panes',
	    value: function panes() {
	      var _this2 = this;
	
	      if (!this.hasRelay) {
	        return [];
	      }
	      return [function (node, id) {
	        return React.createElement(
	          StoreWrapper,
	          { store: _this2.relayStore, key: 'relay' },
	          function () {
	            return React.createElement(ElementPanel, { node: node, id: id });
	          }
	        );
	      }];
	    }
	  }, {
	    key: 'teardown',
	    value: function teardown() {}
	  }, {
	    key: 'tabs',
	    value: function tabs() {
	      var _this3 = this;
	
	      if (!this.hasRelay) {
	        return null;
	      }
	      return {
	        Relay: function Relay() {
	          return React.createElement(
	            StoreWrapper,
	            { store: _this3.relayStore },
	            function () {
	              return React.createElement(QueriesTab, null);
	            }
	          );
	        }
	      };
	    }
	  }]);
	
	  return RelayPlugin;
	}();
	
	module.exports = RelayPlugin;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(326),
	    EventEmitter = _require.EventEmitter;
	
	var _require2 = __webpack_require__(315),
	    OrderedMap = _require2.OrderedMap,
	    Map = _require2.Map;
	
	var assign = __webpack_require__(19);
	var consts = __webpack_require__(32);
	var invariant = __webpack_require__(56);
	
	function getDataIDs(obj) {
	  var collector = [];
	  getDataIDsInternal(obj, collector);
	  return collector;
	}
	function getDataIDsInternal(obj, collector) {
	  for (var name in obj) {
	    if (name === 'id' && typeof obj[name] === 'string') {
	      collector.push(obj[name]);
	    } else if (_typeof(obj[name]) === 'object') {
	      getDataIDs(obj[name]);
	    }
	  }
	}
	
	var Store = function (_EventEmitter) {
	  _inherits(Store, _EventEmitter);
	
	  function Store(bridge, mainStore) {
	    _classCallCheck(this, Store);
	
	    var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this));
	
	    _this.storeData = null;
	    _this.storeDateSubscriptionCount = 0;
	    _this.selectedQuery = null;
	    _this.queries = new OrderedMap();
	    _this._bridge = bridge;
	    _this._mainStore = mainStore;
	    // initial population of the store
	    bridge.on('relay:store', function (data) {
	      _this.storeData = data;
	      _this.emit('storeData');
	    });
	    _this.queriesByDataID = {};
	    // queries and mutations
	    bridge.on('relay:pending', function (pendingQueries) {
	      pendingQueries.forEach(function (pendingQuery) {
	        _this.queries = _this.queries.set(pendingQuery.id, new Map(_extends({}, pendingQuery, {
	          status: 'pending',
	          text: pendingQuery.text.join('')
	        })));
	        _this.emit('queries');
	        _this.emit(pendingQuery.id);
	        getDataIDs(pendingQuery.variables).forEach(function (id) {
	          if (!_this.queriesByDataID[id]) {
	            _this.queriesByDataID[id] = [pendingQuery.id];
	          } else {
	            _this.queriesByDataID[id].push(pendingQuery.id);
	          }
	        });
	      });
	    });
	    bridge.on('relay:success', function (_ref) {
	      var id = _ref.id,
	          response = _ref.response,
	          end = _ref.end;
	
	      _this.queries = _this.queries.mergeIn([id], new Map({ status: 'success', response: response, end: end }));
	      _this.emit('queries');
	      _this.emit(id);
	    });
	    bridge.on('relay:failure', function (_ref2) {
	      var id = _ref2.id,
	          error = _ref2.error,
	          end = _ref2.end;
	
	      _this.queries = _this.queries.mergeIn([id], new Map({ status: 'failure', error: error, end: end }));
	      _this.emit('queries');
	      _this.emit(id);
	    });
	    _this.dataIDsToNodes = {};
	    _this.nodesToDataIDs = {};
	    // track nodes
	    bridge.on('mount', function (data) {
	      if (!data.props || !data.props.relay && data.name.indexOf('Relay(') !== 0) {
	        return; // not a relay child
	      }
	      _this.nodesToDataIDs[data.id] = new window.Set();
	      for (var name in data.props) {
	        var id = data.props[name] && data.props[name].__dataID__;
	        if (!id) {
	          continue;
	        }
	        if (!_this.dataIDsToNodes[id]) {
	          _this.dataIDsToNodes[id] = new window.Set();
	        }
	        _this.dataIDsToNodes[id].add(data.id);
	        _this.nodesToDataIDs[data.id].add(id);
	      }
	    });
	    bridge.on('update', function (data) {
	      if (!data.props || !_this.nodesToDataIDs[data.id]) {
	        return;
	      }
	      var newIds = new window.Set();
	      for (var name in data.props) {
	        var id = data.props[name] && data.props[name].__dataID__;
	        if (!id) {
	          continue;
	        }
	        newIds.add(id);
	        if (_this.nodesToDataIDs[data.id].has(id)) {
	          continue;
	        }
	        if (!_this.dataIDsToNodes[id]) {
	          _this.dataIDsToNodes[id] = new window.Set();
	        }
	        _this.dataIDsToNodes[id].add(data.id);
	        // this.nodesToDataIDs[data.id].add(id);
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = _this.nodesToDataIDs[data.id][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var item = _step.value;
	
	          if (!newIds.has(item)) {
	            _this.dataIDsToNodes[item].delete(data.id);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      _this.nodesToDataIDs[id] = newIds;
	    });
	    bridge.on('unmount', function (id) {
	      if (!_this.nodesToDataIDs[id]) {
	        return;
	      }
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = _this.nodesToDataIDs[id][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var item = _step2.value;
	
	          _this.dataIDsToNodes[item].delete(id);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      _this.nodesToDataIDs[id] = null;
	    });
	    return _this;
	  }
	
	  _createClass(Store, [{
	    key: 'jumpToDataID',
	    value: function jumpToDataID(dataID) {
	      this._mainStore.setSelectedTab('RelayStore');
	      this.selectedDataNode = dataID;
	      this.emit('selectedDataNode');
	    }
	  }, {
	    key: 'jumpToQuery',
	    value: function jumpToQuery(queryID) {
	      this._mainStore.setSelectedTab('Relay');
	      this.selectedQuery = queryID;
	      this.emit('selectedQuery');
	      this.emit('queries');
	    }
	  }, {
	    key: 'inspect',
	    value: function inspect(id, path, cb) {
	      var _this2 = this;
	
	      this._bridge.inspect(id, path, function (value) {
	        var base;
	        if (id === 'relay:store') {
	          invariant(_this2.storeData, 'RelayStore.inspect: this.storeData should be defined.');
	          base = _this2.storeData.nodes;
	        } else {
	          base = _this2.queries.get(id).get(path[0]);
	        }
	        // $FlowFixMe
	        var inspected = path.slice(1).reduce(function (obj, attr) {
	          return obj ? obj[attr] : null;
	        }, base);
	        if (inspected) {
	          assign(inspected, value);
	          inspected[consts.inspected] = true;
	        }
	        cb();
	      });
	    }
	  }, {
	    key: 'on',
	    value: function on(evt, fn) {
	      if (evt === 'storeData') {
	        this.storeDateSubscriptionCount++;
	        if (this.storeDateSubscriptionCount === 1) {
	          this._bridge.call('relay:store:enable', [], function () {});
	        }
	      }
	      this.addListener(evt, fn);
	    }
	  }, {
	    key: 'off',
	    value: function off(evt, fn) {
	      if (evt === 'storeData') {
	        this.storeDateSubscriptionCount--;
	        if (this.storeDateSubscriptionCount === 0) {
	          this._bridge.call('relay:store:disable', [], function () {});
	        }
	      }
	      this.removeListener(evt, fn);
	    }
	  }, {
	    key: 'selectQuery',
	    value: function selectQuery(id) {
	      this.selectedQuery = id;
	      this.emit('selectedQuery');
	    }
	  }]);
	
	  return Store;
	}(EventEmitter);
	
	module.exports = Store;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(11);
	var decorate = __webpack_require__(20);
	
	var _require = __webpack_require__(17),
	    sansSerif = _require.sansSerif;
	
	var QueryList = __webpack_require__(376);
	var QueryViewer = __webpack_require__(378);
	var SplitPane = __webpack_require__(322);
	
	var QueriesTab = function (_React$Component) {
	  _inherits(QueriesTab, _React$Component);
	
	  function QueriesTab() {
	    _classCallCheck(this, QueriesTab);
	
	    return _possibleConstructorReturn(this, (QueriesTab.__proto__ || Object.getPrototypeOf(QueriesTab)).apply(this, arguments));
	  }
	
	  _createClass(QueriesTab, [{
	    key: 'render',
	    value: function render() {
	      var contents;
	      if (!this.props.isSplit) {
	        contents = React.createElement(QueryList, null);
	      } else {
	        contents = React.createElement(SplitPane, {
	          initialWidth: 500,
	          initialHeight: 500,
	          left: function left() {
	            return React.createElement(QueryList, null);
	          },
	          right: function right() {
	            return React.createElement(QueryViewer, null);
	          },
	          isVertical: false
	        });
	      }
	
	      return React.createElement(
	        'div',
	        { style: styles.container },
	        contents
	      );
	    }
	  }]);
	
	  return QueriesTab;
	}(React.Component);
	
	var styles = {
	  container: {
	    fontFamily: sansSerif.family,
	    fontSize: sansSerif.sizes.normal,
	    flex: 1,
	    display: 'flex'
	  }
	};
	
	module.exports = decorate({
	  store: 'relayStore',
	  listeners: function listeners() {
	    return ['selectedQuery'];
	  },
	  props: function props(store) {
	    return {
	      isSplit: !!store.selectedQuery
	    };
	  }
	}, QueriesTab);

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(11);
	var decorate = __webpack_require__(20);
	
	var _require = __webpack_require__(17),
	    sansSerif = _require.sansSerif;
	
	var Query = __webpack_require__(377);
	
	var QueryList = function (_React$Component) {
	  _inherits(QueryList, _React$Component);
	
	  function QueryList() {
	    _classCallCheck(this, QueryList);
	
	    return _possibleConstructorReturn(this, (QueryList.__proto__ || Object.getPrototypeOf(QueryList)).apply(this, arguments));
	  }
	
	  _createClass(QueryList, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (!this.props.queries.count()) {
	        return React.createElement(
	          'div',
	          { style: styles.empty },
	          'No Relay Queries logged'
	        );
	      }
	
	      var rows = [];
	      var odd = false;
	      var lastRequestNumber = -1;
	      this.props.queries.forEach(function (query) {
	        var requestNumber = query.get('requestNumber');
	        if (lastRequestNumber !== requestNumber) {
	          lastRequestNumber = requestNumber;
	          rows.push(React.createElement(
	            'tr',
	            { key: 'request' + requestNumber },
	            React.createElement(
	              'td',
	              { colSpan: '4', style: styles.grouper },
	              'Request ',
	              requestNumber
	            )
	          ));
	          odd = false;
	        }
	        rows.push(React.createElement(Query, {
	          data: query,
	          isSelected: query.get('id') === _this2.props.selectedQuery,
	          key: query.get('id'),
	          oddRow: odd,
	          onSelect: function onSelect() {
	            return _this2.props.selectQuery(query.get('id'));
	          }
	        }));
	        odd = !odd;
	      });
	
	      return React.createElement(
	        'div',
	        { style: styles.container },
	        React.createElement(
	          'table',
	          { style: styles.table },
	          React.createElement(
	            'tbody',
	            null,
	            rows
	          )
	        )
	      );
	    }
	  }]);
	
	  return QueryList;
	}(React.Component);
	
	var styles = {
	  container: {
	    position: 'relative',
	    flex: 1,
	    overflow: 'scroll'
	  },
	
	  table: {
	    flex: 1,
	    borderCollapse: 'collapse',
	    width: '100%'
	  },
	
	  grouper: {
	    fontWeight: 'bold',
	    fontSize: sansSerif.sizes.normal
	  },
	
	  empty: {
	    flex: 1,
	    padding: 50,
	    textAlign: 'center'
	  }
	};
	
	module.exports = decorate({
	  store: 'relayStore',
	  listeners: function listeners() {
	    return ['queries', 'selectedQuery'];
	  },
	  props: function props(store, _props) {
	    return {
	      queries: store.queries,
	      selectQuery: function selectQuery(id) {
	        return store.selectQuery(id);
	      },
	      selectedQuery: store.selectedQuery
	    };
	  }
	}, QueryList);

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(17),
	    sansSerif = _require.sansSerif;
	
	var PropTypes = __webpack_require__(6);
	var React = __webpack_require__(11);
	
	var Query = function (_React$Component) {
	  _inherits(Query, _React$Component);
	
	  function Query() {
	    _classCallCheck(this, Query);
	
	    return _possibleConstructorReturn(this, (Query.__proto__ || Object.getPrototypeOf(Query)).apply(this, arguments));
	  }
	
	  _createClass(Query, [{
	    key: 'render',
	    value: function render() {
	      var theme = this.context.theme;
	      var data = this.props.data;
	      var containerStyle = baseContainer;
	      if (this.props.isSelected) {
	        containerStyle = containerSelectedStyle(theme);
	      } else if (this.props.oddRow) {
	        containerStyle = containeroOddRowStyle(theme);
	      }
	
	      var status = data.get('status');
	
	      var start = data.get('start');
	      var end = data.get('end');
	
	      return React.createElement(
	        'tr',
	        { onClick: this.props.onSelect, style: containerStyle },
	        React.createElement(
	          'td',
	          { style: tdFirstStyle(theme) },
	          React.createElement('span', { style: statusStyle(status), title: status })
	        ),
	        React.createElement(
	          'td',
	          { style: tdNameStyle(theme) },
	          data.get('name')
	        ),
	        React.createElement(
	          'td',
	          { style: baseTDStyle(theme) },
	          Math.round(start) / 1000,
	          's'
	        ),
	        React.createElement(
	          'td',
	          { style: baseTDStyle(theme) },
	          Math.round(end - start),
	          'ms'
	        )
	      );
	    }
	  }]);
	
	  return Query;
	}(React.Component);
	
	Query.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	var baseContainer = {
	  cursor: 'pointer',
	  fontSize: sansSerif.sizes.normal,
	  height: 21,
	  lineHeight: '21px',
	  fontFamily: sansSerif.family
	};
	
	var baseTDStyle = function baseTDStyle(theme) {
	  return {
	    whiteSpace: 'nowrap',
	    'padding': '1px 4px',
	    'lineHeight': '17px',
	    'borderLeft': '1px solid ' + theme.base01
	  };
	};
	
	var tdFirstStyle = function tdFirstStyle(theme) {
	  return _extends({}, baseTDStyle(theme), {
	    borderLeft: ''
	  });
	};
	
	var tdNameStyle = function tdNameStyle(theme) {
	  return _extends({}, baseTDStyle(theme), {
	    width: '100%'
	  });
	};
	
	var containeroOddRowStyle = function containeroOddRowStyle(theme) {
	  return _extends({}, baseContainer, {
	    backgroundColor: theme.base01
	  });
	};
	
	var containerSelectedStyle = function containerSelectedStyle(theme) {
	  return _extends({}, baseContainer, {
	    backgroundColor: theme.state00,
	    color: theme.base04
	  });
	};
	
	// Status colors not themed b'c the color choice is significant
	var statusColors = {
	  pending: 'orange',
	  success: 'green',
	  failure: 'red',
	  error: '#aaa'
	};
	
	var statusStyle = function statusStyle(status) {
	  return {
	    display: 'inline-block',
	    width: 11,
	    height: 11,
	    borderRadius: 6,
	    backgroundColor: statusColors[status] || statusColors.error
	  };
	};
	
	module.exports = Query;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DataView = __webpack_require__(24);
	
	var _DataView2 = _interopRequireDefault(_DataView);
	
	var _DetailPane = __webpack_require__(52);
	
	var _DetailPane2 = _interopRequireDefault(_DetailPane);
	
	var _DetailPaneSection = __webpack_require__(53);
	
	var _DetailPaneSection2 = _interopRequireDefault(_DetailPaneSection);
	
	var _Fonts = __webpack_require__(17);
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _decorate = __webpack_require__(20);
	
	var _decorate2 = _interopRequireDefault(_decorate);
	
	var _tidyGraphQL = __webpack_require__(379);
	
	var _tidyGraphQL2 = _interopRequireDefault(_tidyGraphQL);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QueryViewer = function (_React$Component) {
	  _inherits(QueryViewer, _React$Component);
	
	  function QueryViewer() {
	    _classCallCheck(this, QueryViewer);
	
	    return _possibleConstructorReturn(this, (QueryViewer.__proto__ || Object.getPrototypeOf(QueryViewer)).apply(this, arguments));
	  }
	
	  _createClass(QueryViewer, [{
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	      var status = data.get('status');
	
	      var resultBlock = null;
	      if (status === 'success') {
	        resultBlock = _react2.default.createElement(
	          _DetailPaneSection2.default,
	          { title: 'Response' },
	          _react2.default.createElement(_DataView2.default, {
	            data: data.get('response'),
	            readOnly: true,
	            showMenu: false,
	            inspect: this.props.inspect,
	            path: ['response']
	          })
	        );
	      } else if (status === 'failure') {
	        resultBlock = _react2.default.createElement(
	          _DetailPaneSection2.default,
	          { title: 'Error' },
	          _react2.default.createElement(_DataView2.default, {
	            data: data.get('error'),
	            readOnly: true,
	            showMenu: false,
	            inspect: this.props.inspect,
	            path: ['error']
	          })
	        );
	      }
	
	      var start = data.get('start');
	      var end = data.get('end');
	
	      return _react2.default.createElement(
	        _DetailPane2.default,
	        { header: data.get('type') + ': ' + data.get('name') },
	        _react2.default.createElement(
	          _DetailPaneSection2.default,
	          { title: 'Start' },
	          _react2.default.createElement(
	            'div',
	            null,
	            Math.round(start) / 1000,
	            's since page load'
	          )
	        ),
	        _react2.default.createElement(
	          _DetailPaneSection2.default,
	          { title: 'Status' },
	          _react2.default.createElement(
	            'div',
	            null,
	            status
	          )
	        ),
	        _react2.default.createElement(
	          _DetailPaneSection2.default,
	          { title: 'Duration' },
	          _react2.default.createElement(
	            'div',
	            null,
	            Math.round(end - start),
	            'ms'
	          )
	        ),
	        _react2.default.createElement(
	          _DetailPaneSection2.default,
	          { title: 'Query' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.query },
	            (0, _tidyGraphQL2.default)(data.get('text'))
	          )
	        ),
	        _react2.default.createElement(
	          _DetailPaneSection2.default,
	          { title: 'Variables' },
	          _react2.default.createElement(_DataView2.default, {
	            data: data.get('variables'),
	            readOnly: true,
	            showMenu: false,
	            inspect: this.props.inspect,
	            path: ['variables']
	          })
	        ),
	        resultBlock
	      );
	    }
	  }]);
	
	  return QueryViewer;
	}(_react2.default.Component);
	
	var styles = {
	  query: {
	    cursor: 'text',
	    fontFamily: _Fonts.monospace.family,
	    fontSize: _Fonts.monospace.sizes.normal,
	    userSelect: 'text',
	    MozUserSelect: 'text',
	    WebkitUserSelect: 'text',
	    whiteSpace: 'pre',
	    wordWrap: 'break-word'
	  }
	};
	
	module.exports = (0, _decorate2.default)({
	  store: 'relayStore',
	  listeners: function listeners(props, store) {
	    return ['selectedQuery', store.selectedQuery];
	  },
	  props: function props(store) {
	    return {
	      data: store.queries.get(store.selectedQuery),
	      inspect: store.inspect.bind(store, store.selectedQuery)
	    };
	  }
	}, QueryViewer);

/***/ },
/* 379 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	function tidyGraphQL(input) {
	  var indent = '';
	
	  var lastWasNewline = false;
	
	  var parenCount = 0;
	  var line = '';
	  var head = [];
	  var stack = [head];
	
	  for (var i = 0; i < input.length; i++) {
	    var c = input.charAt(i);
	    if (c == '(') {
	      parenCount++;
	    } else if (c == ')') {
	      parenCount--;
	    }
	
	    if (c == '{') {
	      indent += '  ';
	      lastWasNewline = true;
	
	      head.push(line + '{');
	      line = indent;
	      head = [];
	      stack.push(head);
	    } else if (c == ',' && parenCount == 0) {
	      head.push(line);
	
	      lastWasNewline = true;
	      line = indent;
	    } else if (c == '}') {
	      indent = indent.substr(2);
	
	      head.push(line.replace(/ +$/, ''));
	      head.sort();
	      line = head.join(',\n');
	      stack.pop();
	      head = stack[stack.length - 1];
	      line = head.pop() + '\n' + line + '\n' + indent + '}';
	    } else if (c == ' ' && lastWasNewline) {
	      continue;
	    } else if (c != ' ' && i + 1 < input.length && input.charAt(i + 1) == '{') {
	      line += c + ' ';
	    } else {
	      lastWasNewline = false;
	      line += c;
	    }
	  }
	
	  // TODO(jkassens) hack to format queries with fragments.
	  return line.replace(/^} /gm, '}\n\n');
	}
	
	module.exports = tidyGraphQL;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(6);
	
	var React = __webpack_require__(11);
	var decorate = __webpack_require__(20);
	
	var ElementPanel = function (_React$Component) {
	  _inherits(ElementPanel, _React$Component);
	
	  function ElementPanel() {
	    _classCallCheck(this, ElementPanel);
	
	    return _possibleConstructorReturn(this, (ElementPanel.__proto__ || Object.getPrototypeOf(ElementPanel)).apply(this, arguments));
	  }
	
	  _createClass(ElementPanel, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (!this.props.dataIDs.length) {
	        return React.createElement('span', null);
	      }
	      var theme = this.context.theme;
	
	      return React.createElement(
	        'div',
	        null,
	        'Relay Nodes',
	        React.createElement(
	          'ul',
	          { style: styles.dataIDs },
	          this.props.dataIDs.map(function (_ref) {
	            var id = _ref.id,
	                queries = _ref.queries;
	            return React.createElement(
	              'li',
	              { style: dataNodeStyle(theme) },
	              React.createElement(
	                'div',
	                { style: dataIDStyle(theme), onClick: function onClick() {
	                    return _this2.props.jumpToData(id);
	                  } },
	                'ID: ',
	                id
	              ),
	              React.createElement(
	                'ul',
	                { style: styles.queries },
	                queries.map(function (query) {
	                  return React.createElement(
	                    'li',
	                    { style: styles.queryID, onClick: function onClick() {
	                        var queryID = query.get('id');
	                        if (queryID) {
	                          _this2.props.jumpToQuery(queryID);
	                        }
	                      } },
	                    query.get('name')
	                  );
	                }),
	                !queries.length && React.createElement(
	                  'li',
	                  { style: noQueriesStyle(theme) },
	                  'No Queries'
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return ElementPanel;
	}(React.Component);
	
	ElementPanel.contextTypes = {
	  theme: PropTypes.object.isRequired
	};
	
	var dataNodeStyle = function dataNodeStyle(theme) {
	  return {
	    marginBottom: 5,
	    border: '1px solid ' + theme.base02
	  };
	};
	
	var dataIDStyle = function dataIDStyle(theme) {
	  return {
	    cursor: 'pointer',
	    padding: '2px 4px',
	    backgroundColor: theme.base02
	  };
	};
	
	var noQueriesStyle = function noQueriesStyle(theme) {
	  return {
	    color: theme.base03,
	    padding: '2px 4px'
	  };
	};
	
	var styles = {
	  dataIDs: {
	    listStyle: 'none',
	    padding: 0,
	    margin: 0
	  },
	  queries: {
	    listStyle: 'none',
	    padding: 0,
	    margin: 0
	  },
	  queryID: {
	    cursor: 'pointer',
	    padding: '2px 4px'
	  }
	};
	
	module.exports = decorate({
	  store: 'relayStore',
	  listeners: function listeners(props, store) {
	    return [props.id];
	  },
	  shouldUpdate: function shouldUpdate(props, prevProps) {
	    return props.id !== prevProps.id;
	  },
	  props: function props(store, _props) {
	    var dataIDs = [];
	    if (store.nodesToDataIDs[_props.id]) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = store.nodesToDataIDs[_props.id][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var id = _step.value;
	
	          dataIDs.push({
	            id: id,
	            queries: (store.queriesByDataID[id] || []).map(function (qid) {
	              return store.queries.get(qid);
	            })
	          });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	    return {
	      dataIDs: dataIDs,
	      jumpToData: function jumpToData(dataID) {
	        return store.jumpToDataID(dataID);
	      },
	      jumpToQuery: function jumpToQuery(queryID) {
	        return store.jumpToQuery(queryID);
	      }
	    };
	  }
	}, ElementPanel);

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	var fs = __webpack_require__(2);
	var path = __webpack_require__(3);
	var child_process = __webpack_require__(382);
	var shellQuote = __webpack_require__(383);
	
	function isTerminalEditor(editor) {
	  switch (editor) {
	    case 'vim':
	    case 'emacs':
	    case 'nano':
	      return true;
	  }
	  return false;
	}
	
	// Map from full process name to binary that starts the process
	// We can't just re-use full process name, because it will spawn a new instance
	// of the app every time
	var COMMON_EDITORS = {
	  '/Applications/Atom.app/Contents/MacOS/Atom': 'atom',
	  '/Applications/Atom Beta.app/Contents/MacOS/Atom Beta': '/Applications/Atom Beta.app/Contents/MacOS/Atom Beta',
	  '/Applications/Sublime Text.app/Contents/MacOS/Sublime Text': '/Applications/Sublime Text.app/Contents/SharedSupport/bin/subl',
	  '/Applications/Sublime Text 2.app/Contents/MacOS/Sublime Text 2': '/Applications/Sublime Text 2.app/Contents/SharedSupport/bin/subl',
	  '/Applications/Visual Studio Code.app/Contents/MacOS/Electron': 'code'
	};
	
	function getArgumentsForLineNumber(editor, filePath, lineNumber) {
	  switch (path.basename(editor)) {
	    case 'vim':
	    case 'mvim':
	      return [filePath, '+' + lineNumber];
	    case 'atom':
	    case 'Atom':
	    case 'Atom Beta':
	    case 'subl':
	    case 'sublime':
	    case 'wstorm':
	    case 'appcode':
	    case 'charm':
	    case 'idea':
	      return [filePath + ':' + lineNumber];
	    case 'joe':
	    case 'emacs':
	    case 'emacsclient':
	      return ['+' + lineNumber, filePath];
	    case 'rmate':
	    case 'mate':
	    case 'mine':
	      return ['--line', lineNumber, filePath];
	    case 'code':
	      return ['-g', filePath + ':' + lineNumber];
	  }
	
	  // For all others, drop the lineNumber until we have
	  // a mapping above, since providing the lineNumber incorrectly
	  // can result in errors or confusing behavior.
	  return [filePath];
	}
	
	function guessEditor() {
	  // Explicit config always wins
	  if (process.env.REACT_EDITOR) {
	    return shellQuote.parse(process.env.REACT_EDITOR);
	  }
	
	  // Using `ps x` on OSX we can find out which editor is currently running.
	  // Potentially we could use similar technique for Windows and Linux
	  if (process.platform === 'darwin') {
	    try {
	      var output = child_process.execSync('ps x').toString();
	      var processNames = Object.keys(COMMON_EDITORS);
	      for (var i = 0; i < processNames.length; i++) {
	        var processName = processNames[i];
	        if (output.indexOf(processName) !== -1) {
	          return [COMMON_EDITORS[processName]];
	        }
	      }
	    } catch (error) {
	      // Ignore...
	    }
	  }
	
	  // Last resort, use old skool env vars
	  if (process.env.VISUAL) {
	    return [process.env.VISUAL];
	  } else if (process.env.EDITOR) {
	    return [process.env.EDITOR];
	  }
	
	  return [];
	}
	
	var _childProcess = null;
	function launchEditor(maybeRelativePath, lineNumber, absoluteProjectRoots) {
	  // We use relative paths at Facebook we deterministic builds.
	  // This is why our internal tooling calls React DevTools with absoluteProjectRoots.
	  // If the filename is absolute then we don't need to care about this.
	  var filePath = [maybeRelativePath].concat(absoluteProjectRoots.map(function (root) {
	    return path.join(root, maybeRelativePath);
	  })).find(function (combinedPath) {
	    return fs.existsSync(combinedPath);
	  });
	
	  if (!filePath) {
	    return;
	  }
	
	  // Sanitize lineNumber to prevent malicious use on win32
	  // via: https://github.com/nodejs/node/blob/c3bb4b1aa5e907d489619fb43d233c3336bfc03d/lib/child_process.js#L333
	  if (lineNumber && isNaN(lineNumber)) {
	    return;
	  }
	
	  var _guessEditor = guessEditor(),
	      _guessEditor2 = _toArray(_guessEditor),
	      editor = _guessEditor2[0],
	      args = _guessEditor2.slice(1);
	
	  if (!editor) {
	    return;
	  }
	
	  if (lineNumber) {
	    args = args.concat(getArgumentsForLineNumber(editor, filePath, lineNumber));
	  } else {
	    args.push(filePath);
	  }
	
	  if (_childProcess && isTerminalEditor(editor)) {
	    // There's an existing editor process already and it's attached
	    // to the terminal, so go kill it. Otherwise two separate editor
	    // instances attach to the stdin/stdout which gets confusing.
	    _childProcess.kill('SIGKILL');
	  }
	
	  if (process.platform === 'win32') {
	    // On Windows, launch the editor in a shell because spawn can only
	    // launch .exe files.
	    _childProcess = child_process.spawn('cmd.exe', ['/C', editor].concat(args), { stdio: 'inherit' });
	  } else {
	    _childProcess = child_process.spawn(editor, args, { stdio: 'inherit' });
	  }
	  _childProcess.on('error', function () {});
	  _childProcess.on('exit', function (errorCode) {
	    _childProcess = null;
	  });
	}
	
	module.exports = launchEditor;

/***/ },
/* 382 */
/***/ function(module, exports) {

	module.exports = require("child_process");

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	var json = typeof JSON !== undefined ? JSON : __webpack_require__(384);
	var map = __webpack_require__(387);
	var filter = __webpack_require__(388);
	var reduce = __webpack_require__(389);
	
	exports.quote = function (xs) {
	    return map(xs, function (s) {
	        if (s && typeof s === 'object') {
	            return s.op.replace(/(.)/g, '\\$1');
	        }
	        else if (/["\s]/.test(s) && !/'/.test(s)) {
	            return "'" + s.replace(/(['\\])/g, '\\$1') + "'";
	        }
	        else if (/["'\s]/.test(s)) {
	            return '"' + s.replace(/(["\\$`!])/g, '\\$1') + '"';
	        }
	        else {
	            return String(s).replace(/([#!"$&'()*,:;<=>?@\[\\\]^`{|}])/g, '\\$1'); 
	        }
	    }).join(' ');
	};
	
	var CONTROL = '(?:' + [
	    '\\|\\|', '\\&\\&', ';;', '\\|\\&', '[&;()|<>]'
	].join('|') + ')';
	var META = '|&;()<> \\t';
	var BAREWORD = '(\\\\[\'"' + META + ']|[^\\s\'"' + META + '])+';
	var SINGLE_QUOTE = '"((\\\\"|[^"])*?)"';
	var DOUBLE_QUOTE = '\'((\\\\\'|[^\'])*?)\'';
	
	var TOKEN = '';
	for (var i = 0; i < 4; i++) {
	    TOKEN += (Math.pow(16,8)*Math.random()).toString(16);
	}
	
	exports.parse = function (s, env, opts) {
	    var mapped = parse(s, env, opts);
	    if (typeof env !== 'function') return mapped;
	    return reduce(mapped, function (acc, s) {
	        if (typeof s === 'object') return acc.concat(s);
	        var xs = s.split(RegExp('(' + TOKEN + '.*?' + TOKEN + ')', 'g'));
	        if (xs.length === 1) return acc.concat(xs[0]);
	        return acc.concat(map(filter(xs, Boolean), function (x) {
	            if (RegExp('^' + TOKEN).test(x)) {
	                return json.parse(x.split(TOKEN)[1]);
	            }
	            else return x;
	        }));
	    }, []);
	};
	
	function parse (s, env, opts) {
	    var chunker = new RegExp([
	        '(' + CONTROL + ')', // control chars
	        '(' + BAREWORD + '|' + SINGLE_QUOTE + '|' + DOUBLE_QUOTE + ')*'
	    ].join('|'), 'g');
	    var match = filter(s.match(chunker), Boolean);
	    var commented = false;
	
	    if (!match) return [];
	    if (!env) env = {};
	    if (!opts) opts = {};
	    return map(match, function (s, j) {
	        if (commented) {
	            return;
	        }
	        if (RegExp('^' + CONTROL + '$').test(s)) {
	            return { op: s };
	        }
	
	        // Hand-written scanner/parser for Bash quoting rules:
	        //
	        //  1. inside single quotes, all characters are printed literally.
	        //  2. inside double quotes, all characters are printed literally
	        //     except variables prefixed by '$' and backslashes followed by
	        //     either a double quote or another backslash.
	        //  3. outside of any quotes, backslashes are treated as escape
	        //     characters and not printed (unless they are themselves escaped)
	        //  4. quote context can switch mid-token if there is no whitespace
	        //     between the two quote contexts (e.g. all'one'"token" parses as
	        //     "allonetoken")
	        var SQ = "'";
	        var DQ = '"';
	        var DS = '$';
	        var BS = opts.escape || '\\';
	        var quote = false;
	        var esc = false;
	        var out = '';
	        var isGlob = false;
	
	        for (var i = 0, len = s.length; i < len; i++) {
	            var c = s.charAt(i);
	            isGlob = isGlob || (!quote && (c === '*' || c === '?'));
	            if (esc) {
	                out += c;
	                esc = false;
	            }
	            else if (quote) {
	                if (c === quote) {
	                    quote = false;
	                }
	                else if (quote == SQ) {
	                    out += c;
	                }
	                else { // Double quote
	                    if (c === BS) {
	                        i += 1;
	                        c = s.charAt(i);
	                        if (c === DQ || c === BS || c === DS) {
	                            out += c;
	                        } else {
	                            out += BS + c;
	                        }
	                    }
	                    else if (c === DS) {
	                        out += parseEnvVar();
	                    }
	                    else {
	                        out += c;
	                    }
	                }
	            }
	            else if (c === DQ || c === SQ) {
	                quote = c;
	            }
	            else if (RegExp('^' + CONTROL + '$').test(c)) {
	                return { op: s };
	            }
	            else if (RegExp('^#$').test(c)) {
	                commented = true;
	                if (out.length){
	                    return [out, { comment: s.slice(i+1) + match.slice(j+1).join(' ') }];
	                }
	                return [{ comment: s.slice(i+1) + match.slice(j+1).join(' ') }];
	            }
	            else if (c === BS) {
	                esc = true;
	            }
	            else if (c === DS) {
	                out += parseEnvVar();
	            }
	            else out += c;
	        }
	
	        if (isGlob) return {op: 'glob', pattern: out};
	
	        return out;
	
	        function parseEnvVar() {
	            i += 1;
	            var varend, varname;
	            //debugger
	            if (s.charAt(i) === '{') {
	                i += 1;
	                if (s.charAt(i) === '}') {
	                    throw new Error("Bad substitution: " + s.substr(i - 2, 3));
	                }
	                varend = s.indexOf('}', i);
	                if (varend < 0) {
	                    throw new Error("Bad substitution: " + s.substr(i));
	                }
	                varname = s.substr(i, varend - i);
	                i = varend;
	            }
	            else if (/[*@#?$!_\-]/.test(s.charAt(i))) {
	                varname = s.charAt(i);
	                i += 1;
	            }
	            else {
	                varend = s.substr(i).match(/[^\w\d_]/);
	                if (!varend) {
	                    varname = s.substr(i);
	                    i = s.length;
	                } else {
	                    varname = s.substr(i, varend.index);
	                    i += varend.index - 1;
	                }
	            }
	            return getVar(null, '', varname);
	        }
	    })
	    // finalize parsed aruments
	    .reduce(function(prev, arg){
	        if (arg === undefined){
	            return prev;
	        }
	        return prev.concat(arg);
	    },[]);
	
	    function getVar (_, pre, key) {
	        var r = typeof env === 'function' ? env(key) : env[key];
	        if (r === undefined) r = '';
	
	        if (typeof r === 'object') {
	            return pre + TOKEN + json.stringify(r) + TOKEN;
	        }
	        else return pre + r;
	    }
	}


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	exports.parse = __webpack_require__(385);
	exports.stringify = __webpack_require__(386);


/***/ },
/* 385 */
/***/ function(module, exports) {

	var at, // The index of the current character
	    ch, // The current character
	    escapee = {
	        '"':  '"',
	        '\\': '\\',
	        '/':  '/',
	        b:    '\b',
	        f:    '\f',
	        n:    '\n',
	        r:    '\r',
	        t:    '\t'
	    },
	    text,
	
	    error = function (m) {
	        // Call error when something is wrong.
	        throw {
	            name:    'SyntaxError',
	            message: m,
	            at:      at,
	            text:    text
	        };
	    },
	    
	    next = function (c) {
	        // If a c parameter is provided, verify that it matches the current character.
	        if (c && c !== ch) {
	            error("Expected '" + c + "' instead of '" + ch + "'");
	        }
	        
	        // Get the next character. When there are no more characters,
	        // return the empty string.
	        
	        ch = text.charAt(at);
	        at += 1;
	        return ch;
	    },
	    
	    number = function () {
	        // Parse a number value.
	        var number,
	            string = '';
	        
	        if (ch === '-') {
	            string = '-';
	            next('-');
	        }
	        while (ch >= '0' && ch <= '9') {
	            string += ch;
	            next();
	        }
	        if (ch === '.') {
	            string += '.';
	            while (next() && ch >= '0' && ch <= '9') {
	                string += ch;
	            }
	        }
	        if (ch === 'e' || ch === 'E') {
	            string += ch;
	            next();
	            if (ch === '-' || ch === '+') {
	                string += ch;
	                next();
	            }
	            while (ch >= '0' && ch <= '9') {
	                string += ch;
	                next();
	            }
	        }
	        number = +string;
	        if (!isFinite(number)) {
	            error("Bad number");
	        } else {
	            return number;
	        }
	    },
	    
	    string = function () {
	        // Parse a string value.
	        var hex,
	            i,
	            string = '',
	            uffff;
	        
	        // When parsing for string values, we must look for " and \ characters.
	        if (ch === '"') {
	            while (next()) {
	                if (ch === '"') {
	                    next();
	                    return string;
	                } else if (ch === '\\') {
	                    next();
	                    if (ch === 'u') {
	                        uffff = 0;
	                        for (i = 0; i < 4; i += 1) {
	                            hex = parseInt(next(), 16);
	                            if (!isFinite(hex)) {
	                                break;
	                            }
	                            uffff = uffff * 16 + hex;
	                        }
	                        string += String.fromCharCode(uffff);
	                    } else if (typeof escapee[ch] === 'string') {
	                        string += escapee[ch];
	                    } else {
	                        break;
	                    }
	                } else {
	                    string += ch;
	                }
	            }
	        }
	        error("Bad string");
	    },
	
	    white = function () {
	
	// Skip whitespace.
	
	        while (ch && ch <= ' ') {
	            next();
	        }
	    },
	
	    word = function () {
	
	// true, false, or null.
	
	        switch (ch) {
	        case 't':
	            next('t');
	            next('r');
	            next('u');
	            next('e');
	            return true;
	        case 'f':
	            next('f');
	            next('a');
	            next('l');
	            next('s');
	            next('e');
	            return false;
	        case 'n':
	            next('n');
	            next('u');
	            next('l');
	            next('l');
	            return null;
	        }
	        error("Unexpected '" + ch + "'");
	    },
	
	    value,  // Place holder for the value function.
	
	    array = function () {
	
	// Parse an array value.
	
	        var array = [];
	
	        if (ch === '[') {
	            next('[');
	            white();
	            if (ch === ']') {
	                next(']');
	                return array;   // empty array
	            }
	            while (ch) {
	                array.push(value());
	                white();
	                if (ch === ']') {
	                    next(']');
	                    return array;
	                }
	                next(',');
	                white();
	            }
	        }
	        error("Bad array");
	    },
	
	    object = function () {
	
	// Parse an object value.
	
	        var key,
	            object = {};
	
	        if (ch === '{') {
	            next('{');
	            white();
	            if (ch === '}') {
	                next('}');
	                return object;   // empty object
	            }
	            while (ch) {
	                key = string();
	                white();
	                next(':');
	                if (Object.hasOwnProperty.call(object, key)) {
	                    error('Duplicate key "' + key + '"');
	                }
	                object[key] = value();
	                white();
	                if (ch === '}') {
	                    next('}');
	                    return object;
	                }
	                next(',');
	                white();
	            }
	        }
	        error("Bad object");
	    };
	
	value = function () {
	
	// Parse a JSON value. It could be an object, an array, a string, a number,
	// or a word.
	
	    white();
	    switch (ch) {
	    case '{':
	        return object();
	    case '[':
	        return array();
	    case '"':
	        return string();
	    case '-':
	        return number();
	    default:
	        return ch >= '0' && ch <= '9' ? number() : word();
	    }
	};
	
	// Return the json_parse function. It will have access to all of the above
	// functions and variables.
	
	module.exports = function (source, reviver) {
	    var result;
	    
	    text = source;
	    at = 0;
	    ch = ' ';
	    result = value();
	    white();
	    if (ch) {
	        error("Syntax error");
	    }
	
	    // If there is a reviver function, we recursively walk the new structure,
	    // passing each name/value pair to the reviver function for possible
	    // transformation, starting with a temporary root object that holds the result
	    // in an empty key. If there is not a reviver function, we simply return the
	    // result.
	
	    return typeof reviver === 'function' ? (function walk(holder, key) {
	        var k, v, value = holder[key];
	        if (value && typeof value === 'object') {
	            for (k in value) {
	                if (Object.prototype.hasOwnProperty.call(value, k)) {
	                    v = walk(value, k);
	                    if (v !== undefined) {
	                        value[k] = v;
	                    } else {
	                        delete value[k];
	                    }
	                }
	            }
	        }
	        return reviver.call(holder, key, value);
	    }({'': result}, '')) : result;
	};


/***/ },
/* 386 */
/***/ function(module, exports) {

	var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
	    escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
	    gap,
	    indent,
	    meta = {    // table of character substitutions
	        '\b': '\\b',
	        '\t': '\\t',
	        '\n': '\\n',
	        '\f': '\\f',
	        '\r': '\\r',
	        '"' : '\\"',
	        '\\': '\\\\'
	    },
	    rep;
	
	function quote(string) {
	    // If the string contains no control characters, no quote characters, and no
	    // backslash characters, then we can safely slap some quotes around it.
	    // Otherwise we must also replace the offending characters with safe escape
	    // sequences.
	    
	    escapable.lastIndex = 0;
	    return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
	        var c = meta[a];
	        return typeof c === 'string' ? c :
	            '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
	    }) + '"' : '"' + string + '"';
	}
	
	function str(key, holder) {
	    // Produce a string from holder[key].
	    var i,          // The loop counter.
	        k,          // The member key.
	        v,          // The member value.
	        length,
	        mind = gap,
	        partial,
	        value = holder[key];
	    
	    // If the value has a toJSON method, call it to obtain a replacement value.
	    if (value && typeof value === 'object' &&
	            typeof value.toJSON === 'function') {
	        value = value.toJSON(key);
	    }
	    
	    // If we were called with a replacer function, then call the replacer to
	    // obtain a replacement value.
	    if (typeof rep === 'function') {
	        value = rep.call(holder, key, value);
	    }
	    
	    // What happens next depends on the value's type.
	    switch (typeof value) {
	        case 'string':
	            return quote(value);
	        
	        case 'number':
	            // JSON numbers must be finite. Encode non-finite numbers as null.
	            return isFinite(value) ? String(value) : 'null';
	        
	        case 'boolean':
	        case 'null':
	            // If the value is a boolean or null, convert it to a string. Note:
	            // typeof null does not produce 'null'. The case is included here in
	            // the remote chance that this gets fixed someday.
	            return String(value);
	            
	        case 'object':
	            if (!value) return 'null';
	            gap += indent;
	            partial = [];
	            
	            // Array.isArray
	            if (Object.prototype.toString.apply(value) === '[object Array]') {
	                length = value.length;
	                for (i = 0; i < length; i += 1) {
	                    partial[i] = str(i, value) || 'null';
	                }
	                
	                // Join all of the elements together, separated with commas, and
	                // wrap them in brackets.
	                v = partial.length === 0 ? '[]' : gap ?
	                    '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' :
	                    '[' + partial.join(',') + ']';
	                gap = mind;
	                return v;
	            }
	            
	            // If the replacer is an array, use it to select the members to be
	            // stringified.
	            if (rep && typeof rep === 'object') {
	                length = rep.length;
	                for (i = 0; i < length; i += 1) {
	                    k = rep[i];
	                    if (typeof k === 'string') {
	                        v = str(k, value);
	                        if (v) {
	                            partial.push(quote(k) + (gap ? ': ' : ':') + v);
	                        }
	                    }
	                }
	            }
	            else {
	                // Otherwise, iterate through all of the keys in the object.
	                for (k in value) {
	                    if (Object.prototype.hasOwnProperty.call(value, k)) {
	                        v = str(k, value);
	                        if (v) {
	                            partial.push(quote(k) + (gap ? ': ' : ':') + v);
	                        }
	                    }
	                }
	            }
	            
	        // Join all of the member texts together, separated with commas,
	        // and wrap them in braces.
	
	        v = partial.length === 0 ? '{}' : gap ?
	            '{\n' + gap + partial.join(',\n' + gap) + '\n' + mind + '}' :
	            '{' + partial.join(',') + '}';
	        gap = mind;
	        return v;
	    }
	}
	
	module.exports = function (value, replacer, space) {
	    var i;
	    gap = '';
	    indent = '';
	    
	    // If the space parameter is a number, make an indent string containing that
	    // many spaces.
	    if (typeof space === 'number') {
	        for (i = 0; i < space; i += 1) {
	            indent += ' ';
	        }
	    }
	    // If the space parameter is a string, it will be used as the indent string.
	    else if (typeof space === 'string') {
	        indent = space;
	    }
	
	    // If there is a replacer, it must be a function or an array.
	    // Otherwise, throw an error.
	    rep = replacer;
	    if (replacer && typeof replacer !== 'function'
	    && (typeof replacer !== 'object' || typeof replacer.length !== 'number')) {
	        throw new Error('JSON.stringify');
	    }
	    
	    // Make a fake root object containing our value under the key of ''.
	    // Return the result of stringifying the value.
	    return str('', {'': value});
	};


/***/ },
/* 387 */
/***/ function(module, exports) {

	module.exports = function (xs, f) {
	    if (xs.map) return xs.map(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        var x = xs[i];
	        if (hasOwn.call(xs, i)) res.push(f(x, i, xs));
	    }
	    return res;
	};
	
	var hasOwn = Object.prototype.hasOwnProperty;


/***/ },
/* 388 */
/***/ function(module, exports) {

	/**
	 * Array#filter.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @return {Array}
	 */
	
	module.exports = function (arr, fn) {
	  if (arr.filter) return arr.filter(fn);
	  var ret = [];
	  for (var i = 0; i < arr.length; i++) {
	    if (!hasOwn.call(arr, i)) continue;
	    if (fn(arr[i], i, arr)) ret.push(arr[i]);
	  }
	  return ret;
	};
	
	var hasOwn = Object.prototype.hasOwnProperty;


/***/ },
/* 389 */
/***/ function(module, exports) {

	var hasOwn = Object.prototype.hasOwnProperty;
	
	module.exports = function (xs, f, acc) {
	    var hasAcc = arguments.length >= 3;
	    if (hasAcc && xs.reduce) return xs.reduce(f, acc);
	    if (xs.reduce) return xs.reduce(f);
	    
	    for (var i = 0; i < xs.length; i++) {
	        if (!hasOwn.call(xs, i)) continue;
	        if (!hasAcc) {
	            acc = xs[i];
	            hasAcc = true;
	            continue;
	        }
	        acc = f(acc, xs[i], i);
	    }
	    return acc;
	};


/***/ },
/* 390 */
/***/ function(module, exports) {

	module.exports = require("http");

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** standalone.js
 **/